import * as I1 from "react";
import Et, { createContext as Ft, useContext as Oe, useRef as Qe, useEffect as _e, useLayoutEffect as N1, useCallback as B1, useMemo as Pr, forwardRef as $1, createElement as Z1, useState as $e, cloneElement as Ja, Children as Tl, isValidElement as Ml, useDebugValue as F1 } from "react";
import { useDispatch as Qa, useSelector as ei } from "react-redux";
import { createPortal as Al } from "react-dom";
import { combineReducers as Rl } from "redux";
var ya = function(e, t) {
  return ya = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, n) {
    r.__proto__ = n;
  } || function(r, n) {
    for (var a in n)
      Object.prototype.hasOwnProperty.call(n, a) && (r[a] = n[a]);
  }, ya(e, t);
};
function W1(e, t) {
  if (typeof t != "function" && t !== null)
    throw new TypeError("Class extends value " + String(t) + " is not a constructor or null");
  ya(e, t);
  function r() {
    this.constructor = e;
  }
  e.prototype = t === null ? Object.create(t) : (r.prototype = t.prototype, new r());
}
var P = function() {
  return P = Object.assign || function(t) {
    for (var r, n = 1, a = arguments.length; n < a; n++) {
      r = arguments[n];
      for (var i in r)
        Object.prototype.hasOwnProperty.call(r, i) && (t[i] = r[i]);
    }
    return t;
  }, P.apply(this, arguments);
};
function nt(e, t) {
  var r = {};
  for (var n in e)
    Object.prototype.hasOwnProperty.call(e, n) && t.indexOf(n) < 0 && (r[n] = e[n]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var a = 0, n = Object.getOwnPropertySymbols(e); a < n.length; a++)
      t.indexOf(n[a]) < 0 && Object.prototype.propertyIsEnumerable.call(e, n[a]) && (r[n[a]] = e[n[a]]);
  return r;
}
function Re(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r)
    return e;
  var n = r.call(e), a, i = [], o;
  try {
    for (; (t === void 0 || t-- > 0) && !(a = n.next()).done; )
      i.push(a.value);
  } catch (s) {
    o = { error: s };
  } finally {
    try {
      a && !a.done && (r = n.return) && r.call(n);
    } finally {
      if (o)
        throw o.error;
    }
  }
  return i;
}
function Fe(e, t, r) {
  if (r || arguments.length === 2)
    for (var n = 0, a = t.length, i; n < a; n++)
      (i || !(n in t)) && (i || (i = Array.prototype.slice.call(t, 0, n)), i[n] = t[n]);
  return e.concat(i || Array.prototype.slice.call(t));
}
var xt = function(e) {
  return {
    isEnabled: function(t) {
      return e.some(function(r) {
        return !!t[r];
      });
    }
  };
}, ti = {
  measureLayout: xt([
    "layout",
    "layoutId",
    "drag",
    "_layoutResetTransform"
  ]),
  animation: xt([
    "animate",
    "exit",
    "variants",
    "whileHover",
    "whileTap",
    "whileFocus",
    "whileDrag"
  ]),
  exit: xt(["exit"]),
  drag: xt(["drag", "dragControls"]),
  focus: xt(["whileFocus"]),
  hover: xt(["whileHover", "onHoverStart", "onHoverEnd"]),
  tap: xt(["whileTap", "onTap", "onTapStart", "onTapCancel"]),
  pan: xt([
    "onPan",
    "onPanStart",
    "onPanSessionStart",
    "onPanEnd"
  ]),
  layoutAnimation: xt(["layout", "layoutId"])
};
function Sl(e) {
  for (var t in e) {
    var r = e[t];
    r !== null && (ti[t].Component = r);
  }
}
var Dn = function() {
}, Ye = function() {
};
process.env.NODE_ENV !== "production" && (Dn = function(e, t) {
  !e && typeof console < "u" && console.warn(t);
}, Ye = function(e, t) {
  if (!e)
    throw new Error(t);
});
var U1 = Ft({ strict: !1 }), jn = { exports: {} }, qt = {};
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var ta, Ni;
function z1() {
  if (Ni)
    return ta;
  Ni = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, r = Object.prototype.propertyIsEnumerable;
  function n(i) {
    if (i == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(i);
  }
  function a() {
    try {
      if (!Object.assign)
        return !1;
      var i = new String("abc");
      if (i[5] = "de", Object.getOwnPropertyNames(i)[0] === "5")
        return !1;
      for (var o = {}, s = 0; s < 10; s++)
        o["_" + String.fromCharCode(s)] = s;
      var l = Object.getOwnPropertyNames(o).map(function(c) {
        return o[c];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var d = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(c) {
        d[c] = c;
      }), Object.keys(Object.assign({}, d)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return ta = a() ? Object.assign : function(i, o) {
    for (var s, l = n(i), d, c = 1; c < arguments.length; c++) {
      s = Object(arguments[c]);
      for (var p in s)
        t.call(s, p) && (l[p] = s[p]);
      if (e) {
        d = e(s);
        for (var v = 0; v < d.length; v++)
          r.call(s, d[v]) && (l[d[v]] = s[d[v]]);
      }
    }
    return l;
  }, ta;
}
/** @license React v17.0.2
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Bi;
function Pl() {
  if (Bi)
    return qt;
  Bi = 1, z1();
  var e = Et, t = 60103;
  if (qt.Fragment = 60107, typeof Symbol == "function" && Symbol.for) {
    var r = Symbol.for;
    t = r("react.element"), qt.Fragment = r("react.fragment");
  }
  var n = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = Object.prototype.hasOwnProperty, i = { key: !0, ref: !0, __self: !0, __source: !0 };
  function o(s, l, d) {
    var c, p = {}, v = null, m = null;
    d !== void 0 && (v = "" + d), l.key !== void 0 && (v = "" + l.key), l.ref !== void 0 && (m = l.ref);
    for (c in l)
      a.call(l, c) && !i.hasOwnProperty(c) && (p[c] = l[c]);
    if (s && s.defaultProps)
      for (c in l = s.defaultProps, l)
        p[c] === void 0 && (p[c] = l[c]);
    return { $$typeof: t, type: s, key: v, ref: m, props: p, _owner: n.current };
  }
  return qt.jsx = o, qt.jsxs = o, qt;
}
var ra = {};
/** @license React v17.0.2
 * react-jsx-runtime.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var $i;
function El() {
  return $i || ($i = 1, function(e) {
    process.env.NODE_ENV !== "production" && function() {
      var t = Et, r = z1(), n = 60103, a = 60106;
      e.Fragment = 60107;
      var i = 60108, o = 60114, s = 60109, l = 60110, d = 60112, c = 60113, p = 60120, v = 60115, m = 60116, h = 60121, C = 60122, y = 60117, x = 60129, T = 60131;
      if (typeof Symbol == "function" && Symbol.for) {
        var M = Symbol.for;
        n = M("react.element"), a = M("react.portal"), e.Fragment = M("react.fragment"), i = M("react.strict_mode"), o = M("react.profiler"), s = M("react.provider"), l = M("react.context"), d = M("react.forward_ref"), c = M("react.suspense"), p = M("react.suspense_list"), v = M("react.memo"), m = M("react.lazy"), h = M("react.block"), C = M("react.server.block"), y = M("react.fundamental"), M("react.scope"), M("react.opaque.id"), x = M("react.debug_trace_mode"), M("react.offscreen"), T = M("react.legacy_hidden");
      }
      var f = typeof Symbol == "function" && Symbol.iterator, b = "@@iterator";
      function w(g) {
        if (g === null || typeof g != "object")
          return null;
        var H = f && g[f] || g[b];
        return typeof H == "function" ? H : null;
      }
      var V = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
      function S(g) {
        {
          for (var H = arguments.length, Y = new Array(H > 1 ? H - 1 : 0), ie = 1; ie < H; ie++)
            Y[ie - 1] = arguments[ie];
          k("error", g, Y);
        }
      }
      function k(g, H, Y) {
        {
          var ie = V.ReactDebugCurrentFrame, Me = ie.getStackAddendum();
          Me !== "" && (H += "%s", Y = Y.concat([Me]));
          var Ae = Y.map(function(ge) {
            return "" + ge;
          });
          Ae.unshift("Warning: " + H), Function.prototype.apply.call(console[g], console, Ae);
        }
      }
      var I = !1;
      function $(g) {
        return !!(typeof g == "string" || typeof g == "function" || g === e.Fragment || g === o || g === x || g === i || g === c || g === p || g === T || I || typeof g == "object" && g !== null && (g.$$typeof === m || g.$$typeof === v || g.$$typeof === s || g.$$typeof === l || g.$$typeof === d || g.$$typeof === y || g.$$typeof === h || g[0] === C));
      }
      function X(g, H, Y) {
        var ie = H.displayName || H.name || "";
        return g.displayName || (ie !== "" ? Y + "(" + ie + ")" : Y);
      }
      function G(g) {
        return g.displayName || "Context";
      }
      function F(g) {
        if (g == null)
          return null;
        if (typeof g.tag == "number" && S("Received an unexpected object in getComponentName(). This is likely a bug in React. Please file an issue."), typeof g == "function")
          return g.displayName || g.name || null;
        if (typeof g == "string")
          return g;
        switch (g) {
          case e.Fragment:
            return "Fragment";
          case a:
            return "Portal";
          case o:
            return "Profiler";
          case i:
            return "StrictMode";
          case c:
            return "Suspense";
          case p:
            return "SuspenseList";
        }
        if (typeof g == "object")
          switch (g.$$typeof) {
            case l:
              var H = g;
              return G(H) + ".Consumer";
            case s:
              var Y = g;
              return G(Y._context) + ".Provider";
            case d:
              return X(g, g.render, "ForwardRef");
            case v:
              return F(g.type);
            case h:
              return F(g._render);
            case m: {
              var ie = g, Me = ie._payload, Ae = ie._init;
              try {
                return F(Ae(Me));
              } catch {
                return null;
              }
            }
          }
        return null;
      }
      var z = 0, J, se, ee, pe, le, ve, B;
      function Z() {
      }
      Z.__reactDisabledLog = !0;
      function U() {
        {
          if (z === 0) {
            J = console.log, se = console.info, ee = console.warn, pe = console.error, le = console.group, ve = console.groupCollapsed, B = console.groupEnd;
            var g = {
              configurable: !0,
              enumerable: !0,
              value: Z,
              writable: !0
            };
            Object.defineProperties(console, {
              info: g,
              log: g,
              warn: g,
              error: g,
              group: g,
              groupCollapsed: g,
              groupEnd: g
            });
          }
          z++;
        }
      }
      function te() {
        {
          if (z--, z === 0) {
            var g = {
              configurable: !0,
              enumerable: !0,
              writable: !0
            };
            Object.defineProperties(console, {
              log: r({}, g, {
                value: J
              }),
              info: r({}, g, {
                value: se
              }),
              warn: r({}, g, {
                value: ee
              }),
              error: r({}, g, {
                value: pe
              }),
              group: r({}, g, {
                value: le
              }),
              groupCollapsed: r({}, g, {
                value: ve
              }),
              groupEnd: r({}, g, {
                value: B
              })
            });
          }
          z < 0 && S("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
        }
      }
      var L = V.ReactCurrentDispatcher, ce;
      function j(g, H, Y) {
        {
          if (ce === void 0)
            try {
              throw Error();
            } catch (Me) {
              var ie = Me.stack.trim().match(/\n( *(at )?)/);
              ce = ie && ie[1] || "";
            }
          return `
` + ce + g;
        }
      }
      var ye = !1, ue;
      {
        var me = typeof WeakMap == "function" ? WeakMap : Map;
        ue = new me();
      }
      function O(g, H) {
        if (!g || ye)
          return "";
        {
          var Y = ue.get(g);
          if (Y !== void 0)
            return Y;
        }
        var ie;
        ye = !0;
        var Me = Error.prepareStackTrace;
        Error.prepareStackTrace = void 0;
        var Ae;
        Ae = L.current, L.current = null, U();
        try {
          if (H) {
            var ge = function() {
              throw Error();
            };
            if (Object.defineProperty(ge.prototype, "props", {
              set: function() {
                throw Error();
              }
            }), typeof Reflect == "object" && Reflect.construct) {
              try {
                Reflect.construct(ge, []);
              } catch (bt) {
                ie = bt;
              }
              Reflect.construct(g, [], ge);
            } else {
              try {
                ge.call();
              } catch (bt) {
                ie = bt;
              }
              g.call(ge.prototype);
            }
          } else {
            try {
              throw Error();
            } catch (bt) {
              ie = bt;
            }
            g();
          }
        } catch (bt) {
          if (bt && ie && typeof bt.stack == "string") {
            for (var fe = bt.stack.split(`
`), Ne = ie.stack.split(`
`), Ee = fe.length - 1, ke = Ne.length - 1; Ee >= 1 && ke >= 0 && fe[Ee] !== Ne[ke]; )
              ke--;
            for (; Ee >= 1 && ke >= 0; Ee--, ke--)
              if (fe[Ee] !== Ne[ke]) {
                if (Ee !== 1 || ke !== 1)
                  do
                    if (Ee--, ke--, ke < 0 || fe[Ee] !== Ne[ke]) {
                      var Ct = `
` + fe[Ee].replace(" at new ", " at ");
                      return typeof g == "function" && ue.set(g, Ct), Ct;
                    }
                  while (Ee >= 1 && ke >= 0);
                break;
              }
          }
        } finally {
          ye = !1, L.current = Ae, te(), Error.prepareStackTrace = Me;
        }
        var Yt = g ? g.displayName || g.name : "", Ii = Yt ? j(Yt) : "";
        return typeof g == "function" && ue.set(g, Ii), Ii;
      }
      function we(g, H, Y) {
        return O(g, !1);
      }
      function W(g) {
        var H = g.prototype;
        return !!(H && H.isReactComponent);
      }
      function A(g, H, Y) {
        if (g == null)
          return "";
        if (typeof g == "function")
          return O(g, W(g));
        if (typeof g == "string")
          return j(g);
        switch (g) {
          case c:
            return j("Suspense");
          case p:
            return j("SuspenseList");
        }
        if (typeof g == "object")
          switch (g.$$typeof) {
            case d:
              return we(g.render);
            case v:
              return A(g.type, H, Y);
            case h:
              return we(g._render);
            case m: {
              var ie = g, Me = ie._payload, Ae = ie._init;
              try {
                return A(Ae(Me), H, Y);
              } catch {
              }
            }
          }
        return "";
      }
      var _ = {}, q = V.ReactDebugCurrentFrame;
      function ne(g) {
        if (g) {
          var H = g._owner, Y = A(g.type, g._source, H ? H.type : null);
          q.setExtraStackFrame(Y);
        } else
          q.setExtraStackFrame(null);
      }
      function Le(g, H, Y, ie, Me) {
        {
          var Ae = Function.call.bind(Object.prototype.hasOwnProperty);
          for (var ge in g)
            if (Ae(g, ge)) {
              var fe = void 0;
              try {
                if (typeof g[ge] != "function") {
                  var Ne = Error((ie || "React class") + ": " + Y + " type `" + ge + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof g[ge] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                  throw Ne.name = "Invariant Violation", Ne;
                }
                fe = g[ge](H, ge, ie, Y, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
              } catch (Ee) {
                fe = Ee;
              }
              fe && !(fe instanceof Error) && (ne(Me), S("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", ie || "React class", Y, ge, typeof fe), ne(null)), fe instanceof Error && !(fe.message in _) && (_[fe.message] = !0, ne(Me), S("Failed %s type: %s", Y, fe.message), ne(null));
            }
        }
      }
      var ae = V.ReactCurrentOwner, Se = Object.prototype.hasOwnProperty, Ve = {
        key: !0,
        ref: !0,
        __self: !0,
        __source: !0
      }, Te, Q, Ce;
      Ce = {};
      function dt(g) {
        if (Se.call(g, "ref")) {
          var H = Object.getOwnPropertyDescriptor(g, "ref").get;
          if (H && H.isReactWarning)
            return !1;
        }
        return g.ref !== void 0;
      }
      function ft(g) {
        if (Se.call(g, "key")) {
          var H = Object.getOwnPropertyDescriptor(g, "key").get;
          if (H && H.isReactWarning)
            return !1;
        }
        return g.key !== void 0;
      }
      function je(g, H) {
        if (typeof g.ref == "string" && ae.current && H && ae.current.stateNode !== H) {
          var Y = F(ae.current.type);
          Ce[Y] || (S('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', F(ae.current.type), g.ref), Ce[Y] = !0);
        }
      }
      function Xn(g, H) {
        {
          var Y = function() {
            Te || (Te = !0, S("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", H));
          };
          Y.isReactWarning = !0, Object.defineProperty(g, "key", {
            get: Y,
            configurable: !0
          });
        }
      }
      function Gn(g, H) {
        {
          var Y = function() {
            Q || (Q = !0, S("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", H));
          };
          Y.isReactWarning = !0, Object.defineProperty(g, "ref", {
            get: Y,
            configurable: !0
          });
        }
      }
      var Jn = function(g, H, Y, ie, Me, Ae, ge) {
        var fe = {
          $$typeof: n,
          type: g,
          key: H,
          ref: Y,
          props: ge,
          _owner: Ae
        };
        return fe._store = {}, Object.defineProperty(fe._store, "validated", {
          configurable: !1,
          enumerable: !1,
          writable: !0,
          value: !1
        }), Object.defineProperty(fe, "_self", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: ie
        }), Object.defineProperty(fe, "_source", {
          configurable: !1,
          enumerable: !1,
          writable: !1,
          value: Me
        }), Object.freeze && (Object.freeze(fe.props), Object.freeze(fe)), fe;
      };
      function Qn(g, H, Y, ie, Me) {
        {
          var Ae, ge = {}, fe = null, Ne = null;
          Y !== void 0 && (fe = "" + Y), ft(H) && (fe = "" + H.key), dt(H) && (Ne = H.ref, je(H, Me));
          for (Ae in H)
            Se.call(H, Ae) && !Ve.hasOwnProperty(Ae) && (ge[Ae] = H[Ae]);
          if (g && g.defaultProps) {
            var Ee = g.defaultProps;
            for (Ae in Ee)
              ge[Ae] === void 0 && (ge[Ae] = Ee[Ae]);
          }
          if (fe || Ne) {
            var ke = typeof g == "function" ? g.displayName || g.name || "Unknown" : g;
            fe && Xn(ge, ke), Ne && Gn(ge, ke);
          }
          return Jn(g, fe, Ne, Me, ie, ae.current, ge);
        }
      }
      var mr = V.ReactCurrentOwner, R = V.ReactDebugCurrentFrame;
      function K(g) {
        if (g) {
          var H = g._owner, Y = A(g.type, g._source, H ? H.type : null);
          R.setExtraStackFrame(Y);
        } else
          R.setExtraStackFrame(null);
      }
      var re;
      re = !1;
      function he(g) {
        return typeof g == "object" && g !== null && g.$$typeof === n;
      }
      function de() {
        {
          if (mr.current) {
            var g = F(mr.current.type);
            if (g)
              return `

Check the render method of \`` + g + "`.";
          }
          return "";
        }
      }
      function De(g) {
        {
          if (g !== void 0) {
            var H = g.fileName.replace(/^.*[\\\/]/, ""), Y = g.lineNumber;
            return `

Check your code at ` + H + ":" + Y + ".";
          }
          return "";
        }
      }
      var Ie = {};
      function Mt(g) {
        {
          var H = de();
          if (!H) {
            var Y = typeof g == "string" ? g : g.displayName || g.name;
            Y && (H = `

Check the top-level render call using <` + Y + ">.");
          }
          return H;
        }
      }
      function hr(g, H) {
        {
          if (!g._store || g._store.validated || g.key != null)
            return;
          g._store.validated = !0;
          var Y = Mt(H);
          if (Ie[Y])
            return;
          Ie[Y] = !0;
          var ie = "";
          g && g._owner && g._owner !== mr.current && (ie = " It was passed a child from " + F(g._owner.type) + "."), K(g), S('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', Y, ie), K(null);
        }
      }
      function pt(g, H) {
        {
          if (typeof g != "object")
            return;
          if (Array.isArray(g))
            for (var Y = 0; Y < g.length; Y++) {
              var ie = g[Y];
              he(ie) && hr(ie, H);
            }
          else if (he(g))
            g._store && (g._store.validated = !0);
          else if (g) {
            var Me = w(g);
            if (typeof Me == "function" && Me !== g.entries)
              for (var Ae = Me.call(g), ge; !(ge = Ae.next()).done; )
                he(ge.value) && hr(ge.value, H);
          }
        }
      }
      function gr(g) {
        {
          var H = g.type;
          if (H == null || typeof H == "string")
            return;
          var Y;
          if (typeof H == "function")
            Y = H.propTypes;
          else if (typeof H == "object" && (H.$$typeof === d || H.$$typeof === v))
            Y = H.propTypes;
          else
            return;
          if (Y) {
            var ie = F(H);
            Le(Y, g.props, "prop", ie, g);
          } else if (H.PropTypes !== void 0 && !re) {
            re = !0;
            var Me = F(H);
            S("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Me || "Unknown");
          }
          typeof H.getDefaultProps == "function" && !H.getDefaultProps.isReactClassApproved && S("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
        }
      }
      function Ut(g) {
        {
          for (var H = Object.keys(g.props), Y = 0; Y < H.length; Y++) {
            var ie = H[Y];
            if (ie !== "children" && ie !== "key") {
              K(g), S("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", ie), K(null);
              break;
            }
          }
          g.ref !== null && (K(g), S("Invalid attribute `ref` supplied to `React.Fragment`."), K(null));
        }
      }
      function yt(g, H, Y, ie, Me, Ae) {
        {
          var ge = $(g);
          if (!ge) {
            var fe = "";
            (g === void 0 || typeof g == "object" && g !== null && Object.keys(g).length === 0) && (fe += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
            var Ne = De(Me);
            Ne ? fe += Ne : fe += de();
            var Ee;
            g === null ? Ee = "null" : Array.isArray(g) ? Ee = "array" : g !== void 0 && g.$$typeof === n ? (Ee = "<" + (F(g.type) || "Unknown") + " />", fe = " Did you accidentally export a JSX literal instead of a component?") : Ee = typeof g, S("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", Ee, fe);
          }
          var ke = Qn(g, H, Y, Me, Ae);
          if (ke == null)
            return ke;
          if (ge) {
            var Ct = H.children;
            if (Ct !== void 0)
              if (ie)
                if (Array.isArray(Ct)) {
                  for (var Yt = 0; Yt < Ct.length; Yt++)
                    pt(Ct[Yt], g);
                  Object.freeze && Object.freeze(Ct);
                } else
                  S("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
              else
                pt(Ct, g);
          }
          return g === e.Fragment ? Ut(ke) : gr(ke), ke;
        }
      }
      function ea(g, H, Y) {
        return yt(g, H, Y, !0);
      }
      function yr(g, H, Y) {
        return yt(g, H, Y, !1);
      }
      var zt = yr, Ll = ea;
      e.jsx = zt, e.jsxs = Ll;
    }();
  }(ra)), ra;
}
(function(e) {
  process.env.NODE_ENV === "production" ? e.exports = Pl() : e.exports = El();
})(jn);
const He = jn.exports.Fragment, u = jn.exports.jsx, E = jn.exports.jsxs;
var Y1 = Object.keys(ti), kl = Y1.length;
function Ol(e, t, r) {
  var n = [], a = Oe(U1);
  if (!t)
    return null;
  process.env.NODE_ENV !== "production" && r && a.strict && Ye(!1, "You have rendered a `motion` component within a `LazyMotion` component. This will break tree shaking. Import and render a `m` component instead.");
  for (var i = 0; i < kl; i++) {
    var o = Y1[i], s = ti[o], l = s.isEnabled, d = s.Component;
    l(e) && d && n.push(/* @__PURE__ */ u(d, {
      ...P({
        key: o
      }, e, {
        visualElement: t
      })
    }));
  }
  return n;
}
var In = Ft({
  transformPagePoint: function(e) {
    return e;
  },
  isStatic: !1
}), Nn = Ft({});
function _l() {
  return Oe(Nn).visualElement;
}
var Wr = Ft(null);
function Er(e) {
  var t = Qe(null);
  return t.current === null && (t.current = e()), t.current;
}
function q1() {
  var e = Oe(Wr);
  if (e === null)
    return [!0, null];
  var t = e.isPresent, r = e.onExitComplete, n = e.register, a = jl();
  _e(function() {
    return n(a);
  }, []);
  var i = function() {
    return r == null ? void 0 : r(a);
  };
  return !t && r ? [!1, i] : [!0];
}
function Vl(e) {
  return e === null ? !0 : e.isPresent;
}
var Hl = 0, Dl = function() {
  return Hl++;
}, jl = function() {
  return Er(Dl);
}, Il = Ft(null), Ur = typeof window < "u", Zi = Ur ? N1 : _e;
function Nl(e) {
  var t = e.layoutId, r = Oe(Il);
  return r && t !== void 0 ? r + "-" + t : t;
}
function Bl(e, t, r, n) {
  var a = Oe(In), i = Oe(U1), o = _l(), s = Oe(Wr), l = Nl(r), d = Qe(void 0);
  n || (n = i.renderer), !d.current && n && (d.current = n(e, {
    visualState: t,
    parent: o,
    props: P(P({}, r), { layoutId: l }),
    presenceId: s == null ? void 0 : s.id,
    blockInitialAnimation: (s == null ? void 0 : s.initial) === !1
  }));
  var c = d.current;
  return Zi(function() {
    !c || (c.setProps(P(P(P({}, a), r), { layoutId: l })), c.isPresent = Vl(s), c.isPresenceRoot = !o || o.presenceId !== (s == null ? void 0 : s.id), c.syncRender());
  }), _e(function() {
    var p;
    !c || (p = c.animationState) === null || p === void 0 || p.animateChanges();
  }), Zi(function() {
    return function() {
      return c == null ? void 0 : c.notifyUnmount();
    };
  }, []), c;
}
function Ca(e) {
  return typeof e == "object" && Object.prototype.hasOwnProperty.call(e, "current");
}
function $l(e, t, r) {
  return B1(
    function(n) {
      var a;
      n && ((a = e.mount) === null || a === void 0 || a.call(e, n)), t && (n ? t.mount(n) : t.unmount()), r && (typeof r == "function" ? r(n) : Ca(r) && (r.current = n));
    },
    [t]
  );
}
function K1(e) {
  return Array.isArray(e);
}
function st(e) {
  return typeof e == "string" || K1(e);
}
function Zl(e) {
  var t = {};
  return e.forEachValue(function(r, n) {
    return t[n] = r.get();
  }), t;
}
function Fl(e) {
  var t = {};
  return e.forEachValue(function(r, n) {
    return t[n] = r.getVelocity();
  }), t;
}
function X1(e, t, r, n, a) {
  var i;
  return n === void 0 && (n = {}), a === void 0 && (a = {}), typeof t == "string" && (t = (i = e.variants) === null || i === void 0 ? void 0 : i[t]), typeof t == "function" ? t(r != null ? r : e.custom, n, a) : t;
}
function Bn(e, t, r) {
  var n = e.getProps();
  return X1(n, t, r != null ? r : n.custom, Zl(e), Fl(e));
}
function $n(e) {
  var t;
  return typeof ((t = e.animate) === null || t === void 0 ? void 0 : t.start) == "function" || st(e.initial) || st(e.animate) || st(e.whileHover) || st(e.whileDrag) || st(e.whileTap) || st(e.whileFocus) || st(e.exit);
}
function G1(e) {
  return Boolean($n(e) || e.variants);
}
function Wl(e, t) {
  if ($n(e)) {
    var r = e.initial, n = e.animate;
    return {
      initial: r === !1 || st(r) ? r : void 0,
      animate: st(n) ? n : void 0
    };
  }
  return e.inherit !== !1 ? t : {};
}
function Ul(e, t) {
  var r = Wl(e, Oe(Nn)), n = r.initial, a = r.animate;
  return Pr(
    function() {
      return { initial: n, animate: a };
    },
    t ? [
      Fi(n),
      Fi(a)
    ] : []
  );
}
function Fi(e) {
  return Array.isArray(e) ? e.join(" ") : e;
}
function zl(e) {
  var t = e.preloadedFeatures, r = e.createVisualElement, n = e.useRender, a = e.useVisualState, i = e.Component;
  t && Sl(t);
  function o(s, l) {
    var d = Oe(In).isStatic, c = null, p = Ul(s, d), v = a(s, d);
    return !d && Ur && (p.visualElement = Bl(i, v, s, r), c = Ol(s, p.visualElement, t)), /* @__PURE__ */ E(He, {
      children: [/* @__PURE__ */ u(Nn.Provider, {
        value: p,
        children: n(i, s, $l(v, p.visualElement, l), v, d)
      }), c]
    });
  }
  return $1(o);
}
function Yl(e) {
  function t(n, a) {
    return a === void 0 && (a = {}), zl(e(n, a));
  }
  var r = /* @__PURE__ */ new Map();
  return new Proxy(t, {
    get: function(n, a) {
      return r.has(a) || r.set(a, t(a)), r.get(a);
    }
  });
}
var ql = [
  "animate",
  "circle",
  "defs",
  "desc",
  "ellipse",
  "g",
  "image",
  "line",
  "filter",
  "marker",
  "mask",
  "metadata",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "rect",
  "stop",
  "svg",
  "switch",
  "symbol",
  "text",
  "tspan",
  "use",
  "view"
];
function ri(e) {
  return typeof e != "string" || e.includes("-") ? !1 : !!(ql.indexOf(e) > -1 || /[A-Z]/.test(e));
}
var xr = {};
function Kl(e) {
  for (var t in e)
    xr[t] = e[t];
}
var Xl = ["", "X", "Y", "Z"], Gl = ["translate", "scale", "rotate", "skew"], kr = ["transformPerspective", "x", "y", "z"];
Gl.forEach(function(e) {
  return Xl.forEach(function(t) {
    return kr.push(e + t);
  });
});
function Jl(e, t) {
  return kr.indexOf(e) - kr.indexOf(t);
}
var Ql = new Set(kr);
function Zn(e) {
  return Ql.has(e);
}
var ec = /* @__PURE__ */ new Set(["originX", "originY", "originZ"]);
function J1(e) {
  return ec.has(e);
}
function Q1(e, t) {
  var r = t.layout, n = t.layoutId;
  return Zn(e) || J1(e) || (r || n !== void 0) && (!!xr[e] || e === "opacity");
}
var St = function(e) {
  return e !== null && typeof e == "object" && e.getVelocity;
}, tc = {
  x: "translateX",
  y: "translateY",
  z: "translateZ",
  transformPerspective: "perspective"
};
function rc(e, t, r, n) {
  var a = e.transform, i = e.transformKeys, o = t.enableHardwareAcceleration, s = o === void 0 ? !0 : o, l = t.allowTransformNone, d = l === void 0 ? !0 : l, c = "";
  i.sort(Jl);
  for (var p = !1, v = i.length, m = 0; m < v; m++) {
    var h = i[m];
    c += (tc[h] || h) + "(" + a[h] + ") ", h === "z" && (p = !0);
  }
  return !p && s ? c += "translateZ(0)" : c = c.trim(), n ? c = n(a, r ? "" : c) : d && r && (c = "none"), c;
}
function nc(e) {
  var t = e.originX, r = t === void 0 ? "50%" : t, n = e.originY, a = n === void 0 ? "50%" : n, i = e.originZ, o = i === void 0 ? 0 : i;
  return r + " " + a + " " + o;
}
function es(e) {
  return e.startsWith("--");
}
var ac = function(e, t) {
  return t && typeof e == "number" ? t.transform(e) : e;
}, ts = function(e, t) {
  return function(r) {
    return Math.max(Math.min(r, t), e);
  };
}, wr = function(e) {
  return e % 1 ? Number(e.toFixed(5)) : e;
}, Or = /(-)?([\d]*\.?[\d])+/g, ba = /(#[0-9a-f]{6}|#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))/gi, ic = /^(#[0-9a-f]{3}|#(?:[0-9a-f]{2}){2,4}|(rgb|hsl)a?\((-?[\d\.]+%?[,\s]+){2,3}\s*\/*\s*[\d\.]+%?\))$/i;
function zr(e) {
  return typeof e == "string";
}
var Wt = {
  test: function(e) {
    return typeof e == "number";
  },
  parse: parseFloat,
  transform: function(e) {
    return e;
  }
}, Lr = P(P({}, Wt), { transform: ts(0, 1) }), rn = P(P({}, Wt), { default: 1 }), Yr = function(e) {
  return {
    test: function(t) {
      return zr(t) && t.endsWith(e) && t.split(" ").length === 1;
    },
    parse: parseFloat,
    transform: function(t) {
      return "" + t + e;
    }
  };
}, Rt = Yr("deg"), nr = Yr("%"), oe = Yr("px"), oc = Yr("vh"), sc = Yr("vw"), Wi = P(P({}, nr), { parse: function(e) {
  return nr.parse(e) / 100;
}, transform: function(e) {
  return nr.transform(e * 100);
} }), ni = function(e, t) {
  return function(r) {
    return Boolean(zr(r) && ic.test(r) && r.startsWith(e) || t && Object.prototype.hasOwnProperty.call(r, t));
  };
}, rs = function(e, t, r) {
  return function(n) {
    var a;
    if (!zr(n))
      return n;
    var i = n.match(Or), o = i[0], s = i[1], l = i[2], d = i[3];
    return a = {}, a[e] = parseFloat(o), a[t] = parseFloat(s), a[r] = parseFloat(l), a.alpha = d !== void 0 ? parseFloat(d) : 1, a;
  };
}, Qt = {
  test: ni("hsl", "hue"),
  parse: rs("hue", "saturation", "lightness"),
  transform: function(e) {
    var t = e.hue, r = e.saturation, n = e.lightness, a = e.alpha, i = a === void 0 ? 1 : a;
    return "hsla(" + Math.round(t) + ", " + nr.transform(wr(r)) + ", " + nr.transform(wr(n)) + ", " + wr(Lr.transform(i)) + ")";
  }
}, uc = ts(0, 255), na = P(P({}, Wt), { transform: function(e) {
  return Math.round(uc(e));
} }), er = {
  test: ni("rgb", "red"),
  parse: rs("red", "green", "blue"),
  transform: function(e) {
    var t = e.red, r = e.green, n = e.blue, a = e.alpha, i = a === void 0 ? 1 : a;
    return "rgba(" + na.transform(t) + ", " + na.transform(r) + ", " + na.transform(n) + ", " + wr(Lr.transform(i)) + ")";
  }
};
function lc(e) {
  var t = "", r = "", n = "", a = "";
  return e.length > 5 ? (t = e.substr(1, 2), r = e.substr(3, 2), n = e.substr(5, 2), a = e.substr(7, 2)) : (t = e.substr(1, 1), r = e.substr(2, 1), n = e.substr(3, 1), a = e.substr(4, 1), t += t, r += r, n += n, a += a), {
    red: parseInt(t, 16),
    green: parseInt(r, 16),
    blue: parseInt(n, 16),
    alpha: a ? parseInt(a, 16) / 255 : 1
  };
}
var xa = {
  test: ni("#"),
  parse: lc,
  transform: er.transform
}, Be = {
  test: function(e) {
    return er.test(e) || xa.test(e) || Qt.test(e);
  },
  parse: function(e) {
    return er.test(e) ? er.parse(e) : Qt.test(e) ? Qt.parse(e) : xa.parse(e);
  },
  transform: function(e) {
    return zr(e) ? e : e.hasOwnProperty("red") ? er.transform(e) : Qt.transform(e);
  }
}, ns = "${c}", as = "${n}";
function cc(e) {
  var t, r, n, a;
  return isNaN(e) && zr(e) && ((r = (t = e.match(Or)) === null || t === void 0 ? void 0 : t.length) !== null && r !== void 0 ? r : 0) + ((a = (n = e.match(ba)) === null || n === void 0 ? void 0 : n.length) !== null && a !== void 0 ? a : 0) > 0;
}
function is(e) {
  var t = [], r = 0, n = e.match(ba);
  n && (r = n.length, e = e.replace(ba, ns), t.push.apply(t, n.map(Be.parse)));
  var a = e.match(Or);
  return a && (e = e.replace(Or, as), t.push.apply(t, a.map(Wt.parse))), { values: t, numColors: r, tokenised: e };
}
function os(e) {
  return is(e).values;
}
function ss(e) {
  var t = is(e), r = t.values, n = t.numColors, a = t.tokenised, i = r.length;
  return function(o) {
    for (var s = a, l = 0; l < i; l++)
      s = s.replace(l < n ? ns : as, l < n ? Be.transform(o[l]) : wr(o[l]));
    return s;
  };
}
var dc = function(e) {
  return typeof e == "number" ? 0 : e;
};
function fc(e) {
  var t = os(e), r = ss(e);
  return r(t.map(dc));
}
var Lt = { test: cc, parse: os, createTransformer: ss, getAnimatableNone: fc }, pc = /* @__PURE__ */ new Set(["brightness", "contrast", "saturate", "opacity"]);
function vc(e) {
  var t = e.slice(0, -1).split("("), r = t[0], n = t[1];
  if (r === "drop-shadow")
    return e;
  var a = (n.match(Or) || [])[0];
  if (!a)
    return e;
  var i = n.replace(a, ""), o = pc.has(r) ? 1 : 0;
  return a !== n && (o *= 100), r + "(" + o + i + ")";
}
var mc = /([a-z-]*)\(.*?\)/g, wa = P(P({}, Lt), { getAnimatableNone: function(e) {
  var t = e.match(mc);
  return t ? t.map(vc).join(" ") : e;
} }), Ui = P(P({}, Wt), { transform: Math.round }), us = {
  borderWidth: oe,
  borderTopWidth: oe,
  borderRightWidth: oe,
  borderBottomWidth: oe,
  borderLeftWidth: oe,
  borderRadius: oe,
  radius: oe,
  borderTopLeftRadius: oe,
  borderTopRightRadius: oe,
  borderBottomRightRadius: oe,
  borderBottomLeftRadius: oe,
  width: oe,
  maxWidth: oe,
  height: oe,
  maxHeight: oe,
  size: oe,
  top: oe,
  right: oe,
  bottom: oe,
  left: oe,
  padding: oe,
  paddingTop: oe,
  paddingRight: oe,
  paddingBottom: oe,
  paddingLeft: oe,
  margin: oe,
  marginTop: oe,
  marginRight: oe,
  marginBottom: oe,
  marginLeft: oe,
  rotate: Rt,
  rotateX: Rt,
  rotateY: Rt,
  rotateZ: Rt,
  scale: rn,
  scaleX: rn,
  scaleY: rn,
  scaleZ: rn,
  skew: Rt,
  skewX: Rt,
  skewY: Rt,
  distance: oe,
  translateX: oe,
  translateY: oe,
  translateZ: oe,
  x: oe,
  y: oe,
  z: oe,
  perspective: oe,
  transformPerspective: oe,
  opacity: Lr,
  originX: Wi,
  originY: Wi,
  originZ: oe,
  zIndex: Ui,
  fillOpacity: Lr,
  strokeOpacity: Lr,
  numOctaves: Ui
};
function ai(e, t, r, n, a, i, o, s) {
  var l, d = e.style, c = e.vars, p = e.transform, v = e.transformKeys, m = e.transformOrigin;
  v.length = 0;
  var h = !1, C = !1, y = !0;
  for (var x in t) {
    var T = t[x];
    if (es(x)) {
      c[x] = T;
      continue;
    }
    var M = us[x], f = ac(T, M);
    if (Zn(x)) {
      if (h = !0, p[x] = f, v.push(x), !y)
        continue;
      T !== ((l = M.default) !== null && l !== void 0 ? l : 0) && (y = !1);
    } else if (J1(x))
      m[x] = f, C = !0;
    else if ((r == null ? void 0 : r.isHydrated) && (n == null ? void 0 : n.isHydrated) && xr[x]) {
      var b = xr[x].process(T, n, r), w = xr[x].applyTo;
      if (w)
        for (var V = w.length, S = 0; S < V; S++)
          d[w[S]] = b;
      else
        d[x] = b;
    } else
      d[x] = f;
  }
  n && r && o && s ? (d.transform = o(n.deltaFinal, n.treeScale, h ? p : void 0), i && (d.transform = i(p, d.transform)), d.transformOrigin = s(n)) : (h && (d.transform = rc(e, a, y, i)), C && (d.transformOrigin = nc(m)));
}
var ii = function() {
  return {
    style: {},
    transform: {},
    transformKeys: [],
    transformOrigin: {},
    vars: {}
  };
};
function ls(e, t, r) {
  for (var n in t)
    !St(t[n]) && !Q1(n, r) && (e[n] = t[n]);
}
function hc(e, t, r) {
  var n = e.transformTemplate;
  return Pr(function() {
    var a = ii();
    ai(a, t, void 0, void 0, { enableHardwareAcceleration: !r }, n);
    var i = a.vars, o = a.style;
    return P(P({}, i), o);
  }, [t]);
}
function gc(e, t, r) {
  var n = e.style || {}, a = {};
  return ls(a, n, e), Object.assign(a, hc(e, t, r)), e.transformValues && (a = e.transformValues(a)), a;
}
function yc(e, t, r) {
  var n = {}, a = gc(e, t, r);
  return Boolean(e.drag) && (n.draggable = !1, a.userSelect = a.WebkitUserSelect = a.WebkitTouchCallout = "none", a.touchAction = e.drag === !0 ? "none" : "pan-" + (e.drag === "x" ? "y" : "x")), n.style = a, n;
}
var Cc = /* @__PURE__ */ new Set([
  "initial",
  "animate",
  "exit",
  "style",
  "variants",
  "transition",
  "transformTemplate",
  "transformValues",
  "custom",
  "inherit",
  "layout",
  "layoutId",
  "_layoutResetTransform",
  "onLayoutAnimationComplete",
  "onViewportBoxUpdate",
  "onLayoutMeasure",
  "onBeforeLayoutMeasure",
  "onAnimationStart",
  "onAnimationComplete",
  "onUpdate",
  "onDragStart",
  "onDrag",
  "onDragEnd",
  "onMeasureDragConstraints",
  "onDirectionLock",
  "onDragTransitionEnd",
  "drag",
  "dragControls",
  "dragListener",
  "dragConstraints",
  "dragDirectionLock",
  "_dragX",
  "_dragY",
  "dragElastic",
  "dragMomentum",
  "dragPropagation",
  "dragTransition",
  "whileDrag",
  "onPan",
  "onPanStart",
  "onPanEnd",
  "onPanSessionStart",
  "onTap",
  "onTapStart",
  "onTapCancel",
  "onHoverStart",
  "onHoverEnd",
  "whileFocus",
  "whileTap",
  "whileHover"
]);
function wn(e) {
  return Cc.has(e);
}
var cs = function(e) {
  return !wn(e);
};
try {
  var bc = require("@emotion/is-prop-valid").default;
  cs = function(e) {
    return e.startsWith("on") ? !wn(e) : bc(e);
  };
} catch {
}
function xc(e, t, r) {
  var n = {};
  for (var a in e)
    (cs(a) || r === !0 && wn(a) || !t && !wn(a)) && (n[a] = e[a]);
  return n;
}
function zi(e, t, r) {
  return typeof e == "string" ? e : oe.transform(t + r * e);
}
function wc(e, t, r) {
  var n = zi(t, e.x, e.width), a = zi(r, e.y, e.height);
  return n + " " + a;
}
var aa = function(e, t) {
  return oe.transform(e * t);
}, Lc = {
  offset: "stroke-dashoffset",
  array: "stroke-dasharray"
}, Tc = {
  offset: "strokeDashoffset",
  array: "strokeDasharray"
};
function Mc(e, t, r, n, a, i) {
  n === void 0 && (n = 1), a === void 0 && (a = 0), i === void 0 && (i = !0);
  var o = i ? Lc : Tc;
  e[o.offset] = aa(-a, t);
  var s = aa(r, t), l = aa(n, t);
  e[o.array] = s + " " + l;
}
function oi(e, t, r, n, a, i, o, s) {
  var l = t.attrX, d = t.attrY, c = t.originX, p = t.originY, v = t.pathLength, m = t.pathSpacing, h = m === void 0 ? 1 : m, C = t.pathOffset, y = C === void 0 ? 0 : C, x = nt(t, ["attrX", "attrY", "originX", "originY", "pathLength", "pathSpacing", "pathOffset"]);
  ai(e, x, r, n, a, i, o, s), e.attrs = e.style, e.style = {};
  var T = e.attrs, M = e.style, f = e.dimensions, b = e.totalPathLength;
  T.transform && (f && (M.transform = T.transform), delete T.transform), f && (c !== void 0 || p !== void 0 || M.transform) && (M.transformOrigin = wc(f, c !== void 0 ? c : 0.5, p !== void 0 ? p : 0.5)), l !== void 0 && (T.x = l), d !== void 0 && (T.y = d), b !== void 0 && v !== void 0 && Mc(T, b, v, h, y, !1);
}
var ds = function() {
  return P(P({}, ii()), { attrs: {} });
};
function Ac(e, t) {
  var r = Pr(function() {
    var a = ds();
    return oi(a, t, void 0, void 0, { enableHardwareAcceleration: !1 }, e.transformTemplate), P(P({}, a.attrs), { style: P({}, a.style) });
  }, [t]);
  if (e.style) {
    var n = {};
    ls(n, e.style, e), r.style = P(P({}, n), r.style);
  }
  return r;
}
function Rc(e) {
  e === void 0 && (e = !1);
  var t = function(r, n, a, i, o) {
    var s = i.latestValues, l = ri(r) ? Ac : yc, d = l(n, s, o), c = xc(n, typeof r == "string", e), p = P(P(P({}, c), d), { ref: a });
    return Z1(r, p);
  };
  return t;
}
var Sc = /([a-z])([A-Z])/g, Pc = "$1-$2", fs = function(e) {
  return e.replace(Sc, Pc).toLowerCase();
};
function ps(e, t) {
  var r = t.style, n = t.vars;
  Object.assign(e.style, r);
  for (var a in n)
    e.style.setProperty(a, n[a]);
}
var vs = /* @__PURE__ */ new Set([
  "baseFrequency",
  "diffuseConstant",
  "kernelMatrix",
  "kernelUnitLength",
  "keySplines",
  "keyTimes",
  "limitingConeAngle",
  "markerHeight",
  "markerWidth",
  "numOctaves",
  "targetX",
  "targetY",
  "surfaceScale",
  "specularConstant",
  "specularExponent",
  "stdDeviation",
  "tableValues",
  "viewBox",
  "gradientTransform"
]);
function ms(e, t) {
  ps(e, t);
  for (var r in t.attrs)
    e.setAttribute(vs.has(r) ? r : fs(r), t.attrs[r]);
}
function si(e) {
  var t = e.style, r = {};
  for (var n in t)
    (St(t[n]) || Q1(n, e)) && (r[n] = t[n]);
  return r;
}
function hs(e) {
  var t = si(e);
  for (var r in e)
    if (St(e[r])) {
      var n = r === "x" || r === "y" ? "attr" + r.toUpperCase() : r;
      t[n] = e[r];
    }
  return t;
}
function ui(e) {
  return typeof e == "object" && typeof e.start == "function";
}
var _r = function(e) {
  return Array.isArray(e);
}, Ec = function(e) {
  return Boolean(e && typeof e == "object" && e.mix && e.toValue);
}, kc = function(e) {
  return _r(e) ? e[e.length - 1] || 0 : e;
};
function Oc(e) {
  var t = St(e) ? e.get() : e;
  return Ec(t) ? t.toValue() : t;
}
function Yi(e, t, r, n) {
  var a = e.scrapeMotionValuesFromProps, i = e.createRenderState, o = e.onMount, s = {
    latestValues: _c(t, r, n, a),
    renderState: i()
  };
  return o && (s.mount = function(l) {
    return o(t, l, s);
  }), s;
}
var gs = function(e) {
  return function(t, r) {
    var n = Oe(Nn), a = Oe(Wr);
    return r ? Yi(e, t, n, a) : Er(function() {
      return Yi(e, t, n, a);
    });
  };
};
function _c(e, t, r, n) {
  var a = {}, i = (r == null ? void 0 : r.initial) === !1, o = n(e);
  for (var s in o)
    a[s] = Oc(o[s]);
  var l = e.initial, d = e.animate, c = $n(e), p = G1(e);
  t && p && !c && e.inherit !== !1 && (l != null || (l = t.initial), d != null || (d = t.animate));
  var v = i || l === !1 ? d : l;
  if (v && typeof v != "boolean" && !ui(v)) {
    var m = Array.isArray(v) ? v : [v];
    m.forEach(function(h) {
      var C = X1(e, h);
      if (!!C) {
        var y = C.transitionEnd;
        C.transition;
        var x = nt(C, ["transitionEnd", "transition"]);
        for (var T in x)
          a[T] = x[T];
        for (var T in y)
          a[T] = y[T];
      }
    });
  }
  return a;
}
var Vc = {
  useVisualState: gs({
    scrapeMotionValuesFromProps: hs,
    createRenderState: ds,
    onMount: function(e, t, r) {
      var n = r.renderState, a = r.latestValues;
      try {
        n.dimensions = typeof t.getBBox == "function" ? t.getBBox() : t.getBoundingClientRect();
      } catch {
        n.dimensions = {
          x: 0,
          y: 0,
          width: 0,
          height: 0
        };
      }
      Hc(t) && (n.totalPathLength = t.getTotalLength()), oi(n, a, void 0, void 0, { enableHardwareAcceleration: !1 }, e.transformTemplate), ms(t, n);
    }
  })
};
function Hc(e) {
  return e.tagName === "path";
}
var Dc = {
  useVisualState: gs({
    scrapeMotionValuesFromProps: si,
    createRenderState: ii
  })
};
function jc(e, t, r, n) {
  var a = t.forwardMotionProps, i = a === void 0 ? !1 : a, o = ri(e) ? Vc : Dc;
  return P(P({}, o), {
    preloadedFeatures: r,
    useRender: Rc(i),
    createVisualElement: n,
    Component: e
  });
}
var Pe;
(function(e) {
  e.Animate = "animate", e.Hover = "whileHover", e.Tap = "whileTap", e.Drag = "whileDrag", e.Focus = "whileFocus", e.Exit = "exit";
})(Pe || (Pe = {}));
function li(e, t, r, n) {
  return e.addEventListener(t, r, n), function() {
    return e.removeEventListener(t, r, n);
  };
}
function La(e, t, r, n) {
  _e(function() {
    var a = e.current;
    if (r && a)
      return li(a, t, r, n);
  }, [e, t, r, n]);
}
function Ic(e) {
  var t = e.whileFocus, r = e.visualElement, n = function() {
    var i;
    (i = r.animationState) === null || i === void 0 || i.setActive(Pe.Focus, !0);
  }, a = function() {
    var i;
    (i = r.animationState) === null || i === void 0 || i.setActive(Pe.Focus, !1);
  };
  La(r, "focus", t ? n : void 0), La(r, "blur", t ? a : void 0);
}
function ys(e) {
  return typeof PointerEvent < "u" && e instanceof PointerEvent ? e.pointerType === "mouse" : e instanceof MouseEvent;
}
function Cs(e) {
  var t = !!e.touches;
  return t;
}
function Nc(e) {
  return function(t) {
    var r = t instanceof MouseEvent, n = !r || r && t.button === 0;
    n && e(t);
  };
}
var Bc = { pageX: 0, pageY: 0 };
function $c(e, t) {
  t === void 0 && (t = "page");
  var r = e.touches[0] || e.changedTouches[0], n = r || Bc;
  return {
    x: n[t + "X"],
    y: n[t + "Y"]
  };
}
function Zc(e, t) {
  return t === void 0 && (t = "page"), {
    x: e[t + "X"],
    y: e[t + "Y"]
  };
}
function ci(e, t) {
  return t === void 0 && (t = "page"), {
    point: Cs(e) ? $c(e, t) : Zc(e, t)
  };
}
function Fc(e) {
  return ci(e, "client");
}
var bs = function(e, t) {
  t === void 0 && (t = !1);
  var r = function(n) {
    return e(n, ci(n));
  };
  return t ? Nc(r) : r;
}, Wc = function() {
  return Ur && window.onpointerdown === null;
}, Uc = function() {
  return Ur && window.ontouchstart === null;
}, zc = function() {
  return Ur && window.onmousedown === null;
}, Yc = {
  pointerdown: "mousedown",
  pointermove: "mousemove",
  pointerup: "mouseup",
  pointercancel: "mousecancel",
  pointerover: "mouseover",
  pointerout: "mouseout",
  pointerenter: "mouseenter",
  pointerleave: "mouseleave"
}, qc = {
  pointerdown: "touchstart",
  pointermove: "touchmove",
  pointerup: "touchend",
  pointercancel: "touchcancel"
};
function xs(e) {
  return Wc() ? e : Uc() ? qc[e] : zc() ? Yc[e] : e;
}
function ar(e, t, r, n) {
  return li(e, xs(t), bs(r, t === "pointerdown"), n);
}
function Ln(e, t, r, n) {
  return La(e, xs(t), r && bs(r, t === "pointerdown"), n);
}
function ws(e) {
  var t = null;
  return function() {
    var r = function() {
      t = null;
    };
    return t === null ? (t = e, r) : !1;
  };
}
var qi = ws("dragHorizontal"), Ki = ws("dragVertical");
function Ls(e) {
  var t = !1;
  if (e === "y")
    t = Ki();
  else if (e === "x")
    t = qi();
  else {
    var r = qi(), n = Ki();
    r && n ? t = function() {
      r(), n();
    } : (r && r(), n && n());
  }
  return t;
}
function Ts() {
  var e = Ls(!0);
  return e ? (e(), !1) : !0;
}
function Xi(e, t, r) {
  return function(n, a) {
    var i;
    !ys(n) || Ts() || (r == null || r(n, a), (i = e.animationState) === null || i === void 0 || i.setActive(Pe.Hover, t));
  };
}
function Kc(e) {
  var t = e.onHoverStart, r = e.onHoverEnd, n = e.whileHover, a = e.visualElement;
  Ln(a, "pointerenter", t || n ? Xi(a, !0, t) : void 0), Ln(a, "pointerleave", r || n ? Xi(a, !1, r) : void 0);
}
var Ms = function(e, t) {
  return t ? e === t ? !0 : Ms(e, t.parentElement) : !1;
};
function di(e) {
  return _e(function() {
    return function() {
      return e();
    };
  }, []);
}
var Tn = function(e, t, r) {
  return Math.min(Math.max(r, e), t);
}, ia = 1e-3, Xc = 0.01, Gi = 10, Gc = 0.05, Jc = 1;
function Qc(e) {
  var t = e.duration, r = t === void 0 ? 800 : t, n = e.bounce, a = n === void 0 ? 0.25 : n, i = e.velocity, o = i === void 0 ? 0 : i, s = e.mass, l = s === void 0 ? 1 : s, d, c;
  Dn(r <= Gi * 1e3, "Spring duration must be 10 seconds or less");
  var p = 1 - a;
  p = Tn(Gc, Jc, p), r = Tn(Xc, Gi, r / 1e3), p < 1 ? (d = function(C) {
    var y = C * p, x = y * r, T = y - o, M = Ta(C, p), f = Math.exp(-x);
    return ia - T / M * f;
  }, c = function(C) {
    var y = C * p, x = y * r, T = x * o + o, M = Math.pow(p, 2) * Math.pow(C, 2) * r, f = Math.exp(-x), b = Ta(Math.pow(C, 2), p), w = -d(C) + ia > 0 ? -1 : 1;
    return w * ((T - M) * f) / b;
  }) : (d = function(C) {
    var y = Math.exp(-C * r), x = (C - o) * r + 1;
    return -ia + y * x;
  }, c = function(C) {
    var y = Math.exp(-C * r), x = (o - C) * (r * r);
    return y * x;
  });
  var v = 5 / r, m = td(d, c, v);
  if (r = r * 1e3, isNaN(m))
    return {
      stiffness: 100,
      damping: 10,
      duration: r
    };
  var h = Math.pow(m, 2) * l;
  return {
    stiffness: h,
    damping: p * 2 * Math.sqrt(l * h),
    duration: r
  };
}
var ed = 12;
function td(e, t, r) {
  for (var n = r, a = 1; a < ed; a++)
    n = n - e(n) / t(n);
  return n;
}
function Ta(e, t) {
  return e * Math.sqrt(1 - t * t);
}
var rd = ["duration", "bounce"], nd = ["stiffness", "damping", "mass"];
function Ji(e, t) {
  return t.some(function(r) {
    return e[r] !== void 0;
  });
}
function ad(e) {
  var t = P({ velocity: 0, stiffness: 100, damping: 10, mass: 1, isResolvedFromDuration: !1 }, e);
  if (!Ji(e, nd) && Ji(e, rd)) {
    var r = Qc(e);
    t = P(P(P({}, t), r), { velocity: 0, mass: 1 }), t.isResolvedFromDuration = !0;
  }
  return t;
}
function fi(e) {
  var t = e.from, r = t === void 0 ? 0 : t, n = e.to, a = n === void 0 ? 1 : n, i = e.restSpeed, o = i === void 0 ? 2 : i, s = e.restDelta, l = nt(e, ["from", "to", "restSpeed", "restDelta"]), d = { done: !1, value: r }, c = ad(l), p = c.stiffness, v = c.damping, m = c.mass, h = c.velocity, C = c.duration, y = c.isResolvedFromDuration, x = Qi, T = Qi;
  function M() {
    var f = h ? -(h / 1e3) : 0, b = a - r, w = v / (2 * Math.sqrt(p * m)), V = Math.sqrt(p / m) / 1e3;
    if (s != null || (s = Math.abs(a - r) <= 1 ? 0.01 : 0.4), w < 1) {
      var S = Ta(V, w);
      x = function(I) {
        var $ = Math.exp(-w * V * I);
        return a - $ * ((f + w * V * b) / S * Math.sin(S * I) + b * Math.cos(S * I));
      }, T = function(I) {
        var $ = Math.exp(-w * V * I);
        return w * V * $ * (Math.sin(S * I) * (f + w * V * b) / S + b * Math.cos(S * I)) - $ * (Math.cos(S * I) * (f + w * V * b) - S * b * Math.sin(S * I));
      };
    } else if (w === 1)
      x = function(I) {
        return a - Math.exp(-V * I) * (b + (f + V * b) * I);
      };
    else {
      var k = V * Math.sqrt(w * w - 1);
      x = function(I) {
        var $ = Math.exp(-w * V * I), X = Math.min(k * I, 300);
        return a - $ * ((f + w * V * b) * Math.sinh(X) + k * b * Math.cosh(X)) / k;
      };
    }
  }
  return M(), {
    next: function(f) {
      var b = x(f);
      if (y)
        d.done = f >= C;
      else {
        var w = T(f) * 1e3, V = Math.abs(w) <= o, S = Math.abs(a - b) <= s;
        d.done = V && S;
      }
      return d.value = d.done ? a : b, d;
    },
    flipTarget: function() {
      var f;
      h = -h, f = [a, r], r = f[0], a = f[1], M();
    }
  };
}
fi.needsInterpolation = function(e, t) {
  return typeof e == "string" || typeof t == "string";
};
var Qi = function(e) {
  return 0;
}, Vr = function(e, t, r) {
  var n = t - e;
  return n === 0 ? 1 : (r - e) / n;
}, Ge = function(e, t, r) {
  return -r * e + r * t + e;
}, id = function(e, t, r) {
  var n = e * e, a = t * t;
  return Math.sqrt(Math.max(0, r * (a - n) + n));
}, od = [xa, er, Qt], eo = function(e) {
  return od.find(function(t) {
    return t.test(e);
  });
}, to = function(e) {
  return "'" + e + "' is not an animatable color. Use the equivalent color code instead.";
}, As = function(e, t) {
  var r = eo(e), n = eo(t);
  Ye(!!r, to(e)), Ye(!!n, to(t)), Ye(r.transform === n.transform, "Both colors must be hex/RGBA, OR both must be HSLA.");
  var a = r.parse(e), i = n.parse(t), o = P({}, a), s = r === Qt ? Ge : id;
  return function(l) {
    for (var d in o)
      d !== "alpha" && (o[d] = s(a[d], i[d], l));
    return o.alpha = Ge(a.alpha, i.alpha, l), r.transform(o);
  };
}, Ma = function(e) {
  return typeof e == "number";
}, sd = function(e, t) {
  return function(r) {
    return t(e(r));
  };
}, qr = function() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  return e.reduce(sd);
};
function Rs(e, t) {
  return Ma(e) ? function(r) {
    return Ge(e, t, r);
  } : Be.test(e) ? As(e, t) : Ps(e, t);
}
var Ss = function(e, t) {
  var r = Fe([], e), n = r.length, a = e.map(function(i, o) {
    return Rs(i, t[o]);
  });
  return function(i) {
    for (var o = 0; o < n; o++)
      r[o] = a[o](i);
    return r;
  };
}, ud = function(e, t) {
  var r = P(P({}, e), t), n = {};
  for (var a in r)
    e[a] !== void 0 && t[a] !== void 0 && (n[a] = Rs(e[a], t[a]));
  return function(i) {
    for (var o in n)
      r[o] = n[o](i);
    return r;
  };
};
function ro(e) {
  for (var t = Lt.parse(e), r = t.length, n = 0, a = 0, i = 0, o = 0; o < r; o++)
    n || typeof t[o] == "number" ? n++ : t[o].hue !== void 0 ? i++ : a++;
  return { parsed: t, numNumbers: n, numRGB: a, numHSL: i };
}
var Ps = function(e, t) {
  var r = Lt.createTransformer(t), n = ro(e), a = ro(t);
  return Ye(n.numHSL === a.numHSL && n.numRGB === a.numRGB && n.numNumbers >= a.numNumbers, "Complex values '" + e + "' and '" + t + "' too different to mix. Ensure all colors are of the same type."), qr(Ss(n.parsed, a.parsed), r);
}, ld = function(e, t) {
  return function(r) {
    return Ge(e, t, r);
  };
};
function cd(e) {
  if (typeof e == "number")
    return ld;
  if (typeof e == "string")
    return Be.test(e) ? As : Ps;
  if (Array.isArray(e))
    return Ss;
  if (typeof e == "object")
    return ud;
}
function dd(e, t, r) {
  for (var n = [], a = r || cd(e[0]), i = e.length - 1, o = 0; o < i; o++) {
    var s = a(e[o], e[o + 1]);
    if (t) {
      var l = Array.isArray(t) ? t[o] : t;
      s = qr(l, s);
    }
    n.push(s);
  }
  return n;
}
function fd(e, t) {
  var r = e[0], n = e[1], a = t[0];
  return function(i) {
    return a(Vr(r, n, i));
  };
}
function pd(e, t) {
  var r = e.length, n = r - 1;
  return function(a) {
    var i = 0, o = !1;
    if (a <= e[0] ? o = !0 : a >= e[n] && (i = n - 1, o = !0), !o) {
      for (var s = 1; s < r && !(e[s] > a || s === n); s++)
        ;
      i = s - 1;
    }
    var l = Vr(e[i], e[i + 1], a);
    return t[i](l);
  };
}
function Es(e, t, r) {
  var n = r === void 0 ? {} : r, a = n.clamp, i = a === void 0 ? !0 : a, o = n.ease, s = n.mixer, l = e.length;
  Ye(l === t.length, "Both input and output ranges must be the same length"), Ye(!o || !Array.isArray(o) || o.length === l - 1, "Array of easing functions must be of length `input.length - 1`, as it applies to the transitions **between** the defined values."), e[0] > e[l - 1] && (e = [].concat(e), t = [].concat(t), e.reverse(), t.reverse());
  var d = dd(t, o, s), c = l === 2 ? fd(e, d) : pd(e, d);
  return i ? function(p) {
    return c(Tn(e[0], e[l - 1], p));
  } : c;
}
var Fn = function(e) {
  return function(t) {
    return 1 - e(1 - t);
  };
}, pi = function(e) {
  return function(t) {
    return t <= 0.5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2;
  };
}, vd = function(e) {
  return function(t) {
    return Math.pow(t, e);
  };
}, ks = function(e) {
  return function(t) {
    return t * t * ((e + 1) * t - e);
  };
}, md = function(e) {
  var t = ks(e);
  return function(r) {
    return (r *= 2) < 1 ? 0.5 * t(r) : 0.5 * (2 - Math.pow(2, -10 * (r - 1)));
  };
}, Os = 1.525, hd = 4 / 11, gd = 8 / 11, yd = 9 / 10, _s = function(e) {
  return e;
}, vi = vd(2), Cd = Fn(vi), Vs = pi(vi), Hs = function(e) {
  return 1 - Math.sin(Math.acos(e));
}, Ds = Fn(Hs), bd = pi(Ds), mi = ks(Os), xd = Fn(mi), wd = pi(mi), Ld = md(Os), Td = 4356 / 361, Md = 35442 / 1805, Ad = 16061 / 1805, Mn = function(e) {
  if (e === 1 || e === 0)
    return e;
  var t = e * e;
  return e < hd ? 7.5625 * t : e < gd ? 9.075 * t - 9.9 * e + 3.4 : e < yd ? Td * t - Md * e + Ad : 10.8 * e * e - 20.52 * e + 10.72;
}, Rd = Fn(Mn), Sd = function(e) {
  return e < 0.5 ? 0.5 * (1 - Mn(1 - e * 2)) : 0.5 * Mn(e * 2 - 1) + 0.5;
};
function Pd(e, t) {
  return e.map(function() {
    return t || Vs;
  }).splice(0, e.length - 1);
}
function Ed(e) {
  var t = e.length;
  return e.map(function(r, n) {
    return n !== 0 ? n / (t - 1) : 0;
  });
}
function kd(e, t) {
  return e.map(function(r) {
    return r * t;
  });
}
function hn(e) {
  var t = e.from, r = t === void 0 ? 0 : t, n = e.to, a = n === void 0 ? 1 : n, i = e.ease, o = e.offset, s = e.duration, l = s === void 0 ? 300 : s, d = { done: !1, value: r }, c = Array.isArray(a) ? a : [r, a], p = kd(o && o.length === c.length ? o : Ed(c), l);
  function v() {
    return Es(p, c, {
      ease: Array.isArray(i) ? i : Pd(c, i)
    });
  }
  var m = v();
  return {
    next: function(h) {
      return d.value = m(h), d.done = h >= l, d;
    },
    flipTarget: function() {
      c.reverse(), m = v();
    }
  };
}
function Od(e) {
  var t = e.velocity, r = t === void 0 ? 0 : t, n = e.from, a = n === void 0 ? 0 : n, i = e.power, o = i === void 0 ? 0.8 : i, s = e.timeConstant, l = s === void 0 ? 350 : s, d = e.restDelta, c = d === void 0 ? 0.5 : d, p = e.modifyTarget, v = { done: !1, value: a }, m = o * r, h = a + m, C = p === void 0 ? h : p(h);
  return C !== h && (m = C - a), {
    next: function(y) {
      var x = -m * Math.exp(-y / l);
      return v.done = !(x > c || x < -c), v.value = v.done ? C : C + x, v;
    },
    flipTarget: function() {
    }
  };
}
var no = { keyframes: hn, spring: fi, decay: Od };
function _d(e) {
  if (Array.isArray(e.to))
    return hn;
  if (no[e.type])
    return no[e.type];
  var t = new Set(Object.keys(e));
  return t.has("ease") || t.has("duration") && !t.has("dampingRatio") ? hn : t.has("dampingRatio") || t.has("stiffness") || t.has("mass") || t.has("damping") || t.has("restSpeed") || t.has("restDelta") ? fi : hn;
}
var js = 1 / 60 * 1e3, Vd = typeof performance < "u" ? function() {
  return performance.now();
} : function() {
  return Date.now();
}, Is = typeof window < "u" ? function(e) {
  return window.requestAnimationFrame(e);
} : function(e) {
  return setTimeout(function() {
    return e(Vd());
  }, js);
};
function Hd(e) {
  var t = [], r = [], n = 0, a = !1, i = /* @__PURE__ */ new WeakSet(), o = {
    schedule: function(s, l, d) {
      l === void 0 && (l = !1), d === void 0 && (d = !1);
      var c = d && a, p = c ? t : r;
      return l && i.add(s), p.indexOf(s) === -1 && (p.push(s), c && a && (n = t.length)), s;
    },
    cancel: function(s) {
      var l = r.indexOf(s);
      l !== -1 && r.splice(l, 1), i.delete(s);
    },
    process: function(s) {
      var l;
      if (a = !0, l = [r, t], t = l[0], r = l[1], r.length = 0, n = t.length, n)
        for (var d = 0; d < n; d++) {
          var c = t[d];
          c(s), i.has(c) && (o.schedule(c), e());
        }
      a = !1;
    }
  };
  return o;
}
var Dd = 40, Aa = !0, Hr = !1, Ra = !1, ir = {
  delta: 0,
  timestamp: 0
}, Kr = ["read", "update", "preRender", "render", "postRender"], Wn = /* @__PURE__ */ Kr.reduce(function(e, t) {
  return e[t] = Hd(function() {
    return Hr = !0;
  }), e;
}, {}), mt = /* @__PURE__ */ Kr.reduce(function(e, t) {
  var r = Wn[t];
  return e[t] = function(n, a, i) {
    return a === void 0 && (a = !1), i === void 0 && (i = !1), Hr || Id(), r.schedule(n, a, i);
  }, e;
}, {}), Tr = /* @__PURE__ */ Kr.reduce(function(e, t) {
  return e[t] = Wn[t].cancel, e;
}, {}), tr = /* @__PURE__ */ Kr.reduce(function(e, t) {
  return e[t] = function() {
    return Wn[t].process(ir);
  }, e;
}, {}), jd = function(e) {
  return Wn[e].process(ir);
}, Ns = function(e) {
  Hr = !1, ir.delta = Aa ? js : Math.max(Math.min(e - ir.timestamp, Dd), 1), ir.timestamp = e, Ra = !0, Kr.forEach(jd), Ra = !1, Hr && (Aa = !1, Is(Ns));
}, Id = function() {
  Hr = !0, Aa = !0, Ra || Is(Ns);
}, An = function() {
  return ir;
};
function Bs(e, t, r) {
  return r === void 0 && (r = 0), e - t - r;
}
function Nd(e, t, r, n) {
  return r === void 0 && (r = 0), n === void 0 && (n = !0), n ? Bs(t + -e, t, r) : t - (e - t) + r;
}
function Bd(e, t, r, n) {
  return n ? e >= t + r : e <= -r;
}
var $d = function(e) {
  var t = function(r) {
    var n = r.delta;
    return e(n);
  };
  return {
    start: function() {
      return mt.update(t, !0);
    },
    stop: function() {
      return Tr.update(t);
    }
  };
};
function $s(e) {
  var t, r, n = e.from, a = e.autoplay, i = a === void 0 ? !0 : a, o = e.driver, s = o === void 0 ? $d : o, l = e.elapsed, d = l === void 0 ? 0 : l, c = e.repeat, p = c === void 0 ? 0 : c, v = e.repeatType, m = v === void 0 ? "loop" : v, h = e.repeatDelay, C = h === void 0 ? 0 : h, y = e.onPlay, x = e.onStop, T = e.onComplete, M = e.onRepeat, f = e.onUpdate, b = nt(e, ["from", "autoplay", "driver", "elapsed", "repeat", "repeatType", "repeatDelay", "onPlay", "onStop", "onComplete", "onRepeat", "onUpdate"]), w = b.to, V, S = 0, k = b.duration, I, $ = !1, X = !0, G, F = _d(b);
  !((r = (t = F).needsInterpolation) === null || r === void 0) && r.call(t, n, w) && (G = Es([0, 100], [n, w], {
    clamp: !1
  }), n = 0, w = 100);
  var z = F(P(P({}, b), { from: n, to: w }));
  function J() {
    S++, m === "reverse" ? (X = S % 2 === 0, d = Nd(d, k, C, X)) : (d = Bs(d, k, C), m === "mirror" && z.flipTarget()), $ = !1, M && M();
  }
  function se() {
    V.stop(), T && T();
  }
  function ee(le) {
    if (X || (le = -le), d += le, !$) {
      var ve = z.next(Math.max(0, d));
      I = ve.value, G && (I = G(I)), $ = X ? ve.done : d <= 0;
    }
    f == null || f(I), $ && (S === 0 && (k != null || (k = d)), S < p ? Bd(d, k, C, X) && J() : se());
  }
  function pe() {
    y == null || y(), V = s(ee), V.start();
  }
  return i && pe(), {
    stop: function() {
      x == null || x(), V.stop();
    }
  };
}
function Zs(e, t) {
  return t ? e * (1e3 / t) : 0;
}
function Zd(e) {
  var t = e.from, r = t === void 0 ? 0 : t, n = e.velocity, a = n === void 0 ? 0 : n, i = e.min, o = e.max, s = e.power, l = s === void 0 ? 0.8 : s, d = e.timeConstant, c = d === void 0 ? 750 : d, p = e.bounceStiffness, v = p === void 0 ? 500 : p, m = e.bounceDamping, h = m === void 0 ? 10 : m, C = e.restDelta, y = C === void 0 ? 1 : C, x = e.modifyTarget, T = e.driver, M = e.onUpdate, f = e.onComplete, b;
  function w(J) {
    return i !== void 0 && J < i || o !== void 0 && J > o;
  }
  function V(J) {
    return i === void 0 ? o : o === void 0 || Math.abs(i - J) < Math.abs(o - J) ? i : o;
  }
  function S(J) {
    b == null || b.stop(), b = $s(P(P({}, J), { driver: T, onUpdate: function(se) {
      var ee;
      M == null || M(se), (ee = J.onUpdate) === null || ee === void 0 || ee.call(J, se);
    }, onComplete: f }));
  }
  function k(J) {
    S(P({ type: "spring", stiffness: v, damping: h, restDelta: y }, J));
  }
  if (w(r))
    k({ from: r, velocity: a, to: V(r) });
  else {
    var I = l * a + r;
    typeof x < "u" && (I = x(I));
    var $ = V(I), X = $ === i ? -1 : 1, G, F, z = function(J) {
      G = F, F = J, a = Zs(J - G, An().delta), (X === 1 && J > $ || X === -1 && J < $) && k({ from: J, to: $, velocity: a });
    };
    S({
      type: "decay",
      from: r,
      velocity: a,
      timeConstant: c,
      power: l,
      restDelta: y,
      modifyTarget: x,
      onUpdate: w(I) ? z : void 0
    });
  }
  return {
    stop: function() {
      return b == null ? void 0 : b.stop();
    }
  };
}
var Sa = function(e) {
  return e.hasOwnProperty("x") && e.hasOwnProperty("y");
}, ao = function(e) {
  return Sa(e) && e.hasOwnProperty("z");
}, nn = function(e, t) {
  return Math.abs(e - t);
};
function Fs(e, t) {
  if (Ma(e) && Ma(t))
    return nn(e, t);
  if (Sa(e) && Sa(t)) {
    var r = nn(e.x, t.x), n = nn(e.y, t.y), a = ao(e) && ao(t) ? nn(e.z, t.z) : 0;
    return Math.sqrt(Math.pow(r, 2) + Math.pow(n, 2) + Math.pow(a, 2));
  }
}
var Ws = function(e, t) {
  return 1 - 3 * t + 3 * e;
}, Us = function(e, t) {
  return 3 * t - 6 * e;
}, zs = function(e) {
  return 3 * e;
}, Rn = function(e, t, r) {
  return ((Ws(t, r) * e + Us(t, r)) * e + zs(t)) * e;
}, Ys = function(e, t, r) {
  return 3 * Ws(t, r) * e * e + 2 * Us(t, r) * e + zs(t);
}, Fd = 1e-7, Wd = 10;
function Ud(e, t, r, n, a) {
  var i, o, s = 0;
  do
    o = t + (r - t) / 2, i = Rn(o, n, a) - e, i > 0 ? r = o : t = o;
  while (Math.abs(i) > Fd && ++s < Wd);
  return o;
}
var zd = 8, Yd = 1e-3;
function qd(e, t, r, n) {
  for (var a = 0; a < zd; ++a) {
    var i = Ys(t, r, n);
    if (i === 0)
      return t;
    var o = Rn(t, r, n) - e;
    t -= o / i;
  }
  return t;
}
var gn = 11, an = 1 / (gn - 1);
function Kd(e, t, r, n) {
  if (e === t && r === n)
    return _s;
  for (var a = new Float32Array(gn), i = 0; i < gn; ++i)
    a[i] = Rn(i * an, e, r);
  function o(s) {
    for (var l = 0, d = 1, c = gn - 1; d !== c && a[d] <= s; ++d)
      l += an;
    --d;
    var p = (s - a[d]) / (a[d + 1] - a[d]), v = l + p * an, m = Ys(v, e, r);
    return m >= Yd ? qd(s, v, e, r) : m === 0 ? v : Ud(s, l, l + an, e, r);
  }
  return function(s) {
    return s === 0 || s === 1 ? s : Rn(o(s), t, n);
  };
}
function Xd(e) {
  var t = e.onTap, r = e.onTapStart, n = e.onTapCancel, a = e.whileTap, i = e.visualElement, o = t || r || n || a, s = Qe(!1), l = Qe(null);
  function d() {
    var h;
    (h = l.current) === null || h === void 0 || h.call(l), l.current = null;
  }
  function c() {
    var h;
    return d(), s.current = !1, (h = i.animationState) === null || h === void 0 || h.setActive(Pe.Tap, !1), !Ts();
  }
  function p(h, C) {
    !c() || (Ms(i.getInstance(), h.target) ? t == null || t(h, C) : n == null || n(h, C));
  }
  function v(h, C) {
    !c() || n == null || n(h, C);
  }
  function m(h, C) {
    var y;
    d(), !s.current && (s.current = !0, l.current = qr(ar(window, "pointerup", p), ar(window, "pointercancel", v)), r == null || r(h, C), (y = i.animationState) === null || y === void 0 || y.setActive(Pe.Tap, !0));
  }
  Ln(i, "pointerdown", o ? m : void 0), di(d);
}
var jt = function(e) {
  return function(t) {
    return e(t), null;
  };
}, Gd = {
  tap: jt(Xd),
  focus: jt(Ic),
  hover: jt(Kc)
};
function qs(e, t) {
  if (!Array.isArray(t))
    return !1;
  var r = t.length;
  if (r !== e.length)
    return !1;
  for (var n = 0; n < r; n++)
    if (t[n] !== e[n])
      return !1;
  return !0;
}
var Sn = function(e) {
  return e * 1e3;
}, io = {
  linear: _s,
  easeIn: vi,
  easeInOut: Vs,
  easeOut: Cd,
  circIn: Hs,
  circInOut: bd,
  circOut: Ds,
  backIn: mi,
  backInOut: wd,
  backOut: xd,
  anticipate: Ld,
  bounceIn: Rd,
  bounceInOut: Sd,
  bounceOut: Mn
}, oo = function(e) {
  if (Array.isArray(e)) {
    Ye(e.length === 4, "Cubic bezier arrays must contain four numerical values.");
    var t = Re(e, 4), r = t[0], n = t[1], a = t[2], i = t[3];
    return Kd(r, n, a, i);
  } else if (typeof e == "string")
    return Ye(io[e] !== void 0, "Invalid easing type '" + e + "'"), io[e];
  return e;
}, Jd = function(e) {
  return Array.isArray(e) && typeof e[0] != "number";
}, so = function(e, t) {
  return e === "zIndex" ? !1 : !!(typeof t == "number" || Array.isArray(t) || typeof t == "string" && Lt.test(t) && !t.startsWith("url("));
}, Ot = function() {
  return {
    type: "spring",
    stiffness: 500,
    damping: 25,
    restDelta: 0.5,
    restSpeed: 10
  };
}, on = function(e) {
  return {
    type: "spring",
    stiffness: 550,
    damping: e === 0 ? 2 * Math.sqrt(550) : 30,
    restDelta: 0.01,
    restSpeed: 10
  };
}, oa = function() {
  return {
    type: "keyframes",
    ease: "linear",
    duration: 0.3
  };
}, Qd = function(e) {
  return {
    type: "keyframes",
    duration: 0.8,
    values: e
  };
}, uo = {
  x: Ot,
  y: Ot,
  z: Ot,
  rotate: Ot,
  rotateX: Ot,
  rotateY: Ot,
  rotateZ: Ot,
  scaleX: on,
  scaleY: on,
  scale: on,
  opacity: oa,
  backgroundColor: oa,
  color: oa,
  default: on
}, ef = function(e, t) {
  var r;
  return _r(t) ? r = Qd : r = uo[e] || uo.default, P({ to: t }, r(t));
}, tf = P(P({}, us), {
  color: Be,
  backgroundColor: Be,
  outlineColor: Be,
  fill: Be,
  stroke: Be,
  borderColor: Be,
  borderTopColor: Be,
  borderRightColor: Be,
  borderBottomColor: Be,
  borderLeftColor: Be,
  filter: wa,
  WebkitFilter: wa
}), hi = function(e) {
  return tf[e];
};
function gi(e, t) {
  var r, n = hi(e);
  return n !== wa && (n = Lt), (r = n.getAnimatableNone) === null || r === void 0 ? void 0 : r.call(n, t);
}
function rf(e) {
  e.when, e.delay, e.delayChildren, e.staggerChildren, e.staggerDirection, e.repeat, e.repeatType, e.repeatDelay, e.from;
  var t = nt(e, ["when", "delay", "delayChildren", "staggerChildren", "staggerDirection", "repeat", "repeatType", "repeatDelay", "from"]);
  return !!Object.keys(t).length;
}
var lo = !1;
function nf(e) {
  var t = e.ease, r = e.times, n = e.yoyo, a = e.flip, i = e.loop, o = nt(e, ["ease", "times", "yoyo", "flip", "loop"]), s = P({}, o);
  return r && (s.offset = r), o.duration && (s.duration = Sn(o.duration)), o.repeatDelay && (s.repeatDelay = Sn(o.repeatDelay)), t && (s.ease = Jd(t) ? t.map(oo) : oo(t)), o.type === "tween" && (s.type = "keyframes"), (n || i || a) && (Dn(!lo, "yoyo, loop and flip have been removed from the API. Replace with repeat and repeatType options."), lo = !0, n ? s.repeatType = "reverse" : i ? s.repeatType = "loop" : a && (s.repeatType = "mirror"), s.repeat = i || n || a || o.repeat), o.type !== "spring" && (s.type = "keyframes"), s;
}
function af(e, t) {
  var r, n = yi(e, t) || {};
  return (r = n.delay) !== null && r !== void 0 ? r : 0;
}
function of(e) {
  return Array.isArray(e.to) && e.to[0] === null && (e.to = Fe([], Re(e.to)), e.to[0] = e.from), e;
}
function sf(e, t, r) {
  var n;
  return Array.isArray(t.to) && ((n = e.duration) !== null && n !== void 0 || (e.duration = 0.8)), of(t), rf(e) || (e = P(P({}, e), ef(r, t.to))), P(P({}, t), nf(e));
}
function uf(e, t, r, n, a) {
  var i, o = yi(n, e), s = (i = o.from) !== null && i !== void 0 ? i : t.get(), l = so(e, r);
  s === "none" && l && typeof r == "string" ? s = gi(e, r) : co(s) && typeof r == "string" ? s = fo(r) : !Array.isArray(r) && co(r) && typeof s == "string" && (r = fo(s));
  var d = so(e, s);
  Dn(d === l, "You are trying to animate " + e + ' from "' + s + '" to "' + r + '". ' + s + " is not an animatable value - to enable this animation set " + s + " to a value animatable to " + r + " via the `style` property.");
  function c() {
    var v = {
      from: s,
      to: r,
      velocity: t.getVelocity(),
      onComplete: a,
      onUpdate: function(m) {
        return t.set(m);
      }
    };
    return o.type === "inertia" || o.type === "decay" ? Zd(P(P({}, v), o)) : $s(P(P({}, sf(o, v, e)), { onUpdate: function(m) {
      var h;
      v.onUpdate(m), (h = o.onUpdate) === null || h === void 0 || h.call(o, m);
    }, onComplete: function() {
      var m;
      v.onComplete(), (m = o.onComplete) === null || m === void 0 || m.call(o);
    } }));
  }
  function p() {
    var v;
    return t.set(r), a(), (v = o == null ? void 0 : o.onComplete) === null || v === void 0 || v.call(o), { stop: function() {
    } };
  }
  return !d || !l || o.type === !1 ? p : c;
}
function co(e) {
  return e === 0 || typeof e == "string" && parseFloat(e) === 0 && e.indexOf(" ") === -1;
}
function fo(e) {
  return typeof e == "number" ? 0 : gi("", e);
}
function yi(e, t) {
  return e[t] || e.default || e;
}
function Pn(e, t, r, n) {
  return n === void 0 && (n = {}), t.start(function(a) {
    var i, o, s = uf(e, t, r, n, a), l = af(n, e), d = function() {
      return o = s();
    };
    return l ? i = setTimeout(d, Sn(l)) : d(), function() {
      clearTimeout(i), o == null || o.stop();
    };
  });
}
var lf = function(e) {
  return /^\-?\d*\.?\d+$/.test(e);
};
function Ks(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function Xs(e, t) {
  var r = e.indexOf(t);
  r > -1 && e.splice(r, 1);
}
var yn = function() {
  function e() {
    this.subscriptions = [];
  }
  return e.prototype.add = function(t) {
    var r = this;
    return Ks(this.subscriptions, t), function() {
      return Xs(r.subscriptions, t);
    };
  }, e.prototype.notify = function(t, r, n) {
    var a = this.subscriptions.length;
    if (!!a)
      if (a === 1)
        this.subscriptions[0](t, r, n);
      else
        for (var i = 0; i < a; i++) {
          var o = this.subscriptions[i];
          o && o(t, r, n);
        }
  }, e.prototype.getSize = function() {
    return this.subscriptions.length;
  }, e.prototype.clear = function() {
    this.subscriptions.length = 0;
  }, e;
}(), cf = function(e) {
  return !isNaN(parseFloat(e));
}, df = function() {
  function e(t) {
    var r = this;
    this.timeDelta = 0, this.lastUpdated = 0, this.updateSubscribers = new yn(), this.velocityUpdateSubscribers = new yn(), this.renderSubscribers = new yn(), this.canTrackVelocity = !1, this.updateAndNotify = function(n, a) {
      a === void 0 && (a = !0), r.prev = r.current, r.current = n;
      var i = An(), o = i.delta, s = i.timestamp;
      r.lastUpdated !== s && (r.timeDelta = o, r.lastUpdated = s, mt.postRender(r.scheduleVelocityCheck)), r.prev !== r.current && r.updateSubscribers.notify(r.current), r.velocityUpdateSubscribers.getSize() && r.velocityUpdateSubscribers.notify(r.getVelocity()), a && r.renderSubscribers.notify(r.current);
    }, this.scheduleVelocityCheck = function() {
      return mt.postRender(r.velocityCheck);
    }, this.velocityCheck = function(n) {
      var a = n.timestamp;
      a !== r.lastUpdated && (r.prev = r.current, r.velocityUpdateSubscribers.notify(r.getVelocity()));
    }, this.hasAnimated = !1, this.prev = this.current = t, this.canTrackVelocity = cf(this.current);
  }
  return e.prototype.onChange = function(t) {
    return this.updateSubscribers.add(t);
  }, e.prototype.clearListeners = function() {
    this.updateSubscribers.clear();
  }, e.prototype.onRenderRequest = function(t) {
    return t(this.get()), this.renderSubscribers.add(t);
  }, e.prototype.attach = function(t) {
    this.passiveEffect = t;
  }, e.prototype.set = function(t, r) {
    r === void 0 && (r = !0), !r || !this.passiveEffect ? this.updateAndNotify(t, r) : this.passiveEffect(t, this.updateAndNotify);
  }, e.prototype.get = function() {
    return this.current;
  }, e.prototype.getPrevious = function() {
    return this.prev;
  }, e.prototype.getVelocity = function() {
    return this.canTrackVelocity ? Zs(parseFloat(this.current) - parseFloat(this.prev), this.timeDelta) : 0;
  }, e.prototype.start = function(t) {
    var r = this;
    return this.stop(), new Promise(function(n) {
      r.hasAnimated = !0, r.stopAnimation = t(n);
    }).then(function() {
      return r.clearAnimation();
    });
  }, e.prototype.stop = function() {
    this.stopAnimation && this.stopAnimation(), this.clearAnimation();
  }, e.prototype.isAnimating = function() {
    return !!this.stopAnimation;
  }, e.prototype.clearAnimation = function() {
    this.stopAnimation = null;
  }, e.prototype.destroy = function() {
    this.updateSubscribers.clear(), this.renderSubscribers.clear(), this.stop();
  }, e;
}();
function It(e) {
  return new df(e);
}
var Gs = function(e) {
  return function(t) {
    return t.test(e);
  };
}, ff = {
  test: function(e) {
    return e === "auto";
  },
  parse: function(e) {
    return e;
  }
}, Js = [Wt, oe, nr, Rt, sc, oc, ff], sn = function(e) {
  return Js.find(Gs(e));
}, pf = Fe(Fe([], Re(Js)), [Be, Lt]), vf = function(e) {
  return pf.find(Gs(e));
};
function mf(e, t, r) {
  e.hasValue(t) ? e.getValue(t).set(r) : e.addValue(t, It(r));
}
function hf(e, t) {
  var r = Bn(e, t), n = r ? e.makeTargetAnimatable(r, !1) : {}, a = n.transitionEnd, i = a === void 0 ? {} : a;
  n.transition;
  var o = nt(n, ["transitionEnd", "transition"]);
  o = P(P({}, o), i);
  for (var s in o) {
    var l = kc(o[s]);
    mf(e, s, l);
  }
}
function gf(e, t, r) {
  var n, a, i, o, s = Object.keys(t).filter(function(m) {
    return !e.hasValue(m);
  }), l = s.length;
  if (!!l)
    for (var d = 0; d < l; d++) {
      var c = s[d], p = t[c], v = null;
      Array.isArray(p) && (v = p[0]), v === null && (v = (a = (n = r[c]) !== null && n !== void 0 ? n : e.readValue(c)) !== null && a !== void 0 ? a : t[c]), v != null && (typeof v == "string" && lf(v) ? v = parseFloat(v) : !vf(v) && Lt.test(p) && (v = gi(c, p)), e.addValue(c, It(v)), (i = (o = r)[c]) !== null && i !== void 0 || (o[c] = v), e.setBaseTarget(c, v));
    }
}
function yf(e, t) {
  if (!!t) {
    var r = t[e] || t.default || t;
    return r.from;
  }
}
function Cf(e, t, r) {
  var n, a, i = {};
  for (var o in e)
    i[o] = (n = yf(o, t)) !== null && n !== void 0 ? n : (a = r.getValue(o)) === null || a === void 0 ? void 0 : a.get();
  return i;
}
function bf(e, t, r) {
  r === void 0 && (r = {}), e.notifyAnimationStart();
  var n;
  if (Array.isArray(t)) {
    var a = t.map(function(o) {
      return Pa(e, o, r);
    });
    n = Promise.all(a);
  } else if (typeof t == "string")
    n = Pa(e, t, r);
  else {
    var i = typeof t == "function" ? Bn(e, t, r.custom) : t;
    n = Qs(e, i, r);
  }
  return n.then(function() {
    return e.notifyAnimationComplete(t);
  });
}
function Pa(e, t, r) {
  var n;
  r === void 0 && (r = {});
  var a = Bn(e, t, r.custom), i = (a || {}).transition, o = i === void 0 ? e.getDefaultTransition() || {} : i;
  r.transitionOverride && (o = r.transitionOverride);
  var s = a ? function() {
    return Qs(e, a, r);
  } : function() {
    return Promise.resolve();
  }, l = !((n = e.variantChildren) === null || n === void 0) && n.size ? function(m) {
    m === void 0 && (m = 0);
    var h = o.delayChildren, C = h === void 0 ? 0 : h, y = o.staggerChildren, x = o.staggerDirection;
    return xf(e, t, C + m, y, x, r);
  } : function() {
    return Promise.resolve();
  }, d = o.when;
  if (d) {
    var c = Re(d === "beforeChildren" ? [s, l] : [l, s], 2), p = c[0], v = c[1];
    return p().then(v);
  } else
    return Promise.all([s(), l(r.delay)]);
}
function Qs(e, t, r) {
  var n, a = r === void 0 ? {} : r, i = a.delay, o = i === void 0 ? 0 : i, s = a.transitionOverride, l = a.type, d = e.makeTargetAnimatable(t), c = d.transition, p = c === void 0 ? e.getDefaultTransition() : c, v = d.transitionEnd, m = nt(d, ["transition", "transitionEnd"]);
  s && (p = s);
  var h = [], C = l && ((n = e.animationState) === null || n === void 0 ? void 0 : n.getState()[l]);
  for (var y in m) {
    var x = e.getValue(y), T = m[y];
    if (!(!x || T === void 0 || C && Lf(C, y))) {
      var M = Pn(y, x, T, P({ delay: o }, p));
      h.push(M);
    }
  }
  return Promise.all(h).then(function() {
    v && hf(e, v);
  });
}
function xf(e, t, r, n, a, i) {
  r === void 0 && (r = 0), n === void 0 && (n = 0), a === void 0 && (a = 1);
  var o = [], s = (e.variantChildren.size - 1) * n, l = a === 1 ? function(d) {
    return d === void 0 && (d = 0), d * n;
  } : function(d) {
    return d === void 0 && (d = 0), s - d * n;
  };
  return Array.from(e.variantChildren).sort(wf).forEach(function(d, c) {
    o.push(Pa(d, t, P(P({}, i), { delay: r + l(c) })).then(function() {
      return d.notifyAnimationComplete(t);
    }));
  }), Promise.all(o);
}
function wf(e, t) {
  return e.sortNodePosition(t);
}
function Lf(e, t) {
  var r = e.protectedKeys, n = e.needsAnimating, a = r.hasOwnProperty(t) && n[t] !== !0;
  return n[t] = !1, a;
}
var Ci = [
  Pe.Animate,
  Pe.Hover,
  Pe.Tap,
  Pe.Drag,
  Pe.Focus,
  Pe.Exit
], Tf = Fe([], Re(Ci)).reverse(), Mf = Ci.length;
function Af(e) {
  return function(t) {
    return Promise.all(t.map(function(r) {
      var n = r.animation, a = r.options;
      return bf(e, n, a);
    }));
  };
}
function Rf(e) {
  var t = Af(e), r = Pf(), n = {}, a = !0, i = function(c, p) {
    var v = Bn(e, p);
    if (v) {
      v.transition;
      var m = v.transitionEnd, h = nt(v, ["transition", "transitionEnd"]);
      c = P(P(P({}, c), h), m);
    }
    return c;
  };
  function o(c) {
    return n[c] !== void 0;
  }
  function s(c) {
    t = c(e);
  }
  function l(c, p) {
    for (var v, m = e.getProps(), h = e.getVariantContext(!0) || {}, C = [], y = /* @__PURE__ */ new Set(), x = {}, T = 1 / 0, M = function(V) {
      var S = Tf[V], k = r[S], I = (v = m[S]) !== null && v !== void 0 ? v : h[S], $ = st(I), X = S === p ? k.isActive : null;
      X === !1 && (T = V);
      var G = I === h[S] && I !== m[S] && $;
      if (G && a && e.manuallyAnimateOnMount && (G = !1), k.protectedKeys = P({}, x), !k.isActive && X === null || !I && !k.prevProp || ui(I) || typeof I == "boolean")
        return "continue";
      var F = Sf(k.prevProp, I) || S === p && k.isActive && !G && $ || V > T && $, z = Array.isArray(I) ? I : [I], J = z.reduce(i, {});
      X === !1 && (J = {});
      var se = k.prevResolvedValues, ee = se === void 0 ? {} : se, pe = P(P({}, ee), J), le = function(U) {
        F = !0, y.delete(U), k.needsAnimating[U] = !0;
      };
      for (var ve in pe) {
        var B = J[ve], Z = ee[ve];
        x.hasOwnProperty(ve) || (B !== Z ? _r(B) && _r(Z) ? qs(B, Z) ? k.protectedKeys[ve] = !0 : le(ve) : B !== void 0 ? le(ve) : y.add(ve) : B !== void 0 && y.has(ve) ? le(ve) : k.protectedKeys[ve] = !0);
      }
      k.prevProp = I, k.prevResolvedValues = J, k.isActive && (x = P(P({}, x), J)), a && e.blockInitialAnimation && (F = !1), F && !G && C.push.apply(C, Fe([], Re(z.map(function(U) {
        return {
          animation: U,
          options: P({ type: S }, c)
        };
      }))));
    }, f = 0; f < Mf; f++)
      M(f);
    if (n = P({}, x), y.size) {
      var b = {};
      y.forEach(function(V) {
        var S = e.getBaseTarget(V);
        S !== void 0 && (b[V] = S);
      }), C.push({ animation: b });
    }
    var w = Boolean(C.length);
    return a && m.initial === !1 && !e.manuallyAnimateOnMount && (w = !1), a = !1, w ? t(C) : Promise.resolve();
  }
  function d(c, p, v) {
    var m;
    return r[c].isActive === p ? Promise.resolve() : ((m = e.variantChildren) === null || m === void 0 || m.forEach(function(h) {
      var C;
      return (C = h.animationState) === null || C === void 0 ? void 0 : C.setActive(c, p);
    }), r[c].isActive = p, l(v, c));
  }
  return {
    isAnimated: o,
    animateChanges: l,
    setActive: d,
    setAnimateFunction: s,
    getState: function() {
      return r;
    }
  };
}
function Sf(e, t) {
  return typeof t == "string" ? t !== e : K1(t) ? !qs(t, e) : !1;
}
function Kt(e) {
  return e === void 0 && (e = !1), {
    isActive: e,
    protectedKeys: {},
    needsAnimating: {},
    prevResolvedValues: {}
  };
}
function Pf() {
  var e;
  return e = {}, e[Pe.Animate] = Kt(!0), e[Pe.Hover] = Kt(), e[Pe.Tap] = Kt(), e[Pe.Drag] = Kt(), e[Pe.Focus] = Kt(), e[Pe.Exit] = Kt(), e;
}
var Ef = {
  animation: jt(function(e) {
    var t = e.visualElement, r = e.animate;
    t.animationState || (t.animationState = Rf(t)), ui(r) && _e(function() {
      return r.subscribe(t);
    }, [r]);
  }),
  exit: jt(function(e) {
    var t = e.custom, r = e.visualElement, n = Re(q1(), 2), a = n[0], i = n[1], o = Oe(Wr);
    _e(function() {
      var s, l, d = (s = r.animationState) === null || s === void 0 ? void 0 : s.setActive(Pe.Exit, !a, { custom: (l = o == null ? void 0 : o.custom) !== null && l !== void 0 ? l : t });
      !a && (d == null || d.then(i));
    }, [a]);
  })
}, eu = function() {
  function e(t, r, n) {
    var a = this, i = n === void 0 ? {} : n, o = i.transformPagePoint;
    if (this.startEvent = null, this.lastMoveEvent = null, this.lastMoveEventInfo = null, this.handlers = {}, this.updatePoint = function() {
      if (!!(a.lastMoveEvent && a.lastMoveEventInfo)) {
        var v = ua(a.lastMoveEventInfo, a.history), m = a.startEvent !== null, h = Fs(v.offset, { x: 0, y: 0 }) >= 3;
        if (!(!m && !h)) {
          var C = v.point, y = An().timestamp;
          a.history.push(P(P({}, C), { timestamp: y }));
          var x = a.handlers, T = x.onStart, M = x.onMove;
          m || (T && T(a.lastMoveEvent, v), a.startEvent = a.lastMoveEvent), M && M(a.lastMoveEvent, v);
        }
      }
    }, this.handlePointerMove = function(v, m) {
      if (a.lastMoveEvent = v, a.lastMoveEventInfo = sa(m, a.transformPagePoint), ys(v) && v.buttons === 0) {
        a.handlePointerUp(v, m);
        return;
      }
      mt.update(a.updatePoint, !0);
    }, this.handlePointerUp = function(v, m) {
      a.end();
      var h = a.handlers, C = h.onEnd, y = h.onSessionEnd, x = ua(sa(m, a.transformPagePoint), a.history);
      a.startEvent && C && C(v, x), y && y(v, x);
    }, !(Cs(t) && t.touches.length > 1)) {
      this.handlers = r, this.transformPagePoint = o;
      var s = ci(t), l = sa(s, this.transformPagePoint), d = l.point, c = An().timestamp;
      this.history = [P(P({}, d), { timestamp: c })];
      var p = r.onSessionStart;
      p && p(t, ua(l, this.history)), this.removeListeners = qr(ar(window, "pointermove", this.handlePointerMove), ar(window, "pointerup", this.handlePointerUp), ar(window, "pointercancel", this.handlePointerUp));
    }
  }
  return e.prototype.updateHandlers = function(t) {
    this.handlers = t;
  }, e.prototype.end = function() {
    this.removeListeners && this.removeListeners(), Tr.update(this.updatePoint);
  }, e;
}();
function sa(e, t) {
  return t ? { point: t(e.point) } : e;
}
function po(e, t) {
  return { x: e.x - t.x, y: e.y - t.y };
}
function ua(e, t) {
  var r = e.point;
  return {
    point: r,
    delta: po(r, tu(t)),
    offset: po(r, kf(t)),
    velocity: Of(t, 0.1)
  };
}
function kf(e) {
  return e[0];
}
function tu(e) {
  return e[e.length - 1];
}
function Of(e, t) {
  if (e.length < 2)
    return { x: 0, y: 0 };
  for (var r = e.length - 1, n = null, a = tu(e); r >= 0 && (n = e[r], !(a.timestamp - n.timestamp > Sn(t))); )
    r--;
  if (!n)
    return { x: 0, y: 0 };
  var i = (a.timestamp - n.timestamp) / 1e3;
  if (i === 0)
    return { x: 0, y: 0 };
  var o = {
    x: (a.x - n.x) / i,
    y: (a.y - n.y) / i
  };
  return o.x === 1 / 0 && (o.x = 0), o.y === 1 / 0 && (o.y = 0), o;
}
function _f(e) {
  return e;
}
function ru(e) {
  var t = e.top, r = e.left, n = e.right, a = e.bottom;
  return {
    x: { min: r, max: n },
    y: { min: t, max: a }
  };
}
function Vf(e) {
  var t = e.x, r = e.y;
  return {
    top: r.min,
    bottom: r.max,
    left: t.min,
    right: t.max
  };
}
function Hf(e, t) {
  var r = e.top, n = e.left, a = e.bottom, i = e.right;
  t === void 0 && (t = _f);
  var o = t({ x: n, y: r }), s = t({ x: i, y: a });
  return {
    top: o.y,
    left: o.x,
    bottom: s.y,
    right: s.x
  };
}
function Pt() {
  return { x: { min: 0, max: 1 }, y: { min: 0, max: 1 } };
}
function Df(e) {
  return {
    x: P({}, e.x),
    y: P({}, e.y)
  };
}
var vo = {
  translate: 0,
  scale: 1,
  origin: 0,
  originPoint: 0
};
function mo() {
  return {
    x: P({}, vo),
    y: P({}, vo)
  };
}
function Ue(e) {
  return [e("x"), e("y")];
}
function nu(e, t, r) {
  var n = t.min, a = t.max;
  return n !== void 0 && e < n ? e = r ? Ge(n, e, r.min) : Math.max(e, n) : a !== void 0 && e > a && (e = r ? Ge(a, e, r.max) : Math.min(e, a)), e;
}
function jf(e, t, r, n, a) {
  var i = e - t * r;
  return n ? nu(i, n, a) : i;
}
function ho(e, t, r) {
  return {
    min: t !== void 0 ? e.min + t : void 0,
    max: r !== void 0 ? e.max + r - (e.max - e.min) : void 0
  };
}
function If(e, t) {
  var r = t.top, n = t.left, a = t.bottom, i = t.right;
  return {
    x: ho(e.x, n, i),
    y: ho(e.y, r, a)
  };
}
function go(e, t) {
  var r, n = t.min - e.min, a = t.max - e.max;
  return t.max - t.min < e.max - e.min && (r = Re([a, n], 2), n = r[0], a = r[1]), {
    min: e.min + n,
    max: e.min + a
  };
}
function Nf(e, t) {
  return {
    x: go(e.x, t.x),
    y: go(e.y, t.y)
  };
}
function Bf(e, t, r) {
  var n = e.max - e.min, a = Ge(t.min, t.max - n, r);
  return { min: a, max: a + n };
}
function $f(e, t) {
  var r = {};
  return t.min !== void 0 && (r.min = t.min - e.min), t.max !== void 0 && (r.max = t.max - e.min), r;
}
var au = 0.35;
function Zf(e) {
  return e === !1 ? e = 0 : e === !0 && (e = au), {
    x: yo(e, "left", "right"),
    y: yo(e, "top", "bottom")
  };
}
function yo(e, t, r) {
  return {
    min: Co(e, t),
    max: Co(e, r)
  };
}
function Co(e, t) {
  var r;
  return typeof e == "number" ? e : (r = e[t]) !== null && r !== void 0 ? r : 0;
}
function iu(e, t) {
  var r = e.getBoundingClientRect();
  return ru(Hf(r, t));
}
var Ff = function(e) {
  return Tn(0, 1, e);
};
function bo(e, t, r) {
  return t === void 0 && (t = 0), r === void 0 && (r = 0.01), Fs(e, t) < r;
}
function Dr(e) {
  return e.max - e.min;
}
function Wf(e, t) {
  var r = 0.5, n = Dr(e), a = Dr(t);
  return a > n ? r = Vr(t.min, t.max - n, e.min) : n > a && (r = Vr(e.min, e.max - a, t.min)), Ff(r);
}
function xo(e, t, r, n) {
  n === void 0 && (n = 0.5), e.origin = n, e.originPoint = Ge(t.min, t.max, e.origin), e.scale = Dr(r) / Dr(t), bo(e.scale, 1, 1e-4) && (e.scale = 1), e.translate = Ge(r.min, r.max, e.origin) - e.originPoint, bo(e.translate) && (e.translate = 0);
}
function ou(e, t, r, n) {
  xo(e.x, t.x, r.x, wo(n.originX)), xo(e.y, t.y, r.y, wo(n.originY));
}
function wo(e) {
  return typeof e == "number" ? e : 0.5;
}
function Lo(e, t, r) {
  e.min = r.min + t.min, e.max = e.min + Dr(t);
}
function Uf(e, t) {
  Lo(e.target.x, e.relativeTarget.x, t.target.x), Lo(e.target.y, e.relativeTarget.y, t.target.y);
}
var bi = function(e, t) {
  return e.depth - t.depth;
};
function su(e) {
  var t = e.projection.isEnabled;
  return t || e.shouldResetTransform();
}
function En(e, t) {
  t === void 0 && (t = []);
  var r = e.parent;
  return r && En(r, t), su(e) && t.push(e), t;
}
function zf(e) {
  var t = [], r = function(n) {
    su(n) && t.push(n), n.children.forEach(r);
  };
  return e.children.forEach(r), t.sort(bi);
}
function Cn(e) {
  if (!e.shouldResetTransform()) {
    var t = e.getLayoutState();
    e.notifyBeforeLayoutMeasure(t.layout), t.isHydrated = !0, t.layout = e.measureViewportBox(), t.layoutCorrected = Df(t.layout), e.notifyLayoutMeasure(t.layout, e.prevViewportBox || t.layout), mt.update(function() {
      return e.rebaseProjectionTarget();
    });
  }
}
function Yf(e) {
  e.shouldResetTransform() || (e.prevViewportBox = e.measureViewportBox(!1), e.rebaseProjectionTarget(!1, e.prevViewportBox));
}
function qf(e, t, r, n) {
  e.min = Ge(t.min, r.min, n), e.max = Ge(t.max, r.max, n);
}
function To(e, t) {
  return {
    min: t.min - e.min,
    max: t.max - e.min
  };
}
function or(e, t) {
  return {
    x: To(e.x, t.x),
    y: To(e.y, t.y)
  };
}
function Kf(e, t) {
  var r = e.getLayoutId(), n = t.getLayoutId();
  return r !== n || n === void 0 && e !== t;
}
function uu(e) {
  var t = e.getProps(), r = t.drag, n = t._dragX;
  return r && !n;
}
function Mo(e, t) {
  e.min = t.min, e.max = t.max;
}
function Xf(e, t) {
  Mo(e.x, t.x), Mo(e.y, t.y);
}
function kn(e, t, r) {
  var n = e - r, a = t * n;
  return r + a;
}
function Ao(e, t, r, n, a) {
  return a !== void 0 && (e = kn(e, a, n)), kn(e, r, n) + t;
}
function Ea(e, t, r, n, a) {
  t === void 0 && (t = 0), r === void 0 && (r = 1), e.min = Ao(e.min, t, r, n, a), e.max = Ao(e.max, t, r, n, a);
}
function Gf(e, t) {
  var r = t.x, n = t.y;
  Ea(e.x, r.translate, r.scale, r.originPoint), Ea(e.y, n.translate, n.scale, n.originPoint);
}
function Ro(e, t, r, n) {
  var a = Re(n, 3), i = a[0], o = a[1], s = a[2];
  e.min = t.min, e.max = t.max;
  var l = r[s] !== void 0 ? r[s] : 0.5, d = Ge(t.min, t.max, l);
  Ea(e, r[i], r[o], d, r.scale);
}
var lu = ["x", "scaleX", "originX"], cu = ["y", "scaleY", "originY"];
function ka(e, t, r) {
  Ro(e.x, t.x, r, lu), Ro(e.y, t.y, r, cu);
}
function So(e, t, r, n, a) {
  return e -= t, e = kn(e, 1 / r, n), a !== void 0 && (e = kn(e, 1 / a, n)), e;
}
function Jf(e, t, r, n, a) {
  t === void 0 && (t = 0), r === void 0 && (r = 1), n === void 0 && (n = 0.5);
  var i = Ge(e.min, e.max, n) - t;
  e.min = So(e.min, t, r, i, a), e.max = So(e.max, t, r, i, a);
}
function Po(e, t, r) {
  var n = Re(r, 3), a = n[0], i = n[1], o = n[2];
  Jf(e, t[a], t[i], t[o], t.scale);
}
function du(e, t) {
  Po(e.x, t, lu), Po(e.y, t, cu);
}
function Qf(e, t, r) {
  var n = r.length;
  if (!!n) {
    t.x = t.y = 1;
    for (var a, i, o = 0; o < n; o++)
      a = r[o], i = a.getLayoutState().delta, t.x *= i.x.scale, t.y *= i.y.scale, Gf(e, i), uu(a) && ka(e, e, a.getLatestValues());
  }
}
function e2(e, t) {
  t === void 0 && (t = !0);
  var r = e.getProjectionParent();
  if (!r)
    return !1;
  var n;
  return t ? (n = or(r.projection.target, e.projection.target), du(n, r.getLatestValues())) : n = or(r.getLayoutState().layout, e.getLayoutState().layout), Ue(function(a) {
    return e.setProjectionTargetAxis(a, n[a].min, n[a].max, !0);
  }), !0;
}
var Mr = /* @__PURE__ */ new Set();
function Eo(e, t, r) {
  e[r] || (e[r] = []), e[r].push(t);
}
function Oa(e) {
  return Mr.add(e), function() {
    return Mr.delete(e);
  };
}
function _a() {
  if (!!Mr.size) {
    var e = 0, t = [[]], r = [], n = function(s) {
      return Eo(t, s, e);
    }, a = function(s) {
      Eo(r, s, e), e++;
    };
    Mr.forEach(function(s) {
      s(n, a), e = 0;
    }), Mr.clear();
    for (var i = r.length, o = 0; o <= i; o++)
      t[o] && t[o].forEach(ko), r[o] && r[o].forEach(ko);
  }
}
var ko = function(e) {
  return e();
}, t2 = /* @__PURE__ */ new WeakMap(), Oo, r2 = function() {
  function e(t) {
    var r = t.visualElement;
    this.isDragging = !1, this.currentDirection = null, this.constraints = !1, this.elastic = Pt(), this.props = {}, this.hasMutatedConstraints = !1, this.cursorProgress = {
      x: 0.5,
      y: 0.5
    }, this.originPoint = {}, this.openGlobalLock = null, this.panSession = null, this.visualElement = r, this.visualElement.enableLayoutProjection(), t2.set(r, this);
  }
  return e.prototype.start = function(t, r) {
    var n = this, a = r === void 0 ? {} : r, i = a.snapToCursor, o = i === void 0 ? !1 : i, s = a.cursorProgress, l = function(m) {
      var h;
      n.stopMotion();
      var C = Fc(m).point;
      (h = n.cancelLayout) === null || h === void 0 || h.call(n), n.cancelLayout = Oa(function(y, x) {
        var T = En(n.visualElement), M = zf(n.visualElement), f = Fe(Fe([], Re(T)), Re(M)), b = !1;
        n.isLayoutDrag() && n.visualElement.lockProjectionTarget(), x(function() {
          f.forEach(function(w) {
            return w.resetTransform();
          });
        }), y(function() {
          Cn(n.visualElement), M.forEach(Cn);
        }), x(function() {
          f.forEach(function(w) {
            return w.restoreTransform();
          }), o && (b = n.snapToCursor(C));
        }), y(function() {
          var w = Boolean(n.getAxisMotionValue("x") && !n.isExternalDrag());
          w || n.visualElement.rebaseProjectionTarget(!0, n.visualElement.measureViewportBox(!1)), n.visualElement.scheduleUpdateLayoutProjection();
          var V = n.visualElement.projection;
          Ue(function(S) {
            if (!b) {
              var k = V.target[S], I = k.min, $ = k.max;
              n.cursorProgress[S] = s ? s[S] : Vr(I, $, C[S]);
            }
            var X = n.getAxisMotionValue(S);
            X && (n.originPoint[S] = X.get());
          });
        }), x(function() {
          tr.update(), tr.preRender(), tr.render(), tr.postRender();
        }), y(function() {
          return n.resolveDragConstraints();
        });
      });
    }, d = function(m, h) {
      var C, y, x, T = n.props, M = T.drag, f = T.dragPropagation;
      M && !f && (n.openGlobalLock && n.openGlobalLock(), n.openGlobalLock = Ls(M), !n.openGlobalLock) || (_a(), n.isDragging = !0, n.currentDirection = null, (y = (C = n.props).onDragStart) === null || y === void 0 || y.call(C, m, h), (x = n.visualElement.animationState) === null || x === void 0 || x.setActive(Pe.Drag, !0));
    }, c = function(m, h) {
      var C, y, x, T, M = n.props, f = M.dragPropagation, b = M.dragDirectionLock;
      if (!(!f && !n.openGlobalLock)) {
        var w = h.offset;
        if (b && n.currentDirection === null) {
          n.currentDirection = n2(w), n.currentDirection !== null && ((y = (C = n.props).onDirectionLock) === null || y === void 0 || y.call(C, n.currentDirection));
          return;
        }
        n.updateAxis("x", h.point, w), n.updateAxis("y", h.point, w), (T = (x = n.props).onDrag) === null || T === void 0 || T.call(x, m, h), Oo = m;
      }
    }, p = function(m, h) {
      return n.stop(m, h);
    }, v = this.props.transformPagePoint;
    this.panSession = new eu(t, {
      onSessionStart: l,
      onStart: d,
      onMove: c,
      onSessionEnd: p
    }, { transformPagePoint: v });
  }, e.prototype.resolveDragConstraints = function() {
    var t = this, r = this.props, n = r.dragConstraints, a = r.dragElastic, i = this.visualElement.getLayoutState().layoutCorrected;
    n ? this.constraints = Ca(n) ? this.resolveRefConstraints(i, n) : If(i, n) : this.constraints = !1, this.elastic = Zf(a), this.constraints && !this.hasMutatedConstraints && Ue(function(o) {
      t.getAxisMotionValue(o) && (t.constraints[o] = $f(i[o], t.constraints[o]));
    });
  }, e.prototype.resolveRefConstraints = function(t, r) {
    var n = this.props, a = n.onMeasureDragConstraints, i = n.transformPagePoint, o = r.current;
    Ye(o !== null, "If `dragConstraints` is set as a React ref, that ref must be passed to another component's `ref` prop."), this.constraintsBox = iu(o, i);
    var s = Nf(t, this.constraintsBox);
    if (a) {
      var l = a(Vf(s));
      this.hasMutatedConstraints = !!l, l && (s = ru(l));
    }
    return s;
  }, e.prototype.cancelDrag = function() {
    var t, r;
    this.visualElement.unlockProjectionTarget(), (t = this.cancelLayout) === null || t === void 0 || t.call(this), this.isDragging = !1, this.panSession && this.panSession.end(), this.panSession = null, !this.props.dragPropagation && this.openGlobalLock && (this.openGlobalLock(), this.openGlobalLock = null), (r = this.visualElement.animationState) === null || r === void 0 || r.setActive(Pe.Drag, !1);
  }, e.prototype.stop = function(t, r) {
    var n, a, i;
    (n = this.panSession) === null || n === void 0 || n.end(), this.panSession = null;
    var o = this.isDragging;
    if (this.cancelDrag(), !!o) {
      var s = r.velocity;
      this.animateDragEnd(s), (i = (a = this.props).onDragEnd) === null || i === void 0 || i.call(a, t, r);
    }
  }, e.prototype.snapToCursor = function(t) {
    var r = this;
    return Ue(function(n) {
      var a = r.props.drag;
      if (!!un(n, a, r.currentDirection)) {
        var i = r.getAxisMotionValue(n);
        if (i) {
          var o = r.visualElement.getLayoutState().layout, s = o[n].max - o[n].min, l = o[n].min + s / 2, d = t[n] - l;
          r.originPoint[n] = t[n], i.set(d);
        } else
          return r.cursorProgress[n] = 0.5, !0;
      }
    }).includes(!0);
  }, e.prototype.updateAxis = function(t, r, n) {
    var a = this.props.drag;
    if (!!un(t, a, this.currentDirection))
      return this.getAxisMotionValue(t) ? this.updateAxisMotionValue(t, n) : this.updateVisualElementAxis(t, r);
  }, e.prototype.updateAxisMotionValue = function(t, r) {
    var n = this.getAxisMotionValue(t);
    if (!(!r || !n)) {
      var a = this.originPoint[t] + r[t], i = this.constraints ? nu(a, this.constraints[t], this.elastic[t]) : a;
      n.set(i);
    }
  }, e.prototype.updateVisualElementAxis = function(t, r) {
    var n, a = this.visualElement.getLayoutState().layout[t], i = a.max - a.min, o = this.cursorProgress[t], s = jf(r[t], i, o, (n = this.constraints) === null || n === void 0 ? void 0 : n[t], this.elastic[t]);
    this.visualElement.setProjectionTargetAxis(t, s, s + i);
  }, e.prototype.setProps = function(t) {
    var r = t.drag, n = r === void 0 ? !1 : r, a = t.dragDirectionLock, i = a === void 0 ? !1 : a, o = t.dragPropagation, s = o === void 0 ? !1 : o, l = t.dragConstraints, d = l === void 0 ? !1 : l, c = t.dragElastic, p = c === void 0 ? au : c, v = t.dragMomentum, m = v === void 0 ? !0 : v, h = nt(t, ["drag", "dragDirectionLock", "dragPropagation", "dragConstraints", "dragElastic", "dragMomentum"]);
    this.props = P({
      drag: n,
      dragDirectionLock: i,
      dragPropagation: s,
      dragConstraints: d,
      dragElastic: p,
      dragMomentum: m
    }, h);
  }, e.prototype.getAxisMotionValue = function(t) {
    var r = this.props, n = r.layout, a = r.layoutId, i = "_drag" + t.toUpperCase();
    if (this.props[i])
      return this.props[i];
    if (!n && a === void 0)
      return this.visualElement.getValue(t, 0);
  }, e.prototype.isLayoutDrag = function() {
    return !this.getAxisMotionValue("x");
  }, e.prototype.isExternalDrag = function() {
    var t = this.props, r = t._dragX, n = t._dragY;
    return r || n;
  }, e.prototype.animateDragEnd = function(t) {
    var r = this, n = this.props, a = n.drag, i = n.dragMomentum, o = n.dragElastic, s = n.dragTransition, l = e2(this.visualElement, this.isLayoutDrag() && !this.isExternalDrag()), d = this.constraints || {};
    if (l && Object.keys(d).length && this.isLayoutDrag()) {
      var c = this.visualElement.getProjectionParent();
      if (c) {
        var p = or(c.projection.targetFinal, d);
        Ue(function(m) {
          var h = p[m], C = h.min, y = h.max;
          d[m] = {
            min: isNaN(C) ? void 0 : C,
            max: isNaN(y) ? void 0 : y
          };
        });
      }
    }
    var v = Ue(function(m) {
      var h;
      if (!!un(m, a, r.currentDirection)) {
        var C = (h = d == null ? void 0 : d[m]) !== null && h !== void 0 ? h : {}, y = o ? 200 : 1e6, x = o ? 40 : 1e7, T = P(P({
          type: "inertia",
          velocity: i ? t[m] : 0,
          bounceStiffness: y,
          bounceDamping: x,
          timeConstant: 750,
          restDelta: 1,
          restSpeed: 10
        }, s), C);
        return r.getAxisMotionValue(m) ? r.startAxisValueAnimation(m, T) : r.visualElement.startLayoutAnimation(m, T, l);
      }
    });
    return Promise.all(v).then(function() {
      var m, h;
      (h = (m = r.props).onDragTransitionEnd) === null || h === void 0 || h.call(m);
    });
  }, e.prototype.stopMotion = function() {
    var t = this;
    Ue(function(r) {
      var n = t.getAxisMotionValue(r);
      n ? n.stop() : t.visualElement.stopLayoutAnimation();
    });
  }, e.prototype.startAxisValueAnimation = function(t, r) {
    var n = this.getAxisMotionValue(t);
    if (!!n) {
      var a = n.get();
      return n.set(a), n.set(a), Pn(t, n, 0, r);
    }
  }, e.prototype.scalePoint = function() {
    var t = this, r = this.props, n = r.drag, a = r.dragConstraints;
    if (!(!Ca(a) || !this.constraintsBox)) {
      this.stopMotion();
      var i = { x: 0, y: 0 };
      Ue(function(o) {
        i[o] = Wf(t.visualElement.projection.target[o], t.constraintsBox[o]);
      }), this.updateConstraints(function() {
        Ue(function(o) {
          if (!!un(o, n, null)) {
            var s = Bf(t.visualElement.projection.target[o], t.constraintsBox[o], i[o]), l = s.min, d = s.max;
            t.visualElement.setProjectionTargetAxis(o, l, d);
          }
        });
      }), setTimeout(_a, 1);
    }
  }, e.prototype.updateConstraints = function(t) {
    var r = this;
    this.cancelLayout = Oa(function(n, a) {
      var i = En(r.visualElement);
      a(function() {
        return i.forEach(function(o) {
          return o.resetTransform();
        });
      }), n(function() {
        return Cn(r.visualElement);
      }), a(function() {
        return i.forEach(function(o) {
          return o.restoreTransform();
        });
      }), n(function() {
        r.resolveDragConstraints();
      }), t && a(t);
    });
  }, e.prototype.mount = function(t) {
    var r = this, n = t.getInstance(), a = ar(n, "pointerdown", function(l) {
      var d = r.props, c = d.drag, p = d.dragListener, v = p === void 0 ? !0 : p;
      c && v && r.start(l);
    }), i = li(window, "resize", function() {
      r.scalePoint();
    }), o = t.onLayoutUpdate(function() {
      r.isDragging && r.resolveDragConstraints();
    }), s = t.prevDragCursor;
    return s && this.start(Oo, { cursorProgress: s }), function() {
      a == null || a(), i == null || i(), o == null || o(), r.cancelDrag();
    };
  }, e;
}();
function un(e, t, r) {
  return (t === !0 || t === e) && (r === null || r === e);
}
function n2(e, t) {
  t === void 0 && (t = 10);
  var r = null;
  return Math.abs(e.y) > t ? r = "y" : Math.abs(e.x) > t && (r = "x"), r;
}
function a2(e) {
  var t = e.dragControls, r = e.visualElement, n = Oe(In).transformPagePoint, a = Er(function() {
    return new r2({
      visualElement: r
    });
  });
  a.setProps(P(P({}, e), { transformPagePoint: n })), _e(function() {
    return t && t.subscribe(a);
  }, [a]), _e(function() {
    return a.mount(r);
  }, []);
}
function i2(e) {
  var t = e.onPan, r = e.onPanStart, n = e.onPanEnd, a = e.onPanSessionStart, i = e.visualElement, o = t || r || n || a, s = Qe(null), l = Oe(In).transformPagePoint, d = {
    onSessionStart: a,
    onStart: r,
    onMove: t,
    onEnd: function(p, v) {
      s.current = null, n && n(p, v);
    }
  };
  _e(function() {
    s.current !== null && s.current.updateHandlers(d);
  });
  function c(p) {
    s.current = new eu(p, d, {
      transformPagePoint: l
    });
  }
  Ln(i, "pointerdown", o && c), di(function() {
    return s.current && s.current.end();
  });
}
var o2 = {
  pan: jt(i2),
  drag: jt(a2)
}, jr;
(function(e) {
  e[e.Entering = 0] = "Entering", e[e.Present = 1] = "Present", e[e.Exiting = 2] = "Exiting";
})(jr || (jr = {}));
var Va;
(function(e) {
  e[e.Hide = 0] = "Hide", e[e.Show = 1] = "Show";
})(Va || (Va = {}));
function Ha(e) {
  return typeof e == "string" && e.startsWith("var(--");
}
var fu = /var\((--[a-zA-Z0-9-_]+),? ?([a-zA-Z0-9 ()%#.,-]+)?\)/;
function s2(e) {
  var t = fu.exec(e);
  if (!t)
    return [,];
  var r = Re(t, 3), n = r[1], a = r[2];
  return [n, a];
}
var u2 = 4;
function Da(e, t, r) {
  r === void 0 && (r = 1), Ye(r <= u2, 'Max CSS variable fallback depth detected in property "' + e + '". This may indicate a circular fallback dependency.');
  var n = Re(s2(e), 2), a = n[0], i = n[1];
  if (!!a) {
    var o = window.getComputedStyle(t).getPropertyValue(a);
    return o ? o.trim() : Ha(i) ? Da(i, t, r + 1) : i;
  }
}
function l2(e, t, r) {
  var n, a = nt(t, []), i = e.getInstance();
  if (!(i instanceof HTMLElement))
    return { target: a, transitionEnd: r };
  r && (r = P({}, r)), e.forEachValue(function(d) {
    var c = d.get();
    if (!!Ha(c)) {
      var p = Da(c, i);
      p && d.set(p);
    }
  });
  for (var o in a) {
    var s = a[o];
    if (!!Ha(s)) {
      var l = Da(s, i);
      !l || (a[o] = l, r && ((n = r[o]) !== null && n !== void 0 || (r[o] = s)));
    }
  }
  return { target: a, transitionEnd: r };
}
function _o(e, t) {
  return e / (t.max - t.min) * 100;
}
function c2(e, t, r) {
  var n = r.target;
  if (typeof e == "string")
    if (oe.test(e))
      e = parseFloat(e);
    else
      return e;
  var a = _o(e, n.x), i = _o(e, n.y);
  return a + "% " + i + "%";
}
var Vo = "_$css";
function d2(e, t) {
  var r = t.delta, n = t.treeScale, a = e, i = e.includes("var("), o = [];
  i && (e = e.replace(fu, function(C) {
    return o.push(C), Vo;
  }));
  var s = Lt.parse(e);
  if (s.length > 5)
    return a;
  var l = Lt.createTransformer(e), d = typeof s[0] != "number" ? 1 : 0, c = r.x.scale * n.x, p = r.y.scale * n.y;
  s[0 + d] /= c, s[1 + d] /= p;
  var v = Ge(c, p, 0.5);
  typeof s[2 + d] == "number" && (s[2 + d] /= v), typeof s[3 + d] == "number" && (s[3 + d] /= v);
  var m = l(s);
  if (i) {
    var h = 0;
    m = m.replace(Vo, function() {
      var C = o[h];
      return h++, C;
    });
  }
  return m;
}
var Cr = {
  process: c2
}, f2 = {
  borderRadius: P(P({}, Cr), { applyTo: [
    "borderTopLeftRadius",
    "borderTopRightRadius",
    "borderBottomLeftRadius",
    "borderBottomRightRadius"
  ] }),
  borderTopLeftRadius: Cr,
  borderTopRightRadius: Cr,
  borderBottomLeftRadius: Cr,
  borderBottomRightRadius: Cr,
  boxShadow: {
    process: d2
  }
}, Ho = 1e3, p2 = function(e) {
  W1(t, e);
  function t() {
    var r = e !== null && e.apply(this, arguments) || this;
    return r.frameTarget = Pt(), r.currentAnimationTarget = Pt(), r.isAnimating = {
      x: !1,
      y: !1
    }, r.stopAxisAnimation = {
      x: void 0,
      y: void 0
    }, r.isAnimatingTree = !1, r.animate = function(n, a, i) {
      i === void 0 && (i = {});
      var o = i.originBox, s = i.targetBox, l = i.visibilityAction, d = i.shouldStackAnimate, c = i.onComplete, p = i.prevParent, v = nt(i, ["originBox", "targetBox", "visibilityAction", "shouldStackAnimate", "onComplete", "prevParent"]), m = r.props, h = m.visualElement, C = m.layout;
      if (d === !1)
        return r.isAnimatingTree = !1, r.safeToRemove();
      if (!(r.isAnimatingTree && d !== !0)) {
        d && (r.isAnimatingTree = !0), a = o || a, n = s || n;
        var y = !1, x = h.getProjectionParent();
        if (x) {
          var T = x.prevViewportBox, M = x.getLayoutState().layout;
          p && (s && (M = p.getLayoutState().layout), o && !Kf(p, x) && p.prevViewportBox && (T = p.prevViewportBox)), T && g2(p, o, s) && (y = !0, a = or(T, a), n = or(M, n));
        }
        var f = m2(a, n), b = Ue(function(w) {
          var V, S;
          if (C === "position") {
            var k = n[w].max - n[w].min;
            a[w].max = a[w].min + k;
          }
          if (!h.projection.isTargetLocked)
            if (l !== void 0)
              h.setVisibility(l === Va.Show);
            else
              return f ? r.animateAxis(w, n[w], a[w], P(P({}, v), {
                isRelative: y
              })) : ((S = (V = r.stopAxisAnimation)[w]) === null || S === void 0 || S.call(V), h.setProjectionTargetAxis(w, n[w].min, n[w].max, y));
        });
        return h.syncRender(), Promise.all(b).then(function() {
          r.isAnimatingTree = !1, c && c(), h.notifyLayoutAnimationComplete();
        });
      }
    }, r;
  }
  return t.prototype.componentDidMount = function() {
    var r = this, n = this.props.visualElement;
    n.animateMotionValue = Pn, n.enableLayoutProjection(), this.unsubLayoutReady = n.onLayoutUpdate(this.animate), n.layoutSafeToRemove = function() {
      return r.safeToRemove();
    }, Kl(f2);
  }, t.prototype.componentWillUnmount = function() {
    var r = this;
    this.unsubLayoutReady(), Ue(function(n) {
      var a, i;
      return (i = (a = r.stopAxisAnimation)[n]) === null || i === void 0 ? void 0 : i.call(a);
    });
  }, t.prototype.animateAxis = function(r, n, a, i) {
    var o = this, s, l, d = i === void 0 ? {} : i, c = d.transition, p = d.isRelative;
    if (!(this.isAnimating[r] && Ir(n, this.currentAnimationTarget[r]))) {
      (l = (s = this.stopAxisAnimation)[r]) === null || l === void 0 || l.call(s), this.isAnimating[r] = !0;
      var v = this.props.visualElement, m = this.frameTarget[r], h = v.getProjectionAnimationProgress()[r];
      h.clearListeners(), h.set(0), h.set(0);
      var C = function() {
        var M = h.get() / Ho;
        qf(m, a, n, M), v.setProjectionTargetAxis(r, m.min, m.max, p);
      };
      C();
      var y = h.onChange(C);
      this.stopAxisAnimation[r] = function() {
        o.isAnimating[r] = !1, h.stop(), y();
      }, this.currentAnimationTarget[r] = n;
      var x = c || v.getDefaultTransition() || h2, T = Pn(r === "x" ? "layoutX" : "layoutY", h, Ho, x && yi(x, "layout")).then(this.stopAxisAnimation[r]);
      return T;
    }
  }, t.prototype.safeToRemove = function() {
    var r, n;
    (n = (r = this.props).safeToRemove) === null || n === void 0 || n.call(r);
  }, t.prototype.render = function() {
    return null;
  }, t;
}(I1.Component);
function v2(e) {
  var t = Re(q1(), 2), r = t[1];
  return /* @__PURE__ */ u(p2, {
    ...P({}, e, {
      safeToRemove: r
    })
  });
}
function m2(e, t) {
  return !jo(e) && !jo(t) && (!Ir(e.x, t.x) || !Ir(e.y, t.y));
}
var Do = {
  min: 0,
  max: 0
};
function jo(e) {
  return Ir(e.x, Do) && Ir(e.y, Do);
}
function Ir(e, t) {
  return e.min === t.min && e.max === t.max;
}
var h2 = {
  duration: 0.45,
  ease: [0.4, 0, 0.1, 1]
};
function g2(e, t, r) {
  return e || !e && !(t || r);
}
var y2 = {
  layoutReady: function(e) {
    return e.notifyLayoutReady();
  }
};
function pu() {
  var e = /* @__PURE__ */ new Set();
  return {
    add: function(t) {
      return e.add(t);
    },
    flush: function(t) {
      var r = t === void 0 ? y2 : t, n = r.layoutReady, a = r.parent;
      Oa(function(i, o) {
        var s = Array.from(e).sort(bi), l = a ? En(a) : [];
        o(function() {
          var d = Fe(Fe([], Re(l)), Re(s));
          d.forEach(function(c) {
            return c.resetTransform();
          });
        }), i(function() {
          s.forEach(Cn);
        }), o(function() {
          l.forEach(function(d) {
            return d.restoreTransform();
          }), s.forEach(n);
        }), i(function() {
          s.forEach(function(d) {
            d.isPresent && (d.presence = jr.Present);
          });
        }), o(function() {
          tr.preRender(), tr.render();
        }), i(function() {
          mt.postRender(function() {
            return s.forEach(C2);
          }), e.clear();
        });
      }), _a();
    }
  };
}
function C2(e) {
  e.prevViewportBox = e.projection.target;
}
var vu = Ft(pu()), b2 = Ft(pu());
function Vt(e) {
  return !!e.forceUpdate;
}
var x2 = function(e) {
  W1(t, e);
  function t() {
    return e !== null && e.apply(this, arguments) || this;
  }
  return t.prototype.componentDidMount = function() {
    var r = this.props, n = r.syncLayout, a = r.framerSyncLayout, i = r.visualElement;
    Vt(n) && n.register(i), Vt(a) && a.register(i), i.onUnmount(function() {
      Vt(n) && n.remove(i), Vt(a) && a.remove(i);
    });
  }, t.prototype.getSnapshotBeforeUpdate = function() {
    var r = this.props, n = r.syncLayout, a = r.visualElement;
    return Vt(n) ? n.syncUpdate() : (Yf(a), n.add(a)), null;
  }, t.prototype.componentDidUpdate = function() {
    var r = this.props.syncLayout;
    Vt(r) || r.flush();
  }, t.prototype.render = function() {
    return null;
  }, t;
}(Et.Component);
function w2(e) {
  var t = Oe(vu), r = Oe(b2);
  return /* @__PURE__ */ u(x2, {
    ...P({}, e, {
      syncLayout: t,
      framerSyncLayout: r
    })
  });
}
var L2 = {
  measureLayout: w2,
  layoutAnimation: v2
}, T2 = function() {
  return {
    isEnabled: !1,
    isHydrated: !1,
    isTargetLocked: !1,
    target: Pt(),
    targetFinal: Pt()
  };
};
function mu() {
  return {
    isHydrated: !1,
    layout: Pt(),
    layoutCorrected: Pt(),
    treeScale: { x: 1, y: 1 },
    delta: mo(),
    deltaFinal: mo(),
    deltaTransform: ""
  };
}
var Io = mu();
function Un(e, t, r) {
  var n = e.x, a = e.y, i = n.translate / t.x, o = a.translate / t.y, s = "translate3d(" + i + "px, " + o + "px, 0) ";
  if (r) {
    var l = r.rotate, d = r.rotateX, c = r.rotateY;
    l && (s += "rotate(" + l + ") "), d && (s += "rotateX(" + d + ") "), c && (s += "rotateY(" + c + ") ");
  }
  return s += "scale(" + n.scale + ", " + a.scale + ")", !r && s === M2 ? "" : s;
}
function hu(e) {
  var t = e.deltaFinal;
  return t.x.origin * 100 + "% " + t.y.origin * 100 + "% 0";
}
var M2 = Un(Io.delta, Io.treeScale, { x: 1, y: 1 }), ln = [
  "LayoutMeasure",
  "BeforeLayoutMeasure",
  "LayoutUpdate",
  "ViewportBoxUpdate",
  "Update",
  "Render",
  "AnimationComplete",
  "LayoutAnimationComplete",
  "AnimationStart",
  "SetAxisTarget",
  "Unmount"
];
function A2() {
  var e = ln.map(function() {
    return new yn();
  }), t = {}, r = {
    clearAllListeners: function() {
      return e.forEach(function(n) {
        return n.clear();
      });
    },
    updatePropListeners: function(n) {
      return ln.forEach(function(a) {
        var i;
        (i = t[a]) === null || i === void 0 || i.call(t);
        var o = "on" + a, s = n[o];
        s && (t[a] = r[o](s));
      });
    }
  };
  return e.forEach(function(n, a) {
    r["on" + ln[a]] = function(i) {
      return n.add(i);
    }, r["notify" + ln[a]] = function() {
      for (var i = [], o = 0; o < arguments.length; o++)
        i[o] = arguments[o];
      return n.notify.apply(n, Fe([], Re(i)));
    };
  }), r;
}
function R2(e, t, r) {
  var n;
  for (var a in t) {
    var i = t[a], o = r[a];
    if (St(i))
      e.addValue(a, i);
    else if (St(o))
      e.addValue(a, It(i));
    else if (o !== i)
      if (e.hasValue(a)) {
        var s = e.getValue(a);
        !s.hasAnimated && s.set(i);
      } else
        e.addValue(a, It((n = e.getStaticValue(a)) !== null && n !== void 0 ? n : i));
  }
  for (var a in r)
    t[a] === void 0 && e.removeValue(a);
  return t;
}
function S2(e, t, r, n) {
  var a = e.delta, i = e.layout, o = e.layoutCorrected, s = e.treeScale, l = t.target;
  Xf(o, i), Qf(o, s, r), ou(a, o, l, n);
}
var P2 = function() {
  function e() {
    this.children = [], this.isDirty = !1;
  }
  return e.prototype.add = function(t) {
    Ks(this.children, t), this.isDirty = !0;
  }, e.prototype.remove = function(t) {
    Xs(this.children, t), this.isDirty = !0;
  }, e.prototype.forEach = function(t) {
    this.isDirty && this.children.sort(bi), this.isDirty = !1, this.children.forEach(t);
  }, e;
}();
function E2(e) {
  var t = e.getProjectionParent();
  if (!t) {
    e.rebaseProjectionTarget();
    return;
  }
  var r = or(t.getLayoutState().layout, e.getLayoutState().layout);
  Ue(function(n) {
    e.setProjectionTargetAxis(n, r[n].min, r[n].max, !0);
  });
}
var gu = function(e) {
  var t = e.treeType, r = t === void 0 ? "" : t, n = e.build, a = e.getBaseTarget, i = e.makeTargetAnimatable, o = e.measureViewportBox, s = e.render, l = e.readValueFromInstance, d = e.resetTransform, c = e.restoreTransform, p = e.removeValueFromRenderState, v = e.sortNodePosition, m = e.scrapeMotionValuesFromProps;
  return function(h, C) {
    var y = h.parent, x = h.props, T = h.presenceId, M = h.blockInitialAnimation, f = h.visualState;
    C === void 0 && (C = {});
    var b = f.latestValues, w = f.renderState, V, S = A2(), k = T2(), I, $ = k, X = b, G, F = mu(), z, J = !1, se = /* @__PURE__ */ new Map(), ee = /* @__PURE__ */ new Map(), pe = {}, le, ve = P({}, b), B;
    function Z() {
      !V || (W.isProjectionReady() && (ka($.targetFinal, $.target, X), ou(F.deltaFinal, F.layoutCorrected, $.targetFinal, b)), U(), s(V, w));
    }
    function U() {
      var A = b;
      if (z && z.isActive()) {
        var _ = z.getCrossfadeState(W);
        _ && (A = _);
      }
      n(W, w, A, $, F, C, x);
    }
    function te() {
      S.notifyUpdate(b);
    }
    function L() {
      if (!!W.isProjectionReady()) {
        var A = F.delta, _ = F.treeScale, q = _.x, ne = _.y, Le = F.deltaTransform;
        S2(F, $, W.path, b), J && W.notifyViewportBoxUpdate($.target, A), J = !1;
        var ae = Un(A, _);
        (ae !== Le || q !== _.x || ne !== _.y) && W.scheduleRender(), F.deltaTransform = ae;
      }
    }
    function ce() {
      W.layoutTree.forEach(O2);
    }
    function j(A, _) {
      var q = _.onChange(function(Le) {
        b[A] = Le, x.onUpdate && mt.update(te, !1, !0);
      }), ne = _.onRenderRequest(W.scheduleRender);
      ee.set(A, function() {
        q(), ne();
      });
    }
    var ye = m(x);
    for (var ue in ye) {
      var me = ye[ue];
      b[ue] !== void 0 && St(me) && me.set(b[ue], !1);
    }
    var O = $n(x), we = G1(x), W = P(P({
      treeType: r,
      current: null,
      depth: y ? y.depth + 1 : 0,
      parent: y,
      children: /* @__PURE__ */ new Set(),
      path: y ? Fe(Fe([], Re(y.path)), [y]) : [],
      layoutTree: y ? y.layoutTree : new P2(),
      presenceId: T,
      projection: k,
      variantChildren: we ? /* @__PURE__ */ new Set() : void 0,
      isVisible: void 0,
      manuallyAnimateOnMount: Boolean(y == null ? void 0 : y.isMounted()),
      blockInitialAnimation: M,
      isMounted: function() {
        return Boolean(V);
      },
      mount: function(A) {
        V = W.current = A, W.pointTo(W), we && y && !O && (B = y == null ? void 0 : y.addVariantChild(W)), y == null || y.children.add(W);
      },
      unmount: function() {
        Tr.update(te), Tr.render(Z), Tr.preRender(W.updateLayoutProjection), ee.forEach(function(A) {
          return A();
        }), W.stopLayoutAnimation(), W.layoutTree.remove(W), B == null || B(), y == null || y.children.delete(W), G == null || G(), S.clearAllListeners();
      },
      addVariantChild: function(A) {
        var _, q = W.getClosestVariantNode();
        if (q)
          return (_ = q.variantChildren) === null || _ === void 0 || _.add(A), function() {
            return q.variantChildren.delete(A);
          };
      },
      sortNodePosition: function(A) {
        return !v || r !== A.treeType ? 0 : v(W.getInstance(), A.getInstance());
      },
      getClosestVariantNode: function() {
        return we ? W : y == null ? void 0 : y.getClosestVariantNode();
      },
      scheduleUpdateLayoutProjection: y ? y.scheduleUpdateLayoutProjection : function() {
        return mt.preRender(W.updateTreeLayoutProjection, !1, !0);
      },
      getLayoutId: function() {
        return x.layoutId;
      },
      getInstance: function() {
        return V;
      },
      getStaticValue: function(A) {
        return b[A];
      },
      setStaticValue: function(A, _) {
        return b[A] = _;
      },
      getLatestValues: function() {
        return b;
      },
      setVisibility: function(A) {
        W.isVisible !== A && (W.isVisible = A, W.scheduleRender());
      },
      makeTargetAnimatable: function(A, _) {
        return _ === void 0 && (_ = !0), i(W, A, x, _);
      },
      addValue: function(A, _) {
        W.hasValue(A) && W.removeValue(A), se.set(A, _), b[A] = _.get(), j(A, _);
      },
      removeValue: function(A) {
        var _;
        se.delete(A), (_ = ee.get(A)) === null || _ === void 0 || _(), ee.delete(A), delete b[A], p(A, w);
      },
      hasValue: function(A) {
        return se.has(A);
      },
      getValue: function(A, _) {
        var q = se.get(A);
        return q === void 0 && _ !== void 0 && (q = It(_), W.addValue(A, q)), q;
      },
      forEachValue: function(A) {
        return se.forEach(A);
      },
      readValue: function(A) {
        var _;
        return (_ = b[A]) !== null && _ !== void 0 ? _ : l(V, A, C);
      },
      setBaseTarget: function(A, _) {
        ve[A] = _;
      },
      getBaseTarget: function(A) {
        if (a) {
          var _ = a(x, A);
          if (_ !== void 0 && !St(_))
            return _;
        }
        return ve[A];
      }
    }, S), {
      build: function() {
        return U(), w;
      },
      scheduleRender: function() {
        mt.render(Z, !1, !0);
      },
      syncRender: Z,
      setProps: function(A) {
        x = A, S.updatePropListeners(A), pe = R2(W, m(x), pe);
      },
      getProps: function() {
        return x;
      },
      getVariant: function(A) {
        var _;
        return (_ = x.variants) === null || _ === void 0 ? void 0 : _[A];
      },
      getDefaultTransition: function() {
        return x.transition;
      },
      getVariantContext: function(A) {
        if (A === void 0 && (A = !1), A)
          return y == null ? void 0 : y.getVariantContext();
        if (!O) {
          var _ = (y == null ? void 0 : y.getVariantContext()) || {};
          return x.initial !== void 0 && (_.initial = x.initial), _;
        }
        for (var q = {}, ne = 0; ne < _2; ne++) {
          var Le = yu[ne], ae = x[Le];
          (st(ae) || ae === !1) && (q[Le] = ae);
        }
        return q;
      },
      enableLayoutProjection: function() {
        k.isEnabled = !0, W.layoutTree.add(W);
      },
      lockProjectionTarget: function() {
        k.isTargetLocked = !0;
      },
      unlockProjectionTarget: function() {
        W.stopLayoutAnimation(), k.isTargetLocked = !1;
      },
      getLayoutState: function() {
        return F;
      },
      setCrossfader: function(A) {
        z = A;
      },
      isProjectionReady: function() {
        return k.isEnabled && k.isHydrated && F.isHydrated;
      },
      startLayoutAnimation: function(A, _, q) {
        q === void 0 && (q = !1);
        var ne = W.getProjectionAnimationProgress()[A], Le = q ? k.relativeTarget[A] : k.target[A], ae = Le.min, Se = Le.max, Ve = Se - ae;
        return ne.clearListeners(), ne.set(ae), ne.set(ae), ne.onChange(function(Te) {
          W.setProjectionTargetAxis(A, Te, Te + Ve, q);
        }), W.animateMotionValue(A, ne, 0, _);
      },
      stopLayoutAnimation: function() {
        Ue(function(A) {
          return W.getProjectionAnimationProgress()[A].stop();
        });
      },
      measureViewportBox: function(A) {
        A === void 0 && (A = !0);
        var _ = o(V, C);
        return A || du(_, b), _;
      },
      getProjectionAnimationProgress: function() {
        return le || (le = {
          x: It(0),
          y: It(0)
        }), le;
      },
      setProjectionTargetAxis: function(A, _, q, ne) {
        ne === void 0 && (ne = !1);
        var Le;
        ne ? (k.relativeTarget || (k.relativeTarget = Pt()), Le = k.relativeTarget[A]) : (k.relativeTarget = void 0, Le = k.target[A]), k.isHydrated = !0, Le.min = _, Le.max = q, J = !0, S.notifySetAxisTarget();
      },
      rebaseProjectionTarget: function(A, _) {
        _ === void 0 && (_ = F.layout);
        var q = W.getProjectionAnimationProgress(), ne = q.x, Le = q.y, ae = !k.relativeTarget && !k.isTargetLocked && !ne.isAnimating() && !Le.isAnimating();
        (A || ae) && Ue(function(Se) {
          var Ve = _[Se], Te = Ve.min, Q = Ve.max;
          W.setProjectionTargetAxis(Se, Te, Q);
        });
      },
      notifyLayoutReady: function(A) {
        E2(W), W.notifyLayoutUpdate(F.layout, W.prevViewportBox || F.layout, A);
      },
      resetTransform: function() {
        return d(W, V, x);
      },
      restoreTransform: function() {
        return c(V, w);
      },
      updateLayoutProjection: L,
      updateTreeLayoutProjection: function() {
        W.layoutTree.forEach(k2), mt.preRender(ce, !1, !0);
      },
      getProjectionParent: function() {
        if (I === void 0) {
          for (var A = !1, _ = W.path.length - 1; _ >= 0; _--) {
            var q = W.path[_];
            if (q.projection.isEnabled) {
              A = q;
              break;
            }
          }
          I = A;
        }
        return I;
      },
      resolveRelativeTargetBox: function() {
        var A = W.getProjectionParent();
        if (!(!k.relativeTarget || !A) && (Uf(k, A.projection), uu(A))) {
          var _ = k.target;
          ka(_, _, A.getLatestValues());
        }
      },
      shouldResetTransform: function() {
        return Boolean(x._layoutResetTransform);
      },
      pointTo: function(A) {
        $ = A.projection, X = A.getLatestValues(), G == null || G(), G = qr(A.onSetAxisTarget(W.scheduleUpdateLayoutProjection), A.onLayoutAnimationComplete(function() {
          var _;
          W.isPresent ? W.presence = jr.Present : (_ = W.layoutSafeToRemove) === null || _ === void 0 || _.call(W);
        }));
      },
      isPresent: !0,
      presence: jr.Entering
    });
    return W;
  };
};
function k2(e) {
  e.resolveRelativeTargetBox();
}
function O2(e) {
  e.updateLayoutProjection();
}
var yu = Fe(["initial"], Re(Ci)), _2 = yu.length, V2 = /* @__PURE__ */ new Set([
  "width",
  "height",
  "top",
  "left",
  "right",
  "bottom",
  "x",
  "y"
]), Cu = function(e) {
  return V2.has(e);
}, H2 = function(e) {
  return Object.keys(e).some(Cu);
}, bu = function(e, t) {
  e.set(t, !1), e.set(t);
}, cn = function(e) {
  return e === Wt || e === oe;
}, No;
(function(e) {
  e.width = "width", e.height = "height", e.left = "left", e.right = "right", e.top = "top", e.bottom = "bottom";
})(No || (No = {}));
var Bo = function(e, t) {
  return parseFloat(e.split(", ")[t]);
}, $o = function(e, t) {
  return function(r, n) {
    var a = n.transform;
    if (a === "none" || !a)
      return 0;
    var i = a.match(/^matrix3d\((.+)\)$/);
    if (i)
      return Bo(i[1], t);
    var o = a.match(/^matrix\((.+)\)$/);
    return o ? Bo(o[1], e) : 0;
  };
}, D2 = /* @__PURE__ */ new Set(["x", "y", "z"]), j2 = kr.filter(function(e) {
  return !D2.has(e);
});
function I2(e) {
  var t = [];
  return j2.forEach(function(r) {
    var n = e.getValue(r);
    n !== void 0 && (t.push([r, n.get()]), n.set(r.startsWith("scale") ? 1 : 0));
  }), t.length && e.syncRender(), t;
}
var Zo = {
  width: function(e) {
    var t = e.x;
    return t.max - t.min;
  },
  height: function(e) {
    var t = e.y;
    return t.max - t.min;
  },
  top: function(e, t) {
    var r = t.top;
    return parseFloat(r);
  },
  left: function(e, t) {
    var r = t.left;
    return parseFloat(r);
  },
  bottom: function(e, t) {
    var r = e.y, n = t.top;
    return parseFloat(n) + (r.max - r.min);
  },
  right: function(e, t) {
    var r = e.x, n = t.left;
    return parseFloat(n) + (r.max - r.min);
  },
  x: $o(4, 13),
  y: $o(5, 14)
}, N2 = function(e, t, r) {
  var n = t.measureViewportBox(), a = t.getInstance(), i = getComputedStyle(a), o = i.display, s = i.top, l = i.left, d = i.bottom, c = i.right, p = i.transform, v = { top: s, left: l, bottom: d, right: c, transform: p };
  o === "none" && t.setStaticValue("display", e.display || "block"), t.syncRender();
  var m = t.measureViewportBox();
  return r.forEach(function(h) {
    var C = t.getValue(h);
    bu(C, Zo[h](n, v)), e[h] = Zo[h](m, i);
  }), e;
}, B2 = function(e, t, r, n) {
  r === void 0 && (r = {}), n === void 0 && (n = {}), t = P({}, t), n = P({}, n);
  var a = Object.keys(t).filter(Cu), i = [], o = !1, s = [];
  if (a.forEach(function(d) {
    var c = e.getValue(d);
    if (!!e.hasValue(d)) {
      var p = r[d], v = t[d], m = sn(p), h;
      if (_r(v))
        for (var C = v.length, y = v[0] === null ? 1 : 0; y < C; y++)
          h ? Ye(sn(v[y]) === h, "All keyframes must be of the same type") : (h = sn(v[y]), Ye(h === m || cn(m) && cn(h), "Keyframes must be of the same dimension as the current value"));
      else
        h = sn(v);
      if (m !== h)
        if (cn(m) && cn(h)) {
          var x = c.get();
          typeof x == "string" && c.set(parseFloat(x)), typeof v == "string" ? t[d] = parseFloat(v) : Array.isArray(v) && h === oe && (t[d] = v.map(parseFloat));
        } else
          (m == null ? void 0 : m.transform) && (h == null ? void 0 : h.transform) && (p === 0 || v === 0) ? p === 0 ? c.set(h.transform(p)) : t[d] = m.transform(v) : (o || (i = I2(e), o = !0), s.push(d), n[d] = n[d] !== void 0 ? n[d] : t[d], bu(c, v));
    }
  }), s.length) {
    var l = N2(t, e, s);
    return i.length && i.forEach(function(d) {
      var c = Re(d, 2), p = c[0], v = c[1];
      e.getValue(p).set(v);
    }), e.syncRender(), { target: l, transitionEnd: n };
  } else
    return { target: t, transitionEnd: n };
};
function $2(e, t, r, n) {
  return H2(t) ? B2(e, t, r, n) : { target: t, transitionEnd: n };
}
var Z2 = function(e, t, r, n) {
  var a = l2(e, t, n);
  return t = a.target, n = a.transitionEnd, $2(e, t, r, n);
};
function F2(e) {
  return window.getComputedStyle(e);
}
var xu = {
  treeType: "dom",
  readValueFromInstance: function(e, t) {
    if (Zn(t)) {
      var r = hi(t);
      return r && r.default || 0;
    } else {
      var n = F2(e);
      return (es(t) ? n.getPropertyValue(t) : n[t]) || 0;
    }
  },
  sortNodePosition: function(e, t) {
    return e.compareDocumentPosition(t) & 2 ? 1 : -1;
  },
  getBaseTarget: function(e, t) {
    var r;
    return (r = e.style) === null || r === void 0 ? void 0 : r[t];
  },
  measureViewportBox: function(e, t) {
    var r = t.transformPagePoint;
    return iu(e, r);
  },
  resetTransform: function(e, t, r) {
    var n = r.transformTemplate;
    t.style.transform = n ? n({}, "") : "none", e.scheduleRender();
  },
  restoreTransform: function(e, t) {
    e.style.transform = t.style.transform;
  },
  removeValueFromRenderState: function(e, t) {
    var r = t.vars, n = t.style;
    delete r[e], delete n[e];
  },
  makeTargetAnimatable: function(e, t, r, n) {
    var a = r.transformValues;
    n === void 0 && (n = !0);
    var i = t.transition, o = t.transitionEnd, s = nt(t, ["transition", "transitionEnd"]), l = Cf(s, i || {}, e);
    if (a && (o && (o = a(o)), s && (s = a(s)), l && (l = a(l))), n) {
      gf(e, s, l);
      var d = Z2(e, s, l, o);
      o = d.transitionEnd, s = d.target;
    }
    return P({
      transition: i,
      transitionEnd: o
    }, s);
  },
  scrapeMotionValuesFromProps: si,
  build: function(e, t, r, n, a, i, o) {
    e.isVisible !== void 0 && (t.style.visibility = e.isVisible ? "visible" : "hidden");
    var s = n.isEnabled && a.isHydrated;
    ai(t, r, n, a, i, o.transformTemplate, s ? Un : void 0, s ? hu : void 0);
  },
  render: ps
}, W2 = gu(xu), U2 = gu(P(P({}, xu), {
  getBaseTarget: function(e, t) {
    return e[t];
  },
  readValueFromInstance: function(e, t) {
    var r;
    return Zn(t) ? ((r = hi(t)) === null || r === void 0 ? void 0 : r.default) || 0 : (t = vs.has(t) ? t : fs(t), e.getAttribute(t));
  },
  scrapeMotionValuesFromProps: hs,
  build: function(e, t, r, n, a, i, o) {
    var s = n.isEnabled && a.isHydrated;
    oi(t, r, n, a, i, o.transformTemplate, s ? Un : void 0, s ? hu : void 0);
  },
  render: ms
})), z2 = function(e, t) {
  return ri(e) ? U2(t, { enableHardwareAcceleration: !1 }) : W2(t, { enableHardwareAcceleration: !0 });
}, Y2 = P(P(P(P({}, Ef), Gd), o2), L2), at = /* @__PURE__ */ Yl(function(e, t) {
  return jc(e, t, Y2, z2);
});
function q2() {
  var e = Qe(!1), t = Re($e(0), 2), r = t[0], n = t[1];
  return di(function() {
    return e.current = !0;
  }), B1(function() {
    !e.current && n(r + 1);
  }, [r]);
}
var Fo = 0;
function K2() {
  var e = Fo;
  return Fo++, e;
}
var la = function(e) {
  var t = e.children, r = e.initial, n = e.isPresent, a = e.onExitComplete, i = e.custom, o = e.presenceAffectsLayout, s = Er(X2), l = Er(K2), d = Pr(
    function() {
      return {
        id: l,
        initial: r,
        isPresent: n,
        custom: i,
        onExitComplete: function(c) {
          s.set(c, !0);
          var p = !0;
          s.forEach(function(v) {
            v || (p = !1);
          }), p && (a == null || a());
        },
        register: function(c) {
          return s.set(c, !1), function() {
            return s.delete(c);
          };
        }
      };
    },
    o ? void 0 : [n]
  );
  return Pr(function() {
    s.forEach(function(c, p) {
      return s.set(p, !1);
    });
  }, [n]), I1.useEffect(function() {
    !n && !s.size && (a == null || a());
  }, [n]), /* @__PURE__ */ u(Wr.Provider, {
    value: d,
    children: t
  });
};
function X2() {
  return /* @__PURE__ */ new Map();
}
function Gt(e) {
  return e.key || "";
}
function G2(e, t) {
  var r = process.env.NODE_ENV !== "production" ? /* @__PURE__ */ new Set() : null;
  e.forEach(function(n) {
    var a = Gt(n);
    process.env.NODE_ENV !== "production" && r && (r.has(a) && console.warn('Children of AnimatePresence require unique keys. "' + a + '" is a duplicate.'), r.add(a)), t.set(a, n);
  });
}
function J2(e) {
  var t = [];
  return Tl.forEach(e, function(r) {
    Ml(r) && t.push(r);
  }), t;
}
var zn = function(e) {
  var t = e.children, r = e.custom, n = e.initial, a = n === void 0 ? !0 : n, i = e.onExitComplete, o = e.exitBeforeEnter, s = e.presenceAffectsLayout, l = s === void 0 ? !0 : s, d = q2(), c = Oe(vu);
  Vt(c) && (d = c.forceUpdate);
  var p = Qe(!0), v = J2(t), m = Qe(v), h = Qe(/* @__PURE__ */ new Map()).current, C = Qe(/* @__PURE__ */ new Set()).current;
  if (G2(v, h), p.current)
    return p.current = !1, /* @__PURE__ */ u(He, {
      children: v.map(function(w) {
        return /* @__PURE__ */ u(la, {
          isPresent: !0,
          initial: a ? void 0 : !1,
          presenceAffectsLayout: l,
          children: w
        }, Gt(w));
      })
    });
  for (var y = Fe([], Re(v)), x = m.current.map(Gt), T = v.map(Gt), M = x.length, f = 0; f < M; f++) {
    var b = x[f];
    T.indexOf(b) === -1 ? C.add(b) : C.delete(b);
  }
  return o && C.size && (y = []), C.forEach(function(w) {
    if (T.indexOf(w) === -1) {
      var V = h.get(w);
      if (!!V) {
        var S = x.indexOf(w), k = function() {
          h.delete(w), C.delete(w);
          var I = m.current.findIndex(function($) {
            return $.key === w;
          });
          m.current.splice(I, 1), C.size || (m.current = v, d(), i && i());
        };
        y.splice(S, 0, /* @__PURE__ */ u(la, {
          isPresent: !1,
          onExitComplete: k,
          custom: r,
          presenceAffectsLayout: l,
          children: V
        }, Gt(V)));
      }
    }
  }), y = y.map(function(w) {
    var V = w.key;
    return C.has(V) ? w : /* @__PURE__ */ u(la, {
      isPresent: !0,
      presenceAffectsLayout: l,
      children: w
    }, Gt(w));
  }), m.current = y, process.env.NODE_ENV !== "production" && o && y.length > 1 && console.warn("You're attempting to animate multiple children within AnimatePresence, but its exitBeforeEnter prop is set to true. This will lead to odd visual behaviour."), /* @__PURE__ */ u(He, {
    children: C.size ? y : y.map(function(w) {
      return Ja(w);
    })
  });
}, Xr = { exports: {} }, be = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Wo;
function Q2() {
  if (Wo)
    return be;
  Wo = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, d = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, p = e ? Symbol.for("react.suspense") : 60113, v = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, h = e ? Symbol.for("react.lazy") : 60116, C = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, x = e ? Symbol.for("react.responder") : 60118, T = e ? Symbol.for("react.scope") : 60119;
  function M(b) {
    if (typeof b == "object" && b !== null) {
      var w = b.$$typeof;
      switch (w) {
        case t:
          switch (b = b.type, b) {
            case l:
            case d:
            case n:
            case i:
            case a:
            case p:
              return b;
            default:
              switch (b = b && b.$$typeof, b) {
                case s:
                case c:
                case h:
                case m:
                case o:
                  return b;
                default:
                  return w;
              }
          }
        case r:
          return w;
      }
    }
  }
  function f(b) {
    return M(b) === d;
  }
  return be.AsyncMode = l, be.ConcurrentMode = d, be.ContextConsumer = s, be.ContextProvider = o, be.Element = t, be.ForwardRef = c, be.Fragment = n, be.Lazy = h, be.Memo = m, be.Portal = r, be.Profiler = i, be.StrictMode = a, be.Suspense = p, be.isAsyncMode = function(b) {
    return f(b) || M(b) === l;
  }, be.isConcurrentMode = f, be.isContextConsumer = function(b) {
    return M(b) === s;
  }, be.isContextProvider = function(b) {
    return M(b) === o;
  }, be.isElement = function(b) {
    return typeof b == "object" && b !== null && b.$$typeof === t;
  }, be.isForwardRef = function(b) {
    return M(b) === c;
  }, be.isFragment = function(b) {
    return M(b) === n;
  }, be.isLazy = function(b) {
    return M(b) === h;
  }, be.isMemo = function(b) {
    return M(b) === m;
  }, be.isPortal = function(b) {
    return M(b) === r;
  }, be.isProfiler = function(b) {
    return M(b) === i;
  }, be.isStrictMode = function(b) {
    return M(b) === a;
  }, be.isSuspense = function(b) {
    return M(b) === p;
  }, be.isValidElementType = function(b) {
    return typeof b == "string" || typeof b == "function" || b === n || b === d || b === i || b === a || b === p || b === v || typeof b == "object" && b !== null && (b.$$typeof === h || b.$$typeof === m || b.$$typeof === o || b.$$typeof === s || b.$$typeof === c || b.$$typeof === y || b.$$typeof === x || b.$$typeof === T || b.$$typeof === C);
  }, be.typeOf = M, be;
}
var xe = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Uo;
function e0() {
  return Uo || (Uo = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, r = e ? Symbol.for("react.portal") : 60106, n = e ? Symbol.for("react.fragment") : 60107, a = e ? Symbol.for("react.strict_mode") : 60108, i = e ? Symbol.for("react.profiler") : 60114, o = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, d = e ? Symbol.for("react.concurrent_mode") : 60111, c = e ? Symbol.for("react.forward_ref") : 60112, p = e ? Symbol.for("react.suspense") : 60113, v = e ? Symbol.for("react.suspense_list") : 60120, m = e ? Symbol.for("react.memo") : 60115, h = e ? Symbol.for("react.lazy") : 60116, C = e ? Symbol.for("react.block") : 60121, y = e ? Symbol.for("react.fundamental") : 60117, x = e ? Symbol.for("react.responder") : 60118, T = e ? Symbol.for("react.scope") : 60119;
    function M(O) {
      return typeof O == "string" || typeof O == "function" || O === n || O === d || O === i || O === a || O === p || O === v || typeof O == "object" && O !== null && (O.$$typeof === h || O.$$typeof === m || O.$$typeof === o || O.$$typeof === s || O.$$typeof === c || O.$$typeof === y || O.$$typeof === x || O.$$typeof === T || O.$$typeof === C);
    }
    function f(O) {
      if (typeof O == "object" && O !== null) {
        var we = O.$$typeof;
        switch (we) {
          case t:
            var W = O.type;
            switch (W) {
              case l:
              case d:
              case n:
              case i:
              case a:
              case p:
                return W;
              default:
                var A = W && W.$$typeof;
                switch (A) {
                  case s:
                  case c:
                  case h:
                  case m:
                  case o:
                    return A;
                  default:
                    return we;
                }
            }
          case r:
            return we;
        }
      }
    }
    var b = l, w = d, V = s, S = o, k = t, I = c, $ = n, X = h, G = m, F = r, z = i, J = a, se = p, ee = !1;
    function pe(O) {
      return ee || (ee = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), le(O) || f(O) === l;
    }
    function le(O) {
      return f(O) === d;
    }
    function ve(O) {
      return f(O) === s;
    }
    function B(O) {
      return f(O) === o;
    }
    function Z(O) {
      return typeof O == "object" && O !== null && O.$$typeof === t;
    }
    function U(O) {
      return f(O) === c;
    }
    function te(O) {
      return f(O) === n;
    }
    function L(O) {
      return f(O) === h;
    }
    function ce(O) {
      return f(O) === m;
    }
    function j(O) {
      return f(O) === r;
    }
    function ye(O) {
      return f(O) === i;
    }
    function ue(O) {
      return f(O) === a;
    }
    function me(O) {
      return f(O) === p;
    }
    xe.AsyncMode = b, xe.ConcurrentMode = w, xe.ContextConsumer = V, xe.ContextProvider = S, xe.Element = k, xe.ForwardRef = I, xe.Fragment = $, xe.Lazy = X, xe.Memo = G, xe.Portal = F, xe.Profiler = z, xe.StrictMode = J, xe.Suspense = se, xe.isAsyncMode = pe, xe.isConcurrentMode = le, xe.isContextConsumer = ve, xe.isContextProvider = B, xe.isElement = Z, xe.isForwardRef = U, xe.isFragment = te, xe.isLazy = L, xe.isMemo = ce, xe.isPortal = j, xe.isProfiler = ye, xe.isStrictMode = ue, xe.isSuspense = me, xe.isValidElementType = M, xe.typeOf = f;
  }()), xe;
}
(function(e) {
  process.env.NODE_ENV === "production" ? e.exports = Q2() : e.exports = e0();
})(Xr);
function t0(e) {
  function t(B, Z, U, te, L) {
    for (var ce = 0, j = 0, ye = 0, ue = 0, me, O, we = 0, W = 0, A, _ = A = me = 0, q = 0, ne = 0, Le = 0, ae = 0, Se = U.length, Ve = Se - 1, Te, Q = "", Ce = "", dt = "", ft = "", je; q < Se; ) {
      if (O = U.charCodeAt(q), q === Ve && j + ue + ye + ce !== 0 && (j !== 0 && (O = j === 47 ? 10 : 47), ue = ye = ce = 0, Se++, Ve++), j + ue + ye + ce === 0) {
        if (q === Ve && (0 < ne && (Q = Q.replace(v, "")), 0 < Q.trim().length)) {
          switch (O) {
            case 32:
            case 9:
            case 59:
            case 13:
            case 10:
              break;
            default:
              Q += U.charAt(q);
          }
          O = 59;
        }
        switch (O) {
          case 123:
            for (Q = Q.trim(), me = Q.charCodeAt(0), A = 1, ae = ++q; q < Se; ) {
              switch (O = U.charCodeAt(q)) {
                case 123:
                  A++;
                  break;
                case 125:
                  A--;
                  break;
                case 47:
                  switch (O = U.charCodeAt(q + 1)) {
                    case 42:
                    case 47:
                      e: {
                        for (_ = q + 1; _ < Ve; ++_)
                          switch (U.charCodeAt(_)) {
                            case 47:
                              if (O === 42 && U.charCodeAt(_ - 1) === 42 && q + 2 !== _) {
                                q = _ + 1;
                                break e;
                              }
                              break;
                            case 10:
                              if (O === 47) {
                                q = _ + 1;
                                break e;
                              }
                          }
                        q = _;
                      }
                  }
                  break;
                case 91:
                  O++;
                case 40:
                  O++;
                case 34:
                case 39:
                  for (; q++ < Ve && U.charCodeAt(q) !== O; )
                    ;
              }
              if (A === 0)
                break;
              q++;
            }
            switch (A = U.substring(ae, q), me === 0 && (me = (Q = Q.replace(p, "").trim()).charCodeAt(0)), me) {
              case 64:
                switch (0 < ne && (Q = Q.replace(v, "")), O = Q.charCodeAt(1), O) {
                  case 100:
                  case 109:
                  case 115:
                  case 45:
                    ne = Z;
                    break;
                  default:
                    ne = J;
                }
                if (A = t(Z, ne, A, O, L + 1), ae = A.length, 0 < ee && (ne = r(J, Q, Le), je = s(3, A, ne, Z, G, X, ae, O, L, te), Q = ne.join(""), je !== void 0 && (ae = (A = je.trim()).length) === 0 && (O = 0, A = "")), 0 < ae)
                  switch (O) {
                    case 115:
                      Q = Q.replace(w, o);
                    case 100:
                    case 109:
                    case 45:
                      A = Q + "{" + A + "}";
                      break;
                    case 107:
                      Q = Q.replace(T, "$1 $2"), A = Q + "{" + A + "}", A = z === 1 || z === 2 && i("@" + A, 3) ? "@-webkit-" + A + "@" + A : "@" + A;
                      break;
                    default:
                      A = Q + A, te === 112 && (A = (Ce += A, ""));
                  }
                else
                  A = "";
                break;
              default:
                A = t(Z, r(Z, Q, Le), A, te, L + 1);
            }
            dt += A, A = Le = ne = _ = me = 0, Q = "", O = U.charCodeAt(++q);
            break;
          case 125:
          case 59:
            if (Q = (0 < ne ? Q.replace(v, "") : Q).trim(), 1 < (ae = Q.length))
              switch (_ === 0 && (me = Q.charCodeAt(0), me === 45 || 96 < me && 123 > me) && (ae = (Q = Q.replace(" ", ":")).length), 0 < ee && (je = s(1, Q, Z, B, G, X, Ce.length, te, L, te)) !== void 0 && (ae = (Q = je.trim()).length) === 0 && (Q = "\0\0"), me = Q.charCodeAt(0), O = Q.charCodeAt(1), me) {
                case 0:
                  break;
                case 64:
                  if (O === 105 || O === 99) {
                    ft += Q + U.charAt(q);
                    break;
                  }
                default:
                  Q.charCodeAt(ae - 1) !== 58 && (Ce += a(Q, me, O, Q.charCodeAt(2)));
              }
            Le = ne = _ = me = 0, Q = "", O = U.charCodeAt(++q);
        }
      }
      switch (O) {
        case 13:
        case 10:
          j === 47 ? j = 0 : 1 + me === 0 && te !== 107 && 0 < Q.length && (ne = 1, Q += "\0"), 0 < ee * le && s(0, Q, Z, B, G, X, Ce.length, te, L, te), X = 1, G++;
          break;
        case 59:
        case 125:
          if (j + ue + ye + ce === 0) {
            X++;
            break;
          }
        default:
          switch (X++, Te = U.charAt(q), O) {
            case 9:
            case 32:
              if (ue + ce + j === 0)
                switch (we) {
                  case 44:
                  case 58:
                  case 9:
                  case 32:
                    Te = "";
                    break;
                  default:
                    O !== 32 && (Te = " ");
                }
              break;
            case 0:
              Te = "\\0";
              break;
            case 12:
              Te = "\\f";
              break;
            case 11:
              Te = "\\v";
              break;
            case 38:
              ue + j + ce === 0 && (ne = Le = 1, Te = "\f" + Te);
              break;
            case 108:
              if (ue + j + ce + F === 0 && 0 < _)
                switch (q - _) {
                  case 2:
                    we === 112 && U.charCodeAt(q - 3) === 58 && (F = we);
                  case 8:
                    W === 111 && (F = W);
                }
              break;
            case 58:
              ue + j + ce === 0 && (_ = q);
              break;
            case 44:
              j + ye + ue + ce === 0 && (ne = 1, Te += "\r");
              break;
            case 34:
            case 39:
              j === 0 && (ue = ue === O ? 0 : ue === 0 ? O : ue);
              break;
            case 91:
              ue + j + ye === 0 && ce++;
              break;
            case 93:
              ue + j + ye === 0 && ce--;
              break;
            case 41:
              ue + j + ce === 0 && ye--;
              break;
            case 40:
              if (ue + j + ce === 0) {
                if (me === 0)
                  switch (2 * we + 3 * W) {
                    case 533:
                      break;
                    default:
                      me = 1;
                  }
                ye++;
              }
              break;
            case 64:
              j + ye + ue + ce + _ + A === 0 && (A = 1);
              break;
            case 42:
            case 47:
              if (!(0 < ue + ce + ye))
                switch (j) {
                  case 0:
                    switch (2 * O + 3 * U.charCodeAt(q + 1)) {
                      case 235:
                        j = 47;
                        break;
                      case 220:
                        ae = q, j = 42;
                    }
                    break;
                  case 42:
                    O === 47 && we === 42 && ae + 2 !== q && (U.charCodeAt(ae + 2) === 33 && (Ce += U.substring(ae, q + 1)), Te = "", j = 0);
                }
          }
          j === 0 && (Q += Te);
      }
      W = we, we = O, q++;
    }
    if (ae = Ce.length, 0 < ae) {
      if (ne = Z, 0 < ee && (je = s(2, Ce, ne, B, G, X, ae, te, L, te), je !== void 0 && (Ce = je).length === 0))
        return ft + Ce + dt;
      if (Ce = ne.join(",") + "{" + Ce + "}", z * F !== 0) {
        switch (z !== 2 || i(Ce, 2) || (F = 0), F) {
          case 111:
            Ce = Ce.replace(f, ":-moz-$1") + Ce;
            break;
          case 112:
            Ce = Ce.replace(M, "::-webkit-input-$1") + Ce.replace(M, "::-moz-$1") + Ce.replace(M, ":-ms-input-$1") + Ce;
        }
        F = 0;
      }
    }
    return ft + Ce + dt;
  }
  function r(B, Z, U) {
    var te = Z.trim().split(y);
    Z = te;
    var L = te.length, ce = B.length;
    switch (ce) {
      case 0:
      case 1:
        var j = 0;
        for (B = ce === 0 ? "" : B[0] + " "; j < L; ++j)
          Z[j] = n(B, Z[j], U).trim();
        break;
      default:
        var ye = j = 0;
        for (Z = []; j < L; ++j)
          for (var ue = 0; ue < ce; ++ue)
            Z[ye++] = n(B[ue] + " ", te[j], U).trim();
    }
    return Z;
  }
  function n(B, Z, U) {
    var te = Z.charCodeAt(0);
    switch (33 > te && (te = (Z = Z.trim()).charCodeAt(0)), te) {
      case 38:
        return Z.replace(x, "$1" + B.trim());
      case 58:
        return B.trim() + Z.replace(x, "$1" + B.trim());
      default:
        if (0 < 1 * U && 0 < Z.indexOf("\f"))
          return Z.replace(x, (B.charCodeAt(0) === 58 ? "" : "$1") + B.trim());
    }
    return B + Z;
  }
  function a(B, Z, U, te) {
    var L = B + ";", ce = 2 * Z + 3 * U + 4 * te;
    if (ce === 944) {
      B = L.indexOf(":", 9) + 1;
      var j = L.substring(B, L.length - 1).trim();
      return j = L.substring(0, B).trim() + j + ";", z === 1 || z === 2 && i(j, 1) ? "-webkit-" + j + j : j;
    }
    if (z === 0 || z === 2 && !i(L, 1))
      return L;
    switch (ce) {
      case 1015:
        return L.charCodeAt(10) === 97 ? "-webkit-" + L + L : L;
      case 951:
        return L.charCodeAt(3) === 116 ? "-webkit-" + L + L : L;
      case 963:
        return L.charCodeAt(5) === 110 ? "-webkit-" + L + L : L;
      case 1009:
        if (L.charCodeAt(4) !== 100)
          break;
      case 969:
      case 942:
        return "-webkit-" + L + L;
      case 978:
        return "-webkit-" + L + "-moz-" + L + L;
      case 1019:
      case 983:
        return "-webkit-" + L + "-moz-" + L + "-ms-" + L + L;
      case 883:
        if (L.charCodeAt(8) === 45)
          return "-webkit-" + L + L;
        if (0 < L.indexOf("image-set(", 11))
          return L.replace($, "$1-webkit-$2") + L;
        break;
      case 932:
        if (L.charCodeAt(4) === 45)
          switch (L.charCodeAt(5)) {
            case 103:
              return "-webkit-box-" + L.replace("-grow", "") + "-webkit-" + L + "-ms-" + L.replace("grow", "positive") + L;
            case 115:
              return "-webkit-" + L + "-ms-" + L.replace("shrink", "negative") + L;
            case 98:
              return "-webkit-" + L + "-ms-" + L.replace("basis", "preferred-size") + L;
          }
        return "-webkit-" + L + "-ms-" + L + L;
      case 964:
        return "-webkit-" + L + "-ms-flex-" + L + L;
      case 1023:
        if (L.charCodeAt(8) !== 99)
          break;
        return j = L.substring(L.indexOf(":", 15)).replace("flex-", "").replace("space-between", "justify"), "-webkit-box-pack" + j + "-webkit-" + L + "-ms-flex-pack" + j + L;
      case 1005:
        return h.test(L) ? L.replace(m, ":-webkit-") + L.replace(m, ":-moz-") + L : L;
      case 1e3:
        switch (j = L.substring(13).trim(), Z = j.indexOf("-") + 1, j.charCodeAt(0) + j.charCodeAt(Z)) {
          case 226:
            j = L.replace(b, "tb");
            break;
          case 232:
            j = L.replace(b, "tb-rl");
            break;
          case 220:
            j = L.replace(b, "lr");
            break;
          default:
            return L;
        }
        return "-webkit-" + L + "-ms-" + j + L;
      case 1017:
        if (L.indexOf("sticky", 9) === -1)
          break;
      case 975:
        switch (Z = (L = B).length - 10, j = (L.charCodeAt(Z) === 33 ? L.substring(0, Z) : L).substring(B.indexOf(":", 7) + 1).trim(), ce = j.charCodeAt(0) + (j.charCodeAt(7) | 0)) {
          case 203:
            if (111 > j.charCodeAt(8))
              break;
          case 115:
            L = L.replace(j, "-webkit-" + j) + ";" + L;
            break;
          case 207:
          case 102:
            L = L.replace(j, "-webkit-" + (102 < ce ? "inline-" : "") + "box") + ";" + L.replace(j, "-webkit-" + j) + ";" + L.replace(j, "-ms-" + j + "box") + ";" + L;
        }
        return L + ";";
      case 938:
        if (L.charCodeAt(5) === 45)
          switch (L.charCodeAt(6)) {
            case 105:
              return j = L.replace("-items", ""), "-webkit-" + L + "-webkit-box-" + j + "-ms-flex-" + j + L;
            case 115:
              return "-webkit-" + L + "-ms-flex-item-" + L.replace(S, "") + L;
            default:
              return "-webkit-" + L + "-ms-flex-line-pack" + L.replace("align-content", "").replace(S, "") + L;
          }
        break;
      case 973:
      case 989:
        if (L.charCodeAt(3) !== 45 || L.charCodeAt(4) === 122)
          break;
      case 931:
      case 953:
        if (I.test(B) === !0)
          return (j = B.substring(B.indexOf(":") + 1)).charCodeAt(0) === 115 ? a(B.replace("stretch", "fill-available"), Z, U, te).replace(":fill-available", ":stretch") : L.replace(j, "-webkit-" + j) + L.replace(j, "-moz-" + j.replace("fill-", "")) + L;
        break;
      case 962:
        if (L = "-webkit-" + L + (L.charCodeAt(5) === 102 ? "-ms-" + L : "") + L, U + te === 211 && L.charCodeAt(13) === 105 && 0 < L.indexOf("transform", 10))
          return L.substring(0, L.indexOf(";", 27) + 1).replace(C, "$1-webkit-$2") + L;
    }
    return L;
  }
  function i(B, Z) {
    var U = B.indexOf(Z === 1 ? ":" : "{"), te = B.substring(0, Z !== 3 ? U : 10);
    return U = B.substring(U + 1, B.length - 1), pe(Z !== 2 ? te : te.replace(k, "$1"), U, Z);
  }
  function o(B, Z) {
    var U = a(Z, Z.charCodeAt(0), Z.charCodeAt(1), Z.charCodeAt(2));
    return U !== Z + ";" ? U.replace(V, " or ($1)").substring(4) : "(" + Z + ")";
  }
  function s(B, Z, U, te, L, ce, j, ye, ue, me) {
    for (var O = 0, we = Z, W; O < ee; ++O)
      switch (W = se[O].call(c, B, we, U, te, L, ce, j, ye, ue, me)) {
        case void 0:
        case !1:
        case !0:
        case null:
          break;
        default:
          we = W;
      }
    if (we !== Z)
      return we;
  }
  function l(B) {
    switch (B) {
      case void 0:
      case null:
        ee = se.length = 0;
        break;
      default:
        if (typeof B == "function")
          se[ee++] = B;
        else if (typeof B == "object")
          for (var Z = 0, U = B.length; Z < U; ++Z)
            l(B[Z]);
        else
          le = !!B | 0;
    }
    return l;
  }
  function d(B) {
    return B = B.prefix, B !== void 0 && (pe = null, B ? typeof B != "function" ? z = 1 : (z = 2, pe = B) : z = 0), d;
  }
  function c(B, Z) {
    var U = B;
    if (33 > U.charCodeAt(0) && (U = U.trim()), ve = U, U = [ve], 0 < ee) {
      var te = s(-1, Z, U, U, G, X, 0, 0, 0, 0);
      te !== void 0 && typeof te == "string" && (Z = te);
    }
    var L = t(J, U, Z, 0, 0);
    return 0 < ee && (te = s(-2, L, U, U, G, X, L.length, 0, 0, 0), te !== void 0 && (L = te)), ve = "", F = 0, X = G = 1, L;
  }
  var p = /^\0+/g, v = /[\0\r\f]/g, m = /: */g, h = /zoo|gra/, C = /([,: ])(transform)/g, y = /,\r+?/g, x = /([\t\r\n ])*\f?&/g, T = /@(k\w+)\s*(\S*)\s*/, M = /::(place)/g, f = /:(read-only)/g, b = /[svh]\w+-[tblr]{2}/, w = /\(\s*(.*)\s*\)/g, V = /([\s\S]*?);/g, S = /-self|flex-/g, k = /[^]*?(:[rp][el]a[\w-]+)[^]*/, I = /stretch|:\s*\w+\-(?:conte|avail)/, $ = /([^-])(image-set\()/, X = 1, G = 1, F = 0, z = 1, J = [], se = [], ee = 0, pe = null, le = 0, ve = "";
  return c.use = l, c.set = d, e !== void 0 && d(e), c;
}
var r0 = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
function n0(e) {
  var t = {};
  return function(r) {
    return t[r] === void 0 && (t[r] = e(r)), t[r];
  };
}
var a0 = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/, zo = n0(
  function(e) {
    return a0.test(e) || e.charCodeAt(0) === 111 && e.charCodeAt(1) === 110 && e.charCodeAt(2) < 91;
  }
), xi = Xr.exports, i0 = {
  childContextTypes: !0,
  contextType: !0,
  contextTypes: !0,
  defaultProps: !0,
  displayName: !0,
  getDefaultProps: !0,
  getDerivedStateFromError: !0,
  getDerivedStateFromProps: !0,
  mixins: !0,
  propTypes: !0,
  type: !0
}, o0 = {
  name: !0,
  length: !0,
  prototype: !0,
  caller: !0,
  callee: !0,
  arguments: !0,
  arity: !0
}, s0 = {
  $$typeof: !0,
  render: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0
}, wu = {
  $$typeof: !0,
  compare: !0,
  defaultProps: !0,
  displayName: !0,
  propTypes: !0,
  type: !0
}, wi = {};
wi[xi.ForwardRef] = s0;
wi[xi.Memo] = wu;
function Yo(e) {
  return xi.isMemo(e) ? wu : wi[e.$$typeof] || i0;
}
var u0 = Object.defineProperty, l0 = Object.getOwnPropertyNames, qo = Object.getOwnPropertySymbols, c0 = Object.getOwnPropertyDescriptor, d0 = Object.getPrototypeOf, Ko = Object.prototype;
function Lu(e, t, r) {
  if (typeof t != "string") {
    if (Ko) {
      var n = d0(t);
      n && n !== Ko && Lu(e, n, r);
    }
    var a = l0(t);
    qo && (a = a.concat(qo(t)));
    for (var i = Yo(e), o = Yo(t), s = 0; s < a.length; ++s) {
      var l = a[s];
      if (!o0[l] && !(r && r[l]) && !(o && o[l]) && !(i && i[l])) {
        var d = c0(t, l);
        try {
          u0(e, l, d);
        } catch {
        }
      }
    }
  }
  return e;
}
var f0 = Lu;
function ht() {
  return ht = Object.assign || function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var r = arguments[t];
      for (var n in r)
        Object.prototype.hasOwnProperty.call(r, n) && (e[n] = r[n]);
    }
    return e;
  }, ht.apply(this, arguments);
}
function p0(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
var Xo = function(e, t) {
  for (var r = [e[0]], n = 0, a = t.length; n < a; n += 1)
    r.push(t[n], e[n + 1]);
  return r;
}, Li = function(e) {
  return e !== null && typeof e == "object" && (e.toString ? e.toString() : Object.prototype.toString.call(e)) === "[object Object]" && !Xr.exports.typeOf(e);
}, On = Object.freeze([]), Bt = Object.freeze({});
function Gr(e) {
  return typeof e == "function";
}
function Ti(e) {
  return (process.env.NODE_ENV !== "production" ? typeof e == "string" && e : !1) || e.displayName || e.name || "Component";
}
function v0(e) {
  return typeof e == "function" && !(e.prototype && e.prototype.isReactComponent);
}
function Mi(e) {
  return e && typeof e.styledComponentId == "string";
}
var fr = typeof process < "u" && (process.env.REACT_APP_SC_ATTR || process.env.SC_ATTR) || "data-styled", Tu = "active", Mu = "data-styled-version", Au = "5.1.1", Ai = `/*!sc*/
`, Ri = typeof window < "u" && "HTMLElement" in window, m0 = typeof SC_DISABLE_SPEEDY == "boolean" && SC_DISABLE_SPEEDY || typeof process < "u" && (process.env.REACT_APP_SC_DISABLE_SPEEDY || process.env.SC_DISABLE_SPEEDY) || process.env.NODE_ENV !== "production", h0 = function() {
  return typeof __webpack_nonce__ < "u" ? __webpack_nonce__ : null;
}, g0 = {
  1: `Cannot create styled-component for component: %s.

`,
  2: `Can't collect styles once you've consumed a \`ServerStyleSheet\`'s styles! \`ServerStyleSheet\` is a one off instance for each server-side render cycle.

- Are you trying to reuse it across renders?
- Are you accidentally calling collectStyles twice?

`,
  3: `Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.

`,
  4: `The \`StyleSheetManager\` expects a valid target or sheet prop!

- Does this error occur on the client and is your target falsy?
- Does this error occur on the server and is the sheet falsy?

`,
  5: `The clone method cannot be used on the client!

- Are you running in a client-like environment on the server?
- Are you trying to run SSR on the client?

`,
  6: `Trying to insert a new style tag, but the given Node is unmounted!

- Are you using a custom target that isn't mounted?
- Does your document not have a valid head element?
- Have you accidentally removed a style tag manually?

`,
  7: 'ThemeProvider: Please return an object from your "theme" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n',
  8: `ThemeProvider: Please make your "theme" prop an object.

`,
  9: "Missing document `<head>`\n\n",
  10: `Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021

`,
  11: `_This error was replaced with a dev-time warning, it will be deleted for v4 final._ [createGlobalStyle] received children which will not be rendered. Please use the component without passing children elements.

`,
  12: "It seems you are interpolating a keyframe declaration (%s) into an untagged string. This was supported in styled-components v3, but is not longer supported in v4 as keyframes are now injected on-demand. Please wrap your string in the css\\`\\` helper which ensures the styles are injected correctly. See https://www.styled-components.com/docs/api#css\n\n",
  13: `%s is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details.

`,
  14: `ThemeProvider: "theme" prop is required.

`,
  15: "A stylis plugin has been supplied that is not named. We need a name for each plugin to be able to prevent styling collisions between different stylis configurations within the same app. Before you pass your plugin to `<StyleSheetManager stylisPlugins={[]}>`, please make sure each plugin is uniquely-named, e.g.\n\n```js\nObject.defineProperty(importedPlugin, 'name', { value: 'some-unique-name' });\n```\n\n",
  16: `Reached the limit of how many styled components may be created at group %s.
You may only create up to 1,073,741,824 components. If you're creating components dynamically,
as for instance in your render method then you may be running into this limitation.

`,
  17: `CSSStyleSheet could not be found on HTMLStyleElement.
Has styled-components' style tag been unmounted or altered by another script?
`
}, y0 = process.env.NODE_ENV !== "production" ? g0 : {};
function C0() {
  for (var e = arguments.length <= 0 ? void 0 : arguments[0], t = [], r = 1, n = arguments.length; r < n; r += 1)
    t.push(r < 0 || arguments.length <= r ? void 0 : arguments[r]);
  return t.forEach(function(a) {
    e = e.replace(/%[a-z]/, a);
  }), e;
}
function pr(e) {
  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
    r[n - 1] = arguments[n];
  throw process.env.NODE_ENV === "production" ? new Error("An error occurred. See https://github.com/styled-components/styled-components/blob/master/packages/styled-components/src/utils/errors.md#" + e + " for more information." + (r.length > 0 ? " Additional arguments: " + r.join(", ") : "")) : new Error(C0.apply(void 0, [y0[e]].concat(r)).trim());
}
var b0 = 1, x0 = function(t) {
  for (var r = t.childNodes, n = r.length; n >= 0; n--) {
    var a = r[n];
    if (a && a.nodeType === b0 && a.hasAttribute(fr))
      return a;
  }
}, Ru = function(t) {
  var r = document.head, n = t || r, a = document.createElement("style"), i = x0(n), o = i !== void 0 ? i.nextSibling : null;
  a.setAttribute(fr, Tu), a.setAttribute(Mu, Au);
  var s = h0();
  return s && a.setAttribute("nonce", s), n.insertBefore(a, o), a;
}, w0 = function(t) {
  if (t.sheet)
    return t.sheet;
  for (var r = document, n = r.styleSheets, a = 0, i = n.length; a < i; a++) {
    var o = n[a];
    if (o.ownerNode === t)
      return o;
  }
  pr(17);
}, L0 = function(t) {
  var r = t.isServer, n = t.useCSSOMInjection, a = t.target;
  return r ? new A0(a) : n ? new T0(a) : new M0(a);
}, T0 = /* @__PURE__ */ function() {
  function e(r) {
    var n = this.element = Ru(r);
    n.appendChild(document.createTextNode("")), this.sheet = w0(n), this.length = 0;
  }
  var t = e.prototype;
  return t.insertRule = function(n, a) {
    try {
      return this.sheet.insertRule(a, n), this.length++, !0;
    } catch {
      return !1;
    }
  }, t.deleteRule = function(n) {
    this.sheet.deleteRule(n), this.length--;
  }, t.getRule = function(n) {
    var a = this.sheet.cssRules[n];
    return a !== void 0 && typeof a.cssText == "string" ? a.cssText : "";
  }, e;
}(), M0 = /* @__PURE__ */ function() {
  function e(r) {
    var n = this.element = Ru(r);
    this.nodes = n.childNodes, this.length = 0;
  }
  var t = e.prototype;
  return t.insertRule = function(n, a) {
    if (n <= this.length && n >= 0) {
      var i = document.createTextNode(a), o = this.nodes[n];
      return this.element.insertBefore(i, o || null), this.length++, !0;
    } else
      return !1;
  }, t.deleteRule = function(n) {
    this.element.removeChild(this.nodes[n]), this.length--;
  }, t.getRule = function(n) {
    return n < this.length ? this.nodes[n].textContent : "";
  }, e;
}(), A0 = /* @__PURE__ */ function() {
  function e(r) {
    this.rules = [], this.length = 0;
  }
  var t = e.prototype;
  return t.insertRule = function(n, a) {
    return n <= this.length ? (this.rules.splice(n, 0, a), this.length++, !0) : !1;
  }, t.deleteRule = function(n) {
    this.rules.splice(n, 1), this.length--;
  }, t.getRule = function(n) {
    return n < this.length ? this.rules[n] : "";
  }, e;
}(), R0 = function(t) {
  return new S0(t);
}, Go = 1 << 9, S0 = /* @__PURE__ */ function() {
  function e(r) {
    this.groupSizes = new Uint32Array(Go), this.length = Go, this.tag = r;
  }
  var t = e.prototype;
  return t.indexOfGroup = function(n) {
    for (var a = 0, i = 0; i < n; i++)
      a += this.groupSizes[i];
    return a;
  }, t.insertRules = function(n, a) {
    if (n >= this.groupSizes.length) {
      for (var i = this.groupSizes, o = i.length, s = o; n >= s; )
        s <<= 1, s < 0 && pr(16, "" + n);
      this.groupSizes = new Uint32Array(s), this.groupSizes.set(i), this.length = s;
      for (var l = o; l < s; l++)
        this.groupSizes[l] = 0;
    }
    for (var d = this.indexOfGroup(n + 1), c = 0, p = a.length; c < p; c++)
      this.tag.insertRule(d, a[c]) && (this.groupSizes[n]++, d++);
  }, t.clearGroup = function(n) {
    if (n < this.length) {
      var a = this.groupSizes[n], i = this.indexOfGroup(n), o = i + a;
      this.groupSizes[n] = 0;
      for (var s = i; s < o; s++)
        this.tag.deleteRule(i);
    }
  }, t.getGroup = function(n) {
    var a = "";
    if (n >= this.length || this.groupSizes[n] === 0)
      return a;
    for (var i = this.groupSizes[n], o = this.indexOfGroup(n), s = o + i, l = o; l < s; l++)
      a += "" + this.tag.getRule(l) + Ai;
    return a;
  }, e;
}(), P0 = 1 << 31 - 1, bn = /* @__PURE__ */ new Map(), Si = /* @__PURE__ */ new Map(), ja = 1, dn = function(t) {
  if (bn.has(t))
    return bn.get(t);
  var r = ja++;
  return process.env.NODE_ENV !== "production" && ((r | 0) < 0 || r > P0) && pr(16, "" + r), bn.set(t, r), Si.set(r, t), r;
}, E0 = function(t) {
  return Si.get(t);
}, k0 = function(t, r) {
  r >= ja && (ja = r + 1), bn.set(t, r), Si.set(r, t);
}, O0 = "style[" + fr + "][" + Mu + '="' + Au + '"]', _0 = new RegExp("^" + fr + '\\.g(\\d+)\\[id="([\\w\\d-]+)"\\].*?"([^"]*)'), V0 = function(t) {
  for (var r = t.getTag(), n = r.length, a = "", i = 0; i < n; i++) {
    var o = E0(i);
    if (o !== void 0) {
      var s = t.names.get(o), l = r.getGroup(i);
      if (!(s === void 0 || l.length === 0)) {
        var d = fr + ".g" + i + '[id="' + o + '"]', c = "";
        s !== void 0 && s.forEach(function(p) {
          p.length > 0 && (c += p + ",");
        }), a += "" + l + d + '{content:"' + c + '"}' + Ai;
      }
    }
  }
  return a;
}, H0 = function(t, r, n) {
  for (var a = n.split(","), i, o = 0, s = a.length; o < s; o++)
    (i = a[o]) && t.registerName(r, i);
}, D0 = function(t, r) {
  for (var n = r.innerHTML.split(Ai), a = [], i = 0, o = n.length; i < o; i++) {
    var s = n[i].trim();
    if (!!s) {
      var l = s.match(_0);
      if (l) {
        var d = parseInt(l[1], 10) | 0, c = l[2];
        d !== 0 && (k0(c, d), H0(t, c, l[3]), t.getTag().insertRules(d, a)), a.length = 0;
      } else
        a.push(s);
    }
  }
}, j0 = function(t) {
  for (var r = document.querySelectorAll(O0), n = 0, a = r.length; n < a; n++) {
    var i = r[n];
    i && i.getAttribute(fr) !== Tu && (D0(t, i), i.parentNode && i.parentNode.removeChild(i));
  }
}, Jo = Ri, Qo = {
  isServer: !Ri,
  useCSSOMInjection: !m0
}, Su = /* @__PURE__ */ function() {
  e.registerId = function(n) {
    return dn(n);
  };
  function e(r, n, a) {
    r === void 0 && (r = Qo), n === void 0 && (n = {}), this.options = ht({}, Qo, {}, r), this.gs = n, this.names = new Map(a), !this.options.isServer && Ri && Jo && (Jo = !1, j0(this));
  }
  var t = e.prototype;
  return t.reconstructWithOptions = function(n) {
    return new e(ht({}, this.options, {}, n), this.gs, this.names);
  }, t.allocateGSInstance = function(n) {
    return this.gs[n] = (this.gs[n] || 0) + 1;
  }, t.getTag = function() {
    return this.tag || (this.tag = R0(L0(this.options)));
  }, t.hasNameForId = function(n, a) {
    return this.names.has(n) && this.names.get(n).has(a);
  }, t.registerName = function(n, a) {
    if (dn(n), this.names.has(n))
      this.names.get(n).add(a);
    else {
      var i = /* @__PURE__ */ new Set();
      i.add(a), this.names.set(n, i);
    }
  }, t.insertRules = function(n, a, i) {
    this.registerName(n, a), this.getTag().insertRules(dn(n), i);
  }, t.clearNames = function(n) {
    this.names.has(n) && this.names.get(n).clear();
  }, t.clearRules = function(n) {
    this.getTag().clearGroup(dn(n)), this.clearNames(n);
  }, t.clearTag = function() {
    this.tag = void 0;
  }, t.toString = function() {
    return V0(this);
  }, e;
}(), Pu = 5381, rr = function(t, r) {
  for (var n = r.length; n; )
    t = t * 33 ^ r.charCodeAt(--n);
  return t;
}, Eu = function(t) {
  return rr(Pu, t);
};
function I0(e) {
  var t = "/*|*/", r = t + "}";
  function n(a) {
    if (a)
      try {
        e(a + "}");
      } catch {
      }
  }
  return function(i, o, s, l, d, c, p, v, m, h) {
    switch (i) {
      case 1:
        if (m === 0 && o.charCodeAt(0) === 64)
          return e(o + ";"), "";
        break;
      case 2:
        if (v === 0)
          return o + t;
        break;
      case 3:
        switch (v) {
          case 102:
          case 112:
            return e(s[0] + o), "";
          default:
            return o + (h === 0 ? t : "");
        }
      case -2:
        o.split(r).forEach(n);
    }
  };
}
var N0 = /^\s*\/\/.*$/gm;
function B0(e) {
  var t = e === void 0 ? Bt : e, r = t.options, n = r === void 0 ? Bt : r, a = t.plugins, i = a === void 0 ? On : a, o = new t0(n), s = [], l = function(x) {
    if (x === -2) {
      var T = s;
      return s = [], T;
    }
  }, d = I0(function(y) {
    s.push(y);
  }), c, p, v, m = function(x, T, M) {
    return T > 0 && M.slice(0, T).indexOf(p) !== -1 && M.slice(T - p.length, T) !== p ? "." + c : x;
  }, h = function(x, T, M) {
    x === 2 && M.length && M[0].lastIndexOf(p) > 0 && (M[0] = M[0].replace(v, m));
  };
  o.use([].concat(i, [h, d, l]));
  function C(y, x, T, M) {
    M === void 0 && (M = "&");
    var f = y.replace(N0, ""), b = x && T ? T + " " + x + " { " + f + " }" : f;
    return c = M, p = x, v = new RegExp("\\" + p + "\\b", "g"), o(T || !x ? "" : x, b);
  }
  return C.hash = i.length ? i.reduce(function(y, x) {
    return x.name || pr(15), rr(y, x.name);
  }, Pu).toString() : "", C;
}
var ku = Et.createContext();
ku.Consumer;
var Ou = Et.createContext();
Ou.Consumer;
var $0 = new Su(), _u = B0();
function Z0() {
  return Oe(ku) || $0;
}
function F0() {
  return Oe(Ou) || _u;
}
var W0 = /* @__PURE__ */ function() {
  function e(r, n) {
    var a = this;
    this.inject = function(i) {
      i.hasNameForId(a.id, a.name) || i.insertRules(a.id, a.name, _u.apply(void 0, a.stringifyArgs));
    }, this.toString = function() {
      return pr(12, String(a.name));
    }, this.name = r, this.id = "sc-keyframes-" + r, this.stringifyArgs = n;
  }
  var t = e.prototype;
  return t.getName = function() {
    return this.name;
  }, e;
}(), U0 = /([A-Z])/g, z0 = /^ms-/;
function e1(e) {
  return e.replace(U0, "-$1").toLowerCase().replace(z0, "-ms-");
}
function Y0(e, t) {
  return t == null || typeof t == "boolean" || t === "" ? "" : typeof t == "number" && t !== 0 && !(e in r0) ? t + "px" : String(t).trim();
}
var Vu = function(t) {
  return t == null || t === !1 || t === "";
}, q0 = function e(t, r) {
  var n = [], a = Object.keys(t);
  return a.forEach(function(i) {
    if (!Vu(t[i])) {
      if (Li(t[i]))
        return n.push.apply(n, e(t[i], i)), n;
      if (Gr(t[i]))
        return n.push(e1(i) + ":", t[i], ";"), n;
      n.push(e1(i) + ": " + Y0(i, t[i]) + ";");
    }
    return n;
  }), r ? [r + " {"].concat(n, ["}"]) : n;
};
function sr(e, t, r) {
  if (Array.isArray(e)) {
    for (var n = [], a = 0, i = e.length, o; a < i; a += 1)
      o = sr(e[a], t, r), o !== "" && (Array.isArray(o) ? n.push.apply(n, o) : n.push(o));
    return n;
  }
  if (Vu(e))
    return "";
  if (Mi(e))
    return "." + e.styledComponentId;
  if (Gr(e))
    if (v0(e) && t) {
      var s = e(t);
      return process.env.NODE_ENV !== "production" && Xr.exports.isElement(s) && console.warn(Ti(e) + " is not a styled component and cannot be referred to via component selector. See https://www.styled-components.com/docs/advanced#referring-to-other-components for more details."), sr(s, t, r);
    } else
      return e;
  return e instanceof W0 ? r ? (e.inject(r), e.getName()) : e : Li(e) ? q0(e) : e.toString();
}
function Hu(e) {
  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
    r[n - 1] = arguments[n];
  return Gr(e) || Li(e) ? sr(Xo(On, [e].concat(r))) : r.length === 0 && e.length === 1 && typeof e[0] == "string" ? e : sr(Xo(e, r));
}
function Ia(e, t, r) {
  if (r === void 0 && (r = Bt), !Xr.exports.isValidElementType(t))
    return pr(1, String(t));
  var n = function() {
    return e(t, r, Hu.apply(void 0, arguments));
  };
  return n.withConfig = function(a) {
    return Ia(e, t, ht({}, r, {}, a));
  }, n.attrs = function(a) {
    return Ia(e, t, ht({}, r, {
      attrs: Array.prototype.concat(r.attrs, a).filter(Boolean)
    }));
  }, n;
}
var Na = function(t) {
  return typeof t == "function" || typeof t == "object" && t !== null && !Array.isArray(t);
}, K0 = function(t) {
  return t !== "__proto__" && t !== "constructor" && t !== "prototype";
};
function X0(e, t, r) {
  var n = e[r];
  Na(t) && Na(n) ? Du(n, t) : e[r] = t;
}
function Du(e) {
  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
    r[n - 1] = arguments[n];
  for (var a = 0, i = r; a < i.length; a++) {
    var o = i[a];
    if (Na(o))
      for (var s in o)
        K0(s) && X0(e, o[s], s);
  }
  return e;
}
var G0 = /(a)(d)/gi, fn = 52, t1 = function(t) {
  return String.fromCharCode(t + (t > 25 ? 39 : 97));
};
function Ba(e) {
  var t = "", r;
  for (r = Math.abs(e); r > fn; r = r / fn | 0)
    t = t1(r % fn) + t;
  return (t1(r % fn) + t).replace(G0, "$1-$2");
}
function J0(e) {
  for (var t = 0; t < e.length; t += 1) {
    var r = e[t];
    if (Gr(r) && !Mi(r))
      return !1;
  }
  return !0;
}
var Q0 = /* @__PURE__ */ function() {
  function e(r, n) {
    this.rules = r, this.staticRulesId = "", this.isStatic = process.env.NODE_ENV === "production" && J0(r), this.componentId = n, this.baseHash = Eu(n), Su.registerId(n);
  }
  var t = e.prototype;
  return t.generateAndInjectStyles = function(n, a, i) {
    var o = this.componentId;
    if (this.isStatic && !i.hash) {
      if (this.staticRulesId && a.hasNameForId(o, this.staticRulesId))
        return this.staticRulesId;
      var s = sr(this.rules, n, a).join(""), l = Ba(rr(this.baseHash, s.length) >>> 0);
      if (!a.hasNameForId(o, l)) {
        var d = i(s, "." + l, void 0, o);
        a.insertRules(o, l, d);
      }
      return this.staticRulesId = l, l;
    } else {
      for (var c = this.rules.length, p = rr(this.baseHash, i.hash), v = "", m = 0; m < c; m++) {
        var h = this.rules[m];
        if (typeof h == "string")
          v += h, process.env.NODE_ENV !== "production" && (p = rr(p, h + m));
        else {
          var C = sr(h, n, a), y = Array.isArray(C) ? C.join("") : C;
          p = rr(p, y + m), v += y;
        }
      }
      var x = Ba(p >>> 0);
      if (!a.hasNameForId(o, x)) {
        var T = i(v, "." + x, void 0, o);
        a.insertRules(o, x, T);
      }
      return x;
    }
  }, e;
}(), r1 = 200, e5 = function(e, t) {
  var r = {}, n = !1;
  return function(a) {
    if (!n && (r[a] = !0, Object.keys(r).length >= r1)) {
      var i = t ? ' with the id of "' + t + '"' : "";
      console.warn("Over " + r1 + " classes were generated for component " + e + i + `.
Consider using the attrs method, together with a style object for frequently changed styles.
Example:
  const Component = styled.div.attrs(props => ({
    style: {
      background: props.background,
    },
  }))\`width: 100%;\`

  <Component />`), n = !0, r = {};
    }
  };
}, t5 = /invalid hook call/i, ca = /* @__PURE__ */ new Set(), r5 = function(t, r) {
  if (process.env.NODE_ENV !== "production") {
    var n = r ? ' with the id of "' + r + '"' : "", a = "The component " + t + n + ` has been created dynamically.
You may see this warning because you've called styled inside another component.
To resolve this only create new StyledComponents outside of any render method and function component.`;
    try {
      Qe(), ca.has(a) || (console.warn(a), ca.add(a));
    } catch (i) {
      t5.test(i.message) && ca.delete(a);
    }
  }
}, n5 = function(e, t, r) {
  return r === void 0 && (r = Bt), e.theme !== r.theme && e.theme || t || r.theme;
}, a5 = /[!"#$%&'()*+,./:;<=>?@[\\\]^`{|}~-]+/g, i5 = /(^-|-$)/g;
function $a(e) {
  return e.replace(a5, "-").replace(i5, "");
}
function _n(e) {
  return typeof e == "string" && (process.env.NODE_ENV !== "production" ? e.charAt(0) === e.charAt(0).toLowerCase() : !0);
}
function o5(e) {
  return _n(e) ? "styled." + e : "Styled(" + Ti(e) + ")";
}
var s5 = function(e) {
  return Ba(Eu(e) >>> 0);
};
function u5(e, t) {
  return e && t ? e + " " + t : e || t;
}
var ju = Et.createContext();
ju.Consumer;
var da = {};
function l5(e, t) {
  var r = typeof e != "string" ? "sc" : $a(e);
  da[r] = (da[r] || 0) + 1;
  var n = r + "-" + s5(r + da[r]);
  return t ? t + "-" + n : n;
}
function c5(e, t, r) {
  e === void 0 && (e = Bt);
  var n = ht({}, t, {
    theme: e
  }), a = {};
  return r.forEach(function(i) {
    var o = i, s;
    Gr(o) && (o = o(n));
    for (s in o)
      n[s] = a[s] = s === "className" ? u5(a[s], o[s]) : o[s];
  }), [n, a];
}
function d5(e, t, r, n) {
  var a = Z0(), i = F0(), o = e.isStatic && !t, s = o ? e.generateAndInjectStyles(Bt, a, i) : e.generateAndInjectStyles(r, a, i);
  return F1(s), process.env.NODE_ENV !== "production" && !o && n && n(s), s;
}
function f5(e, t, r) {
  var n = e.attrs, a = e.componentStyle, i = e.defaultProps, o = e.foldedComponentIds, s = e.shouldForwardProp, l = e.styledComponentId, d = e.target;
  F1(l);
  var c = n5(t, Oe(ju), i), p = c5(c || Bt, t, n), v = p[0], m = p[1], h = d5(a, n.length > 0, v, process.env.NODE_ENV !== "production" ? e.warnTooManyClasses : void 0), C = r, y = m.$as || t.$as || m.as || t.as || d, x = _n(y), T = m !== t ? ht({}, t, {}, m) : t, M = s || x && zo, f = {};
  for (var b in T)
    b[0] === "$" || b === "as" || (b === "forwardedAs" ? f.as = T[b] : (!M || M(b, zo)) && (f[b] = T[b]));
  return t.style && m.style !== t.style && (f.style = ht({}, t.style, {}, m.style)), f.className = Array.prototype.concat(o, l, h !== l ? h : null, t.className, m.className).filter(Boolean).join(" "), f.ref = C, Z1(y, f);
}
function Iu(e, t, r) {
  var n = Mi(e), a = !_n(e), i = t.displayName, o = i === void 0 ? o5(e) : i, s = t.componentId, l = s === void 0 ? l5(t.displayName, t.parentComponentId) : s, d = t.attrs, c = d === void 0 ? On : d, p = t.displayName && t.componentId ? $a(t.displayName) + "-" + t.componentId : t.componentId || l, v = n && e.attrs ? Array.prototype.concat(e.attrs, c).filter(Boolean) : c, m = t.shouldForwardProp;
  n && e.shouldForwardProp && (m ? m = function(T, M) {
    return e.shouldForwardProp(T, M) && t.shouldForwardProp(T, M);
  } : m = e.shouldForwardProp);
  var h = new Q0(n ? e.componentStyle.rules.concat(r) : r, p), C, y = function(T, M) {
    return f5(C, T, M);
  };
  return y.displayName = o, C = Et.forwardRef(y), C.attrs = v, C.componentStyle = h, C.displayName = o, C.shouldForwardProp = m, C.foldedComponentIds = n ? Array.prototype.concat(e.foldedComponentIds, e.styledComponentId) : On, C.styledComponentId = p, C.target = n ? e.target : e, C.withComponent = function(T) {
    var M = t.componentId, f = p0(t, ["componentId"]), b = M && M + "-" + (_n(T) ? T : $a(Ti(T))), w = ht({}, f, {
      attrs: v,
      componentId: b
    });
    return Iu(T, w, r);
  }, Object.defineProperty(C, "defaultProps", {
    get: function() {
      return this._foldedDefaultProps;
    },
    set: function(T) {
      this._foldedDefaultProps = n ? Du({}, e.defaultProps, T) : T;
    }
  }), process.env.NODE_ENV !== "production" && (r5(o, p), C.warnTooManyClasses = e5(o, p)), C.toString = function() {
    return "." + C.styledComponentId;
  }, a && f0(C, e, {
    attrs: !0,
    componentStyle: !0,
    displayName: !0,
    foldedComponentIds: !0,
    shouldForwardProp: !0,
    self: !0,
    styledComponentId: !0,
    target: !0,
    withComponent: !0
  }), C;
}
var p5 = [
  "a",
  "abbr",
  "address",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "bdi",
  "bdo",
  "big",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "cite",
  "code",
  "col",
  "colgroup",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "div",
  "dl",
  "dt",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "img",
  "input",
  "ins",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "main",
  "map",
  "mark",
  "marquee",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "nav",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "pre",
  "progress",
  "q",
  "rp",
  "rt",
  "ruby",
  "s",
  "samp",
  "script",
  "section",
  "select",
  "small",
  "source",
  "span",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "table",
  "tbody",
  "td",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  "circle",
  "clipPath",
  "defs",
  "ellipse",
  "foreignObject",
  "g",
  "image",
  "line",
  "linearGradient",
  "marker",
  "mask",
  "path",
  "pattern",
  "polygon",
  "polyline",
  "radialGradient",
  "rect",
  "stop",
  "svg",
  "text",
  "tspan"
], Za = function(t) {
  return Ia(Iu, t);
};
p5.forEach(function(e) {
  Za[e] = Za(e);
});
process.env.NODE_ENV !== "production" && typeof navigator < "u" && navigator.product === "ReactNative" && console.warn(`It looks like you've imported 'styled-components' on React Native.
Perhaps you're looking to import 'styled-components/native'?
Read more about this at https://www.styled-components.com/docs/basics#react-native`);
process.env.NODE_ENV !== "production" && process.env.NODE_ENV !== "test" && typeof window < "u" && (window["__styled-components-init__"] = window["__styled-components-init__"] || 0, window["__styled-components-init__"] === 1 && console.warn(`It looks like there are several instances of 'styled-components' initialized in this application. This may cause dynamic styles not rendering properly, errors happening during rehydration process, missing theme prop, and makes your application bigger without a good reason.

See https://s-c.sh/2BAXzed for more info.`), window["__styled-components-init__"] += 1);
const D = Za, n1 = ({
  color: e,
  count: t
}) => {
  const r = t != null ? t : 3, n = Array(r).fill(null).map((a, i) => /* @__PURE__ */ u(m5, {
    variants: g5,
    color: e
  }, i));
  return /* @__PURE__ */ u(v5, {
    variants: h5,
    initial: "initial",
    animate: "animate",
    children: n
  });
}, v5 = D(at.div)`
  display: flex;
  justify-content: center;
  align-items: center;
`, m5 = D(at.span)`
  width: 7px;
  height: 7px;
  border-radius: 50%;
  margin: 2px;
  background-color: var(${({
  color: e
}) => e});
`, h5 = {
  animate: {
    transition: {
      staggerChildren: 0.2
    }
  }
}, g5 = {
  initial: {
    y: "35%"
  },
  animate: {
    y: "-35%",
    transition: {
      repeat: 1 / 0,
      repeatType: "reverse",
      duration: 0.4
    }
  }
}, We = ({
  type: e,
  text: t,
  color: r,
  weight: n,
  textSize: a,
  lineHeight: i,
  letterSpacing: o,
  marginTop: s,
  opacity: l,
  textAlign: d,
  className: c,
  variants: p,
  initial: v,
  animate: m,
  ...h
}) => p ? /* @__PURE__ */ u(He, {
  children: /* @__PURE__ */ u(at.div, {
    variants: p,
    initial: v,
    animate: m,
    children: /* @__PURE__ */ u(a1, {
      as: e,
      color: r,
      weight: n,
      desktopFontSize: a.desktop,
      mobileFontSize: a.mobile,
      desktopLineHeight: i == null ? void 0 : i.desktop,
      mobileLineHeight: i == null ? void 0 : i.mobile,
      desktopLetterSpacing: o == null ? void 0 : o.desktop,
      mobileLetterSpacing: o == null ? void 0 : o.mobile,
      marginTop: s,
      opacity: l,
      textAlign: d,
      className: c,
      "data-testid": "slid-ips-text",
      ...h,
      children: t
    })
  })
}) : /* @__PURE__ */ u(He, {
  children: /* @__PURE__ */ u(a1, {
    as: e,
    color: r,
    weight: n,
    desktopFontSize: a.desktop,
    mobileFontSize: a.mobile,
    desktopLineHeight: i == null ? void 0 : i.desktop,
    mobileLineHeight: i == null ? void 0 : i.mobile,
    desktopLetterSpacing: o == null ? void 0 : o.desktop,
    mobileLetterSpacing: o == null ? void 0 : o.mobile,
    marginTop: s,
    opacity: l,
    textAlign: d,
    className: c,
    "data-testid": "slid-ips-text",
    ...h,
    children: t
  })
}), a1 = D.p`
  white-space: pre-wrap;
  color: var(${({
  color: e
}) => e});
  font-weight: ${({
  weight: e
}) => e};
  //
  font-size: ${({
  desktopFontSize: e
}) => e};
  line-height: ${({
  desktopLineHeight: e
}) => e};
  letter-spacing: ${({
  desktopLetterSpacing: e
}) => e};
  //
  /* This margin & padding setting is to solve the problem caused by bootstrap CSS  */
  margin: ${({
  marginTop: e
}) => e} 0 0 0;
  padding: 0;
  //
  opacity: ${({
  opacity: e
}) => e};
  text-align: ${({
  textAlign: e
}) => e};

  @media screen and (max-width: var(--max-width)) {
    font-size: ${({
  mobileFontSize: e
}) => e};
    line-height: ${({
  mobileLineHeight: e
}) => e};
    letter-spacing: ${({
  mobileLetterSpacing: e
}) => e};
  }
`, et = ({
  type: e,
  text: t,
  color: r,
  weight: n,
  marginTop: a,
  opacity: i,
  textAlign: o,
  className: s,
  variants: l,
  initial: d,
  animate: c,
  ...p
}) => /* @__PURE__ */ u(We, {
  type: e != null ? e : "p",
  text: t,
  color: r,
  weight: n != null ? n : 400,
  textSize: {
    desktop: "1.7rem",
    mobile: "1.7rem"
  },
  lineHeight: {
    desktop: "2.6rem",
    mobile: "2.6rem"
  },
  letterSpacing: {
    desktop: "0rem",
    mobile: "0rem"
  },
  marginTop: a,
  opacity: i,
  textAlign: o,
  className: s,
  variants: l,
  initial: d,
  animate: c,
  ...p
}), Ze = ({
  type: e,
  text: t,
  color: r,
  weight: n,
  marginTop: a,
  opacity: i,
  textAlign: o,
  className: s,
  variants: l,
  initial: d,
  animate: c,
  ...p
}) => /* @__PURE__ */ u(We, {
  type: e != null ? e : "p",
  text: t,
  color: r,
  weight: n != null ? n : 400,
  textSize: {
    desktop: "1.5rem",
    mobile: "1.5rem"
  },
  lineHeight: {
    desktop: "2.3rem",
    mobile: "2.3rem"
  },
  letterSpacing: {
    desktop: "0rem",
    mobile: "0rem"
  },
  marginTop: a,
  opacity: i,
  textAlign: o,
  className: s,
  variants: l,
  initial: d,
  animate: c,
  ...p
}), qe = ({
  type: e,
  text: t,
  color: r,
  weight: n,
  marginTop: a,
  opacity: i,
  textAlign: o,
  className: s,
  variants: l,
  initial: d,
  animate: c,
  ...p
}) => /* @__PURE__ */ u(We, {
  type: e != null ? e : "p",
  text: t,
  color: r,
  weight: n != null ? n : 400,
  textSize: {
    desktop: "1.3rem",
    mobile: "1.3rem"
  },
  lineHeight: {
    desktop: "1.8rem",
    mobile: "1.8rem"
  },
  letterSpacing: {
    desktop: "0rem",
    mobile: "0rem"
  },
  marginTop: a,
  opacity: i,
  textAlign: o,
  className: s,
  variants: l,
  initial: d,
  animate: c,
  ...p
}), ze = ({
  text: e,
  callback: t,
  appearance: r,
  size: n,
  icon: a,
  isDisabled: i,
  isLoading: o,
  marginTop: s,
  variants: l,
  type: d,
  initial: c,
  animate: p,
  customColor: v,
  focusOnRender: m,
  ...h
}) => {
  const C = Et.useRef(null), y = () => v || (r === "primary" ? i ? "--gray5" : "--gray1" : r === "line" ? i ? "--gray5" : "--gray15" : r === "secondary" ? i ? "--gray5" : "--gray9" : "--gray15"), x = (T, M, f) => {
    switch (M) {
      case "small":
        return /* @__PURE__ */ u(qe, {
          text: T,
          color: y(),
          weight: 700,
          textAlign: "center",
          className: f ? "button__visibility__hidden__to__constant__button__size" : "button__text__p__css__reset",
          type: "span"
        });
      case "medium":
        return /* @__PURE__ */ u(Ze, {
          text: T,
          color: y(),
          weight: 700,
          textAlign: "center",
          className: f ? "button__visibility__hidden__to__constant__button__size" : "button__text__p__css__reset",
          type: "span"
        });
      case "large":
        return /* @__PURE__ */ u(et, {
          text: T,
          color: y(),
          weight: 700,
          textAlign: "center",
          className: f ? "button__visibility__hidden__to__constant__button__size" : "button__text__p__css__reset",
          type: "span"
        });
      case "maxWidthLarge":
        return /* @__PURE__ */ u(et, {
          text: T,
          color: y(),
          weight: 700,
          textAlign: "center",
          className: f ? "button__visibility__hidden__to__constant__button__size" : "button__text__p__css__reset",
          type: "span"
        });
      case "autoWidth":
        return /* @__PURE__ */ u(et, {
          text: T,
          color: y(),
          weight: 700,
          textAlign: "center",
          className: f ? "button__visibility__hidden__to__constant__button__size" : "button__text__p__css__reset",
          type: "span"
        });
      default:
        return;
    }
  };
  return _e(() => {
    var T;
    m && ((T = C.current) == null || T.focus());
  }, []), /* @__PURE__ */ u(y5, {
    ref: C,
    "data-testid": "slid-ips-button",
    type: d || "button",
    onClick: () => t(),
    appearance: r,
    size: n,
    disabled: !!(i || o),
    isDisabled: i,
    isLoading: o,
    marginTop: s,
    variants: l,
    initial: c,
    animate: p,
    ...h,
    children: a ? /* @__PURE__ */ E(b5, {
      children: [/* @__PURE__ */ u(C5, {
        isLoading: o,
        children: a
      }), x(e, n, o), o && /* @__PURE__ */ u(i1, {
        children: /* @__PURE__ */ u(n1, {
          color: r === "primary" ? "--gray1" : "--gray13"
        })
      })]
    }) : /* @__PURE__ */ E(He, {
      children: [x(e, n, o), o && /* @__PURE__ */ u(i1, {
        children: /* @__PURE__ */ u(n1, {
          color: r === "primary" ? "--gray1" : "--gray13"
        })
      })]
    })
  });
}, y5 = D(at.button)`
  /* S of basic css reset for button */
  all: unset;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;
  box-sizing: border-box;
  outline-style: none;
  &:focus {
    outline: 0;
  }
  /* E of basic css reset for button */

  display: flex;
  justify-content: center;
  align-items: center;

  /* position for loading state */
  position: relative;

  /* S of appearance and disabled state */
  background-color: ${({
  appearance: e,
  isDisabled: t,
  isLoading: r
}) => e === "primary" ? !t || r ? "var(--blue8)" : "var(--gray3)" : e === "secondary" ? !t || r ? "var(--gray4)" : "var(--gray3)" : "var(gray0)"};

  border: ${({
  appearance: e,
  isDisabled: t,
  isLoading: r
}) => e === "line" && (!t || r ? "1px solid var(--gray13)" : "1px solid var(--gray4)")};
  /* E of appearance and disabled state */

  /* S of interaction */
  // remove hover effect on Mobile(Touch Device)
  @media (hover: hover) {
    :hover {
      background-color: ${({
  appearance: e,
  isDisabled: t,
  isLoading: r
}) => !(t || r) && (e === "primary" ? "var(--blue9)" : "var(--gray3)")};
      transition: background-color 0.2s ease-in-out;
    }
  }

  :active {
    background-color: ${({
  appearance: e,
  isDisabled: t,
  isLoading: r
}) => !(t || r) && (e === "primary" ? "var(--blue7)" : "var(--gray5)")};
    transition: background-color 0.2s ease-in-out;
  }
  /* E of interaction */

  border-radius: 8px;
  width: ${({
  size: e
}) => typeof e == "string" && e === "maxWidthLarge" ? "400px" : e === "autoWidth" ? "100%" : ""};
  max-width: ${({
  size: e
}) => typeof e == "string" && e === "autoWidth" ? "100%" : "400px"};
  height: ${({
  size: e
}) => typeof e == "string" && e === "small" ? "34px" : e === "medium" ? "49px" : "58px"};

  margin-top: ${({
  marginTop: e
}) => e};

  /* We will consider the loading state of the button using padding */
  padding: ${({
  size: e
}) => typeof e == "object" || e === "autoWidth" || e === "maxWidthLarge" ? "" : e === "large" ? "0 32px" : e === "medium" ? "0 26px" : e === "small" ? "0 16px" : ""};

  .button__visibility__hidden__to__constant__button__size {
    visibility: hidden;
  }

  /* for overriding bootstrap css property */
  .button__text__p__css__reset {
    margin: 0;
    padding: 0;
  }

  &:disabled {
    cursor: not-allowed;
  }
`, i1 = D.div`
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
`, C5 = D.div`
  visibility: ${({
  isLoading: e
}) => e && "hidden"};
  margin-right: 12px;
`, b5 = D.div`
  display: flex;
  align-items: center;
`, x5 = ({
  toggleOn: e,
  isDisabled: t,
  color: r,
  ...n
}) => /* @__PURE__ */ u(w5, {
  ...n,
  children: /* @__PURE__ */ E(L5, {
    className: "toggle-control",
    isDisabled: t,
    children: [/* @__PURE__ */ u(T5, {
      type: "checkbox",
      checked: e,
      disabled: !0,
      isDisabled: t
    }), /* @__PURE__ */ u(M5, {
      className: "control",
      color: r || "--gray5"
    })]
  })
}), w5 = D.div`
  display: flex;
  align-items: center;
`, L5 = D.label`
  display: block;
  position: relative;
  padding-left: 28px;
  margin-bottom: 16px;
  cursor: ${({
  isDisabled: e
}) => e ? "default" : "pointer"};
  font-size: 22px;
  user-select: none;
`, T5 = D.input`
  position: absolute;
  opacity: 0;
  cursor: ${({
  isDisabled: e
}) => e ? "default" : "pointer"};
  height: 0;
  width: 0;

  &:checked ~ span {
    background-color: var(--blue8);

    &:after {
      left: 14px;
    }
  }
`, M5 = D.span`
  position: absolute;
  top: 0;
  left: 0;
  height: 16px;
  width: 28px;
  border-radius: 8px;
  background-color: ${({
  color: e
}) => `var(${e})`};
  transition: background-color 0.15s ease-in;

  &:after {
    content: "";
    position: absolute;
    left: 2px;
    top: 2px;
    width: 12px;
    height: 12px;
    border-radius: 8px;
    background: white;
    transition: left 0.15s ease-in;
  }
`, Nu = ({
  type: e,
  text: t,
  color: r,
  weight: n,
  marginTop: a,
  opacity: i,
  textAlign: o,
  className: s,
  variants: l,
  initial: d,
  animate: c,
  ...p
}) => /* @__PURE__ */ u(We, {
  type: e != null ? e : "h2",
  text: t,
  color: r,
  weight: n != null ? n : 700,
  textSize: {
    desktop: "2.8rem",
    mobile: "2.8rem"
  },
  lineHeight: {
    desktop: "3.6rem",
    mobile: "3.6rem"
  },
  letterSpacing: {
    desktop: "0rem",
    mobile: "0rem"
  },
  marginTop: a,
  opacity: i,
  textAlign: o,
  className: s,
  variants: l,
  initial: d,
  animate: c,
  ...p
}), vr = ({
  type: e,
  text: t,
  color: r,
  weight: n,
  marginTop: a,
  opacity: i,
  textAlign: o,
  className: s,
  variants: l,
  initial: d,
  animate: c,
  ...p
}) => /* @__PURE__ */ u(We, {
  type: e != null ? e : "h4",
  text: t,
  color: r,
  weight: n != null ? n : 700,
  textSize: {
    desktop: "2rem",
    mobile: "2rem"
  },
  lineHeight: {
    desktop: "2.8rem",
    mobile: "2.8rem"
  },
  letterSpacing: {
    desktop: "0rem",
    mobile: "0rem"
  },
  marginTop: a,
  opacity: i,
  textAlign: o,
  className: s,
  variants: l,
  initial: d,
  animate: c,
  ...p
}), lv = ({
  emoji: e,
  title: t,
  content: r,
  primaryButtonText: n,
  onPrimaryButtonClicked: a,
  secondaryButtonText: i,
  onSecondaryButtonClicked: o,
  marginTop: s,
  ...l
}) => /* @__PURE__ */ E(A5, {
  marginTop: s,
  "data-testid": "slid-ips-card",
  ...l,
  children: [e && /* @__PURE__ */ u(R5, {
    text: e,
    color: "--gray13",
    weight: 700
  }), /* @__PURE__ */ u(S5, {
    className: "keep__all",
    text: t,
    color: "--gray15",
    weight: 700,
    marginTop: "16px"
  }), /* @__PURE__ */ u(P5, {
    className: "keep__all",
    text: r,
    color: "--gray13",
    weight: 400
  }), /* @__PURE__ */ E(E5, {
    children: [i && o && /* @__PURE__ */ u(ze, {
      appearance: "secondary",
      text: i,
      size: "small",
      callback: o
    }), /* @__PURE__ */ u(ze, {
      appearance: "primary",
      text: n,
      size: "small",
      callback: a
    })]
  })]
}), A5 = D.div`
  display: flex;
  flex-direction: column;
  padding: 24px 16px;
  text-align: center;
  max-width: 252px;
  min-height: 248px;
  background: var(--gray2);
  border: 1px solid var(--gray3);
  box-sizing: border-box;
  border-radius: 8px;
  margin-top: ${({
  marginTop: e
}) => e};
  .keep__all {
    word-break: keep-all;
  }
`, R5 = D((e) => /* @__PURE__ */ u(Nu, {
  ...e
}))``, S5 = D((e) => /* @__PURE__ */ u(vr, {
  ...e
}))`
  margin-bottom: 8px;
`, P5 = D((e) => /* @__PURE__ */ u(qe, {
  ...e
}))`
  margin-bottom: 24px;
`, E5 = D.div`
  display: flex;
  justify-content: center;
  gap: 4px;
`, Bu = "SET_TOAST_ON", $u = "SET_TOAST_MESSAGE", Zu = "SET_MODAL_ON", Fu = "SET_MODAL_PROPS", Wu = "SET_ALERT_ON", Uu = "SET_ALERT_PROPS", pn = (e) => (t) => {
  t({
    type: Bu,
    payload: e
  });
}, o1 = (e) => (t) => {
  t({
    type: $u,
    payload: e
  });
}, k5 = () => {
  const e = Qa(), { toastOn: t, toastMessage: r } = ei(
    (a) => a.toast
  );
  return _e(() => {
    const a = setTimeout(() => {
      t && e(pn(!1));
    }, 1850);
    return () => {
      clearTimeout(a);
    };
  }, [t, r]), { toastOn: t, toastMessage: r, showToast: (a) => {
    t === !1 && (e(pn(!0)), e(o1(a))), t === !0 && (e(pn(!1)), e(o1(a)), setTimeout(() => {
      e(pn(!0));
    }, 200));
  } };
}, cv = ({
  ...e
}) => {
  const {
    toastOn: t,
    toastMessage: r
  } = k5();
  return /* @__PURE__ */ u(zn, {
    children: t && /* @__PURE__ */ u(O5, {
      variants: V5,
      initial: "hide",
      animate: "show",
      exit: "hide",
      "data-testid": "slid-ips-toast",
      ...e,
      children: /* @__PURE__ */ u(_5, {
        "data-testid": "toast-container",
        children: /* @__PURE__ */ u(H5, {
          text: r,
          color: "--gray2"
        })
      })
    })
  });
}, O5 = D(at.div)`
  z-index: 100002;
  position: fixed;
  top: 104px; // 80px(height of header) + 24px
  left: 0;
  right: 0;
  margin: 0 auto;
  max-width: 360px;

  @media all and (max-width: 767px) {
    padding: 4.5vw;
  }
`, _5 = D.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 13px;
  background-color: var(--gray13);
  padding: 16px 24px;
`, V5 = {
  show: {
    y: 0,
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.3
    }
  },
  hide: {
    y: -240,
    opacity: 0,
    scale: 0.8,
    transition: {
      duration: 0.4
    }
  }
}, H5 = D(et)`
  text-align: center;
`;
var D5 = /* @__PURE__ */ ((e) => (e.Purple = "purple", e.LightPurple = "lightPurple", e.Green = "green", e.Red = "red", e.Orange = "orange", e.Blue = "blue", e))(D5 || {});
const dv = ({
  color: e,
  text: t,
  marginTop: r,
  ...n
}) => {
  const a = (i) => e === "purple" ? i ? "--purple9" : "--purple1_opacity" : e === "lightPurple" ? i ? "--purple1_cloudy" : "--purple1" : e === "blue" ? i ? "--blue8" : "--blue1" : e === "green" ? i ? "--green1_dark" : "--green1_opacity" : e === "red" ? i ? "--red9" : "--red1_opacity" : i ? "--orange1_dark" : "--orange1_opacity";
  return /* @__PURE__ */ u(j5, {
    color: a(!1),
    marginTop: r,
    "data-testid": "slid-ips-sticker",
    ...n,
    children: /* @__PURE__ */ u(qe, {
      color: a(!0),
      text: t,
      weight: 700
    })
  });
}, j5 = D.div`
  display: inline-block;
  padding: 2px 6px;
  height: 22px;
  left: 20px;
  top: 20px;

  margin-top: ${({
  marginTop: e
}) => e};
  background-color: var(${({
  color: e
}) => e});
  border-radius: 4px;
  text-align: center;
`, Tt = D.div`
  display: flex;
  flex-direction: column;
`, Yn = D.div`
  width: 100%;
  margin-top: 36px;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`, Pi = D.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  max-height: 60vh;
  overflow-y: auto;
`, zu = D.div`
  width: 100%;
  display: flex;
  gap: 8px;
  justify-content: stretch;
  padding-top: 28px;
`, Nr = D(ze)`
  height: 49px;
`, I5 = ({
  text: e,
  primaryButton: t,
  title: r,
  secondaryButton: n,
  device: a = "desktop"
}) => /* @__PURE__ */ E(He, {
  children: [a === "desktop" && /* @__PURE__ */ E(N5, {
    children: [r && /* @__PURE__ */ u(Cl, {
      className: "keep__all",
      text: r,
      weight: 700,
      color: "--gray17"
    }), /* @__PURE__ */ u(Pi, {
      children: e && /* @__PURE__ */ u(et, {
        className: "keep__all",
        marginTop: r && "16px",
        text: e,
        color: "--gray15",
        weight: 400
      })
    }), /* @__PURE__ */ E(B5, {
      children: [n && /* @__PURE__ */ u(ze, {
        appearance: "secondary",
        text: n.text,
        callback: n.callBack,
        size: "medium"
      }), t && /* @__PURE__ */ u(ze, {
        appearance: "primary",
        text: t.text,
        callback: t.callBack,
        size: "medium",
        tabIndex: 0,
        focusOnRender: !0
      })]
    })]
  }), a === "mobile" && /* @__PURE__ */ E($5, {
    children: [r && /* @__PURE__ */ u(vr, {
      className: "keep__all",
      text: r,
      weight: 700,
      color: "--gray15"
    }), e && /* @__PURE__ */ u(Ze, {
      className: "keep__all",
      marginTop: r && "12px",
      text: e,
      color: "--gray15",
      weight: 400
    }), /* @__PURE__ */ E(zu, {
      children: [n && /* @__PURE__ */ u(Nr, {
        appearance: "secondary",
        text: /* @__PURE__ */ u(Ze, {
          weight: 700,
          color: "--gray9",
          text: n.text
        }),
        callback: n.callBack,
        size: "autoWidth"
      }), t && /* @__PURE__ */ u(Nr, {
        appearance: "primary",
        text: /* @__PURE__ */ u(Ze, {
          weight: 700,
          color: "--gray1",
          text: t.text
        }),
        callback: t.callBack,
        size: "autoWidth"
      })]
    })]
  })]
}), N5 = D(Tt)`
  padding: 36px;
`, B5 = D(Yn)`
  justify-content: flex-end;
`, $5 = D(Tt)`
  padding: 32px 20px 16px 20px;
  align-items: center;
  justify-content: center;
  text-align: center;
`, Z5 = ({
  text: e,
  primaryButton: t,
  title: r,
  secondaryButton: n,
  emoji: a,
  device: i = "desktop"
}) => /* @__PURE__ */ E(He, {
  children: [i === "desktop" && /* @__PURE__ */ E(F5, {
    children: [/* @__PURE__ */ u(tv, {
      text: a,
      color: "--gray17",
      weight: 700
    }), /* @__PURE__ */ u(Ga, {
      className: "keep__all",
      text: r,
      weight: 700,
      color: "--gray17",
      marginTop: "24px",
      textAlign: "center"
    }), /* @__PURE__ */ u(Pi, {
      children: e && /* @__PURE__ */ u(et, {
        className: "keep__all",
        marginTop: "24px",
        text: e,
        color: "--gray15",
        weight: 400
      })
    }), /* @__PURE__ */ E(W5, {
      children: [n && /* @__PURE__ */ u(ze, {
        appearance: "secondary",
        text: n.text,
        callback: n.callBack,
        size: "medium"
      }), t && /* @__PURE__ */ u(ze, {
        appearance: "primary",
        text: t.text,
        callback: t.callBack,
        size: "medium"
      })]
    })]
  }), i === "mobile" && /* @__PURE__ */ E(U5, {
    children: [/* @__PURE__ */ u(Ga, {
      text: a,
      color: "--gray17",
      weight: 700
    }), /* @__PURE__ */ u(vr, {
      className: "keep__all",
      text: r,
      weight: 700,
      color: "--gray15",
      marginTop: "4px",
      textAlign: "center"
    }), e && /* @__PURE__ */ u(et, {
      className: "keep__all",
      marginTop: "12px",
      text: e,
      color: "--gray15",
      weight: 400
    }), /* @__PURE__ */ E(zu, {
      children: [n && /* @__PURE__ */ u(Nr, {
        appearance: "secondary",
        text: /* @__PURE__ */ u(Ze, {
          weight: 700,
          color: "--gray9",
          text: n.text
        }),
        callback: n.callBack,
        size: "autoWidth"
      }), t && /* @__PURE__ */ u(Nr, {
        appearance: "primary",
        text: /* @__PURE__ */ u(Ze, {
          weight: 700,
          color: "--gray1",
          text: t.text
        }),
        callback: t.callBack,
        size: "autoWidth"
      })]
    })]
  })]
}), F5 = D(Tt)`
  align-items: center;
  padding: 48px 36px;
`, W5 = D(Yn)`
  justify-content: center;
  margin-top: 48px;
`, U5 = D(Tt)`
  padding: 28px 20px 16px 20px;
  align-items: center;
  justify-content: center;
  text-align: center;
`, z5 = ({
  textStyle: e,
  text: t,
  primaryButton: r,
  title: n,
  image: a,
  linkButton: i,
  device: o = "desktop"
}) => /* @__PURE__ */ E(He, {
  children: [o === "desktop" && /* @__PURE__ */ E(K5, {
    children: [e === "Typography28" ? /* @__PURE__ */ u(Nu, {
      className: "keep__all",
      text: n,
      weight: 700,
      color: "--gray17",
      textAlign: "center"
    }) : /* @__PURE__ */ u(Ga, {
      className: "keep__all",
      text: n,
      weight: 700,
      color: "--gray17",
      textAlign: "center"
    }), /* @__PURE__ */ E(Pi, {
      children: [/* @__PURE__ */ u(Y5, {
        src: a.src,
        alt: a.altText,
        loading: "lazy",
        width: a.width,
        height: a.height
      }), t && /* @__PURE__ */ u(et, {
        className: "keep__all",
        marginTop: "48px",
        text: t,
        color: "--gray15",
        weight: 400
      })]
    }), r && /* @__PURE__ */ u(X5, {
      children: /* @__PURE__ */ u(ze, {
        appearance: "primary",
        text: r.text,
        callback: r.callBack,
        size: "large"
      })
    }), i && /* @__PURE__ */ u(q5, {
      children: /* @__PURE__ */ u(Yu, {
        linkText: i.linkText,
        href: i.href,
        infoText: i.infoText,
        newTab: i.newTab || !1,
        onClick: i.onClick || void 0
      })
    })]
  }), o === "mobile" && /* @__PURE__ */ E(G5, {
    children: [/* @__PURE__ */ u(J5, {
      src: a.src,
      alt: a.altText,
      loading: "lazy",
      width: a.width,
      height: a.height
    }), /* @__PURE__ */ u(vr, {
      className: "keep__all",
      text: n,
      weight: 700,
      color: "--gray15",
      textAlign: "center",
      marginTop: "24px"
    }), t && /* @__PURE__ */ u(Ze, {
      className: "keep__all",
      marginTop: "12px",
      text: t,
      color: "--gray15",
      weight: 400
    }), r && /* @__PURE__ */ u(Nr, {
      appearance: "primary",
      text: /* @__PURE__ */ u(Ze, {
        weight: 700,
        color: "--gray1",
        text: r.text
      }),
      callback: r.callBack,
      size: "autoWidth",
      marginTop: "28px"
    })]
  })]
}), Y5 = D.img`
  margin-top: 48px;
`, q5 = D.div`
  margin-top: 24px;
`, K5 = D(Tt)`
  height: 100%;
  align-items: center;
  padding: 56px 48px;
`, X5 = D(Yn)`
  justify-content: center;
  margin-top: 48px;
`, G5 = D(Tt)`
  padding: 28px 20px 16px 20px;
  align-items: center;
  justify-content: center;
  text-align: center;
`, J5 = D.img`
  width: 221px;
  height: 149px;
`, s1 = (e) => (t) => {
  t({
    type: Zu,
    payload: e
  });
}, Q5 = (e) => (t) => {
  t({
    type: Fu,
    payload: e
  });
}, ep = () => {
  const e = Qa(), { modalOn: t, modalProps: r } = ei(
    (i) => i.modal
  );
  _e(() => (t && (document.body.style.cssText = "overflow: hidden; touch-action: none; -ms-touch-action: none;"), () => {
    document.body.style.cssText = "", t && a();
  }), [t]);
  const n = (i) => {
    e(Q5(i)), e(s1(!0));
  }, a = () => {
    e(s1(!1));
  };
  return {
    modalOn: t,
    showModal: n,
    closeModal: a,
    modalProps: r
  };
}, tp = ({
  video: e,
  title: t,
  text: r,
  primaryButton: n,
  secondaryButton: a
}) => {
  const [i, o] = $e(!0);
  return _e(() => {
    o(!0);
  }, [e.source]), /* @__PURE__ */ E(He, {
    children: [/* @__PURE__ */ E(rp, {
      children: [e.loadingText && /* @__PURE__ */ E(np, {
        visible: i,
        children: [/* @__PURE__ */ u(ap, {
          className: "spinner-border text-muted",
          role: "status"
        }), /* @__PURE__ */ u(et, {
          text: e.loadingText,
          color: "--gray5",
          marginTop: "12px"
        })]
      }), /* @__PURE__ */ u(ip, {
        "data-testid": "ips-video-modal-video",
        src: e.source,
        autoPlay: !0,
        loop: !0,
        onCanPlayThrough: () => {
          o(!1);
        }
      })]
    }), /* @__PURE__ */ E(op, {
      children: [e && e.text && /* @__PURE__ */ u(et, {
        color: "--gray7",
        weight: 700,
        text: e.text
      }), t && /* @__PURE__ */ u(Cl, {
        className: "keep__all",
        text: t,
        weight: 700,
        color: "--gray17",
        marginTop: e && e.text ? "16px" : ""
      }), r && /* @__PURE__ */ u(et, {
        className: "keep__all",
        marginTop: e && e.text || t ? "16px" : "",
        text: r,
        color: "--gray15",
        weight: 400
      }), /* @__PURE__ */ E(sp, {
        children: [a && /* @__PURE__ */ u(ze, {
          appearance: "secondary",
          text: a.text,
          callback: a.callBack,
          size: "medium"
        }), n && /* @__PURE__ */ u(ze, {
          appearance: "primary",
          text: n.text,
          callback: n.callBack,
          size: "medium"
        })]
      })]
    })]
  });
}, rp = D.div`
  position: relative;
  width: 472px;
  height: 295px;
`, np = D.div`
  position: absolute;
  display: ${({
  visible: e
}) => e ? "flex" : "none"};
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: var(--gray17);
  opacity: 0.9;
  width: 472px;
  height: 295px;
  border-radius: 8px 8px 0px 0px;
`, ap = D.div`
  color: var(--gray4);
  width: 32px;
  height: 32px;
`, ip = D.video`
  width: 472px;
  height: 295px;
  border-radius: 8px 8px 0 0;
`, op = D(Tt)`
  padding: 36px;
`, sp = D(Yn)`
  justify-content: flex-end;
`, up = ({
  icon: e,
  color: t,
  width: r,
  height: n,
  subColor: a,
  ...i
}) => {
  switch (t = t != null && t.startsWith("--") ? `var(${t})` : t, a = a != null && a.startsWith("--") ? `var(${a})` : a, e) {
    case "help8":
      return /* @__PURE__ */ E(N, {
        width: r || 8,
        height: n || 15,
        viewBox: "0 0 8 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...i,
        children: [/* @__PURE__ */ u("path", {
          d: "M1 4C1 2.31579 2.31589 1 4.0001 1C5.68431 1 7 2.31579 7 4C7 5.68421 5.89445 6.57818 5.26287 6.99923C3.99971 7.84133 4 8.31579 4 9.1579V10",
          stroke: t,
          strokeWidth: "2",
          strokeLinecap: "round"
        }), /* @__PURE__ */ u("circle", {
          cx: "4",
          cy: "13.5",
          r: "1.5",
          fill: t
        })]
      });
    case "markdown16":
      return /* @__PURE__ */ E(N, {
        width: r || 16,
        height: n || 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: [/* @__PURE__ */ u("path", {
          d: "M12.9545 2.5H3.04545C2.74421 2.5 2.5 2.74421 2.5 3.04545V12.9545C2.5 13.2558 2.74421 13.5 3.04545 13.5H12.9545C13.2558 13.5 13.5 13.2558 13.5 12.9545V3.04545C13.5 2.74421 13.2558 2.5 12.9545 2.5Z",
          stroke: t,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /* @__PURE__ */ u("path", {
          d: "M4.84553 4.88183H6.36257L7.96484 8.79092H8.03303L9.6353 4.88183H11.1523V10.7H9.95916V6.91308H9.91087L8.40518 10.6716H7.59268L6.087 6.89888H6.03871V10.7H4.84553V4.88183Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          d: "M10.55 11.7L9.35001 10.2H11.75L10.55 11.7Z",
          fill: "#868E96"
        })]
      });
    case "pdf16":
      return /* @__PURE__ */ E(N, {
        width: r || 16,
        height: n || 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: [/* @__PURE__ */ u("path", {
          d: "M12.9545 2.5H3.04545C2.74421 2.5 2.5 2.74421 2.5 3.04545V12.9545C2.5 13.2558 2.74421 13.5 3.04545 13.5H12.9545C13.2558 13.5 13.5 13.2558 13.5 12.9545V3.04545C13.5 2.74421 13.2558 2.5 12.9545 2.5Z",
          stroke: t,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /* @__PURE__ */ u("path", {
          d: "M4.33292 9.5V6.59091H5.48065C5.70129 6.59091 5.88926 6.63305 6.04457 6.71733C6.19987 6.80066 6.31824 6.91667 6.39968 7.06534C6.48207 7.21307 6.52326 7.38352 6.52326 7.5767C6.52326 7.76989 6.48159 7.94034 6.39826 8.08807C6.31493 8.2358 6.19419 8.35085 6.03604 8.43324C5.87885 8.51562 5.68851 8.55682 5.46502 8.55682H4.73349V8.06392H5.36559C5.48396 8.06392 5.5815 8.04356 5.6582 8.00284C5.73585 7.96117 5.79362 7.90388 5.8315 7.83097C5.87032 7.7571 5.88974 7.67235 5.88974 7.5767C5.88974 7.48011 5.87032 7.39583 5.8315 7.32386C5.79362 7.25095 5.73585 7.1946 5.6582 7.15483C5.58055 7.11411 5.48207 7.09375 5.36275 7.09375H4.94798V9.5H4.33292ZM7.95401 9.5H6.92276V6.59091H7.96254C8.25515 6.59091 8.50704 6.64915 8.71822 6.76562C8.92939 6.88116 9.0918 7.04735 9.20543 7.2642C9.32002 7.48106 9.37731 7.74053 9.37731 8.04261C9.37731 8.34564 9.32002 8.60606 9.20543 8.82386C9.0918 9.04167 8.92844 9.20881 8.71538 9.32528C8.50326 9.44176 8.24947 9.5 7.95401 9.5ZM7.53782 8.97301H7.92844C8.11026 8.97301 8.2632 8.94081 8.38725 8.87642C8.51225 8.81108 8.606 8.71023 8.6685 8.57386C8.73195 8.43655 8.76367 8.25947 8.76367 8.04261C8.76367 7.82765 8.73195 7.65199 8.6685 7.51562C8.606 7.37926 8.51272 7.27888 8.38867 7.21449C8.26462 7.15009 8.11168 7.1179 7.92987 7.1179H7.53782V8.97301ZM9.83292 9.5V6.59091H11.7591V7.09801H10.448V7.79119H11.6312V8.2983H10.448V9.5H9.83292Z",
          fill: t
        })]
      });
    case "png16":
      return /* @__PURE__ */ E(N, {
        width: r || 16,
        height: n || 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: [/* @__PURE__ */ u("path", {
          d: "M12.9545 2.5H3.04545C2.74421 2.5 2.5 2.74421 2.5 3.04545V12.9545C2.5 13.2558 2.74421 13.5 3.04545 13.5H12.9545C13.2558 13.5 13.5 13.2558 13.5 12.9545V3.04545C13.5 2.74421 13.2558 2.5 12.9545 2.5Z",
          stroke: t,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /* @__PURE__ */ u("path", {
          d: "M13.5 9.5L9.84766 7.11798C9.80959 7.08061 9.75349 7.05094 9.70345 7.03069C9.65341 7.01043 9.5997 7 9.54545 7C9.4912 7 9.4375 7.01043 9.38746 7.03069C9.33742 7.05094 9.29204 7.08061 9.25398 7.11798L6.9733 9.32275C6.93523 9.36012 6.88986 9.38979 6.83982 9.41005C6.78978 9.4303 6.73607 9.44073 6.68182 9.44073C6.62757 9.44073 6.57386 9.4303 6.52382 9.41005C6.47378 9.38979 6.42841 9.36012 6.39034 9.32275L5.33693 8.3044C5.29887 8.26704 5.25349 8.23736 5.20345 8.21711C5.15341 8.19685 5.0997 8.18642 5.04545 8.18642C4.9912 8.18642 4.9375 8.19685 4.88746 8.21711C4.83742 8.23736 4.79204 8.26704 4.75398 8.3044L2.5 10.5",
          stroke: t,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /* @__PURE__ */ u("path", {
          d: "M6 7C6.55228 7 7 6.55228 7 6C7 5.44772 6.55228 5 6 5C5.44772 5 5 5.44772 5 6C5 6.55228 5.44772 7 6 7Z",
          fill: t
        })]
      });
    case "word16":
      return /* @__PURE__ */ E(N, {
        width: r || 16,
        height: n || 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: [/* @__PURE__ */ u("path", {
          d: "M12.9545 2.5H3.04545C2.74421 2.5 2.5 2.74421 2.5 3.04545V12.9545C2.5 13.2558 2.74421 13.5 3.04545 13.5H12.9545C13.2558 13.5 13.5 13.2558 13.5 12.9545V3.04545C13.5 2.74421 13.2558 2.5 12.9545 2.5Z",
          stroke: t,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /* @__PURE__ */ u("path", {
          d: "M5.96196 10.5L4.50528 5.40909H5.68106L6.52375 8.94638H6.56601L7.49569 5.40909H8.50244L9.42964 8.95384H9.47439L10.3171 5.40909H11.4929L10.0362 10.5H8.98717L8.01771 7.17152H7.97794L7.01096 10.5H5.96196Z",
          fill: t
        })]
      });
    case "thickCheck16":
      return /* @__PURE__ */ u(N, {
        width: r || 16,
        height: n || 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.1919 4.27801C13.5907 4.66014 13.6041 5.29316 13.222 5.69191L7.47199 11.6919C7.09491 12.0854 6.47219 12.1045 6.07172 11.7348L2.82172 8.7348C2.4159 8.3602 2.3906 7.72754 2.7652 7.32172C3.13981 6.9159 3.77246 6.89059 4.17829 7.2652L6.7071 9.59949L11.778 4.3081C12.1601 3.90935 12.7932 3.89588 13.1919 4.27801Z",
          fill: t
        })
      });
    case "chevronLeft16":
      return /* @__PURE__ */ u(N, {
        width: r || 16,
        height: n || 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.85355 4.14645C9.65829 3.95118 9.34171 3.95118 9.14645 4.14645L5.64645 7.64645C5.45118 7.84171 5.45118 8.15829 5.64645 8.35355L9.14645 11.8536C9.34171 12.0488 9.65829 12.0488 9.85355 11.8536C10.0488 11.6583 10.0488 11.3417 9.85355 11.1464L6.70711 8L9.85355 4.85355C10.0488 4.65829 10.0488 4.34171 9.85355 4.14645Z",
          fill: t
        })
      });
    case "chevronRight16":
      return /* @__PURE__ */ u(N, {
        width: r || 16,
        height: n || 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.14645 4.14645C6.34171 3.95118 6.65829 3.95118 6.85355 4.14645L10.3536 7.64645C10.5488 7.84171 10.5488 8.15829 10.3536 8.35355L6.85355 11.8536C6.65829 12.0488 6.34171 12.0488 6.14645 11.8536C5.95118 11.6583 5.95118 11.3417 6.14645 11.1464L9.29289 8L6.14645 4.85355C5.95118 4.65829 5.95118 4.34171 6.14645 4.14645Z",
          fill: t
        })
      });
    case "chevronUp16":
      return /* @__PURE__ */ u(N, {
        width: r || 16,
        height: n || 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.64645 9.35355C4.45118 9.15829 4.45118 8.84171 4.64645 8.64645L7.29289 6C7.68342 5.60948 8.31658 5.60948 8.70711 6L11.3536 8.64645C11.5488 8.84171 11.5488 9.15829 11.3536 9.35355C11.1583 9.54882 10.8417 9.54882 10.6464 9.35355L8 6.70711L5.35355 9.35355C5.15829 9.54882 4.84171 9.54882 4.64645 9.35355Z",
          fill: t
        })
      });
    case "chevronDown16":
      return /* @__PURE__ */ u(N, {
        width: r || 16,
        height: n || 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.3536 6.64645C11.5488 6.84171 11.5488 7.15829 11.3536 7.35355L8.70711 10C8.31658 10.3905 7.68342 10.3905 7.29289 10L4.64645 7.35355C4.45118 7.15829 4.45118 6.84171 4.64645 6.64645C4.84171 6.45118 5.15829 6.45118 5.35355 6.64645L8 9.29289L10.6464 6.64645C10.8417 6.45118 11.1583 6.45118 11.3536 6.64645Z",
          fill: t
        })
      });
    case "import16":
      return /* @__PURE__ */ E(N, {
        width: r || 16,
        height: n || 16,
        viewBox: "0 0 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: [/* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8 2C8.27614 2 8.5 2.22386 8.5 2.5V10.5C8.5 10.7761 8.27614 11 8 11C7.72386 11 7.5 10.7761 7.5 10.5V2.5C7.5 2.22386 7.72386 2 8 2Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4.12038 7.17461C4.30009 6.96495 4.61574 6.94067 4.8254 7.12038L8.00001 9.84147L11.1746 7.12038C11.3843 6.94067 11.6999 6.96495 11.8796 7.17461C12.0593 7.38428 12.0351 7.69993 11.8254 7.87964L8.3254 10.8796C8.13816 11.0401 7.86186 11.0401 7.67461 10.8796L4.17461 7.87964C3.96495 7.69993 3.94067 7.38428 4.12038 7.17461Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2 13.5C2 13.2239 2.22386 13 2.5 13H13.5C13.7761 13 14 13.2239 14 13.5C14 13.7761 13.7761 14 13.5 14H2.5C2.22386 14 2 13.7761 2 13.5Z",
          fill: t
        })]
      });
    case "chevronDown20":
      return /* @__PURE__ */ u(N, {
        width: r || 20,
        height: n || 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: /* @__PURE__ */ u("path", {
          d: "M7.00009 8L10.0001 11L13.0001 8",
          stroke: t,
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      });
    case "import20":
      return /* @__PURE__ */ E(N, {
        width: r || 20,
        height: n || 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: [/* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.5 2.5C10.5 2.22386 10.2761 2 10 2C9.72386 2 9.5 2.22386 9.5 2.5V13.3866L5.83219 10.1263C5.6258 9.94284 5.30976 9.96143 5.1263 10.1678C4.94284 10.3742 4.96143 10.6903 5.16782 10.8737L9.66626 14.8723C9.74882 14.9464 9.85613 14.9934 9.97427 14.9993C9.98279 14.9998 9.99137 15 10 15C10.0105 15 10.0209 14.9997 10.0313 14.999C10.1229 14.9934 10.2079 14.963 10.2796 14.9146C10.298 14.9021 10.3156 14.8885 10.3322 14.8737L14.8322 10.8737C15.0386 10.6903 15.0572 10.3742 14.8737 10.1678C14.6903 9.96143 14.3742 9.94284 14.1678 10.1263L10.5 13.3866V2.5Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2 17.5C2 17.2239 2.22386 17 2.5 17H17.5C17.7761 17 18 17.2239 18 17.5C18 17.7761 17.7761 18 17.5 18H2.5C2.22386 18 2 17.7761 2 17.5Z",
          fill: t
        })]
      });
    case "export20":
      return /* @__PURE__ */ u(N, {
        width: r || 20,
        height: n || 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.6486 2.86386C12.2193 2.34678 12.967 2.06896 13.7368 2.08792C14.5067 2.10687 15.2398 2.42115 15.7843 2.96569C16.3289 3.51022 16.6431 4.24331 16.6621 5.01317C16.681 5.78302 16.4032 6.53069 15.8861 7.10136C15.8814 7.10658 15.8766 7.11169 15.8716 7.1167L8.11383 14.9839C8.10725 14.9906 8.10049 14.9971 8.09354 15.0033C7.76065 15.305 7.32451 15.467 6.87543 15.456C6.42634 15.4449 5.99871 15.2616 5.68106 14.9439C5.36342 14.6263 5.18009 14.1987 5.16903 13.7496C5.15797 13.3005 5.32004 12.8644 5.62167 12.5315C5.62624 12.5264 5.63092 12.5215 5.6357 12.5166L12.1435 5.89942C12.3371 5.70253 12.6537 5.69989 12.8506 5.89352C13.0475 6.08715 13.0501 6.40372 12.8565 6.60061L6.35676 13.2096C6.23131 13.3514 6.16406 13.5355 6.16873 13.725C6.17347 13.9174 6.25204 14.1007 6.38817 14.2368C6.5243 14.373 6.70758 14.4515 6.90004 14.4563C7.08841 14.4609 7.27147 14.3945 7.41293 14.2705L15.1518 6.4225C15.4922 6.043 15.675 5.54769 15.6624 5.03778C15.6498 4.52454 15.4402 4.03582 15.0772 3.67279C14.7142 3.30977 14.2255 3.10025 13.7122 3.08761C13.2034 3.07508 12.7091 3.25701 12.33 3.59603L4.58013 11.4551C3.97149 12.0638 3.62955 12.8893 3.62955 13.75C3.62955 14.6108 3.97148 15.4363 4.58012 16.0449C5.18876 16.6535 6.01425 16.9955 6.875 16.9955C7.73575 16.9955 8.56124 16.6535 9.16989 16.0449L15.5844 9.64603C15.7799 9.451 16.0965 9.45139 16.2915 9.64689C16.4865 9.84239 16.4861 10.159 16.2906 10.354L9.87699 16.752C9.87691 16.7521 9.87707 16.7519 9.87699 16.752C9.08084 17.548 8.00085 17.9955 6.875 17.9955C5.74904 17.9955 4.66919 17.5482 3.87301 16.752C3.07683 15.9558 2.62955 14.876 2.62955 13.75C2.62955 12.6247 3.07635 11.5454 3.87173 10.7493C3.87216 10.7489 3.87258 10.7484 3.87301 10.748L11.6284 2.88332C11.6349 2.87664 11.6417 2.87015 11.6486 2.86386Z",
          fill: t
        })
      });
    case "newNote20":
      return /* @__PURE__ */ u(N, {
        width: r || 20,
        height: n || 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.5 2C3.22386 2 3 2.22386 3 2.5V17.5C3 17.7761 3.22386 18 3.5 18H11.5C11.6348 18 11.7571 17.9467 11.8471 17.8599C11.8492 17.8578 11.8514 17.8557 11.8536 17.8536L16.8536 12.8536C16.8557 12.8514 16.8578 12.8492 16.8599 12.8471C16.9467 12.7571 17 12.6348 17 12.5V2.5C17 2.22386 16.7761 2 16.5 2H3.5ZM16 12V3H4V17H11V12.5C11 12.2239 11.2239 12 11.5 12H16ZM12 16.2929L15.2929 13H12V16.2929Z",
          fill: t
        })
      });
    case "recentNote20":
      return /* @__PURE__ */ u(N, {
        width: r || 20,
        height: n || 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3 2.5C3 2.22386 3.22386 2 3.5 2H16.5C16.7761 2 17 2.22386 17 2.5V12.5C17 12.6348 16.9467 12.7571 16.8599 12.8471L16.8536 12.8536L11.8536 17.8536L11.8471 17.8599C11.7571 17.9467 11.6348 18 11.5 18H3.5C3.22386 18 3 17.7761 3 17.5V2.5ZM16 3V12H11.5C11.2239 12 11 12.2239 11 12.5V17H4V3H16ZM15.2929 13L12 16.2929V13H15.2929ZM6.5 6C6.22386 6 6 6.22386 6 6.5C6 6.77614 6.22386 7 6.5 7H13.5C13.7761 7 14 6.77614 14 6.5C14 6.22386 13.7761 6 13.5 6H6.5ZM6 9.5C6 9.22386 6.22386 9 6.5 9H13.5C13.7761 9 14 9.22386 14 9.5C14 9.77614 13.7761 10 13.5 10H6.5C6.22386 10 6 9.77614 6 9.5ZM6.5 12C6.22386 12 6 12.2239 6 12.5C6 12.7761 6.22386 13 6.5 13H8.5C8.77614 13 9 12.7761 9 12.5C9 12.2239 8.77614 12 8.5 12H6.5Z",
          fill: t
        })
      });
    case "folder20":
      return /* @__PURE__ */ u(N, {
        width: r || 20,
        height: n || 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3 3C2.44772 3 2 3.44772 2 4V7V7.5V16C2 16.5523 2.44772 17 3 17H17C17.5523 17 18 16.5523 18 16V7C18 6.44772 17.5523 6 17 6H10.2342L8.03403 3.35982C7.84404 3.13182 7.56259 3 7.26581 3H3ZM8.93248 6L7.26581 4H3L3 6H8.93248ZM3 7V7.5V16H17V7H3Z",
          fill: t
        })
      });
    case "rename20":
      return /* @__PURE__ */ u(N, {
        width: r || 20,
        height: n || 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.7071 2.49992C13.3166 2.1094 12.6834 2.1094 12.2929 2.49992L2.79289 11.9999C2.60536 12.1875 2.5 12.4418 2.5 12.707V16.4999C2.5 17.0522 2.94772 17.4999 3.5 17.4999H7.29289C7.55811 17.4999 7.81246 17.3946 8 17.207L17.5 7.70703C17.8905 7.31651 17.8905 6.68334 17.5 6.29282L13.7071 2.49992ZM11.2696 4.93746L13 3.20703L16.7929 6.99993L15.0625 8.73036L11.2696 4.93746ZM10.5625 5.64457L3.5 12.707V16.4999H7.29289L14.3554 9.43746L10.5625 5.64457Z",
          fill: t
        })
      });
    case "star20":
      return /* @__PURE__ */ u(N, {
        width: r || 20,
        height: n || 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: /* @__PURE__ */ u("path", {
          d: "M10.3564 14.5854L14.0089 16.9044C14.4799 17.2016 15.0597 16.7595 14.922 16.216L13.8639 12.0562C13.8353 11.9408 13.8399 11.8198 13.8771 11.707C13.9142 11.5941 13.9825 11.4941 14.0741 11.4184L17.3498 8.68628C17.7773 8.33117 17.5599 7.61371 17.0019 7.57748L12.7261 7.30209C12.6095 7.2953 12.4973 7.25468 12.4034 7.18518C12.3094 7.11568 12.2377 7.02032 12.1971 6.91075L10.6028 2.89589C10.5606 2.77986 10.4837 2.67964 10.3825 2.60881C10.2814 2.53799 10.161 2.5 10.0375 2.5C9.91403 2.5 9.79356 2.53799 9.69244 2.60881C9.59131 2.67964 9.51443 2.77986 9.47222 2.89589L7.87787 6.91075C7.83724 7.02032 7.76557 7.11568 7.67162 7.18518C7.57766 7.25468 7.4655 7.2953 7.34884 7.30209L3.07308 7.57748C2.51506 7.61371 2.29765 8.33117 2.72522 8.68628L6.00089 11.4184C6.09244 11.4941 6.16075 11.5941 6.19793 11.707C6.23511 11.8198 6.23966 11.9408 6.21105 12.0562L5.2327 15.9116C5.06602 16.5638 5.76173 17.0928 6.31976 16.7377L9.71862 14.5854C9.81393 14.5248 9.92454 14.4926 10.0375 14.4926C10.1504 14.4926 10.2611 14.5248 10.3564 14.5854V14.5854Z",
          stroke: t,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      });
    case "colorPalette20":
      return /* @__PURE__ */ E(N, {
        width: r || 20,
        height: n || 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: [/* @__PURE__ */ u("path", {
          d: "M10 6.875C10.5178 6.875 10.9375 6.45527 10.9375 5.9375C10.9375 5.41973 10.5178 5 10 5C9.48223 5 9.0625 5.41973 9.0625 5.9375C9.0625 6.45527 9.48223 6.875 10 6.875Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          d: "M6.48438 8.90625C7.00214 8.90625 7.42188 8.48652 7.42188 7.96875C7.42188 7.45098 7.00214 7.03125 6.48438 7.03125C5.96661 7.03125 5.54688 7.45098 5.54688 7.96875C5.54688 8.48652 5.96661 8.90625 6.48438 8.90625Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          d: "M6.48438 12.9688C7.00214 12.9688 7.42188 12.549 7.42188 12.0312C7.42188 11.5135 7.00214 11.0938 6.48438 11.0938C5.96661 11.0938 5.54688 11.5135 5.54688 12.0312C5.54688 12.549 5.96661 12.9688 6.48438 12.9688Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          d: "M13.5156 8.90625C14.0334 8.90625 14.4531 8.48652 14.4531 7.96875C14.4531 7.45098 14.0334 7.03125 13.5156 7.03125C12.9979 7.03125 12.5781 7.45098 12.5781 7.96875C12.5781 8.48652 12.9979 8.90625 13.5156 8.90625Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.2284 3.35597C10.9201 2.93487 9.3636 2.85439 7.67089 3.46992C3.56021 4.96471 2.84348 8.75537 2.99797 10.4548C3.1765 12.4187 4.15182 14.0764 5.30333 15.189C5.87863 15.7448 6.48659 16.1534 7.04218 16.3948C7.60796 16.6406 8.06907 16.6924 8.37881 16.6149C8.84375 16.4987 9.08531 16.3182 9.22369 16.1404C9.36692 15.9563 9.44269 15.72 9.47677 15.4169C9.48498 15.3439 9.49261 15.2626 9.50073 15.1763C9.52343 14.9347 9.54989 14.6531 9.60311 14.4003C9.67951 14.0373 9.82513 13.6399 10.1562 13.3188C10.7797 12.7141 11.5805 12.6 12.0001 12.6H14.0001C14.2054 12.6 14.4081 12.6063 14.5984 12.6122L14.6088 12.6126C14.805 12.6187 14.9872 12.6242 15.162 12.6235C15.516 12.622 15.7966 12.5939 16.0237 12.5151C16.2355 12.4417 16.4081 12.3217 16.5503 12.1069C16.7003 11.8802 16.8341 11.5201 16.9036 10.9404L16.9056 10.9258C17.3837 7.73878 15.2922 4.34214 12.2284 3.35597ZM17.8956 11.0669C18.4415 7.40159 16.0664 3.5408 12.5347 2.40406C11.0332 1.92075 9.24778 1.83244 7.32915 2.53013C2.63983 4.23533 1.82323 8.57801 2.00207 10.5453C2.20575 12.7858 3.31383 14.6572 4.60848 15.9081C5.25625 16.534 5.96207 17.0158 6.64364 17.3119C7.31501 17.6037 8.01445 17.7368 8.62134 17.5851C9.25268 17.4272 9.70835 17.1459 10.0129 16.7545C10.3126 16.3693 10.4255 15.929 10.4705 15.5286C10.4833 15.4148 10.4932 15.3095 10.5025 15.2099C10.523 14.9912 10.5409 14.7999 10.5817 14.6063C10.6368 14.3442 10.7205 14.1646 10.8524 14.0367C11.2154 13.6845 11.715 13.6 12.0001 13.6H14.0001C14.1898 13.6 14.3791 13.6059 14.5739 13.612L14.5777 13.6121C14.7709 13.6181 14.9708 13.6243 15.1662 13.6234C15.5529 13.6218 15.9661 13.5936 16.3515 13.4599C16.7522 13.3209 17.1108 13.072 17.3842 12.6587C17.6489 12.2588 17.8149 11.7337 17.8956 11.0669Z",
          fill: t
        })]
      });
    case "delete20":
      return /* @__PURE__ */ u(N, {
        width: r || 20,
        height: n || 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7 3.5C7 3.22386 7.22386 3 7.5 3H12.5C12.7761 3 13 3.22386 13 3.5V5H7V3.5ZM6 5V3.5C6 2.67157 6.67157 2 7.5 2H12.5C13.3284 2 14 2.67157 14 3.5V5H15.5H17C17.2761 5 17.5 5.22386 17.5 5.5C17.5 5.77614 17.2761 6 17 6H16V16.5C16 17.3284 15.3284 18 14.5 18H5.5C4.67157 18 4 17.3284 4 16.5V6H3C2.72386 6 2.5 5.77614 2.5 5.5C2.5 5.22386 2.72386 5 3 5H4.5H6ZM13.5 6H6.5H5V16.5C5 16.7761 5.22386 17 5.5 17H14.5C14.7761 17 15 16.7761 15 16.5V6H13.5ZM8.5 8.5C8.77614 8.5 9 8.72386 9 9V14C9 14.2761 8.77614 14.5 8.5 14.5C8.22386 14.5 8 14.2761 8 14V9C8 8.72386 8.22386 8.5 8.5 8.5ZM12 9C12 8.72386 11.7761 8.5 11.5 8.5C11.2239 8.5 11 8.72386 11 9V14C11 14.2761 11.2239 14.5 11.5 14.5C11.7761 14.5 12 14.2761 12 14V9Z",
          fill: t
        })
      });
    case "share20":
      return /* @__PURE__ */ u(N, {
        width: r || 20,
        height: n || 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.1464 4.02145C12.3417 3.82618 12.6583 3.82618 12.8536 4.02145L16.6036 7.77145C16.7988 7.96671 16.7988 8.28329 16.6036 8.47855L12.8536 12.2286C12.6583 12.4238 12.3417 12.4238 12.1464 12.2286C11.9512 12.0333 11.9512 11.7167 12.1464 11.5214L15.0429 8.625H13.1253C11.5731 8.6255 10.0648 9.14134 8.83739 10.0916C7.60998 11.0418 6.7328 12.3727 6.34352 13.8754C6.27427 14.1427 6.00142 14.3033 5.73411 14.234C5.46679 14.1648 5.30622 13.8919 5.37547 13.6246C5.8203 11.9075 6.82265 10.3867 8.22522 9.30085C9.62779 8.21499 11.3513 7.62554 13.1251 7.625H15.0429L12.1464 4.72855C11.9512 4.53329 11.9512 4.21671 12.1464 4.02145ZM2.5 6.375C2.77614 6.375 3 6.59886 3 6.875V16.25C3 16.2832 3.01317 16.3149 3.03661 16.3384C3.06005 16.3618 3.09185 16.375 3.125 16.375H15C15.2761 16.375 15.5 16.5989 15.5 16.875C15.5 17.1511 15.2761 17.375 15 17.375H3.125C2.82663 17.375 2.54048 17.2565 2.3295 17.0455C2.11853 16.8345 2 16.5484 2 16.25V6.875C2 6.59886 2.22386 6.375 2.5 6.375Z",
          fill: t
        })
      });
    case "account20":
      return /* @__PURE__ */ E(N, {
        width: r || 20,
        height: n || 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: [/* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17ZM10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10 11C11.3807 11 12.5 9.88071 12.5 8.5C12.5 7.11929 11.3807 6 10 6C8.61929 6 7.5 7.11929 7.5 8.5C7.5 9.88071 8.61929 11 10 11ZM10 12C11.933 12 13.5 10.433 13.5 8.5C13.5 6.567 11.933 5 10 5C8.067 5 6.5 6.567 6.5 8.5C6.5 10.433 8.067 12 10 12Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10 12C8.13384 12 5.86511 12.9335 4.96424 15.1857L4.03577 14.8143C5.1349 12.0665 7.86617 11 10 11C12.1338 11 14.8651 12.0665 15.9642 14.8143L15.0358 15.1857C14.1349 12.9335 11.8662 12 10 12Z",
          fill: t
        })]
      });
    case "chat20":
      return /* @__PURE__ */ E(N, {
        width: r || 20,
        height: n || 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: [/* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2 4C2 3.44771 2.44772 3 3 3H17C17.5523 3 18 3.44771 18 4V13C18 13.5523 17.5523 14 17 14H5.47154L3.7888 16.1595C3.20384 16.9102 2 16.4966 2 15.5449V4ZM17 4L3 4V15.5449L4.68274 13.3854C4.87222 13.1422 5.16326 13 5.47154 13H17V4Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.3536 6.64645C12.5488 6.84171 12.5488 7.15829 12.3536 7.35355L9.35355 10.3536C9.15829 10.5488 8.84171 10.5488 8.64645 10.3536L7.14645 8.85355C6.95118 8.65829 6.95118 8.34171 7.14645 8.14645C7.34171 7.95118 7.65829 7.95118 7.85355 8.14645L9 9.29289L11.6464 6.64645C11.8417 6.45118 12.1583 6.45118 12.3536 6.64645Z",
          fill: t
        })]
      });
    case "copy20":
      return /* @__PURE__ */ E(N, {
        width: r || 20,
        height: n || 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: [/* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3 5C3 4.44772 3.44771 4 4 4H7V5L4 5V17H16V5H13V4H16C16.5523 4 17 4.44772 17 5V17C17 17.5523 16.5523 18 16 18H4C3.44772 18 3 17.5523 3 17V5Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7.17046 5H12.8296C12.4179 3.83505 11.3059 3 10 3C8.69412 3 7.58214 3.83505 7.17046 5ZM6.03084 5.50099C6.27644 3.52736 7.95986 2 10 2C12.0402 2 13.7236 3.52736 13.9692 5.50099C14.0033 5.77502 13.7762 6 13.5 6H6.50001C6.22387 6 5.99673 5.77502 6.03084 5.50099Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7 9.5C7 9.22386 7.22386 9 7.5 9H12.5C12.7761 9 13 9.22386 13 9.5C13 9.77614 12.7761 10 12.5 10H7.5C7.22386 10 7 9.77614 7 9.5Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7 12.5C7 12.2239 7.22386 12 7.5 12H12.5C12.7761 12 13 12.2239 13 12.5C13 12.7761 12.7761 13 12.5 13H7.5C7.22386 13 7 12.7761 7 12.5Z",
          fill: t
        })]
      });
    case "redo20":
      return /* @__PURE__ */ E(N, {
        width: r || 20,
        height: n || 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: [/* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M7 8C4.79086 8 3 9.79086 3 12C3 14.2091 4.79086 16 7 16H15.5C15.7761 16 16 16.2239 16 16.5C16 16.7761 15.7761 17 15.5 17H7C4.23858 17 2 14.7614 2 12C2 9.23858 4.23858 7 7 7H16.5C16.7761 7 17 7.22386 17 7.5C17 7.77614 16.7761 8 16.5 8H7Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.1464 3.14645C13.3417 2.95118 13.6583 2.95118 13.8536 3.14645L17.5 6.79289C17.8905 7.18342 17.8905 7.81658 17.5 8.20711L13.8536 11.8536C13.6583 12.0488 13.3417 12.0488 13.1464 11.8536C12.9512 11.6583 12.9512 11.3417 13.1464 11.1464L16.7929 7.5L13.1464 3.85355C12.9512 3.65829 12.9512 3.34171 13.1464 3.14645Z",
          fill: t
        })]
      });
    case "undo20":
      return /* @__PURE__ */ E(N, {
        width: r || 20,
        height: n || 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: [/* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13 8C15.2091 8 17 9.79086 17 12C17 14.2091 15.2091 16 13 16H4.5C4.22386 16 4 16.2239 4 16.5C4 16.7761 4.22386 17 4.5 17H13C15.7614 17 18 14.7614 18 12C18 9.23858 15.7614 7 13 7H3.5C3.22386 7 3 7.22386 3 7.5C3 7.77614 3.22386 8 3.5 8H13Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M6.85355 3.14645C6.65829 2.95118 6.34171 2.95118 6.14645 3.14645L2.5 6.79289C2.10948 7.18342 2.10948 7.81658 2.5 8.20711L6.14645 11.8536C6.34171 12.0488 6.65829 12.0488 6.85355 11.8536C7.04882 11.6583 7.04882 11.3417 6.85355 11.1464L3.20711 7.5L6.85355 3.85355C7.04882 3.65829 7.04882 3.34171 6.85355 3.14645Z",
          fill: t
        })]
      });
    case "shortcut20":
      return /* @__PURE__ */ E(N, {
        width: r || 20,
        height: n || 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: [/* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17ZM10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          d: "M9.5 6.5C9.5 6.22386 9.72386 6 10 6C10.2761 6 10.5 6.22386 10.5 6.5V11.5C10.5 11.7761 10.2761 12 10 12C9.72386 12 9.5 11.7761 9.5 11.5V6.5Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          d: "M9.5 13.5C9.5 13.2239 9.72386 13 10 13C10.2761 13 10.5 13.2239 10.5 13.5C10.5 13.7761 10.2761 14 10 14C9.72386 14 9.5 13.7761 9.5 13.5Z",
          fill: t
        })]
      });
    case "tutorial20":
      return /* @__PURE__ */ E(N, {
        width: r || 20,
        height: n || 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: [/* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17ZM10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17ZM10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          d: "M9.5 13.5C9.5 13.2239 9.72386 13 10 13C10.2761 13 10.5 13.2239 10.5 13.5C10.5 13.7761 10.2761 14 10 14C9.72386 14 9.5 13.7761 9.5 13.5Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          d: "M8 8.5C8 7.37719 8.87726 6.5 10.0001 6.5C11.1229 6.5 12 7.37719 12 8.5C12 9.62281 11.263 10.2188 10.8419 10.4995C9.99981 11.0609 10 11.3772 10 11.9386V12",
          stroke: t,
          strokeLinecap: "round"
        })]
      });
    case "history20":
      return /* @__PURE__ */ u(N, {
        width: r || 20,
        height: n || 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.122 3.10923C11.6768 2.50309 10.0861 2.34472 8.55165 2.65445C7.72268 2.82177 6.87139 3.32765 6.12491 3.88739C5.36873 4.45441 4.67102 5.11462 4.14522 5.64767L3 6.79289V5C3 4.72386 2.77614 4.5 2.5 4.5C2.22386 4.5 2 4.72386 2 5V7.99991C2 7.99997 2 8.00003 2 8.00009V8.125C2 8.40114 2.22386 8.625 2.5 8.625H5.625C5.90114 8.625 6.125 8.40114 6.125 8.125C6.125 7.84886 5.90114 7.625 5.625 7.625H3.58211L4.85355 6.35355L4.85356 6.35356L4.85599 6.3511C5.36513 5.83486 6.02412 5.21287 6.72483 4.68745C7.43582 4.15432 8.14228 3.75724 8.74951 3.63468C10.0874 3.36463 11.4744 3.5026 12.7353 4.03141C13.9962 4.56025 15.0751 5.45654 15.8346 6.60792C16.5942 7.75936 17 9.11385 17 10.5C17 11.8862 16.5942 13.2406 15.8346 14.3921C15.0751 15.5435 13.9962 16.4397 12.7353 16.9686C11.4744 17.4974 10.0874 17.6354 8.74951 17.3653C7.41156 17.0953 6.18183 16.4291 5.21622 15.45C5.02232 15.2534 4.70574 15.2512 4.50913 15.4451C4.31253 15.6391 4.31033 15.9556 4.50424 16.1522C5.6088 17.2722 7.0172 18.0358 8.55165 18.3456C10.0861 18.6553 11.6768 18.4969 13.122 17.8908C14.5672 17.2847 15.8014 16.2584 16.6693 14.9427C17.5372 13.6272 18 12.0811 18 10.5C18 8.91891 17.5372 7.37282 16.6693 6.05726C15.8014 4.74163 14.5672 3.71535 13.122 3.10923ZM10.5 7C10.5 6.72386 10.2761 6.5 10 6.5C9.72386 6.5 9.5 6.72386 9.5 7V10.9888C9.49937 11.0171 9.50117 11.0452 9.50527 11.0729C9.52708 11.2222 9.61489 11.3501 9.73813 11.426C9.762 11.4407 9.7872 11.4535 9.81351 11.4641L13.303 12.9596C13.5569 13.0684 13.8508 12.9508 13.9596 12.697C14.0684 12.4432 13.9508 12.1492 13.697 12.0404L10.5 10.6703V7Z",
          fill: t
        })
      });
    case "restore20":
      return /* @__PURE__ */ u(N, {
        width: r || 20,
        height: n || 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.122 2.60923C11.6768 2.00309 10.0861 1.84472 8.55165 2.15445C7.72268 2.32177 6.87139 2.82765 6.12491 3.38739C5.36873 3.95441 4.67102 4.61462 4.14522 5.14767L3 6.29289V4.5C3 4.22386 2.77614 4 2.5 4C2.22386 4 2 4.22386 2 4.5V7.49991C2 7.49997 2 7.50003 2 7.50009V7.625C2 7.90114 2.22386 8.125 2.5 8.125H5.625C5.90114 8.125 6.125 7.90114 6.125 7.625C6.125 7.34886 5.90114 7.125 5.625 7.125H3.58211L4.85355 5.85355L4.85356 5.85356L4.85599 5.8511C5.36513 5.33486 6.02412 4.71287 6.72483 4.18745C7.43582 3.65432 8.14228 3.25724 8.74951 3.13468C10.0874 2.86463 11.4744 3.0026 12.7353 3.53141C13.9962 4.06025 15.0751 4.95654 15.8346 6.10792C16.5942 7.25936 17 8.61385 17 10C17 11.3862 16.5942 12.7406 15.8346 13.8921C15.0751 15.0435 13.9962 15.9397 12.7353 16.4686C11.4744 16.9974 10.0874 17.1354 8.74951 16.8653C7.41156 16.5953 6.18183 15.9291 5.21622 14.95C5.02232 14.7534 4.70574 14.7512 4.50913 14.9451C4.31253 15.1391 4.31033 15.4556 4.50424 15.6522C5.6088 16.7722 7.0172 17.5358 8.55165 17.8456C10.0861 18.1553 11.6768 17.9969 13.122 17.3908C14.5672 16.7847 15.8014 15.7584 16.6693 14.4427C17.5372 13.1272 18 11.5811 18 10C18 8.41891 17.5372 6.87282 16.6693 5.55726C15.8014 4.24163 14.5672 3.21535 13.122 2.60923Z",
          fill: t
        })
      });
    case "link20":
      return /* @__PURE__ */ u(N, {
        width: r || 20,
        height: n || 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M10.5098 5.79941L12.0481 4.26104C12.607 3.75553 13.3385 3.48334 14.0921 3.50079C14.8494 3.51832 15.5709 3.827 16.1066 4.36266C16.6359 4.89199 16.9823 5.74498 17.0001 6.51157C17.0168 7.23393 16.7376 7.83774 16.2076 8.42176L13.5051 11.1471L13.5047 11.1476C13.2326 11.4206 12.9093 11.6372 12.5533 11.785C12.1971 11.9329 11.8153 12.0091 11.4296 12.0091C11.044 12.0091 10.6621 11.9329 10.306 11.785C9.94979 11.6371 9.62634 11.4203 9.35415 11.1471C9.15926 10.9515 8.84267 10.9509 8.64705 11.1458C8.45142 11.3407 8.45083 11.6573 8.64572 11.8529C9.01082 12.2194 9.44468 12.5101 9.92241 12.7085C10.4001 12.9069 10.9123 13.0091 11.4296 13.0091C11.9469 13.0091 12.4591 12.9069 12.9368 12.7085C13.4146 12.5101 13.8484 12.2194 14.2135 11.8529L14.2144 11.8521L16.9253 9.11823C16.9302 9.11325 16.9351 9.10816 16.9398 9.10298C17.5992 8.3795 18.024 7.53476 17.9998 6.48843C17.9765 5.4832 17.5376 4.37943 16.8137 3.65556C16.0961 2.93802 15.1297 2.52454 14.1152 2.50106C13.1008 2.47757 12.1162 2.84588 11.3663 3.52944C11.3606 3.53464 11.355 3.53997 11.3495 3.54543L9.80265 5.0923C9.60738 5.28756 9.60738 5.60415 9.80265 5.79941C9.99791 5.99467 10.3145 5.99467 10.5098 5.79941ZM7.44659 9.22406C7.80275 9.07614 8.18461 9 8.57026 9C8.95592 9 9.33778 9.07614 9.69394 9.22406C10.0501 9.37198 10.3736 9.58876 10.6457 9.86196C10.8406 10.0576 11.1572 10.0582 11.3528 9.86329C11.5485 9.66839 11.5491 9.35181 11.3542 9.15618C10.9891 8.78972 10.5552 8.49894 10.0775 8.30054C9.59976 8.10213 9.08756 8 8.57026 8C8.05297 8 7.54077 8.10213 7.06304 8.30054C6.58589 8.4987 6.15251 8.78902 5.78769 9.15485L3.04729 11.8658C3.04117 11.8719 3.0352 11.8781 3.02939 11.8845C2.35922 12.6197 1.97616 13.4785 2.00008 14.5116C2.02313 15.5072 2.42548 16.6019 3.15551 17.3319C3.87305 18.0494 4.83947 18.4629 5.85395 18.4864C6.86843 18.5099 7.85296 18.1416 8.60293 17.458C8.60863 17.4528 8.61422 17.4475 8.61967 17.442L10.1665 15.8951C10.3618 15.6999 10.3618 15.3833 10.1665 15.188C9.97129 14.9928 9.6547 14.9928 9.45944 15.188L7.92107 16.7264C7.36223 17.2319 6.63073 17.5041 5.8771 17.4866C5.11975 17.4691 4.39828 17.1604 3.86262 16.6248C3.33944 16.1016 3.01778 15.2646 2.99981 14.4884C2.9828 13.7536 3.24196 13.1393 3.76003 12.5674L6.49222 9.86453L6.49223 9.86454L6.49479 9.86196C6.76698 9.58876 7.09043 9.37198 7.44659 9.22406Z",
          fill: t
        })
      });
    case "logout20":
      return /* @__PURE__ */ E(N, {
        width: r || 20,
        height: n || 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: [/* @__PURE__ */ u("path", {
          d: "M14 6.5L17.5 10L14 13.5",
          stroke: t,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /* @__PURE__ */ u("path", {
          d: "M8.5 10H17.5",
          stroke: t,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /* @__PURE__ */ u("path", {
          d: "M9.5 17.5H3.125C2.95924 17.5 2.80027 17.4282 2.68306 17.3003C2.56585 17.1724 2.5 16.999 2.5 16.8182V3.18182C2.5 3.00099 2.56585 2.82757 2.68306 2.6997C2.80027 2.57183 2.95924 2.5 3.125 2.5H9.5",
          stroke: t,
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })]
      });
    case "markdown20":
      return /* @__PURE__ */ E(N, {
        width: r || 20,
        height: n || 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: [/* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3.21646 3.47217C3.08181 3.47217 2.97266 3.58132 2.97266 3.71597V17.2284C2.97266 17.363 3.08181 17.4722 3.21646 17.4722H16.7289C16.8635 17.4722 16.9727 17.363 16.9727 17.2284V3.71597C16.9727 3.58132 16.8635 3.47217 16.7289 3.47217H3.21646ZM1.97266 3.71597C1.97266 3.02904 2.52953 2.47217 3.21646 2.47217H16.7289C17.4158 2.47217 17.9727 3.02904 17.9727 3.71597V17.2284C17.9727 17.9153 17.4158 18.4722 16.7289 18.4722H3.21646C2.52953 18.4722 1.97266 17.9153 1.97266 17.2284V3.71597Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          d: "M6.45117 6.95459H8.15785L9.9604 11.3523H10.0371L11.8397 6.95459H13.5463V13.5H12.204V9.23975H12.1497L10.4558 13.4681H9.54173L7.84783 9.22377H7.7935V13.5H6.45117V6.95459Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          d: "M12.8496 15L11.5996 13.5H14.0996L12.8496 15Z",
          fill: t
        })]
      });
    case "pdf20":
      return /* @__PURE__ */ E(N, {
        width: r || 20,
        height: n || 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: [/* @__PURE__ */ u("path", {
          d: "M5.41602 12.5001V8.86377H6.85067C7.12648 8.86377 7.36145 8.91644 7.55558 9.0218C7.7497 9.12596 7.89767 9.27097 7.99947 9.45681C8.10245 9.64147 8.15394 9.85454 8.15394 10.096C8.15394 10.3375 8.10186 10.5506 7.99769 10.7352C7.89353 10.9199 7.7426 11.0637 7.54492 11.1667C7.34843 11.2697 7.1105 11.3212 6.83114 11.3212H5.91673V10.705H6.70685C6.85482 10.705 6.97674 10.6796 7.07262 10.6287C7.16969 10.5766 7.24189 10.505 7.28924 10.4138C7.33777 10.3215 7.36204 10.2156 7.36204 10.096C7.36204 9.97528 7.33777 9.86992 7.28924 9.77996C7.24189 9.68882 7.16969 9.61839 7.07262 9.56867C6.97556 9.51777 6.85245 9.49232 6.7033 9.49232H6.18484V12.5001H5.41602Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          d: "M9.94238 12.5001H8.65332V8.86377H9.95304C10.3188 8.86377 10.6337 8.93657 10.8976 9.08216C11.1616 9.22658 11.3646 9.43432 11.5067 9.70539C11.6499 9.97646 11.7215 10.3008 11.7215 10.6784C11.7215 11.0572 11.6499 11.3827 11.5067 11.655C11.3646 11.9272 11.1604 12.1361 10.8941 12.2817C10.6289 12.4273 10.3117 12.5001 9.94238 12.5001ZM9.42214 11.8414H9.91042C10.1377 11.8414 10.3289 11.8012 10.4839 11.7207C10.6402 11.639 10.7574 11.5129 10.8355 11.3425C10.9148 11.1708 10.9545 10.9495 10.9545 10.6784C10.9545 10.4097 10.9148 10.1901 10.8355 10.0197C10.7574 9.84921 10.6408 9.72374 10.4857 9.64324C10.3306 9.56275 10.1395 9.52251 9.9122 9.52251H9.42214V11.8414Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          d: "M12.291 12.5001V8.86377H14.6987V9.49765H13.0598V10.3641H14.5389V10.998H13.0598V12.5001H12.291Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4 4.5V16.5H16V4.5H4ZM3.5 3.5C3.22386 3.5 3 3.72386 3 4V17C3 17.2761 3.22386 17.5 3.5 17.5H16.5C16.7761 17.5 17 17.2761 17 17V4C17 3.72386 16.7761 3.5 16.5 3.5H3.5Z",
          fill: t
        })]
      });
    case "png20":
      return /* @__PURE__ */ E(N, {
        width: r || 20,
        height: n || 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: [/* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.0564 9.06886C12.1765 9.02308 12.304 9 12.4319 9C12.5597 9 12.6872 9.02308 12.8074 9.06886C12.882 9.09731 13.0001 9.14933 13.1073 9.2357L16.7695 11.5788C17.0021 11.7277 17.07 12.0369 16.9212 12.2695C16.7724 12.5021 16.4632 12.57 16.2306 12.4212L12.5402 10.06C12.5201 10.0472 12.501 10.0329 12.483 10.0174C12.48 10.0158 12.4759 10.0137 12.4706 10.0113C12.4647 10.0087 12.4582 10.0059 12.4514 10.0033C12.4464 10.0015 12.4397 10 12.4319 10C12.4241 10 12.4173 10.0015 12.4124 10.0033C12.4086 10.0048 12.4069 10.0061 12.4066 10.0062L12.404 10.0086L9.55429 12.6014C9.45863 12.6894 9.34731 12.7571 9.22782 12.8026C9.10767 12.8484 8.98016 12.8714 8.85233 12.8714C8.72449 12.8714 8.59698 12.8484 8.47683 12.8026C8.35732 12.7571 8.24598 12.6894 8.15031 12.6014L6.83473 11.4044L6.83211 11.402C6.83182 11.4018 6.83005 11.4005 6.82637 11.3991C6.82142 11.3972 6.81466 11.3958 6.80687 11.3958C6.79908 11.3958 6.79232 11.3972 6.78737 11.3991C6.78337 11.4007 6.78163 11.402 6.78159 11.4021C6.78158 11.4021 6.78143 11.4022 6.78159 11.4021C6.76237 11.4198 6.74201 11.4358 6.72024 11.4504L3.77777 13.4158C3.54814 13.5692 3.23765 13.5073 3.08427 13.2777C2.93089 13.0481 2.99271 12.7376 3.22233 12.5842L6.1378 10.6369C6.22574 10.5629 6.32534 10.505 6.43137 10.4646C6.55152 10.4189 6.67904 10.3958 6.80687 10.3958C6.9347 10.3958 7.06222 10.4189 7.18237 10.4646C7.30187 10.5102 7.41321 10.5778 7.50888 10.6658L8.82709 11.8652C8.82692 11.865 8.827 11.8651 8.82709 11.8652C8.82737 11.8654 8.82914 11.8667 8.83283 11.8681C8.83778 11.87 8.84453 11.8714 8.85233 11.8714C8.86012 11.8714 8.86687 11.87 8.87182 11.8681C8.87556 11.8667 8.87733 11.8654 8.87757 11.8652L8.88017 11.8628L11.7282 9.27155L12.0675 9.6388L11.731 9.26897L11.7299 9.27005C11.8255 9.18205 11.9369 9.11438 12.0564 9.06886Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          d: "M7.4 9.05C8.03513 9.05 8.55 8.53513 8.55 7.9C8.55 7.26487 8.03513 6.75 7.4 6.75C6.76487 6.75 6.25 7.26487 6.25 7.9C6.25 8.53513 6.76487 9.05 7.4 9.05Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4 4.5V16.5H16V4.5H4ZM3.5 3.5C3.22386 3.5 3 3.72386 3 4V17C3 17.2761 3.22386 17.5 3.5 17.5H16.5C16.7761 17.5 17 17.2761 17 17V4C17 3.72386 16.7761 3.5 16.5 3.5H3.5Z",
          fill: t
        })]
      });
    case "word20":
      return /* @__PURE__ */ E(N, {
        width: r || 20,
        height: n || 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: [/* @__PURE__ */ u("path", {
          d: "M7.67063 13.4998L6.00586 7.68164H7.34961L8.31268 11.7243H8.36097L9.42347 7.68164H10.574L11.6337 11.7328H11.6848L12.6479 7.68164H13.9917L12.3269 13.4998H11.128L10.0201 9.69585H9.97461L8.8695 13.4998H7.67063Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4 4.5V16.5H16V4.5H4ZM3.5 3.5C3.22386 3.5 3 3.72386 3 4V17C3 17.2761 3.22386 17.5 3.5 17.5H16.5C16.7761 17.5 17 17.2761 17 17V4C17 3.72386 16.7761 3.5 16.5 3.5H3.5Z",
          fill: t
        })]
      });
    case "translate20":
      return /* @__PURE__ */ E(N, {
        width: r || 20,
        height: n || 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [/* @__PURE__ */ E("g", {
          clipPath: "url(#clip0_766_3388)",
          children: [/* @__PURE__ */ u("path", {
            d: "M9.75 17.5L13.75 8.5L17.75 17.5",
            stroke: t,
            strokeLinecap: "round",
            "stroke-linejoin": "round"
          }), /* @__PURE__ */ u("path", {
            d: "M16.5 15H11",
            stroke: t,
            strokeLinecap: "round",
            "stroke-linejoin": "round"
          }), /* @__PURE__ */ u("path", {
            d: "M2.25 4.5H12.25",
            stroke: t,
            strokeLinecap: "round",
            "stroke-linejoin": "round"
          }), /* @__PURE__ */ u("path", {
            d: "M7.25 2.5V4.5",
            stroke: t,
            strokeLinecap: "round"
          }), /* @__PURE__ */ u("path", {
            d: "M9.75 4.5C9.41667 7 7.45 12 2.25 12",
            stroke: t,
            strokeLinecap: "round"
          }), /* @__PURE__ */ u("path", {
            d: "M4.75 7C5.41667 8.5 7.75 11.6 11.75 12",
            stroke: t,
            strokeLinecap: "round"
          })]
        }), /* @__PURE__ */ u("defs", {
          children: /* @__PURE__ */ u("clipPath", {
            id: "clip0_766_3388",
            children: /* @__PURE__ */ u("rect", {
              width: "20",
              height: "20",
              fill: "white"
            })
          })
        })]
      });
    case "linkedDocument20":
      return /* @__PURE__ */ E(N, {
        width: r || 20,
        height: n || 20,
        viewBox: "0 0 20 20",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [/* @__PURE__ */ u("rect", {
          x: "3.5",
          y: "2.5",
          width: "13",
          height: "15",
          rx: "1",
          stroke: t
        }), /* @__PURE__ */ u("path", {
          d: "M9.38978 10.6102C9.56722 10.779 9.56722 11.056 9.38978 11.2248C9.22099 11.3936 8.94401 11.3936 8.77522 11.2248C7.9313 10.3808 7.9313 9.00893 8.77522 8.165L10.3073 6.63295C11.1512 5.78902 12.5231 5.78902 13.3671 6.63295C14.211 7.47687 14.211 8.8488 13.3671 9.69272L12.7222 10.3376C12.7265 9.98269 12.6703 9.62781 12.5491 9.29024L12.7525 9.0825C13.2632 8.57614 13.2632 7.75385 12.7525 7.2475C12.2461 6.73681 11.4239 6.73681 10.9175 7.2475L9.38978 8.77522C8.87909 9.28158 8.87909 10.1039 9.38978 10.6102ZM10.6102 8.77522C10.779 8.60644 11.056 8.60644 11.2248 8.77522C12.0687 9.61915 12.0687 10.9911 11.2248 11.835L9.69272 13.3671C8.8488 14.211 7.47687 14.211 6.63295 13.3671C5.78902 12.5231 5.78902 11.1512 6.63295 10.3073L7.27779 9.66243C7.27347 10.0173 7.32973 10.3722 7.45091 10.7141L7.2475 10.9175C6.73681 11.4239 6.73681 12.2461 7.2475 12.7525C7.75385 13.2632 8.57614 13.2632 9.0825 12.7525L10.6102 11.2248C11.1209 10.7184 11.1209 9.89613 10.6102 9.38978C10.4328 9.22099 10.4328 8.94401 10.6102 8.77522Z",
          fill: t
        })]
      });
    case "help24":
      return /* @__PURE__ */ E(N, {
        width: r || 24,
        height: n || 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": "slid-ips-icon-language",
        ...i,
        children: [/* @__PURE__ */ u("path", {
          d: "M10 10C10 8.87719 10.8773 8 12.0001 8C13.1229 8 14 8.87719 14 10C14 11.1228 13.263 11.7188 12.8419 11.9995C11.9998 12.5609 12 12.8772 12 13.4386V13.5",
          stroke: t,
          strokeWidth: "2",
          strokeLinecap: "round"
        }), /* @__PURE__ */ u("circle", {
          cx: "12.0035",
          cy: "16.0081",
          r: "1.00812",
          fill: t
        }), /* @__PURE__ */ u("circle", {
          cx: "12",
          cy: "12",
          r: "8",
          stroke: t,
          strokeWidth: "2"
        })]
      });
    case "fullScreen20":
      return /* @__PURE__ */ u(N, {
        viewBox: "0 0 20 20",
        width: r || 20,
        height: n || 20,
        fill: "none",
        children: /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.0625 3C5.71427 3 3 5.71427 3 9.0625C3 12.4107 5.71427 15.125 9.0625 15.125C12.4107 15.125 15.125 12.4107 15.125 9.0625C15.125 5.71427 12.4107 3 9.0625 3ZM2 9.0625C2 5.16199 5.16199 2 9.0625 2C12.963 2 16.125 5.16199 16.125 9.0625C16.125 10.8328 15.4737 12.451 14.3975 13.6904L17.8536 17.1465C18.0488 17.3417 18.0488 17.6583 17.8536 17.8536C17.6583 18.0488 17.3417 18.0488 17.1465 17.8536L13.6904 14.3975C12.451 15.4737 10.8328 16.125 9.0625 16.125C5.16199 16.125 2 12.963 2 9.0625ZM9.5625 6.5625C9.5625 6.28636 9.33864 6.0625 9.0625 6.0625C8.78636 6.0625 8.5625 6.28636 8.5625 6.5625V8.5625H6.5625C6.28636 8.5625 6.0625 8.78636 6.0625 9.0625C6.0625 9.33864 6.28636 9.5625 6.5625 9.5625H8.5625V11.5625C8.5625 11.8386 8.78636 12.0625 9.0625 12.0625C9.33864 12.0625 9.5625 11.8386 9.5625 11.5625V9.5625H11.5625C11.8386 9.5625 12.0625 9.33864 12.0625 9.0625C12.0625 8.78636 11.8386 8.5625 11.5625 8.5625H9.5625V6.5625Z",
          fill: t
        })
      });
    case "markUp20":
      return /* @__PURE__ */ E(N, {
        viewBox: "0 0 20 20",
        width: r || 20,
        height: n || 20,
        fill: "none",
        children: [/* @__PURE__ */ u("clipPath", {
          id: "a",
          children: /* @__PURE__ */ u("path", {
            d: "m0 0h20v20h-20z"
          })
        }), /* @__PURE__ */ u("g", {
          clipPath: "url(#a)",
          children: /* @__PURE__ */ u("path", {
            clipRule: "evenodd",
            d: "m13.7253 2.30644c-.4086-.40859-1.071-.40859-1.4796 0l-9.93926 9.93926c-.19621.1962-.30644.4623-.30644.7398v3.9683c0 .5778.46842 1.0462 1.04624 1.0462h3.96827c.27747 0 .54359-.1102.7398-.3064l9.93929-9.93929c.4085-.40858.4085-1.07102 0-1.47961zm-2.5502 2.5502 1.8104-1.8104 3.9683 3.96827-1.8104 1.8104zm-.7398.7398-7.38906 7.38906v3.9683h3.96827l7.38909-7.38909z",
            fill: t,
            fillRule: "evenodd"
          })
        })]
      });
    case "delete24":
      return /* @__PURE__ */ E(N, {
        width: r || 24,
        height: n || 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": "slid-ips-icon-language",
        ...i,
        children: [/* @__PURE__ */ u("path", {
          d: "M7 7C7 6.44772 6.55228 6 6 6C5.44772 6 5 6.44772 5 7H7ZM19 7C19 6.44772 18.5523 6 18 6C17.4477 6 17 6.44772 17 7H19ZM5 7V19H7V7H5ZM7 21H17V19H7V21ZM19 19V7H17V19H19ZM17 21C18.1046 21 19 20.1046 19 19H17V21ZM5 19C5 20.1046 5.89543 21 7 21V19H5Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          d: "M4 6C3.44772 6 3 6.44772 3 7C3 7.55228 3.44772 8 4 8V6ZM20 8C20.5523 8 21 7.55228 21 7C21 6.44772 20.5523 6 20 6V8ZM4 8H20V6H4V8Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          d: "M7 6C7 6.55228 7.44772 7 8 7C8.55228 7 9 6.55228 9 6H7ZM15 6C15 6.55228 15.4477 7 16 7C16.5523 7 17 6.55228 17 6H15ZM9 6V5H7V6H9ZM9 5H15V3H9V5ZM15 5V6H17V5H15ZM15 5H17C17 3.89543 16.1046 3 15 3V5ZM9 5V3C7.89543 3 7 3.89543 7 5H9Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          d: "M11 11C11 10.4477 10.5523 10 10 10C9.44772 10 9 10.4477 9 11H11ZM9 16C9 16.5523 9.44772 17 10 17C10.5523 17 11 16.5523 11 16H9ZM9 11V16H11V11H9Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          d: "M15 11C15 10.4477 14.5523 10 14 10C13.4477 10 13 10.4477 13 11H15ZM13 16C13 16.5523 13.4477 17 14 17C14.5523 17 15 16.5523 15 16H13ZM13 11V16H15V11H13Z",
          fill: t
        })]
      });
    case "chevronUp24":
      return /* @__PURE__ */ u(N, {
        width: r || 24,
        height: n || 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: /* @__PURE__ */ u("path", {
          d: "M17 15L12 10L7 15",
          stroke: t,
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      });
    case "chevronDown24":
      return /* @__PURE__ */ u(N, {
        width: r || 24,
        height: n || 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": "slid-ips-icon-chevron",
        ...i,
        children: /* @__PURE__ */ u("path", {
          d: "M7 10L12 15L17 10",
          stroke: t,
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      });
    case "check24":
      return /* @__PURE__ */ u(N, {
        width: r || 24,
        height: n || 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": "slid-ips-icon-check",
        ...i,
        children: /* @__PURE__ */ u("path", {
          d: "M6 12L10.5 16L18 8",
          stroke: t,
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      });
    case "chat24":
      return /* @__PURE__ */ E(N, {
        width: r || 24,
        height: n || 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: [/* @__PURE__ */ u("mask", {
          id: "path-1-inside-1_1464_1581",
          fill: "white",
          children: /* @__PURE__ */ u("path", {
            d: "M2 4.5V19.8698C2 20.7893 3.13652 21.2214 3.74741 20.5342L5.55248 18.5035C5.83714 18.1832 6.24514 18 6.6736 18H20.5C21.3284 18 22 17.3284 22 16.5V4.5C22 3.67157 21.3284 3 20.5 3H3.5C2.67157 3 2 3.67157 2 4.5Z"
          })
        }), /* @__PURE__ */ u("path", {
          d: "M5.55248 18.5035L4.80508 17.8391H4.80508L5.55248 18.5035ZM3.74741 20.5342L3 19.8698H3L3.74741 20.5342ZM3 19.8698V4.5H1V19.8698H3ZM3.5 4H20.5V2H3.5V4ZM21 4.5V16.5H23V4.5H21ZM20.5 17H6.6736V19H20.5V17ZM4.80508 17.8391L3 19.8698L4.49482 21.1985L6.29989 19.1678L4.80508 17.8391ZM6.6736 17C5.9595 17 5.27949 17.3054 4.80508 17.8391L6.29989 19.1678C6.39478 19.0611 6.53078 19 6.6736 19V17ZM21 16.5C21 16.7761 20.7761 17 20.5 17V19C21.8807 19 23 17.8807 23 16.5H21ZM20.5 4C20.7761 4 21 4.22386 21 4.5H23C23 3.11929 21.8807 2 20.5 2V4ZM3 4.5C3 4.22386 3.22386 4 3.5 4V2C2.11929 2 1 3.11929 1 4.5H3ZM1 19.8698C1 21.7088 3.27303 22.573 4.49482 21.1985L3 19.8698H3H1Z",
          fill: t,
          mask: "url(#path-1-inside-1_1464_1581)"
        }), /* @__PURE__ */ u("path", {
          d: "M8.35355 10.1464C8.15829 9.95118 7.84171 9.95118 7.64645 10.1464C7.45118 10.3417 7.45118 10.6583 7.64645 10.8536L8.35355 10.1464ZM10.5 13L10.1464 13.3536C10.3293 13.5364 10.6214 13.5497 10.8201 13.3841L10.5 13ZM16.8201 8.38411C17.0322 8.20733 17.0609 7.89205 16.8841 7.67991C16.7073 7.46777 16.392 7.43911 16.1799 7.61589L16.8201 8.38411ZM7.64645 10.8536L10.1464 13.3536L10.8536 12.6464L8.35355 10.1464L7.64645 10.8536ZM10.8201 13.3841L16.8201 8.38411L16.1799 7.61589L10.1799 12.6159L10.8201 13.3841Z",
          fill: t
        })]
      });
    case "language24":
      return /* @__PURE__ */ u(N, {
        width: r || 24,
        height: n || 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": "slid-ips-icon-language",
        ...i,
        children: /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM7.62833 16C8.02379 17.1939 8.62919 18.4009 9.48972 19.5982C7.6131 18.9786 6.04388 17.6831 5.07026 16H7.62833ZM9.75822 16C10.2283 17.1609 10.9487 18.3448 11.988 19.527C12.7526 18.6051 13.5302 17.3958 14.1003 16H9.75822ZM14.7264 14H9.17816C8.96505 12.8108 8.98662 11.663 9.16201 10.5857C9.19412 10.3884 9.23148 10.1931 9.27364 10H14.8218C15.0349 11.1892 15.0134 12.337 14.838 13.4143C14.8059 13.6116 14.7685 13.8069 14.7264 14ZM16.2371 16C15.7644 17.3674 15.1095 18.596 14.4064 19.6318C16.3289 19.0261 17.9382 17.7141 18.9297 16H16.2371ZM19.748 14H16.7662C16.7823 13.9123 16.7976 13.8242 16.812 13.7357C17.0064 12.5415 17.0383 11.2863 16.848 10H19.748C19.9125 10.6392 20 11.3094 20 12C20 12.6906 19.9125 13.3608 19.748 14ZM7.15198 14H4.25203C4.08751 13.3608 4 12.6906 4 12C4 11.3094 4.08751 10.6392 4.25203 10H7.23383C7.21768 10.0877 7.2024 10.1758 7.18799 10.2643C6.99359 11.4585 6.96168 12.7137 7.15198 14ZM7.76292 8H5.07026C6.0618 6.28592 7.67106 4.97387 9.59363 4.36824C8.89046 5.40398 8.23556 6.63259 7.76292 8ZM9.89965 8H14.2418C13.7717 6.83907 13.0513 5.65524 12.012 4.47301C11.2474 5.39494 10.4698 6.6042 9.89965 8ZM16.3717 8H18.9297C17.9561 6.31689 16.3869 5.02142 14.5103 4.40177C15.3708 5.5991 15.9762 6.80607 16.3717 8Z",
          fill: t
        })
      });
    case "plus24":
      return /* @__PURE__ */ u(N, {
        width: r || 24,
        height: n || 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": "slid-ips-icon-plus",
        ...i,
        children: /* @__PURE__ */ u("path", {
          d: "M12 4V20M4 12H20",
          stroke: t,
          strokeWidth: "2",
          strokeLinecap: "round"
        })
      });
    case "arrowDown24":
      return /* @__PURE__ */ E(N, {
        width: r || 24,
        height: n || 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": "slid-ips-icon-arrow-down",
        ...i,
        children: [/* @__PURE__ */ u("path", {
          d: "M7 13L12 18L17 13",
          stroke: t,
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /* @__PURE__ */ u("path", {
          d: "M12 18V6",
          stroke: t,
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })]
      });
    case "arrowUp24":
      return /* @__PURE__ */ E(N, {
        width: r || 24,
        height: n || 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": "slid-ips-icon-arrow-up",
        ...i,
        children: [/* @__PURE__ */ u("path", {
          d: "M17 11L12 6L7 11",
          stroke: t,
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /* @__PURE__ */ u("path", {
          d: "M12 18V6",
          stroke: t,
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })]
      });
    case "chrome24":
      return /* @__PURE__ */ E(N, {
        width: r || 24,
        height: n || 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: [/* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.2819 9.12777C10.7482 8.78623 10.0479 9.16947 10.0479 9.80305V13.1971C10.0479 13.8096 10.707 14.1959 11.2414 13.8966L14.0698 12.3127C14.5982 12.0168 14.6203 11.2644 14.1102 10.9379L11.2819 9.12777Z",
          fill: t
        }), /* @__PURE__ */ u("rect", {
          x: "3.5",
          y: "3.5",
          width: "17",
          height: "16",
          rx: "1",
          stroke: t
        })]
      });
    case "list24":
      return /* @__PURE__ */ E(N, {
        width: r || 24,
        height: n || 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: [/* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8 7C8 6.44772 8.44772 6 9 6H19C19.5523 6 20 6.44772 20 7C20 7.55228 19.5523 8 19 8H9C8.44772 8 8 7.55228 8 7Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8 12C8 11.4477 8.44772 11 9 11H19C19.5523 11 20 11.4477 20 12C20 12.5523 19.5523 13 19 13H9C8.44772 13 8 12.5523 8 12Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8 17C8 16.4477 8.44772 16 9 16H19C19.5523 16 20 16.4477 20 17C20 17.5523 19.5523 18 19 18H9C8.44772 18 8 17.5523 8 17Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          d: "M4.9375 7.875C5.45527 7.875 5.875 7.45527 5.875 6.9375C5.875 6.41973 5.45527 6 4.9375 6C4.41973 6 4 6.41973 4 6.9375C4 7.45527 4.41973 7.875 4.9375 7.875Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          d: "M4.9375 12.875C5.45527 12.875 5.875 12.4553 5.875 11.9375C5.875 11.4197 5.45527 11 4.9375 11C4.41973 11 4 11.4197 4 11.9375C4 12.4553 4.41973 12.875 4.9375 12.875Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          d: "M4.9375 17.875C5.45527 17.875 5.875 17.4553 5.875 16.9375C5.875 16.4197 5.45527 16 4.9375 16C4.41973 16 4 16.4197 4 16.9375C4 17.4553 4.41973 17.875 4.9375 17.875Z",
          fill: t
        })]
      });
    case "more24":
      return /* @__PURE__ */ E(N, {
        width: r || 24,
        height: n || 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: [/* @__PURE__ */ u("path", {
          d: "M12 7.5C12.8284 7.5 13.5 6.82843 13.5 6C13.5 5.17157 12.8284 4.5 12 4.5C11.1716 4.5 10.5 5.17157 10.5 6C10.5 6.82843 11.1716 7.5 12 7.5Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          d: "M12 13.5C12.8284 13.5 13.5 12.8284 13.5 12C13.5 11.1716 12.8284 10.5 12 10.5C11.1716 10.5 10.5 11.1716 10.5 12C10.5 12.8284 11.1716 13.5 12 13.5Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          d: "M12 19.5C12.8284 19.5 13.5 18.8284 13.5 18C13.5 17.1716 12.8284 16.5 12 16.5C11.1716 16.5 10.5 17.1716 10.5 18C10.5 18.8284 11.1716 19.5 12 19.5Z",
          fill: t
        })]
      });
    case "desktop24":
      return /* @__PURE__ */ E(N, {
        width: r || 24,
        height: n || 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: [/* @__PURE__ */ u("rect", {
          x: "6",
          y: "20",
          width: "12",
          height: "1",
          rx: "0.5",
          fill: t
        }), /* @__PURE__ */ u("rect", {
          x: "11",
          y: "18",
          width: "2",
          height: "2",
          fill: t
        }), /* @__PURE__ */ u("rect", {
          x: "2.5",
          y: "3.5",
          width: "19",
          height: "14",
          rx: "1",
          stroke: t
        }), /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.2339 8.12777C10.7003 7.78623 10 8.16947 10 8.80305V12.1971C10 12.8096 10.6591 13.1959 11.1935 12.8966L14.0218 11.3127C14.5503 11.0168 14.5724 10.2644 14.0623 9.93792L11.2339 8.12777Z",
          fill: t
        })]
      });
    case "note24":
      return /* @__PURE__ */ E(N, {
        width: r || 24,
        height: n || 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: [/* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M11.1975 6.10158C10.6796 5.77012 10 6.14206 10 6.75695V10.0509C10 10.6454 10.6396 11.0202 11.1583 10.7298L13.9032 9.19262C14.4161 8.90544 14.4375 8.17518 13.9425 7.85835L11.1975 6.10158Z",
          fill: t
        }), /* @__PURE__ */ u("rect", {
          x: "3.5",
          y: "2.5",
          width: "17",
          height: "19",
          rx: "1",
          stroke: t
        }), /* @__PURE__ */ u("rect", {
          x: "7",
          y: "13",
          width: "10",
          height: "1",
          rx: "0.5",
          fill: t
        }), /* @__PURE__ */ u("rect", {
          x: "7",
          y: "16",
          width: "10",
          height: "1",
          rx: "0.5",
          fill: t
        })]
      });
    case "newTab24":
      return /* @__PURE__ */ E(N, {
        width: r || 24,
        height: n || 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: [/* @__PURE__ */ u("rect", {
          x: "2.5",
          y: "6.5",
          width: "15",
          height: "15",
          rx: "1",
          stroke: t
        }), /* @__PURE__ */ u("path", {
          d: "M5.5 7V3.7C5.5 3.03726 6.03726 2.5 6.7 2.5H20.3C20.9627 2.5 21.5 3.03726 21.5 3.7V17.3C21.5 17.9627 20.9627 18.5 20.3 18.5H17",
          stroke: t
        }), /* @__PURE__ */ u("path", {
          d: "M8.5 15.341V12.159C8.5 11.6514 9.05581 11.3397 9.48894 11.6044L12.0924 13.1954C12.5072 13.4488 12.5072 14.0512 12.0924 14.3046L9.48894 15.8956C9.05581 16.1603 8.5 15.8486 8.5 15.341Z",
          fill: t
        })]
      });
    case "x24":
      return /* @__PURE__ */ u(N, {
        width: r || 24,
        height: n || 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: /* @__PURE__ */ u("path", {
          d: "M6.84313 6.34315L18.1568 17.6569M6.84313 17.6569L18.1568 6.34315",
          stroke: t,
          strokeWidth: "2",
          strokeLinecap: "round"
        })
      });
    case "slid24":
      return /* @__PURE__ */ E(N, {
        width: r || 24,
        height: n || 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: [/* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.03905 9.57136C8.37345 9.14537 7.5 9.62338 7.5 10.4136V14.6469C7.5 15.4109 8.32202 15.8927 8.9886 15.5194L12.5164 13.5439C13.1754 13.1748 13.203 12.2363 12.5668 11.8291L9.03905 9.57136Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4 4.5C4 3.39543 4.89543 2.5 6 2.5H18C18.7403 2.5 19.3866 2.9022 19.7324 3.5H20C21.1046 3.5 22 4.39543 22 5.5V18.5C22 19.6046 21.1046 20.5 20 20.5H16H8H4C2.89543 20.5 2 19.6046 2 18.5V6.5C2 5.39543 2.89543 4.5 4 4.5ZM20 19.5H17.7324C17.9026 19.2058 18 18.8643 18 18.5C19.1046 18.5 20 17.6046 20 16.5V4.5C20.5523 4.5 21 4.94772 21 5.5V18.5C21 19.0523 20.5523 19.5 20 19.5ZM3 6.5C3 5.94772 3.44772 5.5 4 5.5H16C16.5523 5.5 17 5.94772 17 6.5V18.5C17 19.0523 16.5523 19.5 16 19.5H8H6.26756H4C3.96548 19.5 3.93137 19.4983 3.89776 19.4948C3.3935 19.4436 3 19.0178 3 18.5V6.5Z",
          fill: t
        })]
      });
    case "filledFolder24":
      return /* @__PURE__ */ u(N, {
        width: r || 24,
        height: n || 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...i,
        children: /* @__PURE__ */ u("path", {
          d: "M3 18V6C3 4.89543 3.89543 4 5 4H8.40715C8.67365 4 8.92912 4.10637 9.11686 4.29551L12 7.2H19C20.1046 7.2 21 8.09543 21 9.2V18C21 19.1046 20.1046 20 19 20H5C3.89543 20 3 19.1046 3 18Z",
          fill: t
        })
      });
    case "myNote24":
      return /* @__PURE__ */ u(N, {
        width: r || 24,
        height: n || 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": "slid-ips-icon-language",
        ...i,
        children: /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M3 6C3 4.89543 3.89543 4 5 4H8.46298C8.96956 4 9.45727 4.19224 9.82762 4.53789L11.3942 6H17C18.1046 6 19 6.89543 19 8V9H19.6126C20.9777 9 21.9416 10.3374 21.5099 11.6325L19.1766 18.6325C18.9044 19.4491 18.1401 20 17.2792 20H5C3.89543 20 3 19.1046 3 18V6ZM17 9V8H11.3942C10.8876 8 10.3999 7.80776 10.0295 7.46211L8.46298 6H5V12.8377L5.82339 10.3675C6.09562 9.55086 6.8599 9 7.72076 9H17ZM5.38743 18H17.2792L19.6126 11H7.72076L5.38743 18Z",
          fill: t
        })
      });
    case "update24":
      return /* @__PURE__ */ E(N, {
        width: r || 24,
        height: n || 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": "slid-ips-icon-language",
        ...i,
        children: [/* @__PURE__ */ u("path", {
          d: "M9 20H15",
          stroke: t,
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /* @__PURE__ */ u("path", {
          d: "M8.30261 13.9415C7.58829 13.4267 7.00975 12.768 6.61082 12.0154C6.21189 11.2627 6.00303 10.4357 6.00006 9.5971C5.98506 6.58038 8.60262 4.07107 11.8577 4.00156C13.1175 3.97389 14.3547 4.3145 15.3938 4.97509C16.433 5.63569 17.2214 6.58273 17.6471 7.68191C18.0729 8.78109 18.1145 9.9766 17.7659 11.0989C17.4174 12.2212 16.6964 13.2133 15.7053 13.9345C15.4863 14.0914 15.309 14.2925 15.1868 14.5226C15.0646 14.7527 15.0008 15.0057 15.0002 15.2622V16.4439C15.0002 16.5914 14.937 16.7328 14.8245 16.8371C14.712 16.9414 14.5594 17 14.4002 17H9.60014C9.441 17 9.28839 16.9414 9.17586 16.8371C9.06334 16.7328 9.00012 16.5914 9.00012 16.4439V15.2622C8.99825 15.0076 8.93457 14.7567 8.81383 14.5281C8.69308 14.2995 8.51836 14.099 8.30261 13.9415Z",
          stroke: t,
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })]
      });
    case "play24":
      return /* @__PURE__ */ E(N, {
        width: r || 24,
        height: n || 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": "slid-ips-icon-language",
        ...i,
        children: [/* @__PURE__ */ u("circle", {
          cx: "10",
          cy: "10",
          r: "8",
          fill: t
        }), /* @__PURE__ */ u("g", {
          filter: "url(#filter0_d_136_6921)",
          children: /* @__PURE__ */ u("path", {
            d: "M8.24309 6.34009C7.90983 6.14013 7.48584 6.38019 7.48584 6.76884V13.2312C7.48584 13.6199 7.90983 13.8599 8.24309 13.66L13.6284 10.4288C13.9521 10.2346 13.9521 9.76548 13.6284 9.57128L8.24309 6.34009Z",
            fill: "white"
          })
        }), /* @__PURE__ */ u("defs", {
          children: /* @__PURE__ */ E("filter", {
            id: "filter0_d_136_6921",
            x: "3.48584",
            y: "2.26807",
            width: "14.3853",
            height: "15.4639",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [/* @__PURE__ */ u("feFlood", {
              floodOpacity: "0",
              result: "BackgroundImageFix"
            }), /* @__PURE__ */ u("feColorMatrix", {
              in: "SourceAlpha",
              type: "matrix",
              values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
              result: "hardAlpha"
            }), /* @__PURE__ */ u("feOffset", {}), /* @__PURE__ */ u("feGaussianBlur", {
              stdDeviation: "2"
            }), /* @__PURE__ */ u("feComposite", {
              in2: "hardAlpha",
              operator: "out"
            }), /* @__PURE__ */ u("feColorMatrix", {
              type: "matrix",
              values: "0 0 0 0 0.270588 0 0 0 0 0.576471 0 0 0 0 0.988235 0 0 0 0.6 0"
            }), /* @__PURE__ */ u("feBlend", {
              mode: "normal",
              in2: "BackgroundImageFix",
              result: "effect1_dropShadow_136_6921"
            }), /* @__PURE__ */ u("feBlend", {
              mode: "normal",
              in: "SourceGraphic",
              in2: "effect1_dropShadow_136_6921",
              result: "shape"
            })]
          })
        })]
      });
    case "textGrab24":
      return /* @__PURE__ */ E(N, {
        width: r || 24,
        height: n || 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": "slid-ips-icon-language",
        ...i,
        children: [/* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M4 2.5C3.60218 2.5 3.22064 2.65804 2.93934 2.93934C2.65804 3.22064 2.5 3.60218 2.5 4V6C2.5 6.27614 2.27614 6.5 2 6.5C1.72386 6.5 1.5 6.27614 1.5 6V4C1.5 3.33696 1.76339 2.70107 2.23223 2.23223C2.70107 1.76339 3.33696 1.5 4 1.5H6C6.27614 1.5 6.5 1.72386 6.5 2C6.5 2.27614 6.27614 2.5 6 2.5H4Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2 13.5C2.27614 13.5 2.5 13.7239 2.5 14V16C2.5 16.3978 2.65804 16.7794 2.93934 17.0607C3.22064 17.342 3.60218 17.5 4 17.5H6C6.27614 17.5 6.5 17.7239 6.5 18C6.5 18.2761 6.27614 18.5 6 18.5H4C3.33696 18.5 2.70107 18.2366 2.23223 17.7678C1.76339 17.2989 1.5 16.663 1.5 16V14C1.5 13.7239 1.72386 13.5 2 13.5Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.5 2C13.5 1.72386 13.7239 1.5 14 1.5H16C16.663 1.5 17.2989 1.76339 17.7678 2.23223C18.2366 2.70107 18.5 3.33696 18.5 4V6C18.5 6.27614 18.2761 6.5 18 6.5C17.7239 6.5 17.5 6.27614 17.5 6V4C17.5 3.60218 17.342 3.22064 17.0607 2.93934C16.7794 2.65804 16.3978 2.5 16 2.5H14C13.7239 2.5 13.5 2.27614 13.5 2Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M18 13.5C18.2761 13.5 18.5 13.7239 18.5 14V16C18.5 16.663 18.2366 17.2989 17.7678 17.7678C17.2989 18.2366 16.663 18.5 16 18.5H14C13.7239 18.5 13.5 18.2761 13.5 18C13.5 17.7239 13.7239 17.5 14 17.5H16C16.3978 17.5 16.7794 17.342 17.0607 17.0607C17.342 16.7794 17.5 16.3978 17.5 16V14C17.5 13.7239 17.7239 13.5 18 13.5Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.25 4.7449C5.25 4.60964 5.34949 4.5 5.47222 4.5H8.24999H11.0277C11.1505 4.5 11.25 4.60964 11.25 4.7449V5.96938C11.25 6.10463 11.1505 6.21427 11.0277 6.21427C10.905 6.21427 10.8055 6.10463 10.8055 5.96938V4.98979H8.47221V10.0102H9.36073C9.48346 10.0102 9.58295 10.1198 9.58295 10.2551C9.58295 10.3903 9.48346 10.5 9.36073 10.5H7.13852C7.01579 10.5 6.9163 10.3903 6.9163 10.2551C6.9163 10.1198 7.01579 10.0102 7.13852 10.0102H8.02777V4.98979H5.69444V5.96938C5.69444 6.10463 5.59495 6.21427 5.47222 6.21427C5.34949 6.21427 5.25 6.10463 5.25 5.96938V4.7449Z",
          fill: "#ADB5BD"
        }), /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5 4.7449C5 4.49498 5.18912 4.25 5.47222 4.25H11.0277C11.3108 4.25 11.5 4.49498 11.5 4.7449V5.96938C11.5 6.21929 11.3108 6.46427 11.0277 6.46427C10.7446 6.46427 10.5555 6.21929 10.5555 5.96938V5.23979H8.72221V9.76019H9.36073C9.64383 9.76019 9.83295 10.0052 9.83295 10.2551C9.83295 10.505 9.64383 10.75 9.36073 10.75H7.13852C6.85542 10.75 6.6663 10.505 6.6663 10.2551C6.6663 10.0052 6.85542 9.76019 7.13852 9.76019H7.77777V5.23979H5.94444V5.96938C5.94444 6.21929 5.75532 6.46427 5.47222 6.46427C5.18912 6.46427 5 6.21929 5 5.96938V4.7449ZM5.5 4.75V4.83264C5.53145 4.79377 5.57432 4.76453 5.6235 4.75H5.5ZM8.09871 4.75C8.16452 4.76944 8.21902 4.81522 8.24999 4.87514C8.28097 4.81522 8.33547 4.76944 8.40127 4.75H8.09871ZM10.8765 4.75C10.9256 4.76453 10.9685 4.79377 11 4.83264V4.75H10.8765ZM8.24999 10.1248C8.21902 10.1848 8.16452 10.2305 8.09871 10.25H8.40127C8.33547 10.2305 8.28097 10.1848 8.24999 10.1248Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.5 7.75C12.5 7.47386 12.7239 7.25 13 7.25H15C15.2761 7.25 15.5 7.47386 15.5 7.75C15.5 8.02614 15.2761 8.25 15 8.25H13C12.7239 8.25 12.5 8.02614 12.5 7.75Z",
          fill: "#ADB5BD"
        }), /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M12.5 10.25C12.5 9.97386 12.7239 9.75 13 9.75H15C15.2761 9.75 15.5 9.97386 15.5 10.25C15.5 10.5261 15.2761 10.75 15 10.75H13C12.7239 10.75 12.5 10.5261 12.5 10.25Z",
          fill: "#ADB5BD"
        }), /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5 12.75C5 12.4739 5.22386 12.25 5.5 12.25H15C15.2761 12.25 15.5 12.4739 15.5 12.75C15.5 13.0261 15.2761 13.25 15 13.25H5.5C5.22386 13.25 5 13.0261 5 12.75Z",
          fill: "#ADB5BD"
        }), /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5 15.25C5 14.9739 5.22386 14.75 5.5 14.75H15C15.2761 14.75 15.5 14.9739 15.5 15.25C15.5 15.5261 15.2761 15.75 15 15.75H5.5C5.22386 15.75 5 15.5261 5 15.25Z",
          fill: "#ADB5BD"
        })]
      });
    case "foldMenu24":
      return /* @__PURE__ */ u(N, {
        width: r || 24,
        height: n || 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */ E("g", {
          clipPath: "url(#clip0_2837_3334)",
          children: [/* @__PURE__ */ u("path", {
            d: "M20 12H10",
            stroke: t,
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), /* @__PURE__ */ u("path", {
            d: "M20 12L16 16",
            stroke: t,
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), /* @__PURE__ */ u("path", {
            d: "M20 12L16 8",
            stroke: t,
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), /* @__PURE__ */ u("path", {
            d: "M5 5V19",
            stroke: t,
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          })]
        })
      });
    case "unfoldMenu24":
      return /* @__PURE__ */ u(N, {
        width: r || 24,
        height: n || 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */ E("g", {
          clipPath: "url(#clip0_2838_3355)",
          children: [/* @__PURE__ */ u("path", {
            d: "M5 12H15",
            stroke: t,
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), /* @__PURE__ */ u("path", {
            d: "M5 12L9 16",
            stroke: t,
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), /* @__PURE__ */ u("path", {
            d: "M5 12L9 8",
            stroke: t,
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), /* @__PURE__ */ u("path", {
            d: "M20 5V19",
            stroke: t,
            strokeWidth: "1.5",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          })]
        })
      });
    case "sparkles24":
      return /* @__PURE__ */ u(N, {
        width: r || 24,
        height: r || 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */ E("g", {
          clipPath: "url(#clip0_255_128)",
          children: [/* @__PURE__ */ u("path", {
            d: "M19 9L20.25 6.25L23 5L20.25 3.75L19 1L17.75 3.75L15 5L17.75 6.25L19 9Z",
            fill: t
          }), /* @__PURE__ */ u("path", {
            d: "M19 15L17.75 17.75L15 19L17.75 20.25L19 23L20.25 20.25L23 19L20.25 17.75L19 15Z",
            fill: t
          }), /* @__PURE__ */ u("path", {
            d: "M11.5 9.5L9 4L6.5 9.5L1 12L6.5 14.5L9 20L11.5 14.5L17 12L11.5 9.5ZM9.99 12.99L9 15.17L8.01 12.99L5.83 12L8.01 11.01L9 8.83L9.99 11.01L12.17 12L9.99 12.99Z",
            fill: t
          })]
        })
      });
    case "capture24":
      return /* @__PURE__ */ u(N, {
        viewBox: "0 0 24 24",
        width: r || 24,
        height: n || 24,
        children: /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.03647 4.4453C9.22193 4.1671 9.53416 4 9.86852 4H15.1315C15.4658 4 15.7781 4.1671 15.9635 4.4453L17.25 6.375L20 6.375C21.1046 6.375 22 7.27043 22 8.375V17.8333C22 18.9379 21.1046 19.8333 20 19.8333H5C3.89543 19.8333 3 18.9379 3 17.8333V8.375C3 7.27043 3.89543 6.375 5 6.375L7.75 6.375L9.03647 4.4453ZM16.0985 12.9963C16.0985 14.9837 14.4874 16.5947 12.5 16.5947C10.5126 16.5947 8.90148 14.9837 8.90148 12.9963C8.90148 11.0089 10.5126 9.39778 12.5 9.39778C14.4874 9.39778 16.0985 11.0089 16.0985 12.9963Z",
          fill: t
        })
      });
    case "microphone24":
      return /* @__PURE__ */ u(N, {
        viewBox: "0 0 24 24",
        width: r || 24,
        height: n || 24,
        children: /* @__PURE__ */ u("path", {
          d: "M7.5 12V6C7.5 4.80653 7.97411 3.66193 8.81802 2.81802C9.66193 1.97411 10.8065 1.5 12 1.5C13.1935 1.5 14.3381 1.97411 15.182 2.81802C16.0259 3.66193 16.5 4.80653 16.5 6V12C16.5 13.1935 16.0259 14.3381 15.182 15.182C14.3381 16.0259 13.1935 16.5 12 16.5C10.8065 16.5 9.66193 16.0259 8.81802 15.182C7.97411 14.3381 7.5 13.1935 7.5 12ZM19.5 12C19.5 11.8011 19.421 11.6103 19.2803 11.4697C19.1397 11.329 18.9489 11.25 18.75 11.25C18.5511 11.25 18.3603 11.329 18.2197 11.4697C18.079 11.6103 18 11.8011 18 12C18 13.5913 17.3679 15.1174 16.2426 16.2426C15.1174 17.3679 13.5913 18 12 18C10.4087 18 8.88258 17.3679 7.75736 16.2426C6.63214 15.1174 6 13.5913 6 12C6 11.8011 5.92098 11.6103 5.78033 11.4697C5.63968 11.329 5.44891 11.25 5.25 11.25C5.05109 11.25 4.86032 11.329 4.71967 11.4697C4.57902 11.6103 4.5 11.8011 4.5 12C4.50228 13.8586 5.19368 15.6504 6.44048 17.0288C7.68728 18.4072 9.40091 19.2743 11.25 19.4625V21.75C11.25 21.9489 11.329 22.1397 11.4697 22.2803C11.6103 22.421 11.8011 22.5 12 22.5C12.1989 22.5 12.3897 22.421 12.5303 22.2803C12.671 22.1397 12.75 21.9489 12.75 21.75V19.4625C14.5991 19.2743 16.3127 18.4072 17.5595 17.0288C18.8063 15.6504 19.4977 13.8586 19.5 12Z",
          fill: t
        })
      });
    case "text24":
      return /* @__PURE__ */ u(N, {
        viewBox: "0 0 24 24",
        width: r || 24,
        height: n || 24,
        children: /* @__PURE__ */ u("path", {
          d: "M19.875 5.25V8.25C19.875 8.54837 19.7565 8.83452 19.5455 9.0455C19.3345 9.25647 19.0484 9.375 18.75 9.375C18.4516 9.375 18.1655 9.25647 17.9545 9.0455C17.7435 8.83452 17.625 8.54837 17.625 8.25V6.375H13.125V17.625H15C15.2984 17.625 15.5845 17.7435 15.7955 17.9545C16.0065 18.1655 16.125 18.4516 16.125 18.75C16.125 19.0484 16.0065 19.3345 15.7955 19.5455C15.5845 19.7565 15.2984 19.875 15 19.875H9C8.70163 19.875 8.41548 19.7565 8.2045 19.5455C7.99353 19.3345 7.875 19.0484 7.875 18.75C7.875 18.4516 7.99353 18.1655 8.2045 17.9545C8.41548 17.7435 8.70163 17.625 9 17.625H10.875V6.375H6.375V8.25C6.375 8.54837 6.25647 8.83452 6.0455 9.0455C5.83452 9.25647 5.54837 9.375 5.25 9.375C4.95163 9.375 4.66548 9.25647 4.4545 9.0455C4.24353 8.83452 4.125 8.54837 4.125 8.25V5.25C4.125 4.95163 4.24353 4.66548 4.4545 4.4545C4.66548 4.24353 4.95163 4.125 5.25 4.125H18.75C19.0484 4.125 19.3345 4.24353 19.5455 4.4545C19.7565 4.66548 19.875 4.95163 19.875 5.25Z",
          fill: t
        })
      });
    case "1Click28":
      return /* @__PURE__ */ u(N, {
        width: r || 28,
        height: n || 28,
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M9.70323 4.4453C9.88869 4.1671 10.2009 4 10.5353 4H17.4649C17.7993 4 18.1115 4.1671 18.297 4.4453L20.0001 7H23.0001C24.6569 7 26.0001 8.34315 26.0001 10V21C26.0001 22.6569 24.6569 24 23.0001 24H5.00009C3.34324 24 2.00009 22.6569 2.00009 21V10C2.00009 8.34315 3.34324 7 5.00009 7H8.00009L9.70323 4.4453ZM18.5455 15.3637C18.5455 17.8741 16.5104 19.9092 14 19.9092C11.4896 19.9092 9.45456 17.8741 9.45456 15.3637C9.45456 12.8533 11.4896 10.8183 14 10.8183C16.5104 10.8183 18.5455 12.8533 18.5455 15.3637Z",
          fill: t
        })
      });
    case "chevronLeft28":
      return /* @__PURE__ */ u(N, {
        width: r || 28,
        height: n || 28,
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: /* @__PURE__ */ u("path", {
          d: "M17 6L9 14L17 22",
          stroke: t,
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })
      });
    case "doubleChevronLeft28":
      return /* @__PURE__ */ E(N, {
        width: r || 24,
        height: n || 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": "slid-ips-icon-language",
        ...i,
        children: [/* @__PURE__ */ u("path", {
          d: "M13.25 8L8 14L13.25 20",
          stroke: t,
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /* @__PURE__ */ u("path", {
          d: "M20 8L14.75 14L20 20",
          stroke: t,
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })]
      });
    case "doubleChevronRight28":
      return /* @__PURE__ */ E(N, {
        width: r || 24,
        height: n || 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": "slid-ips-icon-language",
        ...i,
        children: [/* @__PURE__ */ u("path", {
          d: "M14.75 8L20 14L14.75 20",
          stroke: t,
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /* @__PURE__ */ u("path", {
          d: "M8 8L13.25 14L8 20",
          stroke: t,
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })]
      });
    case "list28":
      return /* @__PURE__ */ E(N, {
        width: r || 28,
        height: n || 28,
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: [/* @__PURE__ */ u("path", {
          d: "M6 9C6.55228 9 7 8.55228 7 8C7 7.44772 6.55228 7 6 7C5.44772 7 5 7.44772 5 8C5 8.55228 5.44772 9 6 9Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          d: "M6 15C6.55228 15 7 14.5523 7 14C7 13.4477 6.55228 13 6 13C5.44772 13 5 13.4477 5 14C5 14.5523 5.44772 15 6 15Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          d: "M6 21C6.55228 21 7 20.5523 7 20C7 19.4477 6.55228 19 6 19C5.44772 19 5 19.4477 5 20C5 20.5523 5.44772 21 6 21Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          d: "M10 8H22",
          stroke: t,
          strokeWidth: "2",
          strokeLinecap: "round"
        }), /* @__PURE__ */ u("path", {
          d: "M10 14H22",
          stroke: t,
          strokeWidth: "2",
          strokeLinecap: "round"
        }), /* @__PURE__ */ u("path", {
          d: "M10 20H22",
          stroke: t,
          strokeWidth: "2",
          strokeLinecap: "round"
        })]
      });
    case "more28":
      return /* @__PURE__ */ E(N, {
        width: r || 28,
        height: n || 28,
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: [/* @__PURE__ */ u("path", {
          d: "M13.5 8.5C14.3284 8.5 15 7.82843 15 7C15 6.17157 14.3284 5.5 13.5 5.5C12.6716 5.5 12 6.17157 12 7C12 7.82843 12.6716 8.5 13.5 8.5Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          d: "M13.5 15C14.3284 15 15 14.3284 15 13.5C15 12.6716 14.3284 12 13.5 12C12.6716 12 12 12.6716 12 13.5C12 14.3284 12.6716 15 13.5 15Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          d: "M13.5 21.4167C14.3284 21.4167 15 20.7637 15 19.9583C15 19.1529 14.3284 18.5 13.5 18.5C12.6716 18.5 12 19.1529 12 19.9583C12 20.7637 12.6716 21.4167 13.5 21.4167Z",
          fill: t
        })]
      });
    case "recording28":
      return /* @__PURE__ */ u(N, {
        width: r || 28,
        height: n || 28,
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2 9C2 6.79086 3.79086 5 6 5H18C20.2091 5 22 6.79086 22 9V12L25.2929 8.70711C25.9229 8.07714 27 8.52331 27 9.41421V18.5858C27 19.4767 25.9229 19.9229 25.2929 19.2929L22 16V19C22 21.2091 20.2091 23 18 23H6C3.79086 23 2 21.2091 2 19V9ZM11.9999 9C11.4477 9 10.9999 9.44772 10.9999 10V13L7.99994 13C7.44766 13 6.99994 13.4477 6.99994 14C6.99994 14.5523 7.44766 15 7.99994 15H10.9999V18C10.9999 18.5523 11.4477 19 11.9999 19C12.5522 19 12.9999 18.5523 12.9999 18V15H15.9999C16.5522 15 16.9999 14.5523 16.9999 14C16.9999 13.4477 16.5522 13 15.9999 13H12.9999V10C12.9999 9.44772 12.5522 9 11.9999 9Z",
          fill: t
        })
      });
    case "snip28":
      return /* @__PURE__ */ u(N, {
        width: r || 28,
        height: n || 28,
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M5.00006 5V7H3.00006C2.44778 7 2.00006 7.44772 2.00006 8C2.00006 8.55228 2.44778 9 3.00006 9H5.00006V20C5.00006 20.5523 5.44778 21 6.00006 21H21.0001V23C21.0001 23.5523 21.4478 24 22.0001 24C22.5523 24 23.0001 23.5523 23.0001 23V21H25.0001C25.5523 21 26.0001 20.5523 26.0001 20C26.0001 19.4477 25.5523 19 25.0001 19H17.0001H7.00006V10.9167V5C7.00006 4.44771 6.55235 4 6.00006 4C5.44778 4 5.00006 4.44772 5.00006 5ZM23.0001 16.0003V8.00034C23.0001 7.44806 22.5523 7.00034 22.0001 7.00034L10.0001 7.00034C9.44778 7.00034 9.00006 7.44805 9.00006 8.00034C9.00006 8.55262 9.44778 9.00034 10.0001 9.00034H21.0001V16.0003C21.0001 16.5526 21.4478 17.0003 22.0001 17.0003C22.5523 17.0003 23.0001 16.5526 23.0001 16.0003Z",
          fill: t
        })
      });
    case "usingRecording28":
      return /* @__PURE__ */ E(N, {
        width: r || 28,
        height: n || 28,
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        color: t,
        ...i,
        children: [/* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14 23C18.9706 23 23 18.9706 23 14C23 9.02944 18.9706 5 14 5C9.02944 5 5 9.02944 5 14C5 18.9706 9.02944 23 14 23ZM14 25C20.0751 25 25 20.0751 25 14C25 7.92487 20.0751 3 14 3C7.92487 3 3 7.92487 3 14C3 20.0751 7.92487 25 14 25Z",
          fill: t
        }), /* @__PURE__ */ u("path", {
          d: "M20 14C20 17.3137 17.3137 20 14 20C10.6863 20 8 17.3137 8 14C8 10.6863 10.6863 8 14 8C17.3137 8 20 10.6863 20 14Z",
          fill: t
        })]
      });
    case "autoTypingDeactivated28":
      return /* @__PURE__ */ E(N, {
        width: r || 28,
        height: n || 28,
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [/* @__PURE__ */ u("path", {
          d: "M14 7.72727C14 6.22104 12.6569 5 11 5C9.34315 5 8 6.22104 8 7.72727V12.2727C8 13.779 9.34315 15 11 15C12.6569 15 14 13.779 14 12.2727V7.72727Z",
          stroke: t,
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /* @__PURE__ */ u("path", {
          d: "M4 12.2642C4 14.1181 4.7375 15.8962 6.05025 17.2071C7.363 18.5181 9.14348 19.2546 11 19.2546C12.0477 19.2546 13.0711 19.02 14 18.58",
          stroke: t,
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /* @__PURE__ */ u("path", {
          d: "M7.00003 23.249H15",
          stroke: t,
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /* @__PURE__ */ u("path", {
          d: "M11 19.2544V23.2489",
          stroke: t,
          strokeWidth: "1.5",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /* @__PURE__ */ u("path", {
          d: "M15.1111 15.8181C15.1111 15.4682 15.3765 15.123 15.7762 15.123H23.3348C23.7345 15.123 24 15.4682 24 15.8181V17.4818C24 17.8317 23.7345 18.1768 23.3348 18.1768C22.9351 18.1768 22.6697 17.8317 22.6697 17.4818V16.5131H20.2208V22.6097H21.0667C21.4664 22.6097 21.7319 22.9548 21.7319 23.3047C21.7319 23.6546 21.4664 23.9998 21.0667 23.9998H18.0433C17.6436 23.9998 17.3781 23.6546 17.3781 23.3047C17.3781 22.9548 17.6436 22.6097 18.0433 22.6097H18.8905V16.5131H16.4414V17.4818C16.4414 17.8317 16.176 18.1768 15.7762 18.1768C15.3765 18.1768 15.1111 17.8317 15.1111 17.4818V15.8181Z",
          fill: t
        })]
      });
    case "autoTyping28":
      return /* @__PURE__ */ E(N, {
        width: r || 28,
        height: n || 28,
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [/* @__PURE__ */ u("path", {
          d: "M14 7.72728C14 6.22105 12.6569 5.00001 11 5.00001C9.34315 5.00001 8 6.22105 8 7.72728V12.2727C8 13.779 9.34315 15 11 15C12.6569 15 14 13.779 14 12.2727V7.72728Z",
          fill: t,
          stroke: t,
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /* @__PURE__ */ u("path", {
          d: "M4 12.2643C4 14.1182 4.7375 15.8963 6.05025 17.2072C7.363 18.5182 9.14348 19.2547 11 19.2547C12.0477 19.2547 13.0711 19.0201 14 18.5801",
          stroke: t,
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /* @__PURE__ */ u("path", {
          d: "M7.00003 23.2491H15",
          stroke: t,
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /* @__PURE__ */ u("path", {
          d: "M11 19.2546V23.2491",
          stroke: t,
          strokeWidth: "1.75",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /* @__PURE__ */ u("path", {
          d: "M15.1111 15.8183C15.1111 15.4683 15.3765 15.1232 15.7762 15.1232H23.3348C23.7345 15.1232 24 15.4683 24 15.8183V17.4819C24 17.8319 23.7345 18.177 23.3348 18.177C22.9351 18.177 22.6697 17.8319 22.6697 17.4819V16.5133H20.2208V22.6099H21.0667C21.4664 22.6099 21.7319 22.955 21.7319 23.3049C21.7319 23.6548 21.4664 23.9999 21.0667 23.9999H18.0433C17.6436 23.9999 17.3781 23.6548 17.3781 23.3049C17.3781 22.955 17.6436 22.6099 18.0433 22.6099H18.8905V16.5133H16.4414V17.4819C16.4414 17.8319 16.176 18.177 15.7762 18.177C15.3765 18.177 15.1111 17.8319 15.1111 17.4819V15.8183Z",
          fill: a || (t === "var(--gray4)" ? "var(--purple7)" : "var(--gray9)")
        })]
      });
    case "autoTypingOngoing28":
      return /* @__PURE__ */ E(N, {
        width: r || 28,
        height: n || 28,
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [/* @__PURE__ */ E("g", {
          clipPath: "url(#clip0_280_5042)",
          children: [/* @__PURE__ */ u("path", {
            d: "M14 7.72727C14 6.22104 12.6569 5 11 5C9.34315 5 8 6.22104 8 7.72727V12.2727C8 13.779 9.34315 15 11 15C12.6569 15 14 13.779 14 12.2727V7.72727Z",
            fill: t,
            stroke: t,
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), /* @__PURE__ */ u("path", {
            d: "M4 12.2693C4 14.1233 4.7375 15.9013 6.05025 17.2122C7.363 18.5232 9.14348 19.2597 11 19.2597C12.0477 19.2597 13.0711 19.0251 14 18.5852",
            stroke: t,
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), /* @__PURE__ */ u("path", {
            d: "M7 23.2542H15",
            stroke: t,
            strokeWidth: "2",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          }), /* @__PURE__ */ u("path", {
            d: "M11 19.2596V23.2542",
            stroke: t,
            strokeWidth: "1.75",
            strokeLinecap: "round",
            strokeLinejoin: "round"
          })]
        }), /* @__PURE__ */ u("path", {
          d: "M24.5 18.5C24.5 21.5376 22.0376 24 19 24C15.9624 24 13.5 21.5376 13.5 18.5C13.5 15.4624 15.9624 13 19 13C22.0376 13 24.5 15.4624 24.5 18.5Z",
          fill: "transparent"
        }), /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M19 23C21.4853 23 23.5 20.9853 23.5 18.5C23.5 16.0147 21.4853 14 19 14C16.5147 14 14.5 16.0147 14.5 18.5C14.5 20.9853 16.5147 23 19 23ZM19 24C22.0376 24 24.5 21.5376 24.5 18.5C24.5 15.4624 22.0376 13 19 13C15.9624 13 13.5 15.4624 13.5 18.5C13.5 21.5376 15.9624 24 19 24Z",
          fill: t === "var(--gray4)" ? "var(--red7)" : "var(--gray9)",
          stroke: t === "var(--gray4)" ? "var(--red7)" : "var(--gray9)",
          strokeWidth: "0.5"
        }), /* @__PURE__ */ u("path", {
          d: "M21.75 18.5C21.75 20.0188 20.5188 21.25 19 21.25C17.4812 21.25 16.25 20.0188 16.25 18.5C16.25 16.9812 17.4812 15.75 19 15.75C20.5188 15.75 21.75 16.9812 21.75 18.5Z",
          fill: t === "var(--gray4)" ? "var(--red7)" : "var(--gray9)"
        })]
      });
    case "setting28":
      return /* @__PURE__ */ E(N, {
        width: r || 28,
        height: n || 28,
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [/* @__PURE__ */ u("path", {
          d: "M17 14C17 15.6569 15.6569 17 14 17C12.3431 17 11 15.6569 11 14C11 12.3431 12.3431 11 14 11C15.6569 11 17 12.3431 17 14Z",
          stroke: t,
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        }), /* @__PURE__ */ u("path", {
          d: "M20.0028 9.70434C20.2111 10.0174 20.3934 10.3485 20.5477 10.6942L22.788 12.002C23.0677 13.3175 23.0707 14.6812 22.7966 15.998L20.5477 17.3058C20.3934 17.6515 20.2111 17.9826 20.0028 18.2957L20.0461 20.9929C19.0966 21.9013 17.973 22.5857 16.7506 23L14.5449 21.6105C14.1821 21.6377 13.8179 21.6377 13.4551 21.6105L11.2581 22.9909C10.0318 22.5841 8.90443 21.9024 7.95393 20.9929L7.99718 18.3047C7.79069 17.9874 7.60848 17.6533 7.45225 17.3058L5.21201 15.998C4.93228 14.6825 4.92933 13.3188 5.20336 12.002L7.45225 10.6942C7.60663 10.3485 7.78894 10.0174 7.99718 9.70434L7.95393 7.00706C8.90335 6.09868 10.0271 5.41431 11.2494 5L13.4551 6.38951C13.8179 6.36226 14.1821 6.36226 14.5449 6.38951L16.7419 5.00908C17.9682 5.41585 19.0956 6.09758 20.0461 7.00706L20.0028 9.70434Z",
          stroke: t,
          strokeWidth: "2",
          strokeLinecap: "round",
          strokeLinejoin: "round"
        })]
      });
    case "stopRecording28":
      return /* @__PURE__ */ u(N, {
        width: r || 28,
        height: n || 28,
        viewBox: "0 0 28 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /* @__PURE__ */ u("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M14.4858 25C20.6477 25 25.6429 20.0751 25.6429 14C25.6429 7.92487 20.6477 3 14.4858 3C8.32384 3 3.32861 7.92487 3.32861 14C3.32861 20.0751 8.32384 25 14.4858 25ZM18.5429 10H10.4286V18H18.5429V10Z",
          fill: t
        })
      });
  }
}, $t = ({
  icon: e,
  color: t,
  height: r,
  width: n,
  ...a
}) => /* @__PURE__ */ u(He, {
  children: up({
    icon: e,
    color: t,
    width: n,
    height: r,
    ...a
  })
}), N = D.svg`
  display: flex;
  align-items: center;
  justify-content: center;
`, lp = ({
  title: e,
  primaryButton: t,
  secondaryButton: r,
  options: n,
  device: a = "desktop",
  currentOption: i
}) => {
  const [o, s] = $e(i || void 0), l = () => n == null ? void 0 : n.map((c) => /* @__PURE__ */ E(dp, {
    onClick: (p) => {
      c.disabled || (p.stopPropagation(), s(c));
    },
    isDisabled: c.disabled,
    children: [/* @__PURE__ */ u(cp, {
      weight: (o == null ? void 0 : o.id) === (c == null ? void 0 : c.id) ? 700 : 400,
      color: c.disabled && (o == null ? void 0 : o.id) !== (c == null ? void 0 : c.id) || !o && c.disabled ? "--gray6" : "--gray17",
      text: c.text
    }), (o == null ? void 0 : o.id) === (c == null ? void 0 : c.id) && /* @__PURE__ */ u($t, {
      icon: "thickCheck16",
      color: "--gray15"
    })]
  }, c.id));
  return /* @__PURE__ */ E(He, {
    children: [a === "desktop" && /* @__PURE__ */ E(u1, {
      children: [/* @__PURE__ */ u(l1, {
        color: "--gray17",
        weight: 700,
        text: e,
        textAlign: "left"
      }), /* @__PURE__ */ u(c1, {
        children: /* @__PURE__ */ u(d1, {
          children: l()
        })
      }), /* @__PURE__ */ E(f1, {
        children: [r && /* @__PURE__ */ u(ze, {
          appearance: "secondary",
          size: "medium",
          text: r.text,
          callback: r.callBack,
          tabIndex: -1
        }), /* @__PURE__ */ u(ze, {
          appearance: "primary",
          size: "medium",
          text: t.text,
          callback: () => {
            o && t.callBack(o);
          },
          isDisabled: (o == null ? void 0 : o.id) === (i == null ? void 0 : i.id) || o === void 0,
          tabIndex: 0
        })]
      })]
    }), a === "mobile" && /* @__PURE__ */ E(u1, {
      children: [/* @__PURE__ */ u(l1, {
        color: "--gray17",
        weight: 700,
        text: e,
        textAlign: "left"
      }), /* @__PURE__ */ u(c1, {
        children: /* @__PURE__ */ u(d1, {
          children: l()
        })
      }), /* @__PURE__ */ E(f1, {
        children: [r && /* @__PURE__ */ u(ze, {
          appearance: "secondary",
          size: "medium",
          text: r.text,
          callback: r.callBack
        }), /* @__PURE__ */ u(ze, {
          appearance: "primary",
          size: "medium",
          text: t.text,
          callback: () => {
            o && t.callBack(o);
          },
          isDisabled: o === void 0 || o.id === (i == null ? void 0 : i.id)
        })]
      })]
    })]
  });
}, u1 = D(Tt)`
  align-items: center;
  padding: 24px;
  width: 100%;
`, l1 = D(vr)`
  width: 100%;
`, cp = D(Ze)`
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`, c1 = D.div`
  width: 100%;
  height: 100%;
  margin-top: 16px;
  border: 2px solid var(--blue8);
  border-radius: 8px;
  padding: 8px 0px;
  overflow: hidden;
`, d1 = D.div`
  max-height: 217px;
  overflow-y: auto;
  ::-webkit-scrollbar {
    width: 4px;
  }
  ::-webkit-scrollbar-thumb {
    height: 30%;
    background: var(--gray5);
    border-radius: 24px;
  }
  ::-webkit-scrollbar-track {
    background: var(--gray0);
  }
`, dp = D.div`
  cursor: ${({
  isDisabled: e
}) => e ? "not-allowed" : "pointer"};
  padding: 4px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 4px;
  &:hover {
    background-color: var(--gray4);
  }
  &:active {
    background-color: var(--gray3);
  }
`, f1 = D.div`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 32px;
  width: 100%;
`, fp = ({
  customComponent: e
}) => /* @__PURE__ */ u(pp, {
  children: e
}), pp = D(Tt)`
  z-index: 99999;
  box-sizing: border-box;
`, fv = ({
  ...e
}) => {
  const {
    modalOn: t,
    closeModal: r,
    modalProps: n
  } = ep(), [a, i] = $e(), o = Qe();
  _e(() => {
    if (t) {
      const l = o.current;
      l && i(l.clientHeight);
    }
  }, [t]);
  const s = () => {
    switch (n.type) {
      case Dt.modal:
        return /* @__PURE__ */ u(I5, {
          ...n
        });
      case Dt.emojiModal:
        return /* @__PURE__ */ u(Z5, {
          ...n
        });
      case Dt.imageModal:
        return /* @__PURE__ */ u(z5, {
          ...n
        });
      case Dt.videoModal:
        return /* @__PURE__ */ u(tp, {
          ...n
        });
      case Dt.optionModal:
        return /* @__PURE__ */ u(lp, {
          ...n
        });
      default:
        return;
    }
  };
  return /* @__PURE__ */ u(zn, {
    children: t && /* @__PURE__ */ E(He, {
      children: [/* @__PURE__ */ u(Ei, {
        closableDim: n.closableDim,
        callBack: () => n.onDimClick ? n.onDimClick() : r(),
        type: n.device === "mobile" ? "mobile" : "gray9"
      }), /* @__PURE__ */ u(vp, {
        children: n.type === Dt.customModal ? /* @__PURE__ */ u(fp, {
          ...n,
          ...e
        }) : /* @__PURE__ */ u(mp, {
          ref: o,
          modalType: n.type,
          deviceType: n.device ? n.device : "desktop",
          variants: hp,
          initial: "initial",
          animate: "animate",
          exit: "exit",
          "data-testid": "modal-container",
          modalHeight: a,
          ...e,
          children: s()
        })
      })]
    })
  });
}, vp = D.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 99999;
`, mp = D(at.div)`
  box-sizing: border-box;
  max-height: 90vh;
  width: ${({
  deviceType: e
}) => e === "mobile" ? "316px" : "472px"};
  background-color: var(--gray1);
  box-shadow: var(--boxShadow3);
  border-radius: 8px;

  .keep__all {
    word-break: keep-all;
    width: 100%;
  }
`, hp = {
  initial: {
    opacity: 0,
    scale: 0.93,
    y: 30
  },
  animate: {
    opacity: 1,
    scale: 1,
    y: 0,
    transition: {
      duration: 0.25
    }
  },
  exit: {
    opacity: 0,
    scale: 1,
    y: 4,
    transition: {
      duration: 0.3
    }
  }
}, Yu = ({
  infoText: e,
  linkText: t,
  additionalText: r,
  href: n,
  newTab: a,
  marginTop: i,
  onClick: o,
  isMobile: s,
  ...l
}) => /* @__PURE__ */ E(gp, {
  marginTop: i,
  "data-testid": "ips-link-wrapper",
  ...l,
  children: [s ? /* @__PURE__ */ u(qe, {
    text: e,
    color: "--gray9"
  }) : /* @__PURE__ */ u(Ze, {
    weight: 400,
    text: e,
    color: "--gray9"
  }), /* @__PURE__ */ E(yp, {
    "data-testid": "ips-link",
    href: n,
    target: a ? "_blank" : "_self",
    onClick: o ? (d) => (n === "#" && d.preventDefault(), o(d), !1) : void 0,
    infoText: e,
    additionalText: r,
    children: [s ? /* @__PURE__ */ u(qe, {
      weight: 700,
      text: t,
      color: "--blue8"
    }) : /* @__PURE__ */ u(Ze, {
      weight: 700,
      text: t,
      color: "--blue8"
    }), /* @__PURE__ */ u(Cp, {})]
  }), s ? /* @__PURE__ */ u(qe, {
    weight: 400,
    text: r,
    color: "--gray9"
  }) : /* @__PURE__ */ u(Ze, {
    weight: 400,
    text: r,
    color: "--gray9"
  })]
}), gp = D.div`
  display: flex;
  margin-top: ${({
  marginTop: e
}) => e};
  flex-wrap: wrap;
`, yp = D.a`
  margin-left: ${({
  infoText: e
}) => e ? "4px" : null};
  margin-right: ${({
  additionalText: e
}) => e ? "4px" : null};
  text-decoration: none;
  cursor: pointer;
  -webkit-tap-highlight-color: transparent;

  :link,
  :visited {
    color: transparent;
  }

  p {
    margin-bottom: -0.3rem;
  }

  @media (hover: hover) {
    :hover {
      p {
        color: var(--blue9);
        transition: color 0.2s ease-in-out;
      }
      span {
        background-color: var(--blue9);
        transition: background-color 0.2s ease-in-out;
      }
    }
  }

  :active {
    p {
      color: var(--blue7);
      transition: color 0.2s ease-in-out;
    }
    span {
      background-color: var(--blue7);
      transition: background-color 0.2s ease-in-out;
    }
  }
`, Cp = D.span`
  display: inherit;
  height: 2px;
  width: 100%;
  background-color: var(--blue8);
  margin: 0;
`, pv = ({
  labelText: e,
  placeHolderText: t,
  invalidStatementText: r,
  validStatementText: n,
  emptyStatementText: a,
  trailingButtonType: i,
  type: o,
  onChange: s,
  maxLength: l,
  marginTop: d,
  className: c,
  locale: p,
  inputValidationfunc: v,
  inputValue: m,
  ...h
}) => {
  const [C, y] = $e(!1), [x, T] = $e(!1), [M, f] = $e(!1), [b, w] = $e(!1), [V, S] = $e({
    borderColor: "var(--gray5)"
  }), [k, I] = $e(!1);
  _e(() => {
    x || b ? S({
      borderColor: "var(--red7)"
    }) : M ? S({
      borderColor: "var(--green1)"
    }) : k ? k && S({
      borderColor: "var(--gray13)"
    }) : S({
      borderColor: "var(--gray5)"
    });
  }, [x, M, k, b]), _e(() => {
    v && n ? (T(!1), w(!1), f(!0)) : !v && n && (T(!1), w(!1), f(!1));
  }, [v, n]);
  const $ = () => {
    y(!C);
  };
  return /* @__PURE__ */ E(bp, {
    marginTop: d || "48px",
    "data-testid": "slid-ips-textField",
    ...h,
    children: [e && /* @__PURE__ */ u(xp, {
      text: e,
      weight: 400,
      color: "--gray13"
    }), /* @__PURE__ */ E(wp, {
      children: [/* @__PURE__ */ u(Lp, {
        trailingButtonType: i,
        placeholder: t,
        type: o === "password" && !C ? "password" : "text",
        onChange: s,
        onFocus: () => I(!0),
        maxLength: l,
        style: V,
        onBlur: () => {
          m !== "" && !v && r && (f(!1), w(!1), T(!0)), m === "" && a && (f(!1), T(!1), w(!0)), I(!1);
        }
      }), o === "password" && i === "password" && /* @__PURE__ */ u(Tp, {
        onClick: () => {
          $();
        },
        children: /* @__PURE__ */ u(Mp, {
          text: C ? p === "ko" ? "\uC228\uAE30\uAE30" : "hide" : p === "ko" ? "\uBCF4\uAE30" : "show",
          weight: 400,
          color: "--gray13"
        })
      })]
    }), r && x && /* @__PURE__ */ u(fa, {
      text: r,
      weight: 700,
      color: "--red7"
    }), a && b && /* @__PURE__ */ u(fa, {
      text: a,
      weight: 700,
      color: "--red7"
    }), n && M && /* @__PURE__ */ u(fa, {
      text: n,
      weight: 700,
      color: "--green1"
    })]
  });
}, bp = D.div`
  margin-top: ${({
  marginTop: e
}) => e};
  width: 100%;
`, xp = D(qe)`
  padding-left: 4px !important;
  margin-bottom: 12px !important;
`, wp = D.div`
  position: relative;
`, Lp = D.input`
  width: 100%;
  height: 58px;

  /* lightTheme/grayscale/gray7 */
  padding-left: 23px;
  padding-right: ${(e) => e.trailingButtonType ? "55px" : "23px"};
  border: 1px solid var(--gray5);
  box-sizing: border-box;
  background-color: var(--gray1);
  border-radius: 8px;

  /* Body1_400 */
  font-size: 17px;
  line-height: 26px;

  caret-color: var(--gray15);

  ::placeholder {
    color: var(--gray7);
    font-family: Inter;
  }

  :focus {
    outline: none !important;
    border-color: var(--gray13);
  }
`, fa = D(qe)`
  margin-top: 6px !important;
  margin-left: 4px !important;
  float: left;
`, Tp = D.div`
  position: absolute;
  top: 6px;
  right: 7px;
  width: 53px;
  height: 46px;
  display: flex;
  justify-content: end;
  align-items: center;
  cursor: pointer;
  padding-right: 10px;
`, Mp = D(qe)`
  margin: 0;
`;
var ut = /* @__PURE__ */ ((e) => (e.Regular = "regular", e.Large = "large", e))(ut || {}), Fa = /* @__PURE__ */ ((e) => (e.more = "more", e.toggle = "toggle", e))(Fa || {});
const Ap = ({
  icon: e,
  size: t = ut.Regular,
  color: r,
  isMenuActive: n = !1,
  isDropDownMenu: a = !1,
  menuValue: i,
  ...o
}) => /* @__PURE__ */ E(Rp, {
  "data-testid": "dropdown-menu-button",
  color: r,
  ...o,
  children: [e && /* @__PURE__ */ u(Sp, {
    children: e
  }), t === ut.Large ? /* @__PURE__ */ u(Pp, {
    text: i,
    color: r,
    weight: 700,
    "data-testid": "dropdown-value"
  }) : /* @__PURE__ */ u(Ep, {
    text: i,
    color: r,
    weight: 700,
    "data-testid": "dropdown-value"
  }), a && /* @__PURE__ */ u(kp, {
    variants: Op,
    animate: n ? "open" : "closed",
    transition: {
      duration: 0.3
    },
    children: t === ut.Large ? /* @__PURE__ */ u($t, {
      icon: "chevronDown24",
      color: r
    }) : /* @__PURE__ */ u($t, {
      icon: "chevronDown16",
      color: r
    })
  })]
}), Rp = D.button`
  /* s of reset button */
  background: inherit;
  border: none;
  box-shadow: none;
  -webkit-tap-highlight-color: transparent;
  box-sizing: border-box;
  outline-style: none;

  &:focus {
    outline: 0;
    border: none;
  }
  /* e of reset button  */

  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 8px 4px 8px 8px;
  border-radius: 8px;
  max-width: fit-content;
  cursor: pointer;

  &:hover {
    background-color: var(
      ${({
  color: e
}) => e === "--gray3" ? "--gray15" : "--gray3"}
    );
  }

  &:active {
    background-color: var(
      ${({
  color: e
}) => e === "--gray3" ? "--gray13" : "--gray2"}
    );
  }
`, Sp = D.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  margin-right: 4px;
`, Pp = D(Ze)`
  text-align: center;
  white-space: nowrap;
`, Ep = D(qe)`
  text-align: center;
  white-space: nowrap;
`, kp = D(at.div)`
  width: 24px;
  height: 24px;

  display: flex;
  justify-content: center;
  align-items: center;
`, Op = {
  closed: {
    rotate: 0
  },
  open: {
    rotate: 180
  }
}, vv = ({
  icon: e,
  itemList: t,
  color: r,
  menuValue: n,
  ...a
}) => {
  const [i, o] = $e(!1);
  return /* @__PURE__ */ E(_p, {
    onBlur: () => {
      o(!1);
    },
    "data-testid": "slid-ips-menu",
    ...a,
    children: [/* @__PURE__ */ u(Ap, {
      color: r,
      icon: e,
      menuValue: n,
      isMenuActive: i,
      size: ut.Large,
      onClick: () => {
        o(!i);
      },
      isDropDownMenu: !0
    }), /* @__PURE__ */ u(zn, {
      children: i && /* @__PURE__ */ u(Vp, {
        "data-testid": "dropdown-box",
        variants: Dp,
        initial: "initial",
        animate: "animate",
        exit: "initial",
        children: t.map((s, l) => /* @__PURE__ */ u(Hp, {
          onClick: () => {
            s.callback && s.callback();
          },
          variants: jp,
          initial: "initial",
          animate: "animate",
          exit: "initial",
          children: /* @__PURE__ */ u(Ze, {
            text: s.text,
            color: "--gray15",
            weight: n === s.text ? 700 : 400
          })
        }, l))
      })
    })]
  });
}, _p = D.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  position: relative;
  user-select: none;
`, Vp = D(at.ul)`
  /* S of reset ul */
  list-style: none;
  padding: 0;
  margin: 0;
  /* E of reset ul */

  position: absolute;
  top: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 8px 0;
  margin-left: 8px;
  min-width: 160px;
  background: var(--white);
  box-shadow: 0px 8px 24px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  margin-top: 8px;
`, Hp = D(at.li)`
  list-style: none;
  padding: 8px 16px;
  width: 100%;
  cursor: pointer;

  &:hover {
    background-color: var(--gray3);
  }

  &:active {
    background-color: var(--gray2);
  }
`, Dp = {
  initial: {
    height: 0,
    transition: {
      duration: 0.2,
      ease: "easeInOut"
    }
  },
  animate: {
    height: "auto",
    transition: {
      duration: 0.15,
      ease: [0.43, 0.13, 0.23, 0.96]
    }
  }
}, jp = {
  initial: {
    opacity: 0,
    y: 2,
    transition: {
      duration: 0.1
    }
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      delay: 0.15,
      duration: 0.1,
      ease: "easeInOut"
    }
  }
}, mv = ({
  size: e = ut.Regular,
  text: t,
  showCheck: r,
  isSelected: n,
  ...a
}) => /* @__PURE__ */ E(Ip, {
  size: e,
  variants: Np,
  initial: "initial",
  animate: "animate",
  exit: "initial",
  ...a,
  children: [e === ut.Large ? /* @__PURE__ */ u(Ze, {
    weight: n ? 700 : 400,
    color: "--gray15",
    text: t
  }) : /* @__PURE__ */ u(qe, {
    weight: n ? 700 : 400,
    color: "--gray15",
    text: t
  }), r && n && /* @__PURE__ */ u($t, {
    icon: "check24",
    width: 16,
    height: 16,
    color: "--gray15"
  })]
}), Ip = D(at.li)`
  display: flex;
  justify-content: space-between;
  align-items: center;

  /* width: 100%; */
  height: ${({
  size: e
}) => e === ut.Large ? "39px" : "26px"};
  padding: ${({
  size: e
}) => e === ut.Large ? "0px 16px" : "0px 12px"};

  cursor: pointer;

  :hover {
    background-color: var(--gray3);
  }
  :active {
    background-color: var(--gray2);
  }
`, Np = {
  initial: {
    opacity: 0,
    y: 2,
    transition: {
      duration: 0.1
    }
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      delay: 0.15,
      duration: 0.1,
      ease: "easeInOut"
    }
  }
}, Jr = ({
  type: e,
  text: t,
  color: r,
  weight: n,
  marginTop: a,
  opacity: i,
  textAlign: o,
  className: s,
  variants: l,
  initial: d,
  animate: c,
  ...p
}) => /* @__PURE__ */ u(We, {
  type: e != null ? e : "p",
  text: t,
  color: r,
  weight: n != null ? n : 400,
  textSize: {
    desktop: "1.1rem",
    mobile: "1.1rem"
  },
  lineHeight: {
    desktop: "1.6rem",
    mobile: "1.6rem"
  },
  letterSpacing: {
    desktop: "0rem",
    mobile: "0rem"
  },
  marginTop: a,
  opacity: i,
  textAlign: o,
  className: s,
  variants: l,
  initial: d,
  animate: c,
  ...p
}), hv = ({
  size: e = ut.Regular,
  title: t,
  isSelected: r,
  children: n,
  ...a
}) => /* @__PURE__ */ u(zn, {
  children: r && /* @__PURE__ */ E(Bp, {
    size: e,
    variants: Zp,
    initial: "initial",
    animate: "animate",
    exit: "initial",
    ...a,
    children: [t && /* @__PURE__ */ u($p, {
      children: /* @__PURE__ */ u(Jr, {
        weight: 400,
        color: "--gray9",
        text: t
      })
    }), n]
  })
}), Bp = D(at.ul)`
  position: absolute;
  min-width: ${({
  size: e
}) => e === ut.Large ? "160px" : "140px"};
  /* height: auto; */
  padding: 8px 0px;

  background-color: #fff;
  box-shadow: var(--boxShadow2);
  border-radius: 8px;
  z-index: 4;
`, $p = D.div`
  width: 100%;
  height: 20px;
  padding-left: 12px;
`, Zp = {
  initial: {
    height: 0,
    transition: {
      duration: 0.2,
      ease: "easeInOut"
    }
  },
  animate: {
    height: "auto",
    transition: {
      duration: 0.15,
      ease: [0.43, 0.13, 0.23, 0.96]
    }
  }
}, gv = ({
  appearance: e,
  icon: t,
  description: r,
  addOption: n,
  text: a,
  toggleOn: i,
  ...o
}) => /* @__PURE__ */ u(He, {
  children: e === "line" ? /* @__PURE__ */ u(Fp, {
    ...o
  }) : /* @__PURE__ */ E(Wp, {
    ...o,
    children: [/* @__PURE__ */ E(Up, {
      children: [t, /* @__PURE__ */ E(zp, {
        hasIcon: t,
        children: [a && /* @__PURE__ */ u(qe, {
          weight: 400,
          color: "--gray15",
          text: a
        }), r && /* @__PURE__ */ u(Jr, {
          weight: 400,
          color: "--gray9",
          text: r
        })]
      })]
    }), n && (() => {
      switch (n) {
        case Fa.more:
          return /* @__PURE__ */ u($t, {
            icon: "chevronRight16",
            width: 20,
            color: "--gray9"
          });
        case Fa.toggle:
          return /* @__PURE__ */ u(x5, {
            toggleOn: i
          });
        default:
          return;
      }
    })()]
  })
}), Fp = D.div`
  width: 235px;
  border-top: 1px solid var(--gray3);
  margin: 4px 0px;
`, Wp = D.div`
  width: 235px;
  display: flex;
  justify-content: space-between;
  padding: 8px 16px;
  cursor: pointer;

  :hover {
    background-color: var(--gray3);
  }
  :active {
    background-color: var(--gray2);
  }
`, Up = D.div`
  display: flex;
`, zp = D.div`
  margin-left: ${({
  hasIcon: e
}) => e && "4px"};
`, yv = ({
  title: e,
  children: t,
  ...r
}) => /* @__PURE__ */ E(Yp, {
  ...r,
  children: [e && /* @__PURE__ */ u(qp, {
    children: /* @__PURE__ */ u(Jr, {
      weight: 400,
      color: "--gray9",
      text: e
    })
  }), t]
}), Yp = D.div`
  width: auto;
  height: auto;
  background-color: #fff;
  border-radius: 8px;
  padding: 8px 0px;
`, qp = D.div`
  width: 100%;
  height: 32px;
  padding: 8px 16px;
`, Kp = ({
  idx: e,
  title: t,
  content: r,
  isMobile: n
}) => {
  const [a, i] = $e(!1);
  return /* @__PURE__ */ E(Xp, {
    onClick: () => {
      i(!a);
    },
    "data-testid": "list-item-wapper",
    marginTop: e !== 0 ? "24px" : void 0,
    isMobile: n,
    children: [/* @__PURE__ */ E(Gp, {
      children: [n ? /* @__PURE__ */ u(qe, {
        text: t,
        color: "--gray15",
        weight: 700
      }) : /* @__PURE__ */ u(vr, {
        text: t,
        color: "--gray15",
        weight: 700
      }), /* @__PURE__ */ u(Qp, {
        variants: e7,
        animate: a ? "animate" : "initial",
        transition: {
          ease: "easeInOut",
          duriation: 0.2
        },
        children: /* @__PURE__ */ u($t, {
          icon: "plus24",
          color: "--gray15",
          width: n ? 20 : 24
        })
      })]
    }), a && /* @__PURE__ */ u(Jp, {
      children: n ? /* @__PURE__ */ u(Jr, {
        text: r,
        color: "--gray13",
        marginTop: "24px",
        variants: p1,
        initial: "initial",
        animate: "animate"
      }) : /* @__PURE__ */ u(et, {
        text: r,
        color: "--gray13",
        marginTop: "24px",
        variants: p1,
        initial: "initial",
        animate: "animate"
      })
    })]
  });
}, Xp = D.li`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 36px;
  margin-top: ${({
  marginTop: e
}) => e};
  width: 100%;
  cursor: pointer;
  border: 2px solid var(--gray13);
  box-sizing: border-box;
  border-radius: 8px;
  height: fit-content;

  ${({
  isMobile: e
}) => e && Hu`
      padding: 20px 24px;
    `}

  &:hover {
    background: var(--gray3);
    transition: background-color 0.2s ease-in-out;
  }
`, Gp = D.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
`, Jp = D.div`
  width: 100%;
`, Qp = D(at.div)`
  width: 24px;
  height: 24px;
  margin-left: 36px;
`, p1 = {
  initial: {
    opacity: 0,
    y: -2
  },
  animate: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.25,
      ease: "easeInOut"
    }
  }
}, e7 = {
  initial: {
    rotate: 0
  },
  animate: {
    rotate: 315
  }
}, Cv = ({
  type: e,
  listItems: t,
  marginTop: r,
  isMobile: n = !1,
  ...a
}) => {
  const i = (s, l) => {
    switch (e) {
      case "FAQ":
        return /* @__PURE__ */ u(Kp, {
          idx: l,
          title: s.title,
          content: s.content,
          isMobile: n
        }, `${s.title}${l}`);
      default:
        throw new Error("Please check the type!");
    }
  }, o = t.map((s, l) => i(s, l));
  return /* @__PURE__ */ u(t7, {
    marginTop: r,
    "data-testid": "slid-ips-ul",
    ...a,
    children: o
  });
}, t7 = D.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  margin-top: ${({
  marginTop: e
}) => e};
  width: 100%;
`, Ei = ({
  closableDim: e,
  callBack: t,
  type: r
}) => /* @__PURE__ */ u(r7, {
  closableDim: e,
  onClick: () => {
    e && t && t();
  },
  variants: n7,
  initial: "initial",
  animate: r === "mobile" ? "mobileAnimate" : r === "gray4" ? "whiteAnimate" : "animate",
  exit: "exit",
  "data-testid": "modal-dim",
  type: r
});
Ei.defaultProps = {
  closableDim: !0
};
const r7 = D(at.div)`
  z-index: 9998;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${({
  type: e
}) => e === "gray4" ? "var(--gray5)" : "var(--gray17)"};
  cursor: ${({
  closableDim: e
}) => e === !1 ? "not-allowed" : "default"};
`, n7 = {
  initial: {
    opacity: 0
  },
  animate: {
    opacity: 0.5,
    transition: {
      duration: 0.25,
      ease: "easeInOut"
    }
  },
  whiteAnimate: {
    opacity: 0.5,
    transition: {
      duration: 0.25,
      ease: "easeInOut"
    }
  },
  mobileAnimate: {
    opacity: 0.7,
    transition: {
      duration: 0.25,
      ease: "easeInOut"
    }
  },
  exit: {
    opacity: 0,
    transition: {
      duration: 0.3,
      ease: "easeInOut"
    }
  }
};
var qu = /* @__PURE__ */ ((e) => (e.basic = "Basic", e.link = "Link", e))(qu || {});
const v1 = (e) => (t) => {
  t({
    type: Wu,
    payload: e
  });
}, a7 = (e) => (t) => {
  t({
    type: Uu,
    payload: e
  });
}, i7 = () => {
  const e = Qa(), { alertOn: t, alertProps: r } = ei(
    (i) => i.alert
  );
  _e(() => (t && (document.body.style.cssText = "overflow: hidden; touch-action: none; -ms-touch-action: none;"), () => {
    document.body.style.cssText = "", t && a();
  }), [t]);
  const n = (i) => {
    e(a7(i)), e(v1(!0));
  }, a = () => {
    e(v1(!1));
  };
  return {
    alertOn: t,
    showAlert: n,
    closeAlert: a,
    alertProps: r
  };
}, bv = ({
  ...e
}) => {
  const {
    alertOn: t,
    alertProps: r,
    closeAlert: n
  } = i7();
  return /* @__PURE__ */ u(He, {
    children: t && /* @__PURE__ */ E(He, {
      children: [/* @__PURE__ */ u(Ei, {
        closableDim: !1,
        type: "gray4"
      }), /* @__PURE__ */ u(o7, {
        children: /* @__PURE__ */ E(s7, {
          "data-testid": "ips-alert-container",
          ...e,
          children: [/* @__PURE__ */ E(u7, {
            children: [/* @__PURE__ */ u(et, {
              weight: 700,
              text: r.text,
              color: "--gray17"
            }), /* @__PURE__ */ u($t, {
              icon: "x24",
              color: "--gray7",
              onClick: () => n(),
              style: {
                cursor: "pointer",
                marginLeft: "8px"
              }
            })]
          }), r.type === qu.link ? /* @__PURE__ */ u(Yu, {
            ...r.link
          }) : null]
        })
      })]
    })
  });
}, o7 = D.div`
  display: flex;
  justify-content: center;
`, s7 = D.div`
  z-index: 9999;

  position: fixed;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-sizing: border-box;

  min-width: 400px;
  min-height: 58px;
  top: 6.67%;
  padding: 16px 24px;

  box-shadow: var(--boxShadow3);
  border-radius: 8px;
  background: var(--gray1);
`, u7 = D.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;
var Ke = "top", it = "bottom", ot = "right", Xe = "left", qn = "auto", Qr = [Ke, it, ot, Xe], ur = "start", Br = "end", l7 = "clippingParents", Ku = "viewport", br = "popper", c7 = "reference", m1 = /* @__PURE__ */ Qr.reduce(function(e, t) {
  return e.concat([t + "-" + ur, t + "-" + Br]);
}, []), Xu = /* @__PURE__ */ [].concat(Qr, [qn]).reduce(function(e, t) {
  return e.concat([t, t + "-" + ur, t + "-" + Br]);
}, []), d7 = "beforeRead", f7 = "read", p7 = "afterRead", v7 = "beforeMain", m7 = "main", h7 = "afterMain", g7 = "beforeWrite", y7 = "write", C7 = "afterWrite", Wa = [d7, f7, p7, v7, m7, h7, g7, y7, C7];
function gt(e) {
  return e ? (e.nodeName || "").toLowerCase() : null;
}
function rt(e) {
  if (e == null)
    return window;
  if (e.toString() !== "[object Window]") {
    var t = e.ownerDocument;
    return t && t.defaultView || window;
  }
  return e;
}
function Zt(e) {
  var t = rt(e).Element;
  return e instanceof t || e instanceof Element;
}
function tt(e) {
  var t = rt(e).HTMLElement;
  return e instanceof t || e instanceof HTMLElement;
}
function ki(e) {
  if (typeof ShadowRoot > "u")
    return !1;
  var t = rt(e).ShadowRoot;
  return e instanceof t || e instanceof ShadowRoot;
}
function b7(e) {
  var t = e.state;
  Object.keys(t.elements).forEach(function(r) {
    var n = t.styles[r] || {}, a = t.attributes[r] || {}, i = t.elements[r];
    !tt(i) || !gt(i) || (Object.assign(i.style, n), Object.keys(a).forEach(function(o) {
      var s = a[o];
      s === !1 ? i.removeAttribute(o) : i.setAttribute(o, s === !0 ? "" : s);
    }));
  });
}
function x7(e) {
  var t = e.state, r = {
    popper: {
      position: t.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(t.elements.popper.style, r.popper), t.styles = r, t.elements.arrow && Object.assign(t.elements.arrow.style, r.arrow), function() {
    Object.keys(t.elements).forEach(function(n) {
      var a = t.elements[n], i = t.attributes[n] || {}, o = Object.keys(t.styles.hasOwnProperty(n) ? t.styles[n] : r[n]), s = o.reduce(function(l, d) {
        return l[d] = "", l;
      }, {});
      !tt(a) || !gt(a) || (Object.assign(a.style, s), Object.keys(i).forEach(function(l) {
        a.removeAttribute(l);
      }));
    });
  };
}
const Gu = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: b7,
  effect: x7,
  requires: ["computeStyles"]
};
function lt(e) {
  return e.split("-")[0];
}
var Nt = Math.max, Vn = Math.min, lr = Math.round;
function Ua() {
  var e = navigator.userAgentData;
  return e != null && e.brands && Array.isArray(e.brands) ? e.brands.map(function(t) {
    return t.brand + "/" + t.version;
  }).join(" ") : navigator.userAgent;
}
function Ju() {
  return !/^((?!chrome|android).)*safari/i.test(Ua());
}
function cr(e, t, r) {
  t === void 0 && (t = !1), r === void 0 && (r = !1);
  var n = e.getBoundingClientRect(), a = 1, i = 1;
  t && tt(e) && (a = e.offsetWidth > 0 && lr(n.width) / e.offsetWidth || 1, i = e.offsetHeight > 0 && lr(n.height) / e.offsetHeight || 1);
  var o = Zt(e) ? rt(e) : window, s = o.visualViewport, l = !Ju() && r, d = (n.left + (l && s ? s.offsetLeft : 0)) / a, c = (n.top + (l && s ? s.offsetTop : 0)) / i, p = n.width / a, v = n.height / i;
  return {
    width: p,
    height: v,
    top: c,
    right: d + p,
    bottom: c + v,
    left: d,
    x: d,
    y: c
  };
}
function Oi(e) {
  var t = cr(e), r = e.offsetWidth, n = e.offsetHeight;
  return Math.abs(t.width - r) <= 1 && (r = t.width), Math.abs(t.height - n) <= 1 && (n = t.height), {
    x: e.offsetLeft,
    y: e.offsetTop,
    width: r,
    height: n
  };
}
function Qu(e, t) {
  var r = t.getRootNode && t.getRootNode();
  if (e.contains(t))
    return !0;
  if (r && ki(r)) {
    var n = t;
    do {
      if (n && e.isSameNode(n))
        return !0;
      n = n.parentNode || n.host;
    } while (n);
  }
  return !1;
}
function ct(e) {
  return rt(e).getComputedStyle(e);
}
function w7(e) {
  return ["table", "td", "th"].indexOf(gt(e)) >= 0;
}
function kt(e) {
  return ((Zt(e) ? e.ownerDocument : e.document) || window.document).documentElement;
}
function Kn(e) {
  return gt(e) === "html" ? e : e.assignedSlot || e.parentNode || (ki(e) ? e.host : null) || kt(e);
}
function h1(e) {
  return !tt(e) || ct(e).position === "fixed" ? null : e.offsetParent;
}
function L7(e) {
  var t = /firefox/i.test(Ua()), r = /Trident/i.test(Ua());
  if (r && tt(e)) {
    var n = ct(e);
    if (n.position === "fixed")
      return null;
  }
  var a = Kn(e);
  for (ki(a) && (a = a.host); tt(a) && ["html", "body"].indexOf(gt(a)) < 0; ) {
    var i = ct(a);
    if (i.transform !== "none" || i.perspective !== "none" || i.contain === "paint" || ["transform", "perspective"].indexOf(i.willChange) !== -1 || t && i.willChange === "filter" || t && i.filter && i.filter !== "none")
      return a;
    a = a.parentNode;
  }
  return null;
}
function en(e) {
  for (var t = rt(e), r = h1(e); r && w7(r) && ct(r).position === "static"; )
    r = h1(r);
  return r && (gt(r) === "html" || gt(r) === "body" && ct(r).position === "static") ? t : r || L7(e) || t;
}
function _i(e) {
  return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
}
function Ar(e, t, r) {
  return Nt(e, Vn(t, r));
}
function T7(e, t, r) {
  var n = Ar(e, t, r);
  return n > r ? r : n;
}
function el() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function tl(e) {
  return Object.assign({}, el(), e);
}
function rl(e, t) {
  return t.reduce(function(r, n) {
    return r[n] = e, r;
  }, {});
}
var M7 = function(t, r) {
  return t = typeof t == "function" ? t(Object.assign({}, r.rects, {
    placement: r.placement
  })) : t, tl(typeof t != "number" ? t : rl(t, Qr));
};
function A7(e) {
  var t, r = e.state, n = e.name, a = e.options, i = r.elements.arrow, o = r.modifiersData.popperOffsets, s = lt(r.placement), l = _i(s), d = [Xe, ot].indexOf(s) >= 0, c = d ? "height" : "width";
  if (!(!i || !o)) {
    var p = M7(a.padding, r), v = Oi(i), m = l === "y" ? Ke : Xe, h = l === "y" ? it : ot, C = r.rects.reference[c] + r.rects.reference[l] - o[l] - r.rects.popper[c], y = o[l] - r.rects.reference[l], x = en(i), T = x ? l === "y" ? x.clientHeight || 0 : x.clientWidth || 0 : 0, M = C / 2 - y / 2, f = p[m], b = T - v[c] - p[h], w = T / 2 - v[c] / 2 + M, V = Ar(f, w, b), S = l;
    r.modifiersData[n] = (t = {}, t[S] = V, t.centerOffset = V - w, t);
  }
}
function R7(e) {
  var t = e.state, r = e.options, n = r.element, a = n === void 0 ? "[data-popper-arrow]" : n;
  if (a != null && !(typeof a == "string" && (a = t.elements.popper.querySelector(a), !a))) {
    if (process.env.NODE_ENV !== "production" && (tt(a) || console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).', "To use an SVG arrow, wrap it in an HTMLElement that will be used as", "the arrow."].join(" "))), !Qu(t.elements.popper, a)) {
      process.env.NODE_ENV !== "production" && console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', "element."].join(" "));
      return;
    }
    t.elements.arrow = a;
  }
}
const S7 = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: A7,
  effect: R7,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function dr(e) {
  return e.split("-")[1];
}
var P7 = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function E7(e, t) {
  var r = e.x, n = e.y, a = t.devicePixelRatio || 1;
  return {
    x: lr(r * a) / a || 0,
    y: lr(n * a) / a || 0
  };
}
function g1(e) {
  var t, r = e.popper, n = e.popperRect, a = e.placement, i = e.variation, o = e.offsets, s = e.position, l = e.gpuAcceleration, d = e.adaptive, c = e.roundOffsets, p = e.isFixed, v = o.x, m = v === void 0 ? 0 : v, h = o.y, C = h === void 0 ? 0 : h, y = typeof c == "function" ? c({
    x: m,
    y: C
  }) : {
    x: m,
    y: C
  };
  m = y.x, C = y.y;
  var x = o.hasOwnProperty("x"), T = o.hasOwnProperty("y"), M = Xe, f = Ke, b = window;
  if (d) {
    var w = en(r), V = "clientHeight", S = "clientWidth";
    if (w === rt(r) && (w = kt(r), ct(w).position !== "static" && s === "absolute" && (V = "scrollHeight", S = "scrollWidth")), w = w, a === Ke || (a === Xe || a === ot) && i === Br) {
      f = it;
      var k = p && w === b && b.visualViewport ? b.visualViewport.height : w[V];
      C -= k - n.height, C *= l ? 1 : -1;
    }
    if (a === Xe || (a === Ke || a === it) && i === Br) {
      M = ot;
      var I = p && w === b && b.visualViewport ? b.visualViewport.width : w[S];
      m -= I - n.width, m *= l ? 1 : -1;
    }
  }
  var $ = Object.assign({
    position: s
  }, d && P7), X = c === !0 ? E7({
    x: m,
    y: C
  }, rt(r)) : {
    x: m,
    y: C
  };
  if (m = X.x, C = X.y, l) {
    var G;
    return Object.assign({}, $, (G = {}, G[f] = T ? "0" : "", G[M] = x ? "0" : "", G.transform = (b.devicePixelRatio || 1) <= 1 ? "translate(" + m + "px, " + C + "px)" : "translate3d(" + m + "px, " + C + "px, 0)", G));
  }
  return Object.assign({}, $, (t = {}, t[f] = T ? C + "px" : "", t[M] = x ? m + "px" : "", t.transform = "", t));
}
function k7(e) {
  var t = e.state, r = e.options, n = r.gpuAcceleration, a = n === void 0 ? !0 : n, i = r.adaptive, o = i === void 0 ? !0 : i, s = r.roundOffsets, l = s === void 0 ? !0 : s;
  if (process.env.NODE_ENV !== "production") {
    var d = ct(t.elements.popper).transitionProperty || "";
    o && ["transform", "top", "right", "bottom", "left"].some(function(p) {
      return d.indexOf(p) >= 0;
    }) && console.warn(["Popper: Detected CSS transitions on at least one of the following", 'CSS properties: "transform", "top", "right", "bottom", "left".', `

`, 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', "for smooth transitions, or remove these properties from the CSS", "transition declaration on the popper element if only transitioning", "opacity or background-color for example.", `

`, "We recommend using the popper element as a wrapper around an inner", "element that can have any CSS property transitioned for animations."].join(" "));
  }
  var c = {
    placement: lt(t.placement),
    variation: dr(t.placement),
    popper: t.elements.popper,
    popperRect: t.rects.popper,
    gpuAcceleration: a,
    isFixed: t.options.strategy === "fixed"
  };
  t.modifiersData.popperOffsets != null && (t.styles.popper = Object.assign({}, t.styles.popper, g1(Object.assign({}, c, {
    offsets: t.modifiersData.popperOffsets,
    position: t.options.strategy,
    adaptive: o,
    roundOffsets: l
  })))), t.modifiersData.arrow != null && (t.styles.arrow = Object.assign({}, t.styles.arrow, g1(Object.assign({}, c, {
    offsets: t.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-placement": t.placement
  });
}
const O7 = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: k7,
  data: {}
};
var vn = {
  passive: !0
};
function _7(e) {
  var t = e.state, r = e.instance, n = e.options, a = n.scroll, i = a === void 0 ? !0 : a, o = n.resize, s = o === void 0 ? !0 : o, l = rt(t.elements.popper), d = [].concat(t.scrollParents.reference, t.scrollParents.popper);
  return i && d.forEach(function(c) {
    c.addEventListener("scroll", r.update, vn);
  }), s && l.addEventListener("resize", r.update, vn), function() {
    i && d.forEach(function(c) {
      c.removeEventListener("scroll", r.update, vn);
    }), s && l.removeEventListener("resize", r.update, vn);
  };
}
const V7 = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: _7,
  data: {}
};
var H7 = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function xn(e) {
  return e.replace(/left|right|bottom|top/g, function(t) {
    return H7[t];
  });
}
var D7 = {
  start: "end",
  end: "start"
};
function y1(e) {
  return e.replace(/start|end/g, function(t) {
    return D7[t];
  });
}
function Vi(e) {
  var t = rt(e), r = t.pageXOffset, n = t.pageYOffset;
  return {
    scrollLeft: r,
    scrollTop: n
  };
}
function Hi(e) {
  return cr(kt(e)).left + Vi(e).scrollLeft;
}
function j7(e, t) {
  var r = rt(e), n = kt(e), a = r.visualViewport, i = n.clientWidth, o = n.clientHeight, s = 0, l = 0;
  if (a) {
    i = a.width, o = a.height;
    var d = Ju();
    (d || !d && t === "fixed") && (s = a.offsetLeft, l = a.offsetTop);
  }
  return {
    width: i,
    height: o,
    x: s + Hi(e),
    y: l
  };
}
function I7(e) {
  var t, r = kt(e), n = Vi(e), a = (t = e.ownerDocument) == null ? void 0 : t.body, i = Nt(r.scrollWidth, r.clientWidth, a ? a.scrollWidth : 0, a ? a.clientWidth : 0), o = Nt(r.scrollHeight, r.clientHeight, a ? a.scrollHeight : 0, a ? a.clientHeight : 0), s = -n.scrollLeft + Hi(e), l = -n.scrollTop;
  return ct(a || r).direction === "rtl" && (s += Nt(r.clientWidth, a ? a.clientWidth : 0) - i), {
    width: i,
    height: o,
    x: s,
    y: l
  };
}
function Di(e) {
  var t = ct(e), r = t.overflow, n = t.overflowX, a = t.overflowY;
  return /auto|scroll|overlay|hidden/.test(r + a + n);
}
function nl(e) {
  return ["html", "body", "#document"].indexOf(gt(e)) >= 0 ? e.ownerDocument.body : tt(e) && Di(e) ? e : nl(Kn(e));
}
function Rr(e, t) {
  var r;
  t === void 0 && (t = []);
  var n = nl(e), a = n === ((r = e.ownerDocument) == null ? void 0 : r.body), i = rt(n), o = a ? [i].concat(i.visualViewport || [], Di(n) ? n : []) : n, s = t.concat(o);
  return a ? s : s.concat(Rr(Kn(o)));
}
function za(e) {
  return Object.assign({}, e, {
    left: e.x,
    top: e.y,
    right: e.x + e.width,
    bottom: e.y + e.height
  });
}
function N7(e, t) {
  var r = cr(e, !1, t === "fixed");
  return r.top = r.top + e.clientTop, r.left = r.left + e.clientLeft, r.bottom = r.top + e.clientHeight, r.right = r.left + e.clientWidth, r.width = e.clientWidth, r.height = e.clientHeight, r.x = r.left, r.y = r.top, r;
}
function C1(e, t, r) {
  return t === Ku ? za(j7(e, r)) : Zt(t) ? N7(t, r) : za(I7(kt(e)));
}
function B7(e) {
  var t = Rr(Kn(e)), r = ["absolute", "fixed"].indexOf(ct(e).position) >= 0, n = r && tt(e) ? en(e) : e;
  return Zt(n) ? t.filter(function(a) {
    return Zt(a) && Qu(a, n) && gt(a) !== "body";
  }) : [];
}
function $7(e, t, r, n) {
  var a = t === "clippingParents" ? B7(e) : [].concat(t), i = [].concat(a, [r]), o = i[0], s = i.reduce(function(l, d) {
    var c = C1(e, d, n);
    return l.top = Nt(c.top, l.top), l.right = Vn(c.right, l.right), l.bottom = Vn(c.bottom, l.bottom), l.left = Nt(c.left, l.left), l;
  }, C1(e, o, n));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function al(e) {
  var t = e.reference, r = e.element, n = e.placement, a = n ? lt(n) : null, i = n ? dr(n) : null, o = t.x + t.width / 2 - r.width / 2, s = t.y + t.height / 2 - r.height / 2, l;
  switch (a) {
    case Ke:
      l = {
        x: o,
        y: t.y - r.height
      };
      break;
    case it:
      l = {
        x: o,
        y: t.y + t.height
      };
      break;
    case ot:
      l = {
        x: t.x + t.width,
        y: s
      };
      break;
    case Xe:
      l = {
        x: t.x - r.width,
        y: s
      };
      break;
    default:
      l = {
        x: t.x,
        y: t.y
      };
  }
  var d = a ? _i(a) : null;
  if (d != null) {
    var c = d === "y" ? "height" : "width";
    switch (i) {
      case ur:
        l[d] = l[d] - (t[c] / 2 - r[c] / 2);
        break;
      case Br:
        l[d] = l[d] + (t[c] / 2 - r[c] / 2);
        break;
    }
  }
  return l;
}
function $r(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.placement, a = n === void 0 ? e.placement : n, i = r.strategy, o = i === void 0 ? e.strategy : i, s = r.boundary, l = s === void 0 ? l7 : s, d = r.rootBoundary, c = d === void 0 ? Ku : d, p = r.elementContext, v = p === void 0 ? br : p, m = r.altBoundary, h = m === void 0 ? !1 : m, C = r.padding, y = C === void 0 ? 0 : C, x = tl(typeof y != "number" ? y : rl(y, Qr)), T = v === br ? c7 : br, M = e.rects.popper, f = e.elements[h ? T : v], b = $7(Zt(f) ? f : f.contextElement || kt(e.elements.popper), l, c, o), w = cr(e.elements.reference), V = al({
    reference: w,
    element: M,
    strategy: "absolute",
    placement: a
  }), S = za(Object.assign({}, M, V)), k = v === br ? S : w, I = {
    top: b.top - k.top + x.top,
    bottom: k.bottom - b.bottom + x.bottom,
    left: b.left - k.left + x.left,
    right: k.right - b.right + x.right
  }, $ = e.modifiersData.offset;
  if (v === br && $) {
    var X = $[a];
    Object.keys(I).forEach(function(G) {
      var F = [ot, it].indexOf(G) >= 0 ? 1 : -1, z = [Ke, it].indexOf(G) >= 0 ? "y" : "x";
      I[G] += X[z] * F;
    });
  }
  return I;
}
function Z7(e, t) {
  t === void 0 && (t = {});
  var r = t, n = r.placement, a = r.boundary, i = r.rootBoundary, o = r.padding, s = r.flipVariations, l = r.allowedAutoPlacements, d = l === void 0 ? Xu : l, c = dr(n), p = c ? s ? m1 : m1.filter(function(h) {
    return dr(h) === c;
  }) : Qr, v = p.filter(function(h) {
    return d.indexOf(h) >= 0;
  });
  v.length === 0 && (v = p, process.env.NODE_ENV !== "production" && console.error(["Popper: The `allowedAutoPlacements` option did not allow any", "placements. Ensure the `placement` option matches the variation", "of the allowed placements.", 'For example, "auto" cannot be used to allow "bottom-start".', 'Use "auto-start" instead.'].join(" ")));
  var m = v.reduce(function(h, C) {
    return h[C] = $r(e, {
      placement: C,
      boundary: a,
      rootBoundary: i,
      padding: o
    })[lt(C)], h;
  }, {});
  return Object.keys(m).sort(function(h, C) {
    return m[h] - m[C];
  });
}
function F7(e) {
  if (lt(e) === qn)
    return [];
  var t = xn(e);
  return [y1(e), t, y1(t)];
}
function W7(e) {
  var t = e.state, r = e.options, n = e.name;
  if (!t.modifiersData[n]._skip) {
    for (var a = r.mainAxis, i = a === void 0 ? !0 : a, o = r.altAxis, s = o === void 0 ? !0 : o, l = r.fallbackPlacements, d = r.padding, c = r.boundary, p = r.rootBoundary, v = r.altBoundary, m = r.flipVariations, h = m === void 0 ? !0 : m, C = r.allowedAutoPlacements, y = t.options.placement, x = lt(y), T = x === y, M = l || (T || !h ? [xn(y)] : F7(y)), f = [y].concat(M).reduce(function(U, te) {
      return U.concat(lt(te) === qn ? Z7(t, {
        placement: te,
        boundary: c,
        rootBoundary: p,
        padding: d,
        flipVariations: h,
        allowedAutoPlacements: C
      }) : te);
    }, []), b = t.rects.reference, w = t.rects.popper, V = /* @__PURE__ */ new Map(), S = !0, k = f[0], I = 0; I < f.length; I++) {
      var $ = f[I], X = lt($), G = dr($) === ur, F = [Ke, it].indexOf(X) >= 0, z = F ? "width" : "height", J = $r(t, {
        placement: $,
        boundary: c,
        rootBoundary: p,
        altBoundary: v,
        padding: d
      }), se = F ? G ? ot : Xe : G ? it : Ke;
      b[z] > w[z] && (se = xn(se));
      var ee = xn(se), pe = [];
      if (i && pe.push(J[X] <= 0), s && pe.push(J[se] <= 0, J[ee] <= 0), pe.every(function(U) {
        return U;
      })) {
        k = $, S = !1;
        break;
      }
      V.set($, pe);
    }
    if (S)
      for (var le = h ? 3 : 1, ve = function(te) {
        var L = f.find(function(ce) {
          var j = V.get(ce);
          if (j)
            return j.slice(0, te).every(function(ye) {
              return ye;
            });
        });
        if (L)
          return k = L, "break";
      }, B = le; B > 0; B--) {
        var Z = ve(B);
        if (Z === "break")
          break;
      }
    t.placement !== k && (t.modifiersData[n]._skip = !0, t.placement = k, t.reset = !0);
  }
}
const U7 = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: W7,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function b1(e, t, r) {
  return r === void 0 && (r = {
    x: 0,
    y: 0
  }), {
    top: e.top - t.height - r.y,
    right: e.right - t.width + r.x,
    bottom: e.bottom - t.height + r.y,
    left: e.left - t.width - r.x
  };
}
function x1(e) {
  return [Ke, ot, it, Xe].some(function(t) {
    return e[t] >= 0;
  });
}
function z7(e) {
  var t = e.state, r = e.name, n = t.rects.reference, a = t.rects.popper, i = t.modifiersData.preventOverflow, o = $r(t, {
    elementContext: "reference"
  }), s = $r(t, {
    altBoundary: !0
  }), l = b1(o, n), d = b1(s, a, i), c = x1(l), p = x1(d);
  t.modifiersData[r] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: d,
    isReferenceHidden: c,
    hasPopperEscaped: p
  }, t.attributes.popper = Object.assign({}, t.attributes.popper, {
    "data-popper-reference-hidden": c,
    "data-popper-escaped": p
  });
}
const Y7 = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: z7
};
function q7(e, t, r) {
  var n = lt(e), a = [Xe, Ke].indexOf(n) >= 0 ? -1 : 1, i = typeof r == "function" ? r(Object.assign({}, t, {
    placement: e
  })) : r, o = i[0], s = i[1];
  return o = o || 0, s = (s || 0) * a, [Xe, ot].indexOf(n) >= 0 ? {
    x: s,
    y: o
  } : {
    x: o,
    y: s
  };
}
function K7(e) {
  var t = e.state, r = e.options, n = e.name, a = r.offset, i = a === void 0 ? [0, 0] : a, o = Xu.reduce(function(c, p) {
    return c[p] = q7(p, t.rects, i), c;
  }, {}), s = o[t.placement], l = s.x, d = s.y;
  t.modifiersData.popperOffsets != null && (t.modifiersData.popperOffsets.x += l, t.modifiersData.popperOffsets.y += d), t.modifiersData[n] = o;
}
const X7 = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: K7
};
function G7(e) {
  var t = e.state, r = e.name;
  t.modifiersData[r] = al({
    reference: t.rects.reference,
    element: t.rects.popper,
    strategy: "absolute",
    placement: t.placement
  });
}
const J7 = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: G7,
  data: {}
};
function Q7(e) {
  return e === "x" ? "y" : "x";
}
function e4(e) {
  var t = e.state, r = e.options, n = e.name, a = r.mainAxis, i = a === void 0 ? !0 : a, o = r.altAxis, s = o === void 0 ? !1 : o, l = r.boundary, d = r.rootBoundary, c = r.altBoundary, p = r.padding, v = r.tether, m = v === void 0 ? !0 : v, h = r.tetherOffset, C = h === void 0 ? 0 : h, y = $r(t, {
    boundary: l,
    rootBoundary: d,
    padding: p,
    altBoundary: c
  }), x = lt(t.placement), T = dr(t.placement), M = !T, f = _i(x), b = Q7(f), w = t.modifiersData.popperOffsets, V = t.rects.reference, S = t.rects.popper, k = typeof C == "function" ? C(Object.assign({}, t.rects, {
    placement: t.placement
  })) : C, I = typeof k == "number" ? {
    mainAxis: k,
    altAxis: k
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, k), $ = t.modifiersData.offset ? t.modifiersData.offset[t.placement] : null, X = {
    x: 0,
    y: 0
  };
  if (!!w) {
    if (i) {
      var G, F = f === "y" ? Ke : Xe, z = f === "y" ? it : ot, J = f === "y" ? "height" : "width", se = w[f], ee = se + y[F], pe = se - y[z], le = m ? -S[J] / 2 : 0, ve = T === ur ? V[J] : S[J], B = T === ur ? -S[J] : -V[J], Z = t.elements.arrow, U = m && Z ? Oi(Z) : {
        width: 0,
        height: 0
      }, te = t.modifiersData["arrow#persistent"] ? t.modifiersData["arrow#persistent"].padding : el(), L = te[F], ce = te[z], j = Ar(0, V[J], U[J]), ye = M ? V[J] / 2 - le - j - L - I.mainAxis : ve - j - L - I.mainAxis, ue = M ? -V[J] / 2 + le + j + ce + I.mainAxis : B + j + ce + I.mainAxis, me = t.elements.arrow && en(t.elements.arrow), O = me ? f === "y" ? me.clientTop || 0 : me.clientLeft || 0 : 0, we = (G = $ == null ? void 0 : $[f]) != null ? G : 0, W = se + ye - we - O, A = se + ue - we, _ = Ar(m ? Vn(ee, W) : ee, se, m ? Nt(pe, A) : pe);
      w[f] = _, X[f] = _ - se;
    }
    if (s) {
      var q, ne = f === "x" ? Ke : Xe, Le = f === "x" ? it : ot, ae = w[b], Se = b === "y" ? "height" : "width", Ve = ae + y[ne], Te = ae - y[Le], Q = [Ke, Xe].indexOf(x) !== -1, Ce = (q = $ == null ? void 0 : $[b]) != null ? q : 0, dt = Q ? Ve : ae - V[Se] - S[Se] - Ce + I.altAxis, ft = Q ? ae + V[Se] + S[Se] - Ce - I.altAxis : Te, je = m && Q ? T7(dt, ae, ft) : Ar(m ? dt : Ve, ae, m ? ft : Te);
      w[b] = je, X[b] = je - ae;
    }
    t.modifiersData[n] = X;
  }
}
const t4 = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: e4,
  requiresIfExists: ["offset"]
};
function r4(e) {
  return {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  };
}
function n4(e) {
  return e === rt(e) || !tt(e) ? Vi(e) : r4(e);
}
function a4(e) {
  var t = e.getBoundingClientRect(), r = lr(t.width) / e.offsetWidth || 1, n = lr(t.height) / e.offsetHeight || 1;
  return r !== 1 || n !== 1;
}
function i4(e, t, r) {
  r === void 0 && (r = !1);
  var n = tt(t), a = tt(t) && a4(t), i = kt(t), o = cr(e, a, r), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (n || !n && !r) && ((gt(t) !== "body" || Di(i)) && (s = n4(t)), tt(t) ? (l = cr(t, !0), l.x += t.clientLeft, l.y += t.clientTop) : i && (l.x = Hi(i))), {
    x: o.left + s.scrollLeft - l.x,
    y: o.top + s.scrollTop - l.y,
    width: o.width,
    height: o.height
  };
}
function o4(e) {
  var t = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Set(), n = [];
  e.forEach(function(i) {
    t.set(i.name, i);
  });
  function a(i) {
    r.add(i.name);
    var o = [].concat(i.requires || [], i.requiresIfExists || []);
    o.forEach(function(s) {
      if (!r.has(s)) {
        var l = t.get(s);
        l && a(l);
      }
    }), n.push(i);
  }
  return e.forEach(function(i) {
    r.has(i.name) || a(i);
  }), n;
}
function s4(e) {
  var t = o4(e);
  return Wa.reduce(function(r, n) {
    return r.concat(t.filter(function(a) {
      return a.phase === n;
    }));
  }, []);
}
function u4(e) {
  var t;
  return function() {
    return t || (t = new Promise(function(r) {
      Promise.resolve().then(function() {
        t = void 0, r(e());
      });
    })), t;
  };
}
function At(e) {
  for (var t = arguments.length, r = new Array(t > 1 ? t - 1 : 0), n = 1; n < t; n++)
    r[n - 1] = arguments[n];
  return [].concat(r).reduce(function(a, i) {
    return a.replace(/%s/, i);
  }, e);
}
var _t = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s', l4 = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available', w1 = ["name", "enabled", "phase", "fn", "effect", "requires", "options"];
function c4(e) {
  e.forEach(function(t) {
    [].concat(Object.keys(t), w1).filter(function(r, n, a) {
      return a.indexOf(r) === n;
    }).forEach(function(r) {
      switch (r) {
        case "name":
          typeof t.name != "string" && console.error(At(_t, String(t.name), '"name"', '"string"', '"' + String(t.name) + '"'));
          break;
        case "enabled":
          typeof t.enabled != "boolean" && console.error(At(_t, t.name, '"enabled"', '"boolean"', '"' + String(t.enabled) + '"'));
          break;
        case "phase":
          Wa.indexOf(t.phase) < 0 && console.error(At(_t, t.name, '"phase"', "either " + Wa.join(", "), '"' + String(t.phase) + '"'));
          break;
        case "fn":
          typeof t.fn != "function" && console.error(At(_t, t.name, '"fn"', '"function"', '"' + String(t.fn) + '"'));
          break;
        case "effect":
          t.effect != null && typeof t.effect != "function" && console.error(At(_t, t.name, '"effect"', '"function"', '"' + String(t.fn) + '"'));
          break;
        case "requires":
          t.requires != null && !Array.isArray(t.requires) && console.error(At(_t, t.name, '"requires"', '"array"', '"' + String(t.requires) + '"'));
          break;
        case "requiresIfExists":
          Array.isArray(t.requiresIfExists) || console.error(At(_t, t.name, '"requiresIfExists"', '"array"', '"' + String(t.requiresIfExists) + '"'));
          break;
        case "options":
        case "data":
          break;
        default:
          console.error('PopperJS: an invalid property has been provided to the "' + t.name + '" modifier, valid properties are ' + w1.map(function(n) {
            return '"' + n + '"';
          }).join(", ") + '; but "' + r + '" was provided.');
      }
      t.requires && t.requires.forEach(function(n) {
        e.find(function(a) {
          return a.name === n;
        }) == null && console.error(At(l4, String(t.name), n, n));
      });
    });
  });
}
function d4(e, t) {
  var r = /* @__PURE__ */ new Set();
  return e.filter(function(n) {
    var a = t(n);
    if (!r.has(a))
      return r.add(a), !0;
  });
}
function f4(e) {
  var t = e.reduce(function(r, n) {
    var a = r[n.name];
    return r[n.name] = a ? Object.assign({}, a, n, {
      options: Object.assign({}, a.options, n.options),
      data: Object.assign({}, a.data, n.data)
    }) : n, r;
  }, {});
  return Object.keys(t).map(function(r) {
    return t[r];
  });
}
var L1 = "Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.", p4 = "Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.", T1 = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function M1() {
  for (var e = arguments.length, t = new Array(e), r = 0; r < e; r++)
    t[r] = arguments[r];
  return !t.some(function(n) {
    return !(n && typeof n.getBoundingClientRect == "function");
  });
}
function v4(e) {
  e === void 0 && (e = {});
  var t = e, r = t.defaultModifiers, n = r === void 0 ? [] : r, a = t.defaultOptions, i = a === void 0 ? T1 : a;
  return function(s, l, d) {
    d === void 0 && (d = i);
    var c = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, T1, i),
      modifiersData: {},
      elements: {
        reference: s,
        popper: l
      },
      attributes: {},
      styles: {}
    }, p = [], v = !1, m = {
      state: c,
      setOptions: function(x) {
        var T = typeof x == "function" ? x(c.options) : x;
        C(), c.options = Object.assign({}, i, c.options, T), c.scrollParents = {
          reference: Zt(s) ? Rr(s) : s.contextElement ? Rr(s.contextElement) : [],
          popper: Rr(l)
        };
        var M = s4(f4([].concat(n, c.options.modifiers)));
        if (c.orderedModifiers = M.filter(function($) {
          return $.enabled;
        }), process.env.NODE_ENV !== "production") {
          var f = d4([].concat(M, c.options.modifiers), function($) {
            var X = $.name;
            return X;
          });
          if (c4(f), lt(c.options.placement) === qn) {
            var b = c.orderedModifiers.find(function($) {
              var X = $.name;
              return X === "flip";
            });
            b || console.error(['Popper: "auto" placements require the "flip" modifier be', "present and enabled to work."].join(" "));
          }
          var w = ct(l), V = w.marginTop, S = w.marginRight, k = w.marginBottom, I = w.marginLeft;
          [V, S, k, I].some(function($) {
            return parseFloat($);
          }) && console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', "between the popper and its reference element or boundary.", "To replicate margin, use the `offset` modifier, as well as", "the `padding` option in the `preventOverflow` and `flip`", "modifiers."].join(" "));
        }
        return h(), m.update();
      },
      forceUpdate: function() {
        if (!v) {
          var x = c.elements, T = x.reference, M = x.popper;
          if (!M1(T, M)) {
            process.env.NODE_ENV !== "production" && console.error(L1);
            return;
          }
          c.rects = {
            reference: i4(T, en(M), c.options.strategy === "fixed"),
            popper: Oi(M)
          }, c.reset = !1, c.placement = c.options.placement, c.orderedModifiers.forEach(function($) {
            return c.modifiersData[$.name] = Object.assign({}, $.data);
          });
          for (var f = 0, b = 0; b < c.orderedModifiers.length; b++) {
            if (process.env.NODE_ENV !== "production" && (f += 1, f > 100)) {
              console.error(p4);
              break;
            }
            if (c.reset === !0) {
              c.reset = !1, b = -1;
              continue;
            }
            var w = c.orderedModifiers[b], V = w.fn, S = w.options, k = S === void 0 ? {} : S, I = w.name;
            typeof V == "function" && (c = V({
              state: c,
              options: k,
              name: I,
              instance: m
            }) || c);
          }
        }
      },
      update: u4(function() {
        return new Promise(function(y) {
          m.forceUpdate(), y(c);
        });
      }),
      destroy: function() {
        C(), v = !0;
      }
    };
    if (!M1(s, l))
      return process.env.NODE_ENV !== "production" && console.error(L1), m;
    m.setOptions(d).then(function(y) {
      !v && d.onFirstUpdate && d.onFirstUpdate(y);
    });
    function h() {
      c.orderedModifiers.forEach(function(y) {
        var x = y.name, T = y.options, M = T === void 0 ? {} : T, f = y.effect;
        if (typeof f == "function") {
          var b = f({
            state: c,
            name: x,
            instance: m,
            options: M
          }), w = function() {
          };
          p.push(b || w);
        }
      });
    }
    function C() {
      p.forEach(function(y) {
        return y();
      }), p = [];
    }
    return m;
  };
}
var m4 = [V7, J7, O7, Gu, X7, U7, t4, S7, Y7], h4 = /* @__PURE__ */ v4({
  defaultModifiers: m4
}), g4 = "tippy-box", il = "tippy-content", y4 = "tippy-backdrop", ol = "tippy-arrow", sl = "tippy-svg-arrow", Ht = {
  passive: !0,
  capture: !0
}, ul = function() {
  return document.body;
};
function C4(e, t) {
  return {}.hasOwnProperty.call(e, t);
}
function pa(e, t, r) {
  if (Array.isArray(e)) {
    var n = e[t];
    return n == null ? Array.isArray(r) ? r[t] : r : n;
  }
  return e;
}
function ji(e, t) {
  var r = {}.toString.call(e);
  return r.indexOf("[object") === 0 && r.indexOf(t + "]") > -1;
}
function ll(e, t) {
  return typeof e == "function" ? e.apply(void 0, t) : e;
}
function A1(e, t) {
  if (t === 0)
    return e;
  var r;
  return function(n) {
    clearTimeout(r), r = setTimeout(function() {
      e(n);
    }, t);
  };
}
function b4(e, t) {
  var r = Object.assign({}, e);
  return t.forEach(function(n) {
    delete r[n];
  }), r;
}
function x4(e) {
  return e.split(/\s+/).filter(Boolean);
}
function Jt(e) {
  return [].concat(e);
}
function R1(e, t) {
  e.indexOf(t) === -1 && e.push(t);
}
function w4(e) {
  return e.filter(function(t, r) {
    return e.indexOf(t) === r;
  });
}
function L4(e) {
  return e.split("-")[0];
}
function Hn(e) {
  return [].slice.call(e);
}
function S1(e) {
  return Object.keys(e).reduce(function(t, r) {
    return e[r] !== void 0 && (t[r] = e[r]), t;
  }, {});
}
function Sr() {
  return document.createElement("div");
}
function Zr(e) {
  return ["Element", "Fragment"].some(function(t) {
    return ji(e, t);
  });
}
function T4(e) {
  return ji(e, "NodeList");
}
function M4(e) {
  return ji(e, "MouseEvent");
}
function A4(e) {
  return !!(e && e._tippy && e._tippy.reference === e);
}
function R4(e) {
  return Zr(e) ? [e] : T4(e) ? Hn(e) : Array.isArray(e) ? e : Hn(document.querySelectorAll(e));
}
function va(e, t) {
  e.forEach(function(r) {
    r && (r.style.transitionDuration = t + "ms");
  });
}
function P1(e, t) {
  e.forEach(function(r) {
    r && r.setAttribute("data-state", t);
  });
}
function S4(e) {
  var t, r = Jt(e), n = r[0];
  return n != null && (t = n.ownerDocument) != null && t.body ? n.ownerDocument : document;
}
function P4(e, t) {
  var r = t.clientX, n = t.clientY;
  return e.every(function(a) {
    var i = a.popperRect, o = a.popperState, s = a.props, l = s.interactiveBorder, d = L4(o.placement), c = o.modifiersData.offset;
    if (!c)
      return !0;
    var p = d === "bottom" ? c.top.y : 0, v = d === "top" ? c.bottom.y : 0, m = d === "right" ? c.left.x : 0, h = d === "left" ? c.right.x : 0, C = i.top - n + p > l, y = n - i.bottom - v > l, x = i.left - r + m > l, T = r - i.right - h > l;
    return C || y || x || T;
  });
}
function ma(e, t, r) {
  var n = t + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function(a) {
    e[n](a, r);
  });
}
function E1(e, t) {
  for (var r = t; r; ) {
    var n;
    if (e.contains(r))
      return !0;
    r = r.getRootNode == null || (n = r.getRootNode()) == null ? void 0 : n.host;
  }
  return !1;
}
var vt = {
  isTouch: !1
}, k1 = 0;
function E4() {
  vt.isTouch || (vt.isTouch = !0, window.performance && document.addEventListener("mousemove", cl));
}
function cl() {
  var e = performance.now();
  e - k1 < 20 && (vt.isTouch = !1, document.removeEventListener("mousemove", cl)), k1 = e;
}
function k4() {
  var e = document.activeElement;
  if (A4(e)) {
    var t = e._tippy;
    e.blur && !t.state.isVisible && e.blur();
  }
}
function O4() {
  document.addEventListener("touchstart", E4, Ht), window.addEventListener("blur", k4);
}
var _4 = typeof window < "u" && typeof document < "u", V4 = _4 ? !!window.msCrypto : !1;
function Xt(e) {
  var t = e === "destroy" ? "n already-" : " ";
  return [e + "() was called on a" + t + "destroyed instance. This is a no-op but", "indicates a potential memory leak."].join(" ");
}
function O1(e) {
  var t = /[ \t]{2,}/g, r = /^[ \t]*/gm;
  return e.replace(t, " ").replace(r, "").trim();
}
function H4(e) {
  return O1(`
  %ctippy.js

  %c` + O1(e) + `

  %c\u{1F477}\u200D This is a development-only message. It will be removed in production.
  `);
}
function dl(e) {
  return [
    H4(e),
    "color: #00C584; font-size: 1.3em; font-weight: bold;",
    "line-height: 1.5",
    "color: #a6a095;"
  ];
}
var Fr;
process.env.NODE_ENV !== "production" && D4();
function D4() {
  Fr = /* @__PURE__ */ new Set();
}
function wt(e, t) {
  if (e && !Fr.has(t)) {
    var r;
    Fr.add(t), (r = console).warn.apply(r, dl(t));
  }
}
function Ya(e, t) {
  if (e && !Fr.has(t)) {
    var r;
    Fr.add(t), (r = console).error.apply(r, dl(t));
  }
}
function j4(e) {
  var t = !e, r = Object.prototype.toString.call(e) === "[object Object]" && !e.addEventListener;
  Ya(t, ["tippy() was passed", "`" + String(e) + "`", "as its targets (first) argument. Valid types are: String, Element,", "Element[], or NodeList."].join(" ")), Ya(r, ["tippy() was passed a plain object which is not supported as an argument", "for virtual positioning. Use props.getReferenceClientRect instead."].join(" "));
}
var fl = {
  animateFill: !1,
  followCursor: !1,
  inlinePositioning: !1,
  sticky: !1
}, I4 = {
  allowHTML: !1,
  animation: "fade",
  arrow: !0,
  content: "",
  inertia: !1,
  maxWidth: 350,
  role: "tooltip",
  theme: "",
  zIndex: 9999
}, Je = Object.assign({
  appendTo: ul,
  aria: {
    content: "auto",
    expanded: "auto"
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: !0,
  ignoreAttributes: !1,
  interactive: !1,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: "",
  offset: [0, 10],
  onAfterUpdate: function() {
  },
  onBeforeUpdate: function() {
  },
  onCreate: function() {
  },
  onDestroy: function() {
  },
  onHidden: function() {
  },
  onHide: function() {
  },
  onMount: function() {
  },
  onShow: function() {
  },
  onShown: function() {
  },
  onTrigger: function() {
  },
  onUntrigger: function() {
  },
  onClickOutside: function() {
  },
  placement: "top",
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: !1,
  touch: !0,
  trigger: "mouseenter focus",
  triggerTarget: null
}, fl, I4), N4 = Object.keys(Je), B4 = function(t) {
  process.env.NODE_ENV !== "production" && vl(t, []);
  var r = Object.keys(t);
  r.forEach(function(n) {
    Je[n] = t[n];
  });
};
function pl(e) {
  var t = e.plugins || [], r = t.reduce(function(n, a) {
    var i = a.name, o = a.defaultValue;
    if (i) {
      var s;
      n[i] = e[i] !== void 0 ? e[i] : (s = Je[i]) != null ? s : o;
    }
    return n;
  }, {});
  return Object.assign({}, e, r);
}
function $4(e, t) {
  var r = t ? Object.keys(pl(Object.assign({}, Je, {
    plugins: t
  }))) : N4, n = r.reduce(function(a, i) {
    var o = (e.getAttribute("data-tippy-" + i) || "").trim();
    if (!o)
      return a;
    if (i === "content")
      a[i] = o;
    else
      try {
        a[i] = JSON.parse(o);
      } catch {
        a[i] = o;
      }
    return a;
  }, {});
  return n;
}
function _1(e, t) {
  var r = Object.assign({}, t, {
    content: ll(t.content, [e])
  }, t.ignoreAttributes ? {} : $4(e, t.plugins));
  return r.aria = Object.assign({}, Je.aria, r.aria), r.aria = {
    expanded: r.aria.expanded === "auto" ? t.interactive : r.aria.expanded,
    content: r.aria.content === "auto" ? t.interactive ? null : "describedby" : r.aria.content
  }, r;
}
function vl(e, t) {
  e === void 0 && (e = {}), t === void 0 && (t = []);
  var r = Object.keys(e);
  r.forEach(function(n) {
    var a = b4(Je, Object.keys(fl)), i = !C4(a, n);
    i && (i = t.filter(function(o) {
      return o.name === n;
    }).length === 0), wt(i, ["`" + n + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", "a plugin, forgot to pass it in an array as props.plugins.", `

`, `All props: https://atomiks.github.io/tippyjs/v6/all-props/
`, "Plugins: https://atomiks.github.io/tippyjs/v6/plugins/"].join(" "));
  });
}
var Z4 = function() {
  return "innerHTML";
};
function qa(e, t) {
  e[Z4()] = t;
}
function V1(e) {
  var t = Sr();
  return e === !0 ? t.className = ol : (t.className = sl, Zr(e) ? t.appendChild(e) : qa(t, e)), t;
}
function H1(e, t) {
  Zr(t.content) ? (qa(e, ""), e.appendChild(t.content)) : typeof t.content != "function" && (t.allowHTML ? qa(e, t.content) : e.textContent = t.content);
}
function Ka(e) {
  var t = e.firstElementChild, r = Hn(t.children);
  return {
    box: t,
    content: r.find(function(n) {
      return n.classList.contains(il);
    }),
    arrow: r.find(function(n) {
      return n.classList.contains(ol) || n.classList.contains(sl);
    }),
    backdrop: r.find(function(n) {
      return n.classList.contains(y4);
    })
  };
}
function ml(e) {
  var t = Sr(), r = Sr();
  r.className = g4, r.setAttribute("data-state", "hidden"), r.setAttribute("tabindex", "-1");
  var n = Sr();
  n.className = il, n.setAttribute("data-state", "hidden"), H1(n, e.props), t.appendChild(r), r.appendChild(n), a(e.props, e.props);
  function a(i, o) {
    var s = Ka(t), l = s.box, d = s.content, c = s.arrow;
    o.theme ? l.setAttribute("data-theme", o.theme) : l.removeAttribute("data-theme"), typeof o.animation == "string" ? l.setAttribute("data-animation", o.animation) : l.removeAttribute("data-animation"), o.inertia ? l.setAttribute("data-inertia", "") : l.removeAttribute("data-inertia"), l.style.maxWidth = typeof o.maxWidth == "number" ? o.maxWidth + "px" : o.maxWidth, o.role ? l.setAttribute("role", o.role) : l.removeAttribute("role"), (i.content !== o.content || i.allowHTML !== o.allowHTML) && H1(d, e.props), o.arrow ? c ? i.arrow !== o.arrow && (l.removeChild(c), l.appendChild(V1(o.arrow))) : l.appendChild(V1(o.arrow)) : c && l.removeChild(c);
  }
  return {
    popper: t,
    onUpdate: a
  };
}
ml.$$tippy = !0;
var F4 = 1, mn = [], ha = [];
function W4(e, t) {
  var r = _1(e, Object.assign({}, Je, pl(S1(t)))), n, a, i, o = !1, s = !1, l = !1, d = !1, c, p, v, m = [], h = A1(W, r.interactiveDebounce), C, y = F4++, x = null, T = w4(r.plugins), M = {
    isEnabled: !0,
    isVisible: !1,
    isDestroyed: !1,
    isMounted: !1,
    isShown: !1
  }, f = {
    id: y,
    reference: e,
    popper: Sr(),
    popperInstance: x,
    props: r,
    state: M,
    plugins: T,
    clearDelayTimeouts: dt,
    setProps: ft,
    setContent: je,
    show: Xn,
    hide: Gn,
    hideWithInteractivity: Jn,
    enable: Q,
    disable: Ce,
    unmount: Qn,
    destroy: mr
  };
  if (!r.render)
    return process.env.NODE_ENV !== "production" && Ya(!0, "render() function has not been supplied."), f;
  var b = r.render(f), w = b.popper, V = b.onUpdate;
  w.setAttribute("data-tippy-root", ""), w.id = "tippy-" + f.id, f.popper = w, e._tippy = f, w._tippy = f;
  var S = T.map(function(R) {
    return R.fn(f);
  }), k = e.hasAttribute("aria-expanded");
  return me(), le(), se(), ee("onCreate", [f]), r.showOnCreate && Ve(), w.addEventListener("mouseenter", function() {
    f.props.interactive && f.state.isVisible && f.clearDelayTimeouts();
  }), w.addEventListener("mouseleave", function() {
    f.props.interactive && f.props.trigger.indexOf("mouseenter") >= 0 && F().addEventListener("mousemove", h);
  }), f;
  function I() {
    var R = f.props.touch;
    return Array.isArray(R) ? R : [R, 0];
  }
  function $() {
    return I()[0] === "hold";
  }
  function X() {
    var R;
    return !!((R = f.props.render) != null && R.$$tippy);
  }
  function G() {
    return C || e;
  }
  function F() {
    var R = G().parentNode;
    return R ? S4(R) : document;
  }
  function z() {
    return Ka(w);
  }
  function J(R) {
    return f.state.isMounted && !f.state.isVisible || vt.isTouch || c && c.type === "focus" ? 0 : pa(f.props.delay, R ? 0 : 1, Je.delay);
  }
  function se(R) {
    R === void 0 && (R = !1), w.style.pointerEvents = f.props.interactive && !R ? "" : "none", w.style.zIndex = "" + f.props.zIndex;
  }
  function ee(R, K, re) {
    if (re === void 0 && (re = !0), S.forEach(function(de) {
      de[R] && de[R].apply(de, K);
    }), re) {
      var he;
      (he = f.props)[R].apply(he, K);
    }
  }
  function pe() {
    var R = f.props.aria;
    if (!!R.content) {
      var K = "aria-" + R.content, re = w.id, he = Jt(f.props.triggerTarget || e);
      he.forEach(function(de) {
        var De = de.getAttribute(K);
        if (f.state.isVisible)
          de.setAttribute(K, De ? De + " " + re : re);
        else {
          var Ie = De && De.replace(re, "").trim();
          Ie ? de.setAttribute(K, Ie) : de.removeAttribute(K);
        }
      });
    }
  }
  function le() {
    if (!(k || !f.props.aria.expanded)) {
      var R = Jt(f.props.triggerTarget || e);
      R.forEach(function(K) {
        f.props.interactive ? K.setAttribute("aria-expanded", f.state.isVisible && K === G() ? "true" : "false") : K.removeAttribute("aria-expanded");
      });
    }
  }
  function ve() {
    F().removeEventListener("mousemove", h), mn = mn.filter(function(R) {
      return R !== h;
    });
  }
  function B(R) {
    if (!(vt.isTouch && (l || R.type === "mousedown"))) {
      var K = R.composedPath && R.composedPath()[0] || R.target;
      if (!(f.props.interactive && E1(w, K))) {
        if (Jt(f.props.triggerTarget || e).some(function(re) {
          return E1(re, K);
        })) {
          if (vt.isTouch || f.state.isVisible && f.props.trigger.indexOf("click") >= 0)
            return;
        } else
          ee("onClickOutside", [f, R]);
        f.props.hideOnClick === !0 && (f.clearDelayTimeouts(), f.hide(), s = !0, setTimeout(function() {
          s = !1;
        }), f.state.isMounted || L());
      }
    }
  }
  function Z() {
    l = !0;
  }
  function U() {
    l = !1;
  }
  function te() {
    var R = F();
    R.addEventListener("mousedown", B, !0), R.addEventListener("touchend", B, Ht), R.addEventListener("touchstart", U, Ht), R.addEventListener("touchmove", Z, Ht);
  }
  function L() {
    var R = F();
    R.removeEventListener("mousedown", B, !0), R.removeEventListener("touchend", B, Ht), R.removeEventListener("touchstart", U, Ht), R.removeEventListener("touchmove", Z, Ht);
  }
  function ce(R, K) {
    ye(R, function() {
      !f.state.isVisible && w.parentNode && w.parentNode.contains(w) && K();
    });
  }
  function j(R, K) {
    ye(R, K);
  }
  function ye(R, K) {
    var re = z().box;
    function he(de) {
      de.target === re && (ma(re, "remove", he), K());
    }
    if (R === 0)
      return K();
    ma(re, "remove", p), ma(re, "add", he), p = he;
  }
  function ue(R, K, re) {
    re === void 0 && (re = !1);
    var he = Jt(f.props.triggerTarget || e);
    he.forEach(function(de) {
      de.addEventListener(R, K, re), m.push({
        node: de,
        eventType: R,
        handler: K,
        options: re
      });
    });
  }
  function me() {
    $() && (ue("touchstart", we, {
      passive: !0
    }), ue("touchend", A, {
      passive: !0
    })), x4(f.props.trigger).forEach(function(R) {
      if (R !== "manual")
        switch (ue(R, we), R) {
          case "mouseenter":
            ue("mouseleave", A);
            break;
          case "focus":
            ue(V4 ? "focusout" : "blur", _);
            break;
          case "focusin":
            ue("focusout", _);
            break;
        }
    });
  }
  function O() {
    m.forEach(function(R) {
      var K = R.node, re = R.eventType, he = R.handler, de = R.options;
      K.removeEventListener(re, he, de);
    }), m = [];
  }
  function we(R) {
    var K, re = !1;
    if (!(!f.state.isEnabled || q(R) || s)) {
      var he = ((K = c) == null ? void 0 : K.type) === "focus";
      c = R, C = R.currentTarget, le(), !f.state.isVisible && M4(R) && mn.forEach(function(de) {
        return de(R);
      }), R.type === "click" && (f.props.trigger.indexOf("mouseenter") < 0 || o) && f.props.hideOnClick !== !1 && f.state.isVisible ? re = !0 : Ve(R), R.type === "click" && (o = !re), re && !he && Te(R);
    }
  }
  function W(R) {
    var K = R.target, re = G().contains(K) || w.contains(K);
    if (!(R.type === "mousemove" && re)) {
      var he = Se().concat(w).map(function(de) {
        var De, Ie = de._tippy, Mt = (De = Ie.popperInstance) == null ? void 0 : De.state;
        return Mt ? {
          popperRect: de.getBoundingClientRect(),
          popperState: Mt,
          props: r
        } : null;
      }).filter(Boolean);
      P4(he, R) && (ve(), Te(R));
    }
  }
  function A(R) {
    var K = q(R) || f.props.trigger.indexOf("click") >= 0 && o;
    if (!K) {
      if (f.props.interactive) {
        f.hideWithInteractivity(R);
        return;
      }
      Te(R);
    }
  }
  function _(R) {
    f.props.trigger.indexOf("focusin") < 0 && R.target !== G() || f.props.interactive && R.relatedTarget && w.contains(R.relatedTarget) || Te(R);
  }
  function q(R) {
    return vt.isTouch ? $() !== R.type.indexOf("touch") >= 0 : !1;
  }
  function ne() {
    Le();
    var R = f.props, K = R.popperOptions, re = R.placement, he = R.offset, de = R.getReferenceClientRect, De = R.moveTransition, Ie = X() ? Ka(w).arrow : null, Mt = de ? {
      getBoundingClientRect: de,
      contextElement: de.contextElement || G()
    } : e, hr = {
      name: "$$tippy",
      enabled: !0,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: function(Ut) {
        var yt = Ut.state;
        if (X()) {
          var ea = z(), yr = ea.box;
          ["placement", "reference-hidden", "escaped"].forEach(function(zt) {
            zt === "placement" ? yr.setAttribute("data-placement", yt.placement) : yt.attributes.popper["data-popper-" + zt] ? yr.setAttribute("data-" + zt, "") : yr.removeAttribute("data-" + zt);
          }), yt.attributes.popper = {};
        }
      }
    }, pt = [{
      name: "offset",
      options: {
        offset: he
      }
    }, {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: "flip",
      options: {
        padding: 5
      }
    }, {
      name: "computeStyles",
      options: {
        adaptive: !De
      }
    }, hr];
    X() && Ie && pt.push({
      name: "arrow",
      options: {
        element: Ie,
        padding: 3
      }
    }), pt.push.apply(pt, (K == null ? void 0 : K.modifiers) || []), f.popperInstance = h4(Mt, w, Object.assign({}, K, {
      placement: re,
      onFirstUpdate: v,
      modifiers: pt
    }));
  }
  function Le() {
    f.popperInstance && (f.popperInstance.destroy(), f.popperInstance = null);
  }
  function ae() {
    var R = f.props.appendTo, K, re = G();
    f.props.interactive && R === ul || R === "parent" ? K = re.parentNode : K = ll(R, [re]), K.contains(w) || K.appendChild(w), f.state.isMounted = !0, ne(), process.env.NODE_ENV !== "production" && wt(f.props.interactive && R === Je.appendTo && re.nextElementSibling !== w, ["Interactive tippy element may not be accessible via keyboard", "navigation because it is not directly after the reference element", "in the DOM source order.", `

`, "Using a wrapper <div> or <span> tag around the reference element", "solves this by creating a new parentNode context.", `

`, "Specifying `appendTo: document.body` silences this warning, but it", "assumes you are using a focus management solution to handle", "keyboard navigation.", `

`, "See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity"].join(" "));
  }
  function Se() {
    return Hn(w.querySelectorAll("[data-tippy-root]"));
  }
  function Ve(R) {
    f.clearDelayTimeouts(), R && ee("onTrigger", [f, R]), te();
    var K = J(!0), re = I(), he = re[0], de = re[1];
    vt.isTouch && he === "hold" && de && (K = de), K ? n = setTimeout(function() {
      f.show();
    }, K) : f.show();
  }
  function Te(R) {
    if (f.clearDelayTimeouts(), ee("onUntrigger", [f, R]), !f.state.isVisible) {
      L();
      return;
    }
    if (!(f.props.trigger.indexOf("mouseenter") >= 0 && f.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(R.type) >= 0 && o)) {
      var K = J(!1);
      K ? a = setTimeout(function() {
        f.state.isVisible && f.hide();
      }, K) : i = requestAnimationFrame(function() {
        f.hide();
      });
    }
  }
  function Q() {
    f.state.isEnabled = !0;
  }
  function Ce() {
    f.hide(), f.state.isEnabled = !1;
  }
  function dt() {
    clearTimeout(n), clearTimeout(a), cancelAnimationFrame(i);
  }
  function ft(R) {
    if (process.env.NODE_ENV !== "production" && wt(f.state.isDestroyed, Xt("setProps")), !f.state.isDestroyed) {
      ee("onBeforeUpdate", [f, R]), O();
      var K = f.props, re = _1(e, Object.assign({}, K, S1(R), {
        ignoreAttributes: !0
      }));
      f.props = re, me(), K.interactiveDebounce !== re.interactiveDebounce && (ve(), h = A1(W, re.interactiveDebounce)), K.triggerTarget && !re.triggerTarget ? Jt(K.triggerTarget).forEach(function(he) {
        he.removeAttribute("aria-expanded");
      }) : re.triggerTarget && e.removeAttribute("aria-expanded"), le(), se(), V && V(K, re), f.popperInstance && (ne(), Se().forEach(function(he) {
        requestAnimationFrame(he._tippy.popperInstance.forceUpdate);
      })), ee("onAfterUpdate", [f, R]);
    }
  }
  function je(R) {
    f.setProps({
      content: R
    });
  }
  function Xn() {
    process.env.NODE_ENV !== "production" && wt(f.state.isDestroyed, Xt("show"));
    var R = f.state.isVisible, K = f.state.isDestroyed, re = !f.state.isEnabled, he = vt.isTouch && !f.props.touch, de = pa(f.props.duration, 0, Je.duration);
    if (!(R || K || re || he) && !G().hasAttribute("disabled") && (ee("onShow", [f], !1), f.props.onShow(f) !== !1)) {
      if (f.state.isVisible = !0, X() && (w.style.visibility = "visible"), se(), te(), f.state.isMounted || (w.style.transition = "none"), X()) {
        var De = z(), Ie = De.box, Mt = De.content;
        va([Ie, Mt], 0);
      }
      v = function() {
        var pt;
        if (!(!f.state.isVisible || d)) {
          if (d = !0, w.offsetHeight, w.style.transition = f.props.moveTransition, X() && f.props.animation) {
            var gr = z(), Ut = gr.box, yt = gr.content;
            va([Ut, yt], de), P1([Ut, yt], "visible");
          }
          pe(), le(), R1(ha, f), (pt = f.popperInstance) == null || pt.forceUpdate(), ee("onMount", [f]), f.props.animation && X() && j(de, function() {
            f.state.isShown = !0, ee("onShown", [f]);
          });
        }
      }, ae();
    }
  }
  function Gn() {
    process.env.NODE_ENV !== "production" && wt(f.state.isDestroyed, Xt("hide"));
    var R = !f.state.isVisible, K = f.state.isDestroyed, re = !f.state.isEnabled, he = pa(f.props.duration, 1, Je.duration);
    if (!(R || K || re) && (ee("onHide", [f], !1), f.props.onHide(f) !== !1)) {
      if (f.state.isVisible = !1, f.state.isShown = !1, d = !1, o = !1, X() && (w.style.visibility = "hidden"), ve(), L(), se(!0), X()) {
        var de = z(), De = de.box, Ie = de.content;
        f.props.animation && (va([De, Ie], he), P1([De, Ie], "hidden"));
      }
      pe(), le(), f.props.animation ? X() && ce(he, f.unmount) : f.unmount();
    }
  }
  function Jn(R) {
    process.env.NODE_ENV !== "production" && wt(f.state.isDestroyed, Xt("hideWithInteractivity")), F().addEventListener("mousemove", h), R1(mn, h), h(R);
  }
  function Qn() {
    process.env.NODE_ENV !== "production" && wt(f.state.isDestroyed, Xt("unmount")), f.state.isVisible && f.hide(), f.state.isMounted && (Le(), Se().forEach(function(R) {
      R._tippy.unmount();
    }), w.parentNode && w.parentNode.removeChild(w), ha = ha.filter(function(R) {
      return R !== f;
    }), f.state.isMounted = !1, ee("onHidden", [f]));
  }
  function mr() {
    process.env.NODE_ENV !== "production" && wt(f.state.isDestroyed, Xt("destroy")), !f.state.isDestroyed && (f.clearDelayTimeouts(), f.unmount(), O(), delete e._tippy, f.state.isDestroyed = !0, ee("onDestroy", [f]));
  }
}
function tn(e, t) {
  t === void 0 && (t = {});
  var r = Je.plugins.concat(t.plugins || []);
  process.env.NODE_ENV !== "production" && (j4(e), vl(t, r)), O4();
  var n = Object.assign({}, t, {
    plugins: r
  }), a = R4(e);
  if (process.env.NODE_ENV !== "production") {
    var i = Zr(n.content), o = a.length > 1;
    wt(i && o, ["tippy() was passed an Element as the `content` prop, but more than", "one tippy instance was created by this invocation. This means the", "content element will only be appended to the last tippy instance.", `

`, "Instead, pass the .innerHTML of the element, or use a function that", "returns a cloned version of the element instead.", `

`, `1) content: element.innerHTML
`, "2) content: () => element.cloneNode(true)"].join(" "));
  }
  var s = a.reduce(function(l, d) {
    var c = d && W4(d, n);
    return c && l.push(c), l;
  }, []);
  return Zr(e) ? s[0] : s;
}
tn.defaultProps = Je;
tn.setDefaultProps = B4;
tn.currentInput = vt;
Object.assign({}, Gu, {
  effect: function(t) {
    var r = t.state, n = {
      popper: {
        position: r.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
    Object.assign(r.elements.popper.style, n.popper), r.styles = n, r.elements.arrow && Object.assign(r.elements.arrow.style, n.arrow);
  }
});
tn.setDefaultProps({
  render: ml
});
function hl(e, t) {
  if (e == null)
    return {};
  var r = {}, n = Object.keys(e), a, i;
  for (i = 0; i < n.length; i++)
    a = n[i], !(t.indexOf(a) >= 0) && (r[a] = e[a]);
  return r;
}
var gl = typeof window < "u" && typeof document < "u";
function Xa(e, t) {
  e && (typeof e == "function" && e(t), {}.hasOwnProperty.call(e, "current") && (e.current = t));
}
function D1() {
  return gl && document.createElement("div");
}
function U4(e) {
  var t = {
    "data-placement": e.placement
  };
  return e.referenceHidden && (t["data-reference-hidden"] = ""), e.escaped && (t["data-escaped"] = ""), t;
}
function yl(e, t) {
  if (e === t)
    return !0;
  if (typeof e == "object" && e != null && typeof t == "object" && t != null) {
    if (Object.keys(e).length !== Object.keys(t).length)
      return !1;
    for (var r in e)
      if (t.hasOwnProperty(r)) {
        if (!yl(e[r], t[r]))
          return !1;
      } else
        return !1;
    return !0;
  } else
    return !1;
}
function z4(e) {
  var t = [];
  return e.forEach(function(r) {
    t.find(function(n) {
      return yl(r, n);
    }) || t.push(r);
  }), t;
}
function Y4(e, t) {
  var r, n;
  return Object.assign({}, t, {
    popperOptions: Object.assign({}, e.popperOptions, t.popperOptions, {
      modifiers: z4([].concat(((r = e.popperOptions) == null ? void 0 : r.modifiers) || [], ((n = t.popperOptions) == null ? void 0 : n.modifiers) || []))
    })
  });
}
var ga = gl ? N1 : _e;
function q4(e) {
  var t = Qe();
  return t.current || (t.current = typeof e == "function" ? e() : e), t.current;
}
function j1(e, t, r) {
  r.split(/\s+/).forEach(function(n) {
    n && e.classList[t](n);
  });
}
var K4 = {
  name: "className",
  defaultValue: "",
  fn: function(t) {
    var r = t.popper.firstElementChild, n = function() {
      var s;
      return !!((s = t.props.render) != null && s.$$tippy);
    };
    function a() {
      if (t.props.className && !n()) {
        process.env.NODE_ENV !== "production" && console.warn(["@tippyjs/react: Cannot use `className` prop in conjunction with", "`render` prop. Place the className on the element you are", "rendering."].join(" "));
        return;
      }
      j1(r, "add", t.props.className);
    }
    function i() {
      n() && j1(r, "remove", t.props.className);
    }
    return {
      onCreate: a,
      onBeforeUpdate: i,
      onAfterUpdate: a
    };
  }
};
function X4(e) {
  function t(r) {
    var n = r.children, a = r.content, i = r.visible, o = r.singleton, s = r.render, l = r.reference, d = r.disabled, c = d === void 0 ? !1 : d, p = r.ignoreAttributes, v = p === void 0 ? !0 : p;
    r.__source, r.__self;
    var m = hl(r, ["children", "content", "visible", "singleton", "render", "reference", "disabled", "ignoreAttributes", "__source", "__self"]), h = i !== void 0, C = o !== void 0, y = $e(!1), x = y[0], T = y[1], M = $e({}), f = M[0], b = M[1], w = $e(), V = w[0], S = w[1], k = q4(function() {
      return {
        container: D1(),
        renders: 1
      };
    }), I = Object.assign({
      ignoreAttributes: v
    }, m, {
      content: k.container
    });
    h && (process.env.NODE_ENV !== "production" && ["trigger", "hideOnClick", "showOnCreate"].forEach(function(F) {
      I[F] !== void 0 && console.warn(["@tippyjs/react: Cannot specify `" + F + "` prop in", "controlled mode (`visible` prop)"].join(" "));
    }), I.trigger = "manual", I.hideOnClick = !1), C && (c = !0);
    var $ = I, X = I.plugins || [];
    s && ($ = Object.assign({}, I, {
      plugins: C && o.data != null ? [].concat(X, [{
        fn: function() {
          return {
            onTrigger: function(J, se) {
              var ee = o.data.children.find(function(pe) {
                var le = pe.instance;
                return le.reference === se.currentTarget;
              });
              J.state.$$activeSingletonInstance = ee.instance, S(ee.content);
            }
          };
        }
      }]) : X,
      render: function() {
        return {
          popper: k.container
        };
      }
    }));
    var G = [l].concat(n ? [n.type] : []);
    return ga(function() {
      var F = l;
      l && l.hasOwnProperty("current") && (F = l.current);
      var z = e(F || k.ref || D1(), Object.assign({}, $, {
        plugins: [K4].concat(I.plugins || [])
      }));
      return k.instance = z, c && z.disable(), i && z.show(), C && o.hook({
        instance: z,
        content: a,
        props: $,
        setSingletonContent: S
      }), T(!0), function() {
        z.destroy(), o == null || o.cleanup(z);
      };
    }, G), ga(function() {
      var F;
      if (k.renders === 1) {
        k.renders++;
        return;
      }
      var z = k.instance;
      z.setProps(Y4(z.props, $)), (F = z.popperInstance) == null || F.forceUpdate(), c ? z.disable() : z.enable(), h && (i ? z.show() : z.hide()), C && o.hook({
        instance: z,
        content: a,
        props: $,
        setSingletonContent: S
      });
    }), ga(function() {
      var F;
      if (!!s) {
        var z = k.instance;
        z.setProps({
          popperOptions: Object.assign({}, z.props.popperOptions, {
            modifiers: [].concat((((F = z.props.popperOptions) == null ? void 0 : F.modifiers) || []).filter(function(J) {
              var se = J.name;
              return se !== "$$tippyReact";
            }), [{
              name: "$$tippyReact",
              enabled: !0,
              phase: "beforeWrite",
              requires: ["computeStyles"],
              fn: function(se) {
                var ee, pe = se.state, le = (ee = pe.modifiersData) == null ? void 0 : ee.hide;
                (f.placement !== pe.placement || f.referenceHidden !== (le == null ? void 0 : le.isReferenceHidden) || f.escaped !== (le == null ? void 0 : le.hasPopperEscaped)) && b({
                  placement: pe.placement,
                  referenceHidden: le == null ? void 0 : le.isReferenceHidden,
                  escaped: le == null ? void 0 : le.hasPopperEscaped
                }), pe.attributes.popper = {};
              }
            }])
          })
        });
      }
    }, [f.placement, f.referenceHidden, f.escaped].concat(G)), /* @__PURE__ */ E(He, {
      children: [n ? /* @__PURE__ */ Ja(n, {
        ref: function(z) {
          k.ref = z, Xa(n.ref, z);
        }
      }) : null, x && /* @__PURE__ */ Al(s ? s(U4(f), V, k.instance) : a, k.container)]
    });
  }
  return t;
}
var G4 = function(e, t) {
  return /* @__PURE__ */ $1(function(n, a) {
    var i = n.children, o = hl(n, ["children"]);
    return /* @__PURE__ */ u(e, {
      ...Object.assign({}, t, o),
      children: i ? /* @__PURE__ */ Ja(i, {
        ref: function(l) {
          Xa(a, l), Xa(i.ref, l);
        }
      }) : null
    });
  });
}, J4 = /* @__PURE__ */ G4(/* @__PURE__ */ X4(tn));
const Q4 = J4;
const xv = ({
  title: e,
  description: t,
  descriptioncolor: r,
  arrow: n,
  children: a,
  visible: i,
  placement: o,
  ...s
}) => /* @__PURE__ */ u(Q4, {
  visible: i,
  id: "slid-tooltip",
  placement: o != null ? o : "top",
  content: /* @__PURE__ */ E(He, {
    children: [e && /* @__PURE__ */ u(qe, {
      text: e,
      color: "--gray3",
      textAlign: "center",
      weight: 700
    }), t && /* @__PURE__ */ u(Jr, {
      text: t,
      color: r != null ? r : "--gray7",
      textAlign: "center"
    })]
  }),
  arrow: n,
  ...s,
  children: /* @__PURE__ */ u(ev, {
    children: a
  })
}), ev = D("div")({
  width: "fit-content"
}), tv = ({
  type: e,
  text: t,
  color: r,
  weight: n,
  marginTop: a,
  opacity: i,
  textAlign: o,
  className: s,
  variants: l,
  initial: d,
  animate: c,
  ...p
}) => /* @__PURE__ */ u(We, {
  type: e != null ? e : "h1",
  text: t,
  color: r,
  weight: n != null ? n : 700,
  textSize: {
    desktop: "6rem",
    mobile: "6rem"
  },
  lineHeight: {
    desktop: "7rem",
    mobile: "7rem"
  },
  letterSpacing: {
    desktop: "0rem",
    mobile: "0rem"
  },
  marginTop: a,
  opacity: i,
  textAlign: o,
  className: s,
  variants: l,
  initial: d,
  animate: c,
  ...p
}), wv = ({
  type: e,
  text: t,
  color: r,
  weight: n,
  marginTop: a,
  opacity: i,
  textAlign: o,
  className: s,
  variants: l,
  initial: d,
  animate: c,
  ...p
}) => /* @__PURE__ */ u(We, {
  type: e != null ? e : "h2",
  text: t,
  color: r,
  weight: n != null ? n : 700,
  textSize: {
    desktop: "4.8rem",
    mobile: "4.8rem"
  },
  lineHeight: {
    desktop: "5.6rem",
    mobile: "5.6rem"
  },
  letterSpacing: {
    desktop: "0rem",
    mobile: "0rem"
  },
  marginTop: a,
  opacity: i,
  textAlign: o,
  className: s,
  variants: l,
  initial: d,
  animate: c,
  ...p
}), Ga = ({
  type: e,
  text: t,
  color: r,
  weight: n,
  marginTop: a,
  opacity: i,
  textAlign: o,
  className: s,
  variants: l,
  initial: d,
  animate: c,
  ...p
}) => /* @__PURE__ */ u(We, {
  type: e != null ? e : "h1",
  text: t,
  color: r,
  weight: n != null ? n : 700,
  textSize: {
    desktop: "3.4rem",
    mobile: "3.4rem"
  },
  lineHeight: {
    desktop: "4.2rem",
    mobile: "4.2rem"
  },
  letterSpacing: {
    desktop: "0rem",
    mobile: "0rem"
  },
  marginTop: a,
  opacity: i,
  textAlign: o,
  className: s,
  variants: l,
  initial: d,
  animate: c,
  ...p
}), Cl = ({
  type: e,
  text: t,
  color: r,
  weight: n,
  marginTop: a,
  opacity: i,
  textAlign: o,
  className: s,
  variants: l,
  initial: d,
  animate: c,
  ...p
}) => /* @__PURE__ */ u(We, {
  type: e != null ? e : "h3",
  text: t,
  color: r,
  weight: n != null ? n : 700,
  textSize: {
    desktop: "2.4rem",
    mobile: "2.4rem"
  },
  lineHeight: {
    desktop: "3.1rem",
    mobile: "3.1rem"
  },
  letterSpacing: {
    desktop: "0rem",
    mobile: "0rem"
  },
  marginTop: a,
  opacity: i,
  textAlign: o,
  className: s,
  variants: l,
  initial: d,
  animate: c,
  ...p
}), Lv = ({
  type: e,
  text: t,
  color: r,
  weight: n,
  marginTop: a,
  opacity: i,
  textAlign: o,
  className: s,
  variants: l,
  initial: d,
  animate: c,
  ...p
}) => /* @__PURE__ */ u(We, {
  type: e != null ? e : "p",
  text: t,
  color: r,
  weight: n != null ? n : 400,
  textSize: {
    desktop: "1.8rem",
    mobile: "1.8rem"
  },
  lineHeight: {
    desktop: "2.7rem",
    mobile: "2.7rem"
  },
  letterSpacing: {
    desktop: "0rem",
    mobile: "0rem"
  },
  marginTop: a,
  opacity: i,
  textAlign: o,
  className: s,
  variants: l,
  initial: d,
  animate: c,
  ...p
}), Tv = ({
  type: e,
  text: t,
  color: r,
  weight: n,
  marginTop: a,
  opacity: i,
  textAlign: o,
  className: s,
  variants: l,
  initial: d,
  animate: c,
  ...p
}) => /* @__PURE__ */ u(We, {
  type: e != null ? e : "p",
  text: t,
  color: r,
  weight: n != null ? n : 400,
  textSize: {
    desktop: "1.6rem",
    mobile: "1.6rem"
  },
  lineHeight: {
    desktop: "2.4rem",
    mobile: "2.4rem"
  },
  letterSpacing: {
    desktop: "0rem",
    mobile: "0rem"
  },
  marginTop: a,
  opacity: i,
  textAlign: o,
  className: s,
  variants: l,
  initial: d,
  animate: c,
  ...p
}), Mv = ({
  type: e,
  text: t,
  color: r,
  weight: n,
  marginTop: a,
  opacity: i,
  textAlign: o,
  className: s,
  variants: l,
  initial: d,
  animate: c,
  ...p
}) => /* @__PURE__ */ u(We, {
  type: e != null ? e : "p",
  text: t,
  color: r,
  weight: n != null ? n : 400,
  textSize: {
    desktop: "1.4rem",
    mobile: "1.4rem"
  },
  lineHeight: {
    desktop: "2rem",
    mobile: "2rem"
  },
  letterSpacing: {
    desktop: "0rem",
    mobile: "0rem"
  },
  marginTop: a,
  opacity: i,
  textAlign: o,
  className: s,
  variants: l,
  initial: d,
  animate: c,
  ...p
}), Av = ({
  type: e,
  text: t,
  color: r,
  weight: n,
  marginTop: a,
  opacity: i,
  textAlign: o,
  className: s,
  variants: l,
  initial: d,
  animate: c,
  ...p
}) => /* @__PURE__ */ u(We, {
  type: e != null ? e : "p",
  text: t,
  color: r,
  weight: n != null ? n : 400,
  textSize: {
    desktop: "1.2rem",
    mobile: "1.2rem"
  },
  lineHeight: {
    desktop: "1.7rem",
    mobile: "1.7rem"
  },
  letterSpacing: {
    desktop: "0rem",
    mobile: "0rem"
  },
  marginTop: a,
  opacity: i,
  textAlign: o,
  className: s,
  variants: l,
  initial: d,
  animate: c,
  ...p
}), Rv = ({
  type: e,
  text: t,
  color: r,
  weight: n,
  marginTop: a,
  opacity: i,
  textAlign: o,
  className: s,
  variants: l,
  initial: d,
  animate: c,
  ...p
}) => /* @__PURE__ */ u(We, {
  type: e != null ? e : "p",
  text: t,
  color: r,
  weight: n != null ? n : 400,
  textSize: {
    desktop: "0.9rem",
    mobile: "0.9rem"
  },
  lineHeight: {
    desktop: "1.3rem",
    mobile: "1.3rem"
  },
  letterSpacing: {
    desktop: "0rem",
    mobile: "0rem"
  },
  marginTop: a,
  opacity: i,
  textAlign: o,
  className: s,
  variants: l,
  initial: d,
  animate: c,
  ...p
}), rv = {
  alertOn: !1,
  alertProps: null
}, bl = (e = rv, t) => {
  switch (t.type) {
    case Wu:
      return {
        ...e,
        alertOn: t.payload
      };
    case Uu:
      return {
        ...e,
        alertProps: t.payload
      };
    default:
      return e;
  }
}, nv = {
  modalOn: !1,
  modalProps: null
}, xl = (e = nv, t) => {
  switch (t.type) {
    case Zu:
      return {
        ...e,
        modalOn: t.payload
      };
    case Fu:
      return {
        ...e,
        modalProps: t.payload
      };
    default:
      return e;
  }
}, av = {
  toastOn: !1,
  toastMessage: ""
}, wl = (e = av, t) => {
  switch (t.type) {
    case Bu:
      return {
        ...e,
        toastOn: t.payload
      };
    case $u:
      return {
        ...e,
        toastMessage: t.payload
      };
    default:
      return e;
  }
}, Sv = Rl({
  toast: wl,
  modal: xl,
  alert: bl
}), Pv = {
  toast: wl,
  modal: xl,
  alert: bl
};
var Dt = /* @__PURE__ */ ((e) => (e.modal = "Modal", e.imageModal = "ImageModal", e.emojiModal = "EmojiModal", e.videoModal = "VideoModal", e.customModal = "CustomModal", e.optionModal = "OptionModal", e))(Dt || {});
const Ev = [
  "help8",
  "markdown16",
  "pdf16",
  "png16",
  "word16",
  "thickCheck16",
  "chevronLeft16",
  "chevronRight16",
  "chevronUp16",
  "chevronDown16",
  "import16",
  "chevronDown20",
  "import20",
  "export20",
  "newNote20",
  "recentNote20",
  "folder20",
  "rename20",
  "star20",
  "colorPalette20",
  "delete20",
  "share20",
  "account20",
  "chat20",
  "copy20",
  "redo20",
  "undo20",
  "shortcut20",
  "tutorial20",
  "history20",
  "restore20",
  "link20",
  "logout20",
  "markdown20",
  "pdf20",
  "png20",
  "word20",
  "translate20",
  "linkedDocument20",
  "fullScreen20",
  "markUp20",
  "help24",
  "delete24",
  "chevronUp24",
  "chevronDown24",
  "check24",
  "chat24",
  "language24",
  "plus24",
  "arrowDown24",
  "arrowUp24",
  "chrome24",
  "list24",
  "more24",
  "desktop24",
  "note24",
  "newTab24",
  "x24",
  "slid24",
  "filledFolder24",
  "help24",
  "myNote24",
  "update24",
  "play24",
  "textGrab24",
  "foldMenu24",
  "unfoldMenu24",
  "sparkles24",
  "capture24",
  "microphone24",
  "text24",
  "1Click28",
  "chevronLeft28",
  "doubleChevronLeft28",
  "doubleChevronRight28",
  "list28",
  "more28",
  "recording28",
  "snip28",
  "usingRecording28",
  "autoTypingDeactivated28",
  "autoTyping28",
  "autoTypingOngoing28",
  "setting28",
  "stopRecording28"
];
export {
  bv as Alert,
  qu as AlertTypes,
  ze as Button,
  lv as Card,
  D5 as ColorTypes,
  Ei as Dim,
  Pv as IPSReducer,
  $t as Icon,
  Yu as Link,
  Cv as List,
  vv as Menu,
  Ap as MenuButton,
  mv as MenuItem,
  hv as MenuList,
  ut as MenuSizeType,
  fv as Modal,
  Dt as ModalTypes,
  gv as PullDownMenuItem,
  yv as PullDownMenuList,
  Sv as Reducer,
  n1 as StaggerDots,
  dv as Sticker,
  pv as TextField,
  cv as Toast,
  x5 as ToggleButton,
  xv as Tooltip,
  Jr as Typography11,
  Av as Typography12,
  qe as Typography13,
  Mv as Typography14,
  Ze as Typography15,
  Tv as Typography16,
  et as Typography17,
  Lv as Typography18,
  vr as Typography20,
  Cl as Typography24,
  Nu as Typography28,
  Ga as Typography34,
  wv as Typography48,
  tv as Typography60,
  Rv as Typography9,
  Fa as addOptionTypes,
  Ev as iconList,
  i7 as useAlert,
  ep as useModal,
  k5 as useToast
};
